import { print } from 'graphql';
import gql from 'graphql-tag';
/** Describes what kind of action being described. Copy for example describes the coupon code copy behavior. Authwindow shows the login/signup dialog. */
export var ActionDetailsType;
(function (ActionDetailsType) {
  /** Action to pop auth window */
  ActionDetailsType["AUTHWINDOW"] = "AUTHWINDOW";
  /** Action to close a dropdown option */
  ActionDetailsType["CLOSE"] = "CLOSE";
  /** Action to copy contents to clipboard */
  ActionDetailsType["COPY"] = "COPY";
  /** Action to open the date picker */
  ActionDetailsType["DATEPICKER"] = "DATEPICKER";
  /** Action to open an external link off */
  ActionDetailsType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
  /** Action to display free lx message */
  ActionDetailsType["FREE_LX"] = "FREE_LX";
  /** Action to open a link off */
  ActionDetailsType["OPEN"] = "OPEN";
  /** Action to display term and conditions */
  ActionDetailsType["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
})(ActionDetailsType || (ActionDetailsType = {}));
export var ActionType;
(function (ActionType) {
  ActionType["Open"] = "Open";
  ActionType["OpenPriceChangeAlert"] = "OpenPriceChangeAlert";
  ActionType["DownloadDPReport"] = "DownloadDPReport";
  ActionType["JUMPLINK"] = "JUMPLINK";
  ActionType["MODAL"] = "MODAL";
  ActionType["REDIRECT"] = "REDIRECT";
})(ActionType || (ActionType = {}));
/** Indicates the coupon's active state */
export var ActiveState;
(function (ActiveState) {
  ActiveState["ACTIVE"] = "ACTIVE";
  ActiveState["INACTIVE"] = "INACTIVE";
  ActiveState["UNKNOWN"] = "UNKNOWN";
  ActiveState["USED"] = "USED";
})(ActiveState || (ActiveState = {}));
export var ActivityAvailabilityPriceTextTheme;
(function (ActivityAvailabilityPriceTextTheme) {
  ActivityAvailabilityPriceTextTheme["POSITIVE"] = "POSITIVE";
})(ActivityAvailabilityPriceTextTheme || (ActivityAvailabilityPriceTextTheme = {}));
export var ActivityBadgeType;
(function (ActivityBadgeType) {
  ActivityBadgeType["CAMPAIGN_DEAL"] = "CAMPAIGN_DEAL";
  ActivityBadgeType["DEAL_ADD_ON"] = "DEAL_ADD_ON";
  ActivityBadgeType["DEAL_GENERIC"] = "DEAL_GENERIC";
  ActivityBadgeType["DEAL_MEMBER"] = "DEAL_MEMBER";
})(ActivityBadgeType || (ActivityBadgeType = {}));
/** Activity banner type */
export var ActivityBannerType;
(function (ActivityBannerType) {
  ActivityBannerType["ALERT"] = "ALERT";
  ActivityBannerType["INFO"] = "INFO";
  ActivityBannerType["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
})(ActivityBannerType || (ActivityBannerType = {}));
export var ActivityCancellationType;
(function (ActivityCancellationType) {
  ActivityCancellationType["FREE_CANCELLATION"] = "FREE_CANCELLATION";
  ActivityCancellationType["NO_CANCELLATION"] = "NO_CANCELLATION";
})(ActivityCancellationType || (ActivityCancellationType = {}));
export var ActivityCategory;
(function (ActivityCategory) {
  ActivityCategory["ADULTS_ONLY_SHOWS"] = "ADULTS_ONLY_SHOWS";
  ActivityCategory["ADVENTURES"] = "ADVENTURES";
  ActivityCategory["ADVENTURE_OUTDOOR"] = "ADVENTURE_OUTDOOR";
  ActivityCategory["AIRBOAT_TOURS"] = "AIRBOAT_TOURS";
  ActivityCategory["AIRPLANE_RIDES"] = "AIRPLANE_RIDES";
  ActivityCategory["AIRPLANE_TOURS"] = "AIRPLANE_TOURS";
  ActivityCategory["AIRPORT_GROUND_TRANSPORTATION"] = "AIRPORT_GROUND_TRANSPORTATION";
  ActivityCategory["AIRPORT_LOUNGES"] = "AIRPORT_LOUNGES";
  ActivityCategory["AIRPORT_TO_AIRPORT_TRANSFERS"] = "AIRPORT_TO_AIRPORT_TRANSFERS";
  ActivityCategory["AIR_BALLOON_HELICOPTER_TOURS"] = "AIR_BALLOON_HELICOPTER_TOURS";
  ActivityCategory["AIR_HELICOPTER_BALLOON_TOURS"] = "AIR_HELICOPTER_BALLOON_TOURS";
  ActivityCategory["AMUSEMENT_THEME_PARKS"] = "AMUSEMENT_THEME_PARKS";
  ActivityCategory["ARCHITECTURE_TOURS"] = "ARCHITECTURE_TOURS";
  ActivityCategory["ART_CLASSES"] = "ART_CLASSES";
  ActivityCategory["ART_CULTURE_HISTORY_TOURS"] = "ART_CULTURE_HISTORY_TOURS";
  ActivityCategory["ART_MUSIC_LITERARYTOURS"] = "ART_MUSIC_LITERARYTOURS";
  ActivityCategory["ATTRACTIONS"] = "ATTRACTIONS";
  ActivityCategory["ATTRACTION_TICKETS"] = "ATTRACTION_TICKETS";
  ActivityCategory["BALLOON_RIDES"] = "BALLOON_RIDES";
  ActivityCategory["BALLOON_TOURS"] = "BALLOON_TOURS";
  ActivityCategory["BAR_PUB_TOURS"] = "BAR_PUB_TOURS";
  ActivityCategory["BEER_BREWERY_TOURS"] = "BEER_BREWERY_TOURS";
  ActivityCategory["BEYOND_THE_CITY"] = "BEYOND_THE_CITY";
  ActivityCategory["BIKE_MOUNTAIN_BIKE_TOURS"] = "BIKE_MOUNTAIN_BIKE_TOURS";
  ActivityCategory["BIKE_RENTALS"] = "BIKE_RENTALS";
  ActivityCategory["BOAT_RENTAL"] = "BOAT_RENTAL";
  ActivityCategory["BOAT_TOURS"] = "BOAT_TOURS";
  ActivityCategory["BOAT_TOURS_CRUISES"] = "BOAT_TOURS_CRUISES";
  ActivityCategory["BRUNCHC_RUISES"] = "BRUNCHC_RUISES";
  ActivityCategory["BUNGEE_JUMPING_SKYDIVING"] = "BUNGEE_JUMPING_SKYDIVING";
  ActivityCategory["BUS_MINIVAN_TOURS"] = "BUS_MINIVAN_TOURS";
  ActivityCategory["CABARET"] = "CABARET";
  ActivityCategory["CAMPAIGN_DEALS"] = "CAMPAIGN_DEALS";
  ActivityCategory["CASTLE_PALACE_TOURS"] = "CASTLE_PALACE_TOURS";
  ActivityCategory["CHAUFFER_SERVICES"] = "CHAUFFER_SERVICES";
  ActivityCategory["CHRISTMAS"] = "CHRISTMAS";
  ActivityCategory["CIRQUE"] = "CIRQUE";
  ActivityCategory["CIRQUE_DU_SOLEIL"] = "CIRQUE_DU_SOLEIL";
  ActivityCategory["CIRQUE_DU_SOLEILSHOWS"] = "CIRQUE_DU_SOLEILSHOWS";
  ActivityCategory["CITY_AND_ATTRACTION_TRANSFERS"] = "CITY_AND_ATTRACTION_TRANSFERS";
  ActivityCategory["CITY_ATTRACTION_TRANSFERS"] = "CITY_ATTRACTION_TRANSFERS";
  ActivityCategory["CITY_TOURS"] = "CITY_TOURS";
  ActivityCategory["CITY_TOURS_PACKAGES"] = "CITY_TOURS_PACKAGES";
  ActivityCategory["CLASSES_WORKSHOPS"] = "CLASSES_WORKSHOPS";
  ActivityCategory["CLUB_AND_PARTY_BUS_TOURS"] = "CLUB_AND_PARTY_BUS_TOURS";
  ActivityCategory["CLUB_PARTY_BUS_TOURS"] = "CLUB_PARTY_BUS_TOURS";
  ActivityCategory["COFFEE_TEA_TOURS"] = "COFFEE_TEA_TOURS";
  ActivityCategory["COMEDY_SHOWS"] = "COMEDY_SHOWS";
  ActivityCategory["CONCERTS_SPECIAL_EVENTS"] = "CONCERTS_SPECIAL_EVENTS";
  ActivityCategory["COOKING_CLASSES"] = "COOKING_CLASSES";
  ActivityCategory["CRUISES_BOAT_TOURS"] = "CRUISES_BOAT_TOURS";
  ActivityCategory["CRUISES_WATER_TOURS"] = "CRUISES_WATER_TOURS";
  ActivityCategory["CULTURAL_HERITAGE_EXPERIENCES"] = "CULTURAL_HERITAGE_EXPERIENCES";
  ActivityCategory["CUSTOM_PRIVATE_TOURS"] = "CUSTOM_PRIVATE_TOURS";
  ActivityCategory["DANCE_CLASSES"] = "DANCE_CLASSES";
  ActivityCategory["DAY_OF_THE_DEAD"] = "DAY_OF_THE_DEAD";
  ActivityCategory["DAY_SPAS"] = "DAY_SPAS";
  ActivityCategory["DAY_TRIPS"] = "DAY_TRIPS";
  ActivityCategory["DAY_TRIPS_EXCURSIONS"] = "DAY_TRIPS_EXCURSIONS";
  ActivityCategory["DINING_EXPERIENCES"] = "DINING_EXPERIENCES";
  ActivityCategory["DINNER_CRUISES"] = "DINNER_CRUISES";
  ActivityCategory["DINNER_THEATER"] = "DINNER_THEATER";
  ActivityCategory["DISNEY"] = "DISNEY";
  ActivityCategory["DISNEY_PARKS"] = "DISNEY_PARKS";
  ActivityCategory["DOLPHIN_WHALE_WATCHING"] = "DOLPHIN_WHALE_WATCHING";
  ActivityCategory["DOSE_OF_CULTURE"] = "DOSE_OF_CULTURE";
  ActivityCategory["DUCK_TOURS"] = "DUCK_TOURS";
  ActivityCategory["EASTER"] = "EASTER";
  ActivityCategory["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
  ActivityCategory["FASHION_SHOWS_TOURS"] = "FASHION_SHOWS_TOURS";
  ActivityCategory["FISHING_CHARTERS_TOURS"] = "FISHING_CHARTERS_TOURS";
  ActivityCategory["FISHING_TOURS_AND_CHARTERS"] = "FISHING_TOURS_AND_CHARTERS";
  ActivityCategory["FOOD_DRINK"] = "FOOD_DRINK";
  ActivityCategory["FOOD_DRINK_NIGHTLIFE"] = "FOOD_DRINK_NIGHTLIFE";
  ActivityCategory["FOOD_TOURS"] = "FOOD_TOURS";
  ActivityCategory["FUN_FOR_FOODIES"] = "FUN_FOR_FOODIES";
  ActivityCategory["FUN_ON_THE_WATER"] = "FUN_ON_THE_WATER";
  ActivityCategory["GALLERIES_MUSEUMS"] = "GALLERIES_MUSEUMS";
  ActivityCategory["GAMES_SHOWS_SPECIAL_EVENTS"] = "GAMES_SHOWS_SPECIAL_EVENTS";
  ActivityCategory["GETTING_AROUND"] = "GETTING_AROUND";
  ActivityCategory["GOLF_TEE_TIMES"] = "GOLF_TEE_TIMES";
  ActivityCategory["GOLF_TOURS_TEE_TIMES"] = "GOLF_TOURS_TEE_TIMES";
  ActivityCategory["HALLOWEEN"] = "HALLOWEEN";
  ActivityCategory["HAMMAMS_TURKISH_BATHS"] = "HAMMAMS_TURKISH_BATHS";
  ActivityCategory["HELICOPTER_RIDES"] = "HELICOPTER_RIDES";
  ActivityCategory["HELICOPTER_TOURS"] = "HELICOPTER_TOURS";
  ActivityCategory["HIGH_SPEED_DRIVING"] = "HIGH_SPEED_DRIVING";
  ActivityCategory["HIGH_SPEED_RIDES"] = "HIGH_SPEED_RIDES";
  ActivityCategory["HIKING_CAMPING"] = "HIKING_CAMPING";
  ActivityCategory["HISTORICAL_TOURS"] = "HISTORICAL_TOURS";
  ActivityCategory["HISTORY_CULTURE"] = "HISTORY_CULTURE";
  ActivityCategory["HOLIDAY_SEASONAL_TOURS"] = "HOLIDAY_SEASONAL_TOURS";
  ActivityCategory["HONEYMOON_PACKAGE"] = "HONEYMOON_PACKAGE";
  ActivityCategory["HONEYMOON_PACKAGES"] = "HONEYMOON_PACKAGES";
  ActivityCategory["HOP_ON_HOP_OFF"] = "HOP_ON_HOP_OFF";
  ActivityCategory["HOP_ON_HOP_OFF_TOURS"] = "HOP_ON_HOP_OFF_TOURS";
  ActivityCategory["HORSE_CARRIAGE_RIDES"] = "HORSE_CARRIAGE_RIDES";
  ActivityCategory["HOT_SPRINGS_THERMAL_SPAS"] = "HOT_SPRINGS_THERMAL_SPAS";
  ActivityCategory["INTERESTS"] = "INTERESTS";
  ActivityCategory["KAYAKING_CANOEING"] = "KAYAKING_CANOEING";
  ActivityCategory["LATEST_GREATEST"] = "LATEST_GREATEST";
  ActivityCategory["LIFT_TICKETS"] = "LIFT_TICKETS";
  ActivityCategory["LIKELY_TO_SELL_OUT"] = "LIKELY_TO_SELL_OUT";
  ActivityCategory["LITERARY_ART_MUSIC_TOURS"] = "LITERARY_ART_MUSIC_TOURS";
  ActivityCategory["LOCAL_EXPERT_PICKS"] = "LOCAL_EXPERT_PICKS";
  ActivityCategory["LUNCH_CRUISES"] = "LUNCH_CRUISES";
  ActivityCategory["MOTORCYCLE_SCOOTER_TOURS"] = "MOTORCYCLE_SCOOTER_TOURS";
  ActivityCategory["MOVIE_TV_TOURS"] = "MOVIE_TV_TOURS";
  ActivityCategory["MULTIDAY_CRUISES"] = "MULTIDAY_CRUISES";
  ActivityCategory["MULTI_DAY_EXTENDED_TOURS"] = "MULTI_DAY_EXTENDED_TOURS";
  ActivityCategory["MUSEUM_TICKETS"] = "MUSEUM_TICKETS";
  ActivityCategory["MUSEUM_TICKETS_PASSES"] = "MUSEUM_TICKETS_PASSES";
  ActivityCategory["MUST_SEE_SIGHTS"] = "MUST_SEE_SIGHTS";
  ActivityCategory["NA"] = "NA";
  ActivityCategory["NATIONAL_HOLIDAYS"] = "NATIONAL_HOLIDAYS";
  ActivityCategory["NEW"] = "NEW";
  ActivityCategory["NEWY_EARS"] = "NEWY_EARS";
  ActivityCategory["NIGHTLIFE"] = "NIGHTLIFE";
  ActivityCategory["NIGHTLIFE_PASSES"] = "NIGHTLIFE_PASSES";
  ActivityCategory["NIGHT_CRUISES"] = "NIGHT_CRUISES";
  ActivityCategory["NIGHT_TOURS"] = "NIGHT_TOURS";
  ActivityCategory["ONSENS"] = "ONSENS";
  ActivityCategory["OTHER_ANIMALS_ACTIVITIES"] = "OTHER_ANIMALS_ACTIVITIES";
  ActivityCategory["OTHER_ANIMAL_ACTIVITIES"] = "OTHER_ANIMAL_ACTIVITIES";
  ActivityCategory["OTHER_CLASSES"] = "OTHER_CLASSES";
  ActivityCategory["OTHER_OUTDOOR_ACTIVITIES"] = "OTHER_OUTDOOR_ACTIVITIES";
  ActivityCategory["OTHER_SEASONAL_EVENTS"] = "OTHER_SEASONAL_EVENTS";
  ActivityCategory["OTHER_TOURS"] = "OTHER_TOURS";
  ActivityCategory["OTHER_TRANSFERS"] = "OTHER_TRANSFERS";
  ActivityCategory["OTHER_TRANSPORTATION"] = "OTHER_TRANSPORTATION";
  ActivityCategory["OTHER_WATER_ACTIVITIES"] = "OTHER_WATER_ACTIVITIES";
  ActivityCategory["PHOTOGRAPHY_TOURS"] = "PHOTOGRAPHY_TOURS";
  ActivityCategory["PORT_TRANSFERS"] = "PORT_TRANSFERS";
  ActivityCategory["PRIVATE_CUSTOM_TOURS"] = "PRIVATE_CUSTOM_TOURS";
  ActivityCategory["PRIVATE_DAY_TRIPS"] = "PRIVATE_DAY_TRIPS";
  ActivityCategory["PRIVATE_TOURS"] = "PRIVATE_TOURS";
  ActivityCategory["PRIVATE_TRANSFERS"] = "PRIVATE_TRANSFERS";
  ActivityCategory["PURE_ROMANCE"] = "PURE_ROMANCE";
  ActivityCategory["RELIGIOUS_SPIRITUAL_TOURS"] = "RELIGIOUS_SPIRITUAL_TOURS";
  ActivityCategory["RIVER_HARBOUR_CRUISES"] = "RIVER_HARBOUR_CRUISES";
  ActivityCategory["ROMAN_STAYCATION"] = "ROMAN_STAYCATION";
  ActivityCategory["SAFARIS"] = "SAFARIS";
  ActivityCategory["SAILING_TRIPS"] = "SAILING_TRIPS";
  ActivityCategory["SCOOTER_RENTALS"] = "SCOOTER_RENTALS";
  ActivityCategory["SEGWAY_TOURS"] = "SEGWAY_TOURS";
  ActivityCategory["SHARED_TRANSFERS"] = "SHARED_TRANSFERS";
  ActivityCategory["SHARK_DIVING"] = "SHARK_DIVING";
  ActivityCategory["SHOPPING_FASHION"] = "SHOPPING_FASHION";
  ActivityCategory["SHOPPING_PASSES_OFFERS"] = "SHOPPING_PASSES_OFFERS";
  ActivityCategory["SHOPPING_TOURS"] = "SHOPPING_TOURS";
  ActivityCategory["SHORE_EXCURIONS"] = "SHORE_EXCURIONS";
  ActivityCategory["SHOWS_CONCERTS"] = "SHOWS_CONCERTS";
  ActivityCategory["SHOW_SPORT_TICKETS"] = "SHOW_SPORT_TICKETS";
  ActivityCategory["SIGHTSEEING_ATTRACTION_PASSES"] = "SIGHTSEEING_ATTRACTION_PASSES";
  ActivityCategory["SIGHTSEEING_CITY_PASSES"] = "SIGHTSEEING_CITY_PASSES";
  ActivityCategory["SIGHTSEEING_PASSES"] = "SIGHTSEEING_PASSES";
  ActivityCategory["SKIING_RENTALS"] = "SKIING_RENTALS";
  ActivityCategory["SKIP_THE_LINE_TOURS"] = "SKIP_THE_LINE_TOURS";
  ActivityCategory["SNORKELING_SCUBA_DIVING"] = "SNORKELING_SCUBA_DIVING";
  ActivityCategory["SNOWBOARDING_RENTALS"] = "SNOWBOARDING_RENTALS";
  ActivityCategory["SNOWMOBILE_TOURS"] = "SNOWMOBILE_TOURS";
  ActivityCategory["SNOWSHOEING"] = "SNOWSHOEING";
  ActivityCategory["SPA"] = "SPA";
  ActivityCategory["SPA_WELLNESS"] = "SPA_WELLNESS";
  ActivityCategory["SPEED_BOATS_JET_SKIS"] = "SPEED_BOATS_JET_SKIS";
  ActivityCategory["SPORTING_EVENTS_PACKAGES"] = "SPORTING_EVENTS_PACKAGES";
  ActivityCategory["SPORTS_PACKAGES"] = "SPORTS_PACKAGES";
  ActivityCategory["STAY_ACTIVE"] = "STAY_ACTIVE";
  ActivityCategory["SUBMARINE_TOURS"] = "SUBMARINE_TOURS";
  ActivityCategory["SUNSET_CRUISES"] = "SUNSET_CRUISES";
  ActivityCategory["SUPERNATURAL_TOURS"] = "SUPERNATURAL_TOURS";
  ActivityCategory["SUSTAINABLE_TOURS"] = "SUSTAINABLE_TOURS";
  ActivityCategory["SWIM_WITH_DOLPHINS"] = "SWIM_WITH_DOLPHINS";
  ActivityCategory["THEATER_SHOWS_MUSICALS"] = "THEATER_SHOWS_MUSICALS";
  ActivityCategory["THEME_PARKS"] = "THEME_PARKS";
  ActivityCategory["THEME_PARK_TICKETS_TOURS"] = "THEME_PARK_TICKETS_TOURS";
  ActivityCategory["THE_GREAT_OUTDOORS"] = "THE_GREAT_OUTDOORS";
  ActivityCategory["THRILL_SEEKER"] = "THRILL_SEEKER";
  ActivityCategory["TICKETS"] = "TICKETS";
  ActivityCategory["TOURS_ACTIVITIES"] = "TOURS_ACTIVITIES";
  ActivityCategory["TOURS_SIGHTSEEING"] = "TOURS_SIGHTSEEING";
  ActivityCategory["TRANSPORTATION_SERVICES"] = "TRANSPORTATION_SERVICES";
  ActivityCategory["TREAT_YOURSELF"] = "TREAT_YOURSELF";
  ActivityCategory["TUBING"] = "TUBING";
  ActivityCategory["UNIVERSAL_THEME_PARKS"] = "UNIVERSAL_THEME_PARKS";
  ActivityCategory["VALENTINES_DAY"] = "VALENTINES_DAY";
  ActivityCategory["WALKING_BIKE_TOURS"] = "WALKING_BIKE_TOURS";
  ActivityCategory["WALKING_TOURS"] = "WALKING_TOURS";
  ActivityCategory["WATERSKIING_WAKEBOARDING"] = "WATERSKIING_WAKEBOARDING";
  ActivityCategory["WATER_ACTIVITIES"] = "WATER_ACTIVITIES";
  ActivityCategory["WATER_PARKS"] = "WATER_PARKS";
  ActivityCategory["WEDDING_CEREMONIES"] = "WEDDING_CEREMONIES";
  ActivityCategory["WEDDING_HONEYMOON"] = "WEDDING_HONEYMOON";
  ActivityCategory["WEDDING_PACKAGES"] = "WEDDING_PACKAGES";
  ActivityCategory["WEDDING_SHONEYMOONS"] = "WEDDING_SHONEYMOONS";
  ActivityCategory["WHAT_TO_DO_WITH_GROUPS"] = "WHAT_TO_DO_WITH_GROUPS";
  ActivityCategory["WHAT_TO_DO_WITH_KIDS"] = "WHAT_TO_DO_WITH_KIDS";
  ActivityCategory["WHITE_WATER_RAFTING"] = "WHITE_WATER_RAFTING";
  ActivityCategory["WILDLIFE_NATURE"] = "WILDLIFE_NATURE";
  ActivityCategory["WINE_TASTING_WINERY_TOURS"] = "WINE_TASTING_WINERY_TOURS";
  ActivityCategory["WINTER_ACTIVITIES"] = "WINTER_ACTIVITIES";
  ActivityCategory["YOGA_CLASS"] = "YOGA_CLASS";
  ActivityCategory["YOGA_CLASSES"] = "YOGA_CLASSES";
  ActivityCategory["ZOO_TICKETS"] = "ZOO_TICKETS";
  ActivityCategory["ZOO_TICKETS_PASSES"] = "ZOO_TICKETS_PASSES";
})(ActivityCategory || (ActivityCategory = {}));
export var ActivityCategoryType;
(function (ActivityCategoryType) {
  ActivityCategoryType["ACTIVITIES"] = "ACTIVITIES";
  ActivityCategoryType["CATEGORIES"] = "CATEGORIES";
  ActivityCategoryType["DEALS_PROMOTIONS"] = "DEALS_PROMOTIONS";
  ActivityCategoryType["NA"] = "NA";
  ActivityCategoryType["RECOMMENDATIONS"] = "RECOMMENDATIONS";
  ActivityCategoryType["TOURS"] = "TOURS";
  ActivityCategoryType["TRANSPORTATION"] = "TRANSPORTATION";
})(ActivityCategoryType || (ActivityCategoryType = {}));
/** Details view options that are not filters */
export var ActivityDetailViewOptions;
(function (ActivityDetailViewOptions) {
  ActivityDetailViewOptions["NON_CONSOLIDATED_OFFERS"] = "NON_CONSOLIDATED_OFFERS";
  ActivityDetailViewOptions["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
  ActivityDetailViewOptions["THIRD_PARTY_REVIEWS"] = "THIRD_PARTY_REVIEWS";
})(ActivityDetailViewOptions || (ActivityDetailViewOptions = {}));
export var ActivityDiscountType;
(function (ActivityDiscountType) {
  ActivityDiscountType["AIR_ATTACH_MIP"] = "AIR_ATTACH_MIP";
  ActivityDiscountType["AIR_HOTEL_ATTACH_MIP"] = "AIR_HOTEL_ATTACH_MIP";
  ActivityDiscountType["CAMPAIGN_DEAL"] = "CAMPAIGN_DEAL";
  ActivityDiscountType["FREE_ACTIVITY"] = "FREE_ACTIVITY";
  ActivityDiscountType["GUEST"] = "GUEST";
  ActivityDiscountType["HOTEL_ATTACH_MIP"] = "HOTEL_ATTACH_MIP";
  ActivityDiscountType["MIP"] = "MIP";
  ActivityDiscountType["MOD"] = "MOD";
  ActivityDiscountType["STRIKE_OUT"] = "STRIKE_OUT";
})(ActivityDiscountType || (ActivityDiscountType = {}));
export var ActivityGroupType;
(function (ActivityGroupType) {
  ActivityGroupType["ACTIVITY_LIST"] = "ACTIVITY_LIST";
  ActivityGroupType["ACTIVITY_MESSAGE"] = "ACTIVITY_MESSAGE";
  ActivityGroupType["AVAILABLE_TODAY"] = "AVAILABLE_TODAY";
  ActivityGroupType["CATEGORY"] = "CATEGORY";
  ActivityGroupType["FILTERED_ACTIVITIES"] = "FILTERED_ACTIVITIES";
  ActivityGroupType["INTERESTS"] = "INTERESTS";
  ActivityGroupType["KEYWORD_SEARCH"] = "KEYWORD_SEARCH";
  ActivityGroupType["MORE_ACTIVITIES"] = "MORE_ACTIVITIES";
  ActivityGroupType["NEIGHBOURHOOD"] = "NEIGHBOURHOOD";
  ActivityGroupType["PINNED_ACTIVITY"] = "PINNED_ACTIVITY";
  ActivityGroupType["POI"] = "POI";
  ActivityGroupType["RECOMMENDATIONS"] = "RECOMMENDATIONS";
  ActivityGroupType["SLIM_CATEGORY"] = "SLIM_CATEGORY";
  ActivityGroupType["SUB_CATEGORIES"] = "SUB_CATEGORIES";
  ActivityGroupType["SUB_CATEGORY"] = "SUB_CATEGORY";
  ActivityGroupType["SWP_SORT_SECTION"] = "SWP_SORT_SECTION";
  ActivityGroupType["TOP_ACTIVITIES"] = "TOP_ACTIVITIES";
  ActivityGroupType["TRIPS_ACTIVITY_LIST"] = "TRIPS_ACTIVITY_LIST";
  ActivityGroupType["XSELL_RECOMMENDATIONS"] = "XSELL_RECOMMENDATIONS";
})(ActivityGroupType || (ActivityGroupType = {}));
export var ActivityGroupViewType;
(function (ActivityGroupViewType) {
  ActivityGroupViewType["ACTIVITY_LIST"] = "ACTIVITY_LIST";
  ActivityGroupViewType["ACTIVITY_SPANNED_TILE_LIST"] = "ACTIVITY_SPANNED_TILE_LIST";
  ActivityGroupViewType["ACTIVITY_TILES_CAROUSEL"] = "ACTIVITY_TILES_CAROUSEL";
  ActivityGroupViewType["CATEGORY_TILES_CAROUSEL"] = "CATEGORY_TILES_CAROUSEL";
  ActivityGroupViewType["KEYWORD_SEARCH"] = "KEYWORD_SEARCH";
  ActivityGroupViewType["MESSAGE"] = "MESSAGE";
  ActivityGroupViewType["SLIM_CATEGORY_TILES_CAROUSEL"] = "SLIM_CATEGORY_TILES_CAROUSEL";
  ActivityGroupViewType["TEXT"] = "TEXT";
})(ActivityGroupViewType || (ActivityGroupViewType = {}));
export var ActivityMapGroupType;
(function (ActivityMapGroupType) {
  ActivityMapGroupType["POI"] = "POI";
})(ActivityMapGroupType || (ActivityMapGroupType = {}));
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export var ActivityMessageType;
(function (ActivityMessageType) {
  ActivityMessageType["ADDON"] = "ADDON";
  ActivityMessageType["EARN_2X_REWARD_POINTS"] = "EARN_2X_REWARD_POINTS";
  ActivityMessageType["GIFTING_LX_BANNER"] = "GIFTING_LX_BANNER";
  ActivityMessageType["LOGIN"] = "LOGIN";
  ActivityMessageType["SOURCED_CAMPAIGN"] = "SOURCED_CAMPAIGN";
  ActivityMessageType["SUMMER_CAMPAIGN_PRIMARY"] = "SUMMER_CAMPAIGN_PRIMARY";
  ActivityMessageType["SUMMER_CAMPAIGN_SECONDARY"] = "SUMMER_CAMPAIGN_SECONDARY";
})(ActivityMessageType || (ActivityMessageType = {}));
export var ActivityOfferUDSToken;
(function (ActivityOfferUDSToken) {
  ActivityOfferUDSToken["SELECTED"] = "SELECTED";
  ActivityOfferUDSToken["UNSELECTED"] = "UNSELECTED";
})(ActivityOfferUDSToken || (ActivityOfferUDSToken = {}));
/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export var ActivityPageMetaTagType;
(function (ActivityPageMetaTagType) {
  ActivityPageMetaTagType["HTTP_EQUIV"] = "HTTP_EQUIV";
  ActivityPageMetaTagType["NAME"] = "NAME";
  ActivityPageMetaTagType["PROPERTY"] = "PROPERTY";
})(ActivityPageMetaTagType || (ActivityPageMetaTagType = {}));
/** Activity Page Type - infosite */
export var ActivityPageType;
(function (ActivityPageType) {
  ActivityPageType["ACTIVITY_INFO"] = "ACTIVITY_INFO";
})(ActivityPageType || (ActivityPageType = {}));
/** Activity Price types */
export var ActivityPriceType;
(function (ActivityPriceType) {
  ActivityPriceType["GROUP"] = "GROUP";
  ActivityPriceType["NORMAL"] = "NORMAL";
  ActivityPriceType["VOLUME_BASED"] = "VOLUME_BASED";
})(ActivityPriceType || (ActivityPriceType = {}));
export var ActivityRedemptionType;
(function (ActivityRedemptionType) {
  ActivityRedemptionType["PRINT"] = "PRINT";
  ActivityRedemptionType["VOUCHER_LESS"] = "VOUCHER_LESS";
})(ActivityRedemptionType || (ActivityRedemptionType = {}));
export var ActivityReviewSort;
(function (ActivityReviewSort) {
  ActivityReviewSort["HIGHEST_TO_LOWEST_RATED"] = "HIGHEST_TO_LOWEST_RATED";
  ActivityReviewSort["LOWEST_TO_HIGHEST_RATED"] = "LOWEST_TO_HIGHEST_RATED";
  ActivityReviewSort["NEWEST_TO_OLDEST"] = "NEWEST_TO_OLDEST";
})(ActivityReviewSort || (ActivityReviewSort = {}));
/** Search options that are not filters */
export var ActivitySearchOptions;
(function (ActivitySearchOptions) {
  ActivitySearchOptions["CATEGORY"] = "CATEGORY";
  ActivitySearchOptions["FILTER_NESTED_CATEGORIES"] = "FILTER_NESTED_CATEGORIES";
  ActivitySearchOptions["GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER"] = "GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER";
  ActivitySearchOptions["GIFTING_ACTIVITIES"] = "GIFTING_ACTIVITIES";
  ActivitySearchOptions["GUEST_PROMO"] = "GUEST_PROMO";
  ActivitySearchOptions["NON_CONSOLIDATED_OFFERS"] = "NON_CONSOLIDATED_OFFERS";
  ActivitySearchOptions["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
  ActivitySearchOptions["SHOW_GT_BANNER"] = "SHOW_GT_BANNER";
})(ActivitySearchOptions || (ActivitySearchOptions = {}));
/** Search view options that are not filters */
export var ActivitySearchViewOptions;
(function (ActivitySearchViewOptions) {
  ActivitySearchViewOptions["DISTANCE_FROM_HOTEL_TO_ACTIVITY"] = "DISTANCE_FROM_HOTEL_TO_ACTIVITY";
  ActivitySearchViewOptions["FILTER_NESTED_CATEGORIES"] = "FILTER_NESTED_CATEGORIES";
  ActivitySearchViewOptions["NEARBY_ACTIVITIES"] = "NEARBY_ACTIVITIES";
  ActivitySearchViewOptions["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
  ActivitySearchViewOptions["SHOW_GT_BANNER"] = "SHOW_GT_BANNER";
  ActivitySearchViewOptions["THIRD_PARTY_REVIEWS"] = "THIRD_PARTY_REVIEWS";
  ActivitySearchViewOptions["TRAVEL_DISTANCE_FROM_HOTEL"] = "TRAVEL_DISTANCE_FROM_HOTEL";
})(ActivitySearchViewOptions || (ActivitySearchViewOptions = {}));
/** Activity sort types */
export var ActivitySort;
(function (ActivitySort) {
  ActivitySort["CAMPAIGN_DEALS"] = "CAMPAIGN_DEALS";
  ActivitySort["DISCOUNT"] = "DISCOUNT";
  ActivitySort["DISTANCE_FROM_HOTEL"] = "DISTANCE_FROM_HOTEL";
  ActivitySort["PRICE_HIGH_TO_LOW"] = "PRICE_HIGH_TO_LOW";
  ActivitySort["PRICE_LOW_TO_HIGH"] = "PRICE_LOW_TO_HIGH";
  ActivitySort["RECOMMENDED"] = "RECOMMENDED";
})(ActivitySort || (ActivitySort = {}));
export var ActivityTextAlignment;
(function (ActivityTextAlignment) {
  ActivityTextAlignment["CENTRE"] = "CENTRE";
  ActivityTextAlignment["LEFT"] = "LEFT";
  ActivityTextAlignment["RIGHT"] = "RIGHT";
})(ActivityTextAlignment || (ActivityTextAlignment = {}));
export var ActivityTextSize;
(function (ActivityTextSize) {
  ActivityTextSize["LARGE"] = "LARGE";
  ActivityTextSize["MEDIUM"] = "MEDIUM";
  ActivityTextSize["SMALL"] = "SMALL";
})(ActivityTextSize || (ActivityTextSize = {}));
export var ActivityUDSToken;
(function (ActivityUDSToken) {
  ActivityUDSToken["MULTI_SELECT_LIST"] = "MULTI_SELECT_LIST";
  ActivityUDSToken["MULTI_SELECT_RANGE"] = "MULTI_SELECT_RANGE";
  ActivityUDSToken["SINGLE_SELECT"] = "SINGLE_SELECT";
  ActivityUDSToken["TEXT"] = "TEXT";
})(ActivityUDSToken || (ActivityUDSToken = {}));
/** Represents values for add ons */
export var AddOnRequested;
(function (AddOnRequested) {
  AddOnRequested["CB1"] = "CB1";
  AddOnRequested["COB"] = "COB";
  AddOnRequested["SC"] = "SC";
})(AddOnRequested || (AddOnRequested = {}));
export var AdditionalShoppedAncillaries;
(function (AdditionalShoppedAncillaries) {
  AdditionalShoppedAncillaries["FIRST_CHECKED_BAG"] = "FIRST_CHECKED_BAG";
})(AdditionalShoppedAncillaries || (AdditionalShoppedAncillaries = {}));
export var AdditionalShopping;
(function (AdditionalShopping) {
  AdditionalShopping["FIRST_CHECKED_BAG"] = "FIRST_CHECKED_BAG";
})(AdditionalShopping || (AdditionalShopping = {}));
export var AffiliatesChannelType;
(function (AffiliatesChannelType) {
  AffiliatesChannelType["ANDROID"] = "ANDROID";
  AffiliatesChannelType["IOS"] = "IOS";
  AffiliatesChannelType["WEB"] = "WEB";
})(AffiliatesChannelType || (AffiliatesChannelType = {}));
export var AffiliatesCheckFailureType;
(function (AffiliatesCheckFailureType) {
  AffiliatesCheckFailureType["PARTNER_NOT_LINKED"] = "PARTNER_NOT_LINKED";
  AffiliatesCheckFailureType["STATUS_NOT_APPROVED"] = "STATUS_NOT_APPROVED";
  AffiliatesCheckFailureType["TOOL_DISABLED"] = "TOOL_DISABLED";
})(AffiliatesCheckFailureType || (AffiliatesCheckFailureType = {}));
export var AgencyBusinessModel;
(function (AgencyBusinessModel) {
  AgencyBusinessModel["EXPEDIA_COLLECT"] = "EXPEDIA_COLLECT";
  AgencyBusinessModel["HOTEL_COLLECT"] = "HOTEL_COLLECT";
})(AgencyBusinessModel || (AgencyBusinessModel = {}));
/** Parameters for header cells for the records to be sorted in ascending, descending or to be unsorted manner */
export var AgencyQuoteListSortType;
(function (AgencyQuoteListSortType) {
  AgencyQuoteListSortType["ASCENDING"] = "ASCENDING";
  AgencyQuoteListSortType["DESCENDING"] = "DESCENDING";
  AgencyQuoteListSortType["NOT_SORTED"] = "NOT_SORTED";
})(AgencyQuoteListSortType || (AgencyQuoteListSortType = {}));
export var AgentStateType;
(function (AgentStateType) {
  AgentStateType["NotReady"] = "NotReady";
  AgentStateType["Offline"] = "Offline";
  AgentStateType["Ready"] = "Ready";
})(AgentStateType || (AgentStateType = {}));
export var AgentToolsLodgingActionType;
(function (AgentToolsLodgingActionType) {
  AgentToolsLodgingActionType["Cancel"] = "Cancel";
  AgentToolsLodgingActionType["ComboChange"] = "ComboChange";
  AgentToolsLodgingActionType["OccupancyChange"] = "OccupancyChange";
  AgentToolsLodgingActionType["RoomTypeChange"] = "RoomTypeChange";
})(AgentToolsLodgingActionType || (AgentToolsLodgingActionType = {}));
export var AgentToolsReasonUpdateType;
(function (AgentToolsReasonUpdateType) {
  AgentToolsReasonUpdateType["CANCEL_INSIDE_PENALTY"] = "CANCEL_INSIDE_PENALTY";
  AgentToolsReasonUpdateType["CANCEL_OUTSIDE_PENALTY"] = "CANCEL_OUTSIDE_PENALTY";
  AgentToolsReasonUpdateType["CHANGE_INSIDE_PENALTY"] = "CHANGE_INSIDE_PENALTY";
  AgentToolsReasonUpdateType["CHANGE_OUTSIDE_PENALTY"] = "CHANGE_OUTSIDE_PENALTY";
})(AgentToolsReasonUpdateType || (AgentToolsReasonUpdateType = {}));
export var AgentToolsRefundChargeSource;
(function (AgentToolsRefundChargeSource) {
  AgentToolsRefundChargeSource["EXPEDIA"] = "EXPEDIA";
  AgentToolsRefundChargeSource["SUPPLIER"] = "SUPPLIER";
})(AgentToolsRefundChargeSource || (AgentToolsRefundChargeSource = {}));
export var AgentToolsSummaryCardComponentType;
(function (AgentToolsSummaryCardComponentType) {
  AgentToolsSummaryCardComponentType["FLIGHT_CANCEL"] = "FLIGHT_CANCEL";
  AgentToolsSummaryCardComponentType["LODGING_CANCEL"] = "LODGING_CANCEL";
  AgentToolsSummaryCardComponentType["LODGING_CHANGE"] = "LODGING_CHANGE";
  AgentToolsSummaryCardComponentType["LODGING_REFUND"] = "LODGING_REFUND";
})(AgentToolsSummaryCardComponentType || (AgentToolsSummaryCardComponentType = {}));
/** Airport location type chosen in flight search. */
export var AirportLocationType;
(function (AirportLocationType) {
  AirportLocationType["AIRPORT"] = "AIRPORT";
  AirportLocationType["METROCODE"] = "METROCODE";
  AirportLocationType["UNSPECIFIED"] = "UNSPECIFIED";
})(AirportLocationType || (AirportLocationType = {}));
export var Alignment;
(function (Alignment) {
  Alignment["CENTER"] = "CENTER";
  Alignment["LEFT"] = "LEFT";
  Alignment["RIGHT"] = "RIGHT";
})(Alignment || (Alignment = {}));
/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export var AlterMode;
(function (AlterMode) {
  /** Localization messages will be replaced with their namespace and loc key. */
  AlterMode["DEBUG"] = "DEBUG";
  /** None of the ALTER experiments will be used when resolving localization messages. */
  AlterMode["NONE"] = "NONE";
  /** Both released and draft ALTER experiments will be used when resolving localization messages. */
  AlterMode["PREVIEW"] = "PREVIEW";
  /** This is the default. Only released ALTER experiments will be used when resolving localization messages. */
  AlterMode["RELEASED"] = "RELEASED";
})(AlterMode || (AlterMode = {}));
/** List of all the managed link type. */
export var AlternativeLinkType;
(function (AlternativeLinkType) {
  AlternativeLinkType["ALTERNATIVE_ACCOMMODATION"] = "ALTERNATIVE_ACCOMMODATION";
  AlternativeLinkType["ALTERNATIVE_LOBS"] = "ALTERNATIVE_LOBS";
})(AlternativeLinkType || (AlternativeLinkType = {}));
export var AmenityCategory;
(function (AmenityCategory) {
  AmenityCategory["ACCESSIBLE_ROLL_IN_SHOWER"] = "ACCESSIBLE_ROLL_IN_SHOWER";
  AmenityCategory["AIR_CONDITIONING"] = "AIR_CONDITIONING";
  AmenityCategory["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  AmenityCategory["ARCADE"] = "ARCADE";
  AmenityCategory["BABYSITTING"] = "BABYSITTING";
  AmenityCategory["BAR"] = "BAR";
  AmenityCategory["BARBECUE"] = "BARBECUE";
  AmenityCategory["BOWLING"] = "BOWLING";
  AmenityCategory["BREAKFAST_AVAILABLE"] = "BREAKFAST_AVAILABLE";
  AmenityCategory["BREAKFAST_INCLUDED"] = "BREAKFAST_INCLUDED";
  AmenityCategory["BREAKFAST_NOT_AVAILABLE"] = "BREAKFAST_NOT_AVAILABLE";
  AmenityCategory["BUSINESS_SERVICES"] = "BUSINESS_SERVICES";
  AmenityCategory["CHILDREN_CLUB"] = "CHILDREN_CLUB";
  AmenityCategory["DAILY_HOUSEKEEPING"] = "DAILY_HOUSEKEEPING";
  AmenityCategory["EXTRA_BED"] = "EXTRA_BED";
  AmenityCategory["FIRE_PLACE"] = "FIRE_PLACE";
  AmenityCategory["FITNESS_EQUIPMENT"] = "FITNESS_EQUIPMENT";
  AmenityCategory["FREE_AIRPORT_TRANSPORTATION"] = "FREE_AIRPORT_TRANSPORTATION";
  AmenityCategory["FREE_BREAKFAST"] = "FREE_BREAKFAST";
  AmenityCategory["FREE_CANCEL"] = "FREE_CANCEL";
  AmenityCategory["FREE_PARKING"] = "FREE_PARKING";
  AmenityCategory["FREE_WELCOME_DRINK"] = "FREE_WELCOME_DRINK";
  AmenityCategory["FREE_WIRED_INTERNET"] = "FREE_WIRED_INTERNET";
  AmenityCategory["FRONT_DESK_24_HOURS"] = "FRONT_DESK_24_HOURS";
  AmenityCategory["GROCERY"] = "GROCERY";
  AmenityCategory["HIGH_SPEED_INTERNET"] = "HIGH_SPEED_INTERNET";
  AmenityCategory["HOT_TUB"] = "HOT_TUB";
  AmenityCategory["INTERNET_NOT_AVAILABLE"] = "INTERNET_NOT_AVAILABLE";
  AmenityCategory["IN_ROOM_INTERNET"] = "IN_ROOM_INTERNET";
  AmenityCategory["KIDS_POOL"] = "KIDS_POOL";
  AmenityCategory["KITCHEN"] = "KITCHEN";
  AmenityCategory["LAUNDRY"] = "LAUNDRY";
  AmenityCategory["LIVING_AREA"] = "LIVING_AREA";
  AmenityCategory["MICROWAVE"] = "MICROWAVE";
  AmenityCategory["MINI_GOLF"] = "MINI_GOLF";
  AmenityCategory["NON_REFUNDABLE"] = "NON_REFUNDABLE";
  AmenityCategory["ON_PRIVATE_BEACH"] = "ON_PRIVATE_BEACH";
  AmenityCategory["ON_THE_BEACH"] = "ON_THE_BEACH";
  AmenityCategory["OUTDOOR_SPACE"] = "OUTDOOR_SPACE";
  AmenityCategory["PARKING"] = "PARKING";
  AmenityCategory["PARTIAL_REFUND"] = "PARTIAL_REFUND";
  AmenityCategory["PETS_ALLOWED"] = "PETS_ALLOWED";
  AmenityCategory["PLAYGROUND"] = "PLAYGROUND";
  AmenityCategory["POOL"] = "POOL";
  AmenityCategory["RESERVE_NOW_PAY_DEPOSIT"] = "RESERVE_NOW_PAY_DEPOSIT";
  AmenityCategory["RESERVE_NOW_PAY_LATER"] = "RESERVE_NOW_PAY_LATER";
  AmenityCategory["RESTAURANT_IN_HOTEL"] = "RESTAURANT_IN_HOTEL";
  AmenityCategory["ROOM_SERVICE"] = "ROOM_SERVICE";
  AmenityCategory["SMOKE_FREE"] = "SMOKE_FREE";
  AmenityCategory["SOUNDPROOF_ROOM"] = "SOUNDPROOF_ROOM";
  AmenityCategory["SPA_SERVICES_ON_SITE"] = "SPA_SERVICES_ON_SITE";
  AmenityCategory["SPECIAL_DEAL"] = "SPECIAL_DEAL";
  AmenityCategory["TENNIS_COURT"] = "TENNIS_COURT";
  AmenityCategory["TOYS"] = "TOYS";
  AmenityCategory["WASHER"] = "WASHER";
  AmenityCategory["WATERSLIDE"] = "WATERSLIDE";
  AmenityCategory["WIFI_SURCHARGE"] = "WIFI_SURCHARGE";
  AmenityCategory["WIRED_INTERNET_SURCHARGE"] = "WIRED_INTERNET_SURCHARGE";
})(AmenityCategory || (AmenityCategory = {}));
export var AmenityFilter;
(function (AmenityFilter) {
  AmenityFilter["CARRY_ON_BAG"] = "CARRY_ON_BAG";
  AmenityFilter["INVALID"] = "INVALID";
  AmenityFilter["NO_CANCEL_FEE"] = "NO_CANCEL_FEE";
  AmenityFilter["NO_CHANGE_FEE"] = "NO_CHANGE_FEE";
  AmenityFilter["SEAT_CHOICE"] = "SEAT_CHOICE";
})(AmenityFilter || (AmenityFilter = {}));
/** represents the bag template analytics keys */
export var AnalyticsKey;
(function (AnalyticsKey) {
  /** Represents the analytics key for number of bags per traveller */
  AnalyticsKey["NUMBER_OF_BAGS"] = "NUMBER_OF_BAGS";
  /** Represents the analytics key for piece or weight selling model criteria analytics per traveller */
  AnalyticsKey["PIECE_OR_WEIGHT_CONCEPT"] = "PIECE_OR_WEIGHT_CONCEPT";
  /** Represents the analytics key for quantity of bags per traveller (NONE/SOME/ALL) */
  AnalyticsKey["QUANTITY_OF_BAGS"] = "QUANTITY_OF_BAGS";
})(AnalyticsKey || (AnalyticsKey = {}));
/** Represents path plus page for where ancillaries will be shopped. */
export var AncillaryShoppingPath;
(function (AncillaryShoppingPath) {
  AncillaryShoppingPath["PACKAGE_INFOSITE"] = "PACKAGE_INFOSITE";
  AncillaryShoppingPath["PACKAGE_TRIPS"] = "PACKAGE_TRIPS";
  AncillaryShoppingPath["STANDALONE_INFOSITE"] = "STANDALONE_INFOSITE";
  AncillaryShoppingPath["STANDALONE_TRIPS"] = "STANDALONE_TRIPS";
})(AncillaryShoppingPath || (AncillaryShoppingPath = {}));
export var AppGrowthBorderShape;
(function (AppGrowthBorderShape) {
  AppGrowthBorderShape["ROUNDED"] = "ROUNDED";
  AppGrowthBorderShape["SQUARE"] = "SQUARE";
})(AppGrowthBorderShape || (AppGrowthBorderShape = {}));
export var AppGrowthBorderStyle;
(function (AppGrowthBorderStyle) {
  AppGrowthBorderStyle["BOLD"] = "BOLD";
  AppGrowthBorderStyle["DEFAULT"] = "DEFAULT";
  AppGrowthBorderStyle["NONE"] = "NONE";
})(AppGrowthBorderStyle || (AppGrowthBorderStyle = {}));
export var AppGrowthToolbarIcon;
(function (AppGrowthToolbarIcon) {
  AppGrowthToolbarIcon["BACK"] = "BACK";
  AppGrowthToolbarIcon["CLOSE"] = "CLOSE";
})(AppGrowthToolbarIcon || (AppGrowthToolbarIcon = {}));
export var AppGrowthToolbarStyle;
(function (AppGrowthToolbarStyle) {
  AppGrowthToolbarStyle["TRANSPARENT_ACTION_OVERLAY"] = "TRANSPARENT_ACTION_OVERLAY";
})(AppGrowthToolbarStyle || (AppGrowthToolbarStyle = {}));
/** type of action being performed */
export var AppGrowthUIActionName;
(function (AppGrowthUIActionName) {
  /** accept - used for notification prompt */
  AppGrowthUIActionName["ACCEPT"] = "ACCEPT";
  /** should perform a deeplink action */
  AppGrowthUIActionName["DEEPLINK"] = "DEEPLINK";
  /** deny - used for notification prompt */
  AppGrowthUIActionName["DENY"] = "DENY";
  /** exit travel trivia to app home */
  AppGrowthUIActionName["EXIT_TO_APP_HOME"] = "EXIT_TO_APP_HOME";
  /** go to dashboard action */
  AppGrowthUIActionName["GOTO_DASHBOARD"] = "GOTO_DASHBOARD";
  /** login and signup */
  AppGrowthUIActionName["LOGIN_AND_SIGNUP"] = "LOGIN_AND_SIGNUP";
  /** no action to perform - used then object sometimes has an action and other times doesn't */
  AppGrowthUIActionName["NONE"] = "NONE";
  /** ok action */
  AppGrowthUIActionName["OK"] = "OK";
  /** share action */
  AppGrowthUIActionName["SHARE"] = "SHARE";
  /** signup for travel trivia campaign */
  AppGrowthUIActionName["SIGNUP"] = "SIGNUP";
  /** submit trivia answer */
  AppGrowthUIActionName["TRIVIA_ANSWER"] = "TRIVIA_ANSWER";
  /** finish the trivia */
  AppGrowthUIActionName["TRIVIA_END"] = "TRIVIA_END";
  /** go to trivia how to play */
  AppGrowthUIActionName["TRIVIA_HOW_TO"] = "TRIVIA_HOW_TO";
  /** move to next trivia question */
  AppGrowthUIActionName["TRIVIA_NEXT"] = "TRIVIA_NEXT";
  /** go to trivia start */
  AppGrowthUIActionName["TRIVIA_START"] = "TRIVIA_START";
})(AppGrowthUIActionName || (AppGrowthUIActionName = {}));
/** Possible aspect ratios of EGDS images */
export var AspectRatio;
(function (AspectRatio) {
  /** Aspect ratio 4:1 */
  AspectRatio["FOUR_ONE"] = "FOUR_ONE";
  /** Aspect ratio 4:3 */
  AspectRatio["FOUR_THREE"] = "FOUR_THREE";
  /** Aspect ratio 1:1 */
  AspectRatio["ONE_ONE"] = "ONE_ONE";
  /** Aspect ratio 16:9 */
  AspectRatio["SIXTEEN_NINE"] = "SIXTEEN_NINE";
  /** Aspect ratio 3:4 */
  AspectRatio["THREE_FOUR"] = "THREE_FOUR";
  /** Aspect ratio 3:2 */
  AspectRatio["THREE_TWO"] = "THREE_TWO";
  /** Aspect ratio 21:9 */
  AspectRatio["TWENTY_ONE_NINE"] = "TWENTY_ONE_NINE";
})(AspectRatio || (AspectRatio = {}));
export var AtoChallengePlacement;
(function (AtoChallengePlacement) {
  AtoChallengePlacement["DirectFeedbackSubmitFormAction"] = "DirectFeedbackSubmitFormAction";
})(AtoChallengePlacement || (AtoChallengePlacement = {}));
export var AuthenticationState;
(function (AuthenticationState) {
  AuthenticationState["ANONYMOUS"] = "ANONYMOUS";
  AuthenticationState["AUTHENTICATED"] = "AUTHENTICATED";
  AuthenticationState["IDENTIFIED"] = "IDENTIFIED";
})(AuthenticationState || (AuthenticationState = {}));
/** Background styles for the cards */
export var BackgroundType;
(function (BackgroundType) {
  BackgroundType["PRIMARY"] = "PRIMARY";
  BackgroundType["SECONDARY"] = "SECONDARY";
})(BackgroundType || (BackgroundType = {}));
export var BadgeIcon;
(function (BadgeIcon) {
  BadgeIcon["ACCESS_TIME"] = "ACCESS_TIME";
  BadgeIcon["ADD"] = "ADD";
  BadgeIcon["BUNDLED_SAVINGS_PLUS"] = "BUNDLED_SAVINGS_PLUS";
  BadgeIcon["EXP29639_ORB"] = "EXP29639_ORB";
  BadgeIcon["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
  BadgeIcon["INFO_OUTLINE"] = "INFO_OUTLINE";
  BadgeIcon["LOB_DEALS"] = "LOB_DEALS";
  BadgeIcon["LOCAL_OFFER"] = "LOCAL_OFFER";
  BadgeIcon["MOD"] = "MOD";
  BadgeIcon["SMARTPHONE"] = "SMARTPHONE";
})(BadgeIcon || (BadgeIcon = {}));
/** Represents the quantity of bags to be sent in analytics none/some/all */
export var BagsSelectionType;
(function (BagsSelectionType) {
  BagsSelectionType["ALL"] = "ALL";
  BagsSelectionType["NONE"] = "NONE";
  BagsSelectionType["SOME"] = "SOME";
})(BagsSelectionType || (BagsSelectionType = {}));
export var BannerDisplayType;
(function (BannerDisplayType) {
  BannerDisplayType["ERROR"] = "ERROR";
  BannerDisplayType["INFO"] = "INFO";
  BannerDisplayType["NO_BANNER"] = "NO_BANNER";
  BannerDisplayType["WARN"] = "WARN";
})(BannerDisplayType || (BannerDisplayType = {}));
export var BannerTheme;
(function (BannerTheme) {
  BannerTheme["BRAND_PROMO_PRIMARY"] = "BRAND_PROMO_PRIMARY";
  BannerTheme["PRIMARY"] = "PRIMARY";
  BannerTheme["SECONDARY"] = "SECONDARY";
})(BannerTheme || (BannerTheme = {}));
/** The path for cancellation that will be performed by the traveler */
export var BookingServicingCancelType;
(function (BookingServicingCancelType) {
  /** Represents the type for Involuntary/ASC Cancel */
  BookingServicingCancelType["INVOLUNTARY"] = "INVOLUNTARY";
  /** Represents the type for Voluntary Cancel */
  BookingServicingCancelType["VOLUNTARY"] = "VOLUNTARY";
})(BookingServicingCancelType || (BookingServicingCancelType = {}));
export var BookingServicingCardTheme;
(function (BookingServicingCardTheme) {
  BookingServicingCardTheme["NEGATIVE"] = "NEGATIVE";
})(BookingServicingCardTheme || (BookingServicingCardTheme = {}));
export var BookingServicingClient;
(function (BookingServicingClient) {
  /** Represents virtual agent domain */
  BookingServicingClient["VIRTUAL_AGENT"] = "VIRTUAL_AGENT";
  /** Represents VNEXT domain */
  BookingServicingClient["VNEXT"] = "VNEXT";
  /** Represents web domain */
  BookingServicingClient["WEB"] = "WEB";
})(BookingServicingClient || (BookingServicingClient = {}));
/** Target of the Link when clicked */
export var BookingServicingLinkTarget;
(function (BookingServicingLinkTarget) {
  /** Link will be opened in an external view e.g. new tab or browser window */
  BookingServicingLinkTarget["EXTERNAL"] = "EXTERNAL";
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  BookingServicingLinkTarget["INTERNAL"] = "INTERNAL";
})(BookingServicingLinkTarget || (BookingServicingLinkTarget = {}));
/** Booking servicing toolbar navigation type */
export var BookingServicingToolbarNavigationType;
(function (BookingServicingToolbarNavigationType) {
  /** Represents the toolbar with a back button */
  BookingServicingToolbarNavigationType["BACK"] = "BACK";
  /** Represents the toolbar with a back button that triggers a dialog */
  BookingServicingToolbarNavigationType["BACK_DIALOG"] = "BACK_DIALOG";
  /** Represents the toolbar with a close button */
  BookingServicingToolbarNavigationType["CLOSE"] = "CLOSE";
  /** Represents the toolbar with a expand less button */
  BookingServicingToolbarNavigationType["EXPAND_LESS"] = "EXPAND_LESS";
  /** Represents the toolbar with a expand up button */
  BookingServicingToolbarNavigationType["EXPAND_UP"] = "EXPAND_UP";
})(BookingServicingToolbarNavigationType || (BookingServicingToolbarNavigationType = {}));
/** Booking servicing toolbar type */
export var BookingServicingToolbarType;
(function (BookingServicingToolbarType) {
  /** Represents the standard type */
  BookingServicingToolbarType["STANDARD"] = "STANDARD";
  /** Represents the transparent type */
  BookingServicingToolbarType["TRANSPARENT"] = "TRANSPARENT";
})(BookingServicingToolbarType || (BookingServicingToolbarType = {}));
export var BookingServicingTravelerType;
(function (BookingServicingTravelerType) {
  BookingServicingTravelerType["ADULT"] = "ADULT";
  BookingServicingTravelerType["CHILD"] = "CHILD";
  BookingServicingTravelerType["INFANT"] = "INFANT";
})(BookingServicingTravelerType || (BookingServicingTravelerType = {}));
/** The type of input validation that will be performed on the traveler input */
export var BookingServicingTravelerValidationType;
(function (BookingServicingTravelerValidationType) {
  /** Represents the type of validation when a child is traveling alone without an adult */
  BookingServicingTravelerValidationType["CHILD_TRAVELING_ALONE"] = "CHILD_TRAVELING_ALONE";
})(BookingServicingTravelerValidationType || (BookingServicingTravelerValidationType = {}));
export var BooleanEnum;
(function (BooleanEnum) {
  BooleanEnum["FALSE"] = "FALSE";
  BooleanEnum["TRUE"] = "TRUE";
})(BooleanEnum || (BooleanEnum = {}));
export var BulkEditResponseType;
(function (BulkEditResponseType) {
  BulkEditResponseType["SUCCESS"] = "SUCCESS";
  BulkEditResponseType["ERROR"] = "ERROR";
})(BulkEditResponseType || (BulkEditResponseType = {}));
export var BulletStyle;
(function (BulletStyle) {
  BulletStyle["DEFAULT"] = "DEFAULT";
  BulletStyle["ICON_ALTERNATE"] = "ICON_ALTERNATE";
  BulletStyle["ICON_STANDARD"] = "ICON_STANDARD";
  BulletStyle["NO_BULLET"] = "NO_BULLET";
  BulletStyle["UNRECOGNIZED"] = "UNRECOGNIZED";
})(BulletStyle || (BulletStyle = {}));
/** Indicate the business model type of a given offer */
export var BusinessModelType;
(function (BusinessModelType) {
  BusinessModelType["EXPEDIA_COLLECT"] = "EXPEDIA_COLLECT";
  BusinessModelType["HOTEL_COLLECT"] = "HOTEL_COLLECT";
})(BusinessModelType || (BusinessModelType = {}));
export var CampaignOfferBadgeType;
(function (CampaignOfferBadgeType) {
  CampaignOfferBadgeType["DEFAULT"] = "DEFAULT";
  CampaignOfferBadgeType["DISCOUNT"] = "DISCOUNT";
})(CampaignOfferBadgeType || (CampaignOfferBadgeType = {}));
export var CampaignProductType;
(function (CampaignProductType) {
  CampaignProductType["ACTIVITY"] = "ACTIVITY";
  CampaignProductType["FLIGHT"] = "FLIGHT";
  CampaignProductType["HOTEL"] = "HOTEL";
  CampaignProductType["PACKAGE"] = "PACKAGE";
})(CampaignProductType || (CampaignProductType = {}));
export var CarAccessorySelectionState;
(function (CarAccessorySelectionState) {
  CarAccessorySelectionState["NOT_SELECTED"] = "NOT_SELECTED";
  CarAccessorySelectionState["SELECTED"] = "SELECTED";
})(CarAccessorySelectionState || (CarAccessorySelectionState = {}));
export var CarActionType;
(function (CarActionType) {
  /** Apply loyalty points to offer */
  CarActionType["APPLY_LOYALTY_POINTS"] = "APPLY_LOYALTY_POINTS";
  /** Click map marker */
  CarActionType["CAR_MAP_MARKER"] = "CAR_MAP_MARKER";
  /** Change Search */
  CarActionType["CHANGE_SEARCH"] = "CHANGE_SEARCH";
  /** Dismisses a dialog */
  CarActionType["DISMISS"] = "DISMISS";
  /** Click to filter car sales */
  CarActionType["FILTER_SALE_OFFER"] = "FILTER_SALE_OFFER";
  /** Submit content to server */
  CarActionType["FORM_SUBMISSION"] = "FORM_SUBMISSION";
  /** Go back to search page to see all cars */
  CarActionType["GO_BACK_TO_SEARCH"] = "GO_BACK_TO_SEARCH";
  /** Open cancellation policy link */
  CarActionType["GO_TO_CANCELLATION_POLICY"] = "GO_TO_CANCELLATION_POLICY";
  /** Continues to the standalone details page */
  CarActionType["GO_TO_CHECKOUT"] = "GO_TO_CHECKOUT";
  /** Open dialog to see cleaning and safety practices */
  CarActionType["GO_TO_CLEANLINESS_DIALOG"] = "GO_TO_CLEANLINESS_DIALOG";
  /** Open Delta Campaign page */
  CarActionType["GO_TO_DELTA_CAMPAIGN_LINK"] = "GO_TO_DELTA_CAMPAIGN_LINK";
  /** Continues to the standalone details page */
  CarActionType["GO_TO_DETAILS"] = "GO_TO_DETAILS";
  /** Continues to the packages path */
  CarActionType["GO_TO_PACKAGES"] = "GO_TO_PACKAGES";
  /** Open recommended sort FAQ page */
  CarActionType["GO_TO_RECOMMENDED_SORT_FAQ"] = "GO_TO_RECOMMENDED_SORT_FAQ";
  /** Continues to the user sign in page */
  CarActionType["GO_TO_SIGNIN"] = "GO_TO_SIGNIN";
  /** Continues to the user sign up page */
  CarActionType["GO_TO_SIGNUP"] = "GO_TO_SIGNUP";
  /** Click to sign in and unlock car sales */
  CarActionType["GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES"] = "GO_TO_SIGN_IN_AND_UNLOCK_CAR_SALES";
  /** Open Walmart plus member trial page */
  CarActionType["GO_TO_WPLUS_MEMBER_TRIAL_LINK"] = "GO_TO_WPLUS_MEMBER_TRIAL_LINK";
  /** Load more results to search page */
  CarActionType["LOAD_MORE"] = "LOAD_MORE";
  /** Change Search */
  CarActionType["OFF_AIRPORT_CHANGE_SEARCH"] = "OFF_AIRPORT_CHANGE_SEARCH";
  /** Opens a dialog */
  CarActionType["OPEN_DIALOG"] = "OPEN_DIALOG";
  /** Open merchant rules in iframe */
  CarActionType["OPEN_DOC"] = "OPEN_DOC";
  /** Open ground transfers page */
  CarActionType["OPEN_GROUND_TRANSFERS"] = "OPEN_GROUND_TRANSFERS";
  /** Opens the inline time wizard */
  CarActionType["OPEN_INLINE_TIME_WIZARD"] = "OPEN_INLINE_TIME_WIZARD";
  /** Opens the inline search wizard */
  CarActionType["OPEN_INLINE_WIZARD"] = "OPEN_INLINE_WIZARD";
  /** Opens a new tab */
  CarActionType["OPEN_NEW_TAB"] = "OPEN_NEW_TAB";
  /** Opens on current tab */
  CarActionType["OPEN_ON_CURRENT_TAB"] = "OPEN_ON_CURRENT_TAB";
  /** Open Partner Messaging Link */
  CarActionType["OPEN_PARTNER_MESSAGING_LINK"] = "OPEN_PARTNER_MESSAGING_LINK";
  /** Open vendor rules from domain rules */
  CarActionType["OPEN_RULE"] = "OPEN_RULE";
  /** Used to open Telephone Link */
  CarActionType["OPEN_TEL"] = "OPEN_TEL";
  /** Refreshes the current page */
  CarActionType["REFRESH"] = "REFRESH";
  /** Remove loyalty points to offer */
  CarActionType["REMOVE_LOYALTY_POINTS"] = "REMOVE_LOYALTY_POINTS";
  /** Click see cars on map marker item card */
  CarActionType["SEE_CARS_AT_MAP_MARKER"] = "SEE_CARS_AT_MAP_MARKER";
  /** Open share feedback form */
  CarActionType["SHARE_FEEDBACK"] = "SHARE_FEEDBACK";
  /** Show offers with AARP Exclusive benefits */
  CarActionType["SHOW_AARP_EXCLUSIVE_OFFERS"] = "SHOW_AARP_EXCLUSIVE_OFFERS";
  /** Show offers with free cancellations */
  CarActionType["SHOW_FREE_CANCELLATION_OFFERS"] = "SHOW_FREE_CANCELLATION_OFFERS";
  /** Click to unlock car sales */
  CarActionType["UNLOCK_CAR_SALES"] = "UNLOCK_CAR_SALES";
})(CarActionType || (CarActionType = {}));
export var CarFormatStyle;
(function (CarFormatStyle) {
  CarFormatStyle["IFRAME"] = "IFRAME";
  CarFormatStyle["LIST"] = "LIST";
})(CarFormatStyle || (CarFormatStyle = {}));
export var CarMapMarkerType;
(function (CarMapMarkerType) {
  CarMapMarkerType["CarMarker"] = "CarMarker";
  CarMapMarkerType["PlaceMarker"] = "PlaceMarker";
})(CarMapMarkerType || (CarMapMarkerType = {}));
export var CarRouteType;
(function (CarRouteType) {
  CarRouteType["ONEWAY"] = "ONEWAY";
  CarRouteType["ROUNDTRIP"] = "ROUNDTRIP";
})(CarRouteType || (CarRouteType = {}));
/** Represents name and code for each car brand. */
export var CarSearchFormPreferredBrand;
(function (CarSearchFormPreferredBrand) {
  CarSearchFormPreferredBrand["AC"] = "AC";
  CarSearchFormPreferredBrand["AD"] = "AD";
  CarSearchFormPreferredBrand["AL"] = "AL";
  CarSearchFormPreferredBrand["EP"] = "EP";
  CarSearchFormPreferredBrand["ET"] = "ET";
  CarSearchFormPreferredBrand["EY"] = "EY";
  CarSearchFormPreferredBrand["FX"] = "FX";
  CarSearchFormPreferredBrand["GI"] = "GI";
  CarSearchFormPreferredBrand["MW"] = "MW";
  CarSearchFormPreferredBrand["NU"] = "NU";
  CarSearchFormPreferredBrand["RO"] = "RO";
  CarSearchFormPreferredBrand["SC"] = "SC";
  CarSearchFormPreferredBrand["SV"] = "SV";
  CarSearchFormPreferredBrand["SX"] = "SX";
  CarSearchFormPreferredBrand["ZA"] = "ZA";
  CarSearchFormPreferredBrand["ZD"] = "ZD";
  CarSearchFormPreferredBrand["ZE"] = "ZE";
  CarSearchFormPreferredBrand["ZI"] = "ZI";
  CarSearchFormPreferredBrand["ZL"] = "ZL";
  CarSearchFormPreferredBrand["ZR"] = "ZR";
  CarSearchFormPreferredBrand["ZT"] = "ZT";
})(CarSearchFormPreferredBrand || (CarSearchFormPreferredBrand = {}));
export var CardActions;
(function (CardActions) {
  CardActions["DISMISS"] = "DISMISS";
})(CardActions || (CardActions = {}));
export var CardSize;
(function (CardSize) {
  CardSize["LARGE"] = "LARGE";
  CardSize["MEDIUM"] = "MEDIUM";
  CardSize["SMALL"] = "SMALL";
})(CardSize || (CardSize = {}));
export var CardTheme;
(function (CardTheme) {
  CardTheme["GLOBAL_LOYALTY_EXTRAHIGH"] = "GLOBAL_LOYALTY_EXTRAHIGH";
  CardTheme["GLOBAL_LOYALTY_HIGH"] = "GLOBAL_LOYALTY_HIGH";
  CardTheme["GLOBAL_LOYALTY_LOW"] = "GLOBAL_LOYALTY_LOW";
  CardTheme["GLOBAL_LOYALTY_MIDDLE"] = "GLOBAL_LOYALTY_MIDDLE";
  CardTheme["GLOBAL_LOYALTY_STANDARD"] = "GLOBAL_LOYALTY_STANDARD";
  CardTheme["PRIMARY"] = "PRIMARY";
  CardTheme["SECONDARY"] = "SECONDARY";
})(CardTheme || (CardTheme = {}));
/** Enum class to represent the type of carry on bag */
export var CarryOnBagType;
(function (CarryOnBagType) {
  CarryOnBagType["CARRY_ON_BAG"] = "CARRY_ON_BAG";
})(CarryOnBagType || (CarryOnBagType = {}));
export var CarsDialogType;
(function (CarsDialogType) {
  CarsDialogType["LIMITED_RESULTS"] = "LIMITED_RESULTS";
  CarsDialogType["LIMITED_RESULTS_WITHOUT_TURO"] = "LIMITED_RESULTS_WITHOUT_TURO";
  CarsDialogType["LIMITED_RESULTS_WITH_TURO"] = "LIMITED_RESULTS_WITH_TURO";
})(CarsDialogType || (CarsDialogType = {}));
export var CarsRichTextStyle;
(function (CarsRichTextStyle) {
  CarsRichTextStyle["BOLD"] = "BOLD";
  CarsRichTextStyle["BULLET"] = "BULLET";
  CarsRichTextStyle["ITALICIZE"] = "ITALICIZE";
})(CarsRichTextStyle || (CarsRichTextStyle = {}));
export var CartTtl;
(function (CartTtl) {
  CartTtl["FIVE_MINUTES"] = "FIVE_MINUTES";
  CartTtl["SEVEN_DAYS"] = "SEVEN_DAYS";
  CartTtl["TWELVE_HOURS"] = "TWELVE_HOURS";
})(CartTtl || (CartTtl = {}));
export var ChannelType;
(function (ChannelType) {
  ChannelType["VIRTUAL_AGENT"] = "VIRTUAL_AGENT";
})(ChannelType || (ChannelType = {}));
/** Indicates the type of intent. */
export var ChatBotIntentType;
(function (ChatBotIntentType) {
  ChatBotIntentType["CANCEL"] = "CANCEL";
  ChatBotIntentType["CHANGE"] = "CHANGE";
  ChatBotIntentType["VIEW_BOOKING"] = "VIEW_BOOKING";
})(ChatBotIntentType || (ChatBotIntentType = {}));
/** Indicates the type of product. */
export var ChatBotProductType;
(function (ChatBotProductType) {
  ChatBotProductType["FLIGHT"] = "FLIGHT";
})(ChatBotProductType || (ChatBotProductType = {}));
/** Indicates the waiver redemption state. */
export var ChatBotWaiverRedemptionState;
(function (ChatBotWaiverRedemptionState) {
  ChatBotWaiverRedemptionState["CREDIT_REDEMPTION"] = "CREDIT_REDEMPTION";
})(ChatBotWaiverRedemptionState || (ChatBotWaiverRedemptionState = {}));
/** Hold status of chat input for particular message on the basis of flags received form message */
export var ChatInputStatus;
(function (ChatInputStatus) {
  ChatInputStatus["DISABLE"] = "DISABLE";
  ChatInputStatus["ENABLE"] = "ENABLE";
})(ChatInputStatus || (ChatInputStatus = {}));
/** Supported capabilities of chatbot VAC. */
export var ChatbotCapabilities;
(function (ChatbotCapabilities) {
  ChatbotCapabilities["CLICKSTREAM"] = "CLICKSTREAM";
  ChatbotCapabilities["GLASSBOX"] = "GLASSBOX";
})(ChatbotCapabilities || (ChatbotCapabilities = {}));
/** Supported versions of chatbot. */
export var ChatbotVersionId;
(function (ChatbotVersionId) {
  ChatbotVersionId["V1"] = "V1";
  ChatbotVersionId["V2"] = "V2";
})(ChatbotVersionId || (ChatbotVersionId = {}));
export var CheckinValidityWithReason;
(function (CheckinValidityWithReason) {
  /** the associated date is not valid for checkin due to an unknown reason */
  CheckinValidityWithReason["INVALID"] = "INVALID";
  /** the associated date is not valid for checkin due to being in the past */
  CheckinValidityWithReason["INVALID_DUE_TO_BEING_IN_PAST"] = "INVALID_DUE_TO_BEING_IN_PAST";
  /** the associated date is not valid for checkin because checkin was prohibited on that specific date */
  CheckinValidityWithReason["INVALID_DUE_TO_CHANGEOVER_EXCLUSION"] = "INVALID_DUE_TO_CHANGEOVER_EXCLUSION";
  /** the associated date is not valid for checkin because it is too far in the future */
  CheckinValidityWithReason["INVALID_DUE_TO_MAX_FUTURE_BOOKING"] = "INVALID_DUE_TO_MAX_FUTURE_BOOKING";
  /** the associated date is not valid for checkin because checking in on this date would not meet the owner's minimum prior notification requirements */
  CheckinValidityWithReason["INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION"] = "INVALID_DUE_TO_MIN_PRIOR_NOTIFICATION";
  /** the associated date is not valid for checkin because checking in on this date does not satisfy the minimum stay duration */
  CheckinValidityWithReason["INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE"] = "INVALID_DUE_TO_MIN_STAY_NOT_ACHIEVABLE";
  /** the associated date is not valid for checkin because it falls on a day of the week that checkin is prohibited */
  CheckinValidityWithReason["INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK"] = "INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK";
  /** the associated date is not valid for checkin because it is not available (ie. the date is already reserved) */
  CheckinValidityWithReason["INVALID_DUE_TO_NOT_AVAILABLE"] = "INVALID_DUE_TO_NOT_AVAILABLE";
  /** the associated date is not valid for checkin because there is not an associated checkout date that would allow the stay to satisfy stay constraints */
  CheckinValidityWithReason["INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS"] = "INVALID_DUE_TO_NO_VALID_CHECKOUT_WITHIN_CONSTRAINTS";
  /** the associated date is valid for checkin */
  CheckinValidityWithReason["VALID"] = "VALID";
})(CheckinValidityWithReason || (CheckinValidityWithReason = {}));
/** Supported Features on prepareCheckout */
export var CheckoutOptionType;
(function (CheckoutOptionType) {
  CheckoutOptionType["FENCING_ATTRIBUTES"] = "FENCING_ATTRIBUTES";
  CheckoutOptionType["HOTEL_BUSINESS_MODEL"] = "HOTEL_BUSINESS_MODEL";
  CheckoutOptionType["HOTEL_MARKETING_CHANNEL"] = "HOTEL_MARKETING_CHANNEL";
  CheckoutOptionType["META_DEEPLINK"] = "META_DEEPLINK";
  CheckoutOptionType["NATIVE"] = "NATIVE";
  CheckoutOptionType["PRICE_TOKEN"] = "PRICE_TOKEN";
  CheckoutOptionType["PROPERTY_UPSELL_AMOUNT"] = "PROPERTY_UPSELL_AMOUNT";
  CheckoutOptionType["RATE_UPGRADE_ELIGIBLE"] = "RATE_UPGRADE_ELIGIBLE";
  CheckoutOptionType["RATE_UPSELL"] = "RATE_UPSELL";
  CheckoutOptionType["RATE_UPSELL_AMOUNT"] = "RATE_UPSELL_AMOUNT";
  CheckoutOptionType["ROOM_UPGRADE_ELIGIBLE"] = "ROOM_UPGRADE_ELIGIBLE";
  CheckoutOptionType["ROOM_UPSELL"] = "ROOM_UPSELL";
  CheckoutOptionType["SEARCH_ID"] = "SEARCH_ID";
  CheckoutOptionType["SHOPPING_DEAL_BADGE_PERCENTAGE"] = "SHOPPING_DEAL_BADGE_PERCENTAGE";
  CheckoutOptionType["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
  CheckoutOptionType["TAAP_PACKAGE_RATES"] = "TAAP_PACKAGE_RATES";
})(CheckoutOptionType || (CheckoutOptionType = {}));
export var CheckoutValidityWithReason;
(function (CheckoutValidityWithReason) {
  /** the associated date's is not valid for checkout for an unknown reason */
  CheckoutValidityWithReason["INVALID"] = "INVALID";
  /** the associated date is not valid for checkout because checkout was prohibited on that specific date */
  CheckoutValidityWithReason["INVALID_DUE_TO_CHANGEOVER_EXCLUSION"] = "INVALID_DUE_TO_CHANGEOVER_EXCLUSION";
  /** the associated date is not valid for checkout because it falls on a day of the week that checkout is prohibited */
  CheckoutValidityWithReason["INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK"] = "INVALID_DUE_TO_NON_CHANGEOVER_DAY_OF_WEEK";
  /** the associated date is valid for checkout */
  CheckoutValidityWithReason["VALID"] = "VALID";
})(CheckoutValidityWithReason || (CheckoutValidityWithReason = {}));
export var ChronoUnit;
(function (ChronoUnit) {
  ChronoUnit["CENTURIES"] = "CENTURIES";
  ChronoUnit["DAYS"] = "DAYS";
  ChronoUnit["DECADES"] = "DECADES";
  ChronoUnit["ERAS"] = "ERAS";
  ChronoUnit["FOREVER"] = "FOREVER";
  ChronoUnit["HALFDAYS"] = "HALFDAYS";
  ChronoUnit["HOURS"] = "HOURS";
  ChronoUnit["MICROS"] = "MICROS";
  ChronoUnit["MILLENNIA"] = "MILLENNIA";
  ChronoUnit["MILLIS"] = "MILLIS";
  ChronoUnit["MINUTES"] = "MINUTES";
  ChronoUnit["MONTHS"] = "MONTHS";
  ChronoUnit["NANOS"] = "NANOS";
  ChronoUnit["SECONDS"] = "SECONDS";
  ChronoUnit["WEEKS"] = "WEEKS";
  ChronoUnit["YEARS"] = "YEARS";
})(ChronoUnit || (ChronoUnit = {}));
export var CleaningAndSafetyPractice;
(function (CleaningAndSafetyPractice) {
  CleaningAndSafetyPractice["ENHANCED_CLEANING"] = "ENHANCED_CLEANING";
})(CleaningAndSafetyPractice || (CleaningAndSafetyPractice = {}));
export var ClientSideIllustrationAsset;
(function (ClientSideIllustrationAsset) {
  ClientSideIllustrationAsset["FlightHotelIncludedSet"] = "FlightHotelIncludedSet";
})(ClientSideIllustrationAsset || (ClientSideIllustrationAsset = {}));
/** The closed bounding type of the date period. (Boundaries are always included) */
export var ClosedPeriodBounding;
(function (ClosedPeriodBounding) {
  ClosedPeriodBounding["LOWER"] = "LOWER";
  ClosedPeriodBounding["UPPER"] = "UPPER";
})(ClosedPeriodBounding || (ClosedPeriodBounding = {}));
export var CoachingTipsView;
(function (CoachingTipsView) {
  CoachingTipsView["STANDALONE_MINIMAL"] = "STANDALONE_MINIMAL";
  CoachingTipsView["STANDALONE_SUGGESTED"] = "STANDALONE_SUGGESTED";
  CoachingTipsView["OPPY_HUB"] = "OPPY_HUB";
  CoachingTipsView["IN_CONTEXT_COACHING_CAROUSEL"] = "IN_CONTEXT_COACHING_CAROUSEL";
})(CoachingTipsView || (CoachingTipsView = {}));
/** The type of the collection */
export var CollectionType;
(function (CollectionType) {
  CollectionType["FLIGHT"] = "FLIGHT";
  CollectionType["GEOGRAPHY"] = "GEOGRAPHY";
  CollectionType["LODGING"] = "LODGING";
})(CollectionType || (CollectionType = {}));
export var CommissionTier;
(function (CommissionTier) {
  CommissionTier["BASIC"] = "BASIC";
  CommissionTier["BASIC_PLUS"] = "BASIC_PLUS";
  CommissionTier["PREMIUM"] = "PREMIUM";
  CommissionTier["PREMIUM_PLUS"] = "PREMIUM_PLUS";
})(CommissionTier || (CommissionTier = {}));
/** Represents the state of a conversation thread */
export var CommunicationCenterConversationState;
(function (CommunicationCenterConversationState) {
  /** Represents read state */
  CommunicationCenterConversationState["READ"] = "READ";
  /** Represents invalid state */
  CommunicationCenterConversationState["UNKNOWN"] = "UNKNOWN";
  /** Represents unread state - initial state of conversation thread */
  CommunicationCenterConversationState["UNREAD"] = "UNREAD";
})(CommunicationCenterConversationState || (CommunicationCenterConversationState = {}));
/** Represents left or right alignment of a specific messages in the conversation View */
export var CommunicationCenterMessageAlignment;
(function (CommunicationCenterMessageAlignment) {
  /** Represents a card that is not aligned to either left or right */
  CommunicationCenterMessageAlignment["FULL"] = "FULL";
  /** Represents left Alignment */
  CommunicationCenterMessageAlignment["LEFT"] = "LEFT";
  /** Represents Right Alignment */
  CommunicationCenterMessageAlignment["RIGHT"] = "RIGHT";
})(CommunicationCenterMessageAlignment || (CommunicationCenterMessageAlignment = {}));
/** Represents the state of message preview */
export var CommunicationCenterMessagePreviewState;
(function (CommunicationCenterMessagePreviewState) {
  /** Represents read state */
  CommunicationCenterMessagePreviewState["READ"] = "READ";
  /** Represents unread state */
  CommunicationCenterMessagePreviewState["UNREAD"] = "UNREAD";
})(CommunicationCenterMessagePreviewState || (CommunicationCenterMessagePreviewState = {}));
/** The display type of the Customer notification message */
export var CommunicationCenterNotificationMessageDisplayType;
(function (CommunicationCenterNotificationMessageDisplayType) {
  /** Display the message for the form */
  CommunicationCenterNotificationMessageDisplayType["FORM"] = "FORM";
  /** Dislay message on the page level, eg: fly-in message on the page */
  CommunicationCenterNotificationMessageDisplayType["PAGE"] = "PAGE";
})(CommunicationCenterNotificationMessageDisplayType || (CommunicationCenterNotificationMessageDisplayType = {}));
/** The level type of the Customer notification message */
export var CommunicationCenterNotificationMessageLevel;
(function (CommunicationCenterNotificationMessageLevel) {
  /** Type of error for the message */
  CommunicationCenterNotificationMessageLevel["ERROR"] = "ERROR";
  /** Type of info for the message */
  CommunicationCenterNotificationMessageLevel["INFO"] = "INFO";
  /** Type of success for the message */
  CommunicationCenterNotificationMessageLevel["SUCCESS"] = "SUCCESS";
  /** Type of warning for the message */
  CommunicationCenterNotificationMessageLevel["WARNING"] = "WARNING";
})(CommunicationCenterNotificationMessageLevel || (CommunicationCenterNotificationMessageLevel = {}));
/** Represents the state of notification or message */
export var CommunicationCenterNotificationState;
(function (CommunicationCenterNotificationState) {
  /** Represents read state */
  CommunicationCenterNotificationState["READ"] = "READ";
  /** Represents seen state - equivalents as unread */
  CommunicationCenterNotificationState["SEEN"] = "SEEN";
  /** Represents invalid state */
  CommunicationCenterNotificationState["UNKNOWN"] = "UNKNOWN";
  /** Represents unseen state - initial state of notification */
  CommunicationCenterNotificationState["UNSEEN"] = "UNSEEN";
})(CommunicationCenterNotificationState || (CommunicationCenterNotificationState = {}));
/** Represents the type of the notification */
export var CommunicationCenterNotificationType;
(function (CommunicationCenterNotificationType) {
  /** Represents coupon notification */
  CommunicationCenterNotificationType["COUPON_CAMPAIGN"] = "COUPON_CAMPAIGN";
  /** Represents default type of notification */
  CommunicationCenterNotificationType["DEFAULT"] = "DEFAULT";
})(CommunicationCenterNotificationType || (CommunicationCenterNotificationType = {}));
/** Represents the type of user actions of the notification. */
export var CommunicationCenterNotificationUserActionType;
(function (CommunicationCenterNotificationUserActionType) {
  /** Represents the action of deleting a notification */
  CommunicationCenterNotificationUserActionType["DELETE"] = "DELETE";
  /** Represents the action of marking a notification as read */
  CommunicationCenterNotificationUserActionType["MARK_AS_READ"] = "MARK_AS_READ";
  /** Represents the action of marking a notification as unread */
  CommunicationCenterNotificationUserActionType["MARK_AS_UNREAD"] = "MARK_AS_UNREAD";
})(CommunicationCenterNotificationUserActionType || (CommunicationCenterNotificationUserActionType = {}));
/** Represents the status of query/mutation response */
export var CommunicationCenterOperationStatus;
(function (CommunicationCenterOperationStatus) {
  /** Represents the status of failure response for generic or unknown reasons */
  CommunicationCenterOperationStatus["GENERIC_FAILURE"] = "GENERIC_FAILURE";
  /** Represents the status of failure response for invalid input */
  CommunicationCenterOperationStatus["INVALID_INPUT"] = "INVALID_INPUT";
  /** Represents the status of failure response for service errors */
  CommunicationCenterOperationStatus["SERVICE_ERROR"] = "SERVICE_ERROR";
  /** Represents the status of successful response */
  CommunicationCenterOperationStatus["SUCCESS"] = "SUCCESS";
})(CommunicationCenterOperationStatus || (CommunicationCenterOperationStatus = {}));
export var CommunicationChannel;
(function (CommunicationChannel) {
  CommunicationChannel["EMAIL"] = "EMAIL";
  CommunicationChannel["PUSH"] = "PUSH";
  CommunicationChannel["SMS"] = "SMS";
})(CommunicationChannel || (CommunicationChannel = {}));
export var CommunicationPreferencesOptionsType;
(function (CommunicationPreferencesOptionsType) {
  CommunicationPreferencesOptionsType["ACCOUNT_SUPPORT"] = "ACCOUNT_SUPPORT";
  CommunicationPreferencesOptionsType["COMMUNICATION_PREFERENCES_EXPEDIA"] = "COMMUNICATION_PREFERENCES_EXPEDIA";
  CommunicationPreferencesOptionsType["COMMUNICATION_PREFERENCES_HOTELS"] = "COMMUNICATION_PREFERENCES_HOTELS";
  CommunicationPreferencesOptionsType["COMMUNICATION_PREFERENCES_VRBO"] = "COMMUNICATION_PREFERENCES_VRBO";
  CommunicationPreferencesOptionsType["CONFIRMATION_AND_CRITICAL_UPDATES"] = "CONFIRMATION_AND_CRITICAL_UPDATES";
  CommunicationPreferencesOptionsType["DEFAULT"] = "DEFAULT";
  CommunicationPreferencesOptionsType["MANAGE_EMAIL_PREFERENCE"] = "MANAGE_EMAIL_PREFERENCE";
  CommunicationPreferencesOptionsType["OFFERS_AND_INSPIRATION"] = "OFFERS_AND_INSPIRATION";
  CommunicationPreferencesOptionsType["ONE_KEY"] = "ONE_KEY";
  CommunicationPreferencesOptionsType["ONE_KEY_MONTHLY_STATEMENTS"] = "ONE_KEY_MONTHLY_STATEMENTS";
  CommunicationPreferencesOptionsType["PARTNERS_OFFERS_WITH_US"] = "PARTNERS_OFFERS_WITH_US";
  CommunicationPreferencesOptionsType["PERSONALIZED_TRIP_RECOMMENDATIONS"] = "PERSONALIZED_TRIP_RECOMMENDATIONS";
  CommunicationPreferencesOptionsType["PRIVACY_STATEMENT"] = "PRIVACY_STATEMENT";
  CommunicationPreferencesOptionsType["REVIEWS"] = "REVIEWS";
  CommunicationPreferencesOptionsType["SURVEYS"] = "SURVEYS";
  CommunicationPreferencesOptionsType["THE_TRAVEL_EDIT"] = "THE_TRAVEL_EDIT";
  CommunicationPreferencesOptionsType["TRIP_BOARD_ACTIVITY"] = "TRIP_BOARD_ACTIVITY";
  CommunicationPreferencesOptionsType["TRIP_PLANNING_ASSISTANCE"] = "TRIP_PLANNING_ASSISTANCE";
  CommunicationPreferencesOptionsType["UNSUB_ALL"] = "UNSUB_ALL";
  CommunicationPreferencesOptionsType["UNSUB_OTHER_EMAILS"] = "UNSUB_OTHER_EMAILS";
})(CommunicationPreferencesOptionsType || (CommunicationPreferencesOptionsType = {}));
export var CompetitiveSetProductType;
(function (CompetitiveSetProductType) {
  CompetitiveSetProductType["LODGING"] = "LODGING";
})(CompetitiveSetProductType || (CompetitiveSetProductType = {}));
/** A rough measure of the percentage of properties that are sold out in the destination region as calculated by the Urgency Service. */
export var CompressionLevel;
(function (CompressionLevel) {
  CompressionLevel["CAP"] = "CAP";
  CompressionLevel["HIGH"] = "HIGH";
  CompressionLevel["LOW"] = "LOW";
  CompressionLevel["MEDIUM"] = "MEDIUM";
  CompressionLevel["NA"] = "NA";
})(CompressionLevel || (CompressionLevel = {}));
export var ConfigTag;
(function (ConfigTag) {
  ConfigTag["H1"] = "H1";
  ConfigTag["H2"] = "H2";
  ConfigTag["H3"] = "H3";
  ConfigTag["H4"] = "H4";
  ConfigTag["H5"] = "H5";
  ConfigTag["H6"] = "H6";
})(ConfigTag || (ConfigTag = {}));
export var ContactUsOptionType;
(function (ContactUsOptionType) {
  ContactUsOptionType["CALL_BACK_WITH_AGENT"] = "CALL_BACK_WITH_AGENT";
  ContactUsOptionType["CALL_TO_AGENT"] = "CALL_TO_AGENT";
  ContactUsOptionType["CHAT_BACK_WITH_AGENT"] = "CHAT_BACK_WITH_AGENT";
  ContactUsOptionType["CHAT_WITH_AGENT"] = "CHAT_WITH_AGENT";
  ContactUsOptionType["SEND_EMAIL_AGENT"] = "SEND_EMAIL_AGENT";
})(ContactUsOptionType || (ContactUsOptionType = {}));
/** UI Theme to be applied to a `UISectionContainer` or a `TripsSectionContainer`. */
export var ContainerTheme;
(function (ContainerTheme) {
  ContainerTheme["DEFAULT"] = "DEFAULT";
  ContainerTheme["IMPORTANT"] = "IMPORTANT";
})(ContainerTheme || (ContainerTheme = {}));
export var ContentSource;
(function (ContentSource) {
  ContentSource["DESTINATION_API"] = "DESTINATION_API";
  ContentSource["EM"] = "EM";
})(ContentSource || (ContentSource = {}));
export var ConversationMode;
(function (ConversationMode) {
  ConversationMode["CREATE_CONVERSATION"] = "CREATE_CONVERSATION";
})(ConversationMode || (ConversationMode = {}));
export var ConversationParticipantType;
(function (ConversationParticipantType) {
  ConversationParticipantType["HumanAgent"] = "HumanAgent";
  ConversationParticipantType["HumanAgentVA"] = "HumanAgentVA";
  ConversationParticipantType["Supplier"] = "Supplier";
  ConversationParticipantType["SupplierVA"] = "SupplierVA";
  ConversationParticipantType["Traveler"] = "Traveler";
  ConversationParticipantType["TravelerVA"] = "TravelerVA";
})(ConversationParticipantType || (ConversationParticipantType = {}));
export var CouponIdentifierType;
(function (CouponIdentifierType) {
  CouponIdentifierType["CODE"] = "CODE";
  CouponIdentifierType["INSTANCE_ID"] = "INSTANCE_ID";
})(CouponIdentifierType || (CouponIdentifierType = {}));
export var CreditCardApplicationFormOperation;
(function (CreditCardApplicationFormOperation) {
  CreditCardApplicationFormOperation["EQ"] = "EQ";
  CreditCardApplicationFormOperation["GE"] = "GE";
  CreditCardApplicationFormOperation["GT"] = "GT";
  CreditCardApplicationFormOperation["LE"] = "LE";
  CreditCardApplicationFormOperation["LT"] = "LT";
  CreditCardApplicationFormOperation["NE"] = "NE";
})(CreditCardApplicationFormOperation || (CreditCardApplicationFormOperation = {}));
export var CreditCardApplicationHeadingSize;
(function (CreditCardApplicationHeadingSize) {
  CreditCardApplicationHeadingSize["LARGE"] = "LARGE";
  CreditCardApplicationHeadingSize["SMALL"] = "SMALL";
})(CreditCardApplicationHeadingSize || (CreditCardApplicationHeadingSize = {}));
export var CreditCardApplyButtonActionType;
(function (CreditCardApplyButtonActionType) {
  CreditCardApplyButtonActionType["EMBEDDED"] = "EMBEDDED";
  CreditCardApplyButtonActionType["EXTERNAL"] = "EXTERNAL";
})(CreditCardApplyButtonActionType || (CreditCardApplyButtonActionType = {}));
/**
 * The requested format of a downloadable content.
 * For example, the Schumer Box content (A.K.A. Legal Disclosures) can be requested in
 * HTML or PDF format.
 */
export var CreditCardContentFormat;
(function (CreditCardContentFormat) {
  CreditCardContentFormat["HTML"] = "HTML";
  CreditCardContentFormat["PDF"] = "PDF";
})(CreditCardContentFormat || (CreditCardContentFormat = {}));
/**
 * The declared source of a downloadable content.
 * For example, the Schumer Box content can be requested
 * from the Terms and Conditions experience.
 */
export var CreditCardContentSource;
(function (CreditCardContentSource) {
  CreditCardContentSource["TERMS_AND_CONDITIONS"] = "TERMS_AND_CONDITIONS";
})(CreditCardContentSource || (CreditCardContentSource = {}));
export var CreditCardEncodingType;
(function (CreditCardEncodingType) {
  CreditCardEncodingType["Base64"] = "Base64";
})(CreditCardEncodingType || (CreditCardEncodingType = {}));
export var CreditCardFraudOTPScreenType;
(function (CreditCardFraudOTPScreenType) {
  CreditCardFraudOTPScreenType["GENERATE_CODE"] = "GENERATE_CODE";
  CreditCardFraudOTPScreenType["VERIFY_CODE"] = "VERIFY_CODE";
})(CreditCardFraudOTPScreenType || (CreditCardFraudOTPScreenType = {}));
/**
 * Credit card application flow screen;
 *         instruct clients about the next screen to request.
 */
export var CreditCardScreen;
(function (CreditCardScreen) {
  /** The Error Page. */
  CreditCardScreen["ERROR"] = "ERROR";
  /** The Offer Page. */
  CreditCardScreen["OFFER"] = "OFFER";
  /** The page where travellers originally applied for the card. */
  CreditCardScreen["ORIGIN"] = "ORIGIN";
})(CreditCardScreen || (CreditCardScreen = {}));
/** The page the traveler is instantiating the Application Form from. */
export var CreditCardSourcePage;
(function (CreditCardSourcePage) {
  /** The traveler initiated the application journey from the Application (A.K.A. Pillar) Page. */
  CreditCardSourcePage["APPLICATION"] = "APPLICATION";
  /** The traveler initiated the application journey from a Checkout Page. */
  CreditCardSourcePage["CHECKOUT"] = "CHECKOUT";
})(CreditCardSourcePage || (CreditCardSourcePage = {}));
export var CreditCardThankYouScreenType;
(function (CreditCardThankYouScreenType) {
  CreditCardThankYouScreenType["APPROVED"] = "APPROVED";
  CreditCardThankYouScreenType["PENDING"] = "PENDING";
})(CreditCardThankYouScreenType || (CreditCardThankYouScreenType = {}));
export var CreditCardType;
(function (CreditCardType) {
  /** The type of the premium `One Key+ Card` */
  CreditCardType["FEE"] = "FEE";
  /** The type of the plain `One Key Card` */
  CreditCardType["NO_FEE"] = "NO_FEE";
})(CreditCardType || (CreditCardType = {}));
/** Enum class to represent the type of credit eligible filter */
export var CreditEligibleFilterType;
(function (CreditEligibleFilterType) {
  CreditEligibleFilterType["CREDIT_ELIGIBLE"] = "CREDIT_ELIGIBLE";
})(CreditEligibleFilterType || (CreditEligibleFilterType = {}));
export var CrossSellProductType;
(function (CrossSellProductType) {
  CrossSellProductType["ACTIVITY"] = "ACTIVITY";
  CrossSellProductType["CAR"] = "CAR";
  CrossSellProductType["FLIGHT"] = "FLIGHT";
  CrossSellProductType["HOTEL"] = "HOTEL";
})(CrossSellProductType || (CrossSellProductType = {}));
export var CruiseBadgeTheme;
(function (CruiseBadgeTheme) {
  CruiseBadgeTheme["DEAL_GENERIC"] = "DEAL_GENERIC";
  CruiseBadgeTheme["DEAL_MEMBER"] = "DEAL_MEMBER";
  CruiseBadgeTheme["VIP"] = "VIP";
})(CruiseBadgeTheme || (CruiseBadgeTheme = {}));
export var CruiseFeature;
(function (CruiseFeature) {
  CruiseFeature["LIVE_SHOPPING_USING_MSC_ADAPTER"] = "LIVE_SHOPPING_USING_MSC_ADAPTER";
  CruiseFeature["MEMBER_DEALS"] = "MEMBER_DEALS";
  CruiseFeature["MEMBER_DEALS_FOR_NON_MEMBERS"] = "MEMBER_DEALS_FOR_NON_MEMBERS";
})(CruiseFeature || (CruiseFeature = {}));
export var CruiseFilterType;
(function (CruiseFilterType) {
  /** cabin experience - eg. Suite  */
  CruiseFilterType["CABIN"] = "CABIN";
  /** departure port */
  CruiseFilterType["DEPARTURE"] = "DEPARTURE";
  /** use for filtering by the destination */
  CruiseFilterType["DESTINATION"] = "DESTINATION";
  /** length of cruise nights 1-2, 3-5, 6-9 , 10-14, 15+ */
  CruiseFilterType["LENGTH"] = "LENGTH";
  /** use for filtering by the cruise line name */
  CruiseFilterType["NAME"] = "NAME";
  /** default not set value */
  CruiseFilterType["NOT_SET"] = "NOT_SET";
  /** ship type */
  CruiseFilterType["SHIP"] = "SHIP";
  /** use for ocean cruise */
  CruiseFilterType["THEME_OCEAN"] = "THEME_OCEAN";
  /** use for river cruise */
  CruiseFilterType["THEME_RIVER"] = "THEME_RIVER";
})(CruiseFilterType || (CruiseFilterType = {}));
/** Gender of the customer */
export var CustomerGender;
(function (CustomerGender) {
  CustomerGender["FEMALE"] = "FEMALE";
  CustomerGender["MALE"] = "MALE";
  CustomerGender["UNKNOWN"] = "UNKNOWN";
})(CustomerGender || (CustomerGender = {}));
/** The button type of the Customer notification submit button */
export var CustomerNotificationFormButtonType;
(function (CustomerNotificationFormButtonType) {
  /** Type of floating action button */
  CustomerNotificationFormButtonType["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  /** Type of primary button */
  CustomerNotificationFormButtonType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  /** Type of secondary button */
  CustomerNotificationFormButtonType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  /** Type of tertiary button */
  CustomerNotificationFormButtonType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(CustomerNotificationFormButtonType || (CustomerNotificationFormButtonType = {}));
/** Represents the target of the link */
export var CustomerNotificationLinkTarget;
(function (CustomerNotificationLinkTarget) {
  CustomerNotificationLinkTarget["NEW_TAB"] = "NEW_TAB";
  CustomerNotificationLinkTarget["SAME_TAB"] = "SAME_TAB";
})(CustomerNotificationLinkTarget || (CustomerNotificationLinkTarget = {}));
/** Represents the link type */
export var CustomerNotificationLinkType;
(function (CustomerNotificationLinkType) {
  CustomerNotificationLinkType["ANCHOR"] = "ANCHOR";
  CustomerNotificationLinkType["APP_DOWNLOAD_LINK"] = "APP_DOWNLOAD_LINK";
  CustomerNotificationLinkType["BUTTON"] = "BUTTON";
  CustomerNotificationLinkType["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  CustomerNotificationLinkType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  CustomerNotificationLinkType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  CustomerNotificationLinkType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(CustomerNotificationLinkType || (CustomerNotificationLinkType = {}));
/** The display type of the Customer notification message */
export var CustomerNotificationMessageDisplayType;
(function (CustomerNotificationMessageDisplayType) {
  /** Display the message for the form */
  CustomerNotificationMessageDisplayType["FORM"] = "FORM";
  /** Dislay message on the page level, eg: fly-in message on the page */
  CustomerNotificationMessageDisplayType["PAGE"] = "PAGE";
})(CustomerNotificationMessageDisplayType || (CustomerNotificationMessageDisplayType = {}));
/** The level type of the Customer notification message */
export var CustomerNotificationMessageLevel;
(function (CustomerNotificationMessageLevel) {
  /** Type of error for the message */
  CustomerNotificationMessageLevel["ERROR"] = "ERROR";
  /** Type of success for the message */
  CustomerNotificationMessageLevel["SUCCESS"] = "SUCCESS";
  /** Type of warning for the message */
  CustomerNotificationMessageLevel["WARNING"] = "WARNING";
})(CustomerNotificationMessageLevel || (CustomerNotificationMessageLevel = {}));
export var CustomerNotificationMessageType;
(function (CustomerNotificationMessageType) {
  /** INVALID_INPUT message */
  CustomerNotificationMessageType["INVALID_INPUT"] = "INVALID_INPUT";
  /** SERVICE_ERROR message */
  CustomerNotificationMessageType["SERVICE_ERROR"] = "SERVICE_ERROR";
  /** SUCCESS message */
  CustomerNotificationMessageType["SUCCESS"] = "SUCCESS";
})(CustomerNotificationMessageType || (CustomerNotificationMessageType = {}));
/** The style to apply to phrase links */
export var CustomerNotificationPhraseLinkStyle;
(function (CustomerNotificationPhraseLinkStyle) {
  CustomerNotificationPhraseLinkStyle["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  CustomerNotificationPhraseLinkStyle["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  CustomerNotificationPhraseLinkStyle["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  CustomerNotificationPhraseLinkStyle["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(CustomerNotificationPhraseLinkStyle || (CustomerNotificationPhraseLinkStyle = {}));
/** The text style to apply to strings */
export var CustomerNotificationPhrasePartStyle;
(function (CustomerNotificationPhrasePartStyle) {
  /** Italic styling */
  CustomerNotificationPhrasePartStyle["EMPHASIS"] = "EMPHASIS";
  /** Bold styling */
  CustomerNotificationPhrasePartStyle["IMPORTANT"] = "IMPORTANT";
  /** Represents no style or regular text */
  CustomerNotificationPhrasePartStyle["STANDARD"] = "STANDARD";
})(CustomerNotificationPhrasePartStyle || (CustomerNotificationPhrasePartStyle = {}));
export var CustomerNotificationType;
(function (CustomerNotificationType) {
  CustomerNotificationType["APP_DOWNLOAD"] = "APP_DOWNLOAD";
  CustomerNotificationType["APP_HERO"] = "APP_HERO";
  CustomerNotificationType["CITI_COBRAND"] = "CITI_COBRAND";
  CustomerNotificationType["CITI_COBRAND_VERTICAL"] = "CITI_COBRAND_VERTICAL";
  CustomerNotificationType["CLEANLINESS"] = "CLEANLINESS";
  CustomerNotificationType["GDPR"] = "GDPR";
  CustomerNotificationType["GENERIC"] = "GENERIC";
  CustomerNotificationType["HEADER"] = "HEADER";
  CustomerNotificationType["INBOX"] = "INBOX";
  CustomerNotificationType["MAD_MARQUEE"] = "MAD_MARQUEE";
  CustomerNotificationType["NONE"] = "NONE";
  CustomerNotificationType["OSANO"] = "OSANO";
  CustomerNotificationType["TAKEOVER"] = "TAKEOVER";
  CustomerNotificationType["TRAVEL_ADVISORY"] = "TRAVEL_ADVISORY";
})(CustomerNotificationType || (CustomerNotificationType = {}));
export var DamageLiability;
(function (DamageLiability) {
  DamageLiability["COF"] = "COF";
  DamageLiability["RDD"] = "RDD";
})(DamageLiability || (DamageLiability = {}));
export var DashboardType;
(function (DashboardType) {
  DashboardType["DEFERRED_PAYMENT"] = "DEFERRED_PAYMENT";
  DashboardType["PERFORMANCE"] = "PERFORMANCE";
})(DashboardType || (DashboardType = {}));
/**
 * Used to identify the downstream data source.
 * ENTITY: A stateful data service driven by the owning domain
 * CART: Cart Service
 * OFFER: Offer Service
 * ORDER: Ordering Service
 * CHECKOUT: Core Checkout Identifying Service
 */
export var DataSourceType;
(function (DataSourceType) {
  DataSourceType["CART"] = "CART";
  DataSourceType["CHECKOUT"] = "CHECKOUT";
  DataSourceType["ENTITY"] = "ENTITY";
  DataSourceType["OFFER"] = "OFFER";
  DataSourceType["ORDER"] = "ORDER";
})(DataSourceType || (DataSourceType = {}));
/** The unit of date period */
export var DatePeriodUnit;
(function (DatePeriodUnit) {
  DatePeriodUnit["DAY"] = "DAY";
  DatePeriodUnit["MONTH"] = "MONTH";
  DatePeriodUnit["WEEK"] = "WEEK";
  DatePeriodUnit["WEEKEND"] = "WEEKEND";
})(DatePeriodUnit || (DatePeriodUnit = {}));
export var DealType;
(function (DealType) {
  DealType["AARP"] = "AARP";
  DealType["POINTS_PROMOTION"] = "POINTS_PROMOTION";
})(DealType || (DealType = {}));
export var DeeplinkType;
(function (DeeplinkType) {
  DeeplinkType["HSR"] = "HSR";
  DeeplinkType["PDP"] = "PDP";
})(DeeplinkType || (DeeplinkType = {}));
export var DestinationRecommendationPlaceType;
(function (DestinationRecommendationPlaceType) {
  DestinationRecommendationPlaceType["CITY"] = "CITY";
  DestinationRecommendationPlaceType["NEIGHBORHOOD"] = "NEIGHBORHOOD";
  DestinationRecommendationPlaceType["POI"] = "POI";
})(DestinationRecommendationPlaceType || (DestinationRecommendationPlaceType = {}));
/** Strategy to select the relationship of the output destinations and the origin */
export var DestinationRecommendationStrategy;
(function (DestinationRecommendationStrategy) {
  DestinationRecommendationStrategy["NEARBY"] = "NEARBY";
  DestinationRecommendationStrategy["SIMILAR"] = "SIMILAR";
  DestinationRecommendationStrategy["TOP"] = "TOP";
})(DestinationRecommendationStrategy || (DestinationRecommendationStrategy = {}));
/** Input for travelGuideRecommendation query */
export var DestinationTravelGuidePolicy;
(function (DestinationTravelGuidePolicy) {
  DestinationTravelGuidePolicy["PERSONALIZED"] = "PERSONALIZED";
  DestinationTravelGuidePolicy["USER_LOCATION"] = "USER_LOCATION";
})(DestinationTravelGuidePolicy || (DestinationTravelGuidePolicy = {}));
/** Valid device types */
export var DeviceType;
(function (DeviceType) {
  DeviceType["APP_PHONE"] = "APP_PHONE";
  DeviceType["APP_TABLET"] = "APP_TABLET";
  DeviceType["CHAT_APP"] = "CHAT_APP";
  DeviceType["DESKTOP"] = "DESKTOP";
  DeviceType["MOBILE_PHONE"] = "MOBILE_PHONE";
  DeviceType["MOBILE_TABLET"] = "MOBILE_TABLET";
  DeviceType["VOICE_APP"] = "VOICE_APP";
})(DeviceType || (DeviceType = {}));
export var DialogButtonActionType;
(function (DialogButtonActionType) {
  DialogButtonActionType["CLOSE_DIALOG"] = "CLOSE_DIALOG";
  DialogButtonActionType["CREATE_TRACKING_MUTATION"] = "CREATE_TRACKING_MUTATION";
  DialogButtonActionType["DISABLE_TRACKING_MUTATION"] = "DISABLE_TRACKING_MUTATION";
  DialogButtonActionType["EMAIL_OPT_OUT"] = "EMAIL_OPT_OUT";
  DialogButtonActionType["UPDATE_TRACKING_MUTATION"] = "UPDATE_TRACKING_MUTATION";
})(DialogButtonActionType || (DialogButtonActionType = {}));
export var DialogElementType;
(function (DialogElementType) {
  DialogElementType["CLEAR_RATES"] = "CLEAR_RATES";
  DialogElementType["DELETE_QUOTES"] = "DELETE_QUOTES";
})(DialogElementType || (DialogElementType = {}));
export var DirectFeedbackPageDisplayConditionType;
(function (DirectFeedbackPageDisplayConditionType) {
  DirectFeedbackPageDisplayConditionType["BOOL"] = "BOOL";
  DirectFeedbackPageDisplayConditionType["NONE"] = "NONE";
  DirectFeedbackPageDisplayConditionType["PATTERN"] = "PATTERN";
  DirectFeedbackPageDisplayConditionType["TEXT"] = "TEXT";
})(DirectFeedbackPageDisplayConditionType || (DirectFeedbackPageDisplayConditionType = {}));
/** Used as input value to let the server knows what data needs to be populated in a card. */
export var DiscoveryCardContentSize;
(function (DiscoveryCardContentSize) {
  DiscoveryCardContentSize["ABBREVIATED"] = "ABBREVIATED";
  DiscoveryCardContentSize["FOUNDATION"] = "FOUNDATION";
  DiscoveryCardContentSize["FOUNDATION_DETAILS_LIST"] = "FOUNDATION_DETAILS_LIST";
  DiscoveryCardContentSize["LANDING"] = "LANDING";
  DiscoveryCardContentSize["LONG_FORM"] = "LONG_FORM";
  DiscoveryCardContentSize["LONG_FORM_FEATURED"] = "LONG_FORM_FEATURED";
  DiscoveryCardContentSize["SHORT_FORM"] = "SHORT_FORM";
  DiscoveryCardContentSize["SMART_LANDING"] = "SMART_LANDING";
  DiscoveryCardContentSize["UBER_ABBREVIATED"] = "UBER_ABBREVIATED";
  DiscoveryCardContentSize["UBER_ABBREVIATED_PRICE"] = "UBER_ABBREVIATED_PRICE";
  DiscoveryCardContentSize["UBER_ABBREVIATED_RATING"] = "UBER_ABBREVIATED_RATING";
})(DiscoveryCardContentSize || (DiscoveryCardContentSize = {}));
export var DiscoveryContainerType;
(function (DiscoveryContainerType) {
  DiscoveryContainerType["CAROUSEL"] = "CAROUSEL";
  DiscoveryContainerType["EXPANDO"] = "EXPANDO";
  DiscoveryContainerType["LIST"] = "LIST";
})(DiscoveryContainerType || (DiscoveryContainerType = {}));
/** List of all the managed offering types. */
export var DiscoveryOfferingType;
(function (DiscoveryOfferingType) {
  DiscoveryOfferingType["DESTINATION"] = "DESTINATION";
  DiscoveryOfferingType["PRODUCT"] = "PRODUCT";
})(DiscoveryOfferingType || (DiscoveryOfferingType = {}));
/** Strategy used to resolve pricing information. */
export var DiscoveryPriceStrategy;
(function (DiscoveryPriceStrategy) {
  /**
   * Get the best price in the next 30 days seen in the website per pos, input dates are ignored.
   * Products returned can be not available.
   */
  DiscoveryPriceStrategy["DATELESS"] = "DATELESS";
  /** Call for live price, check availability of returned products. */
  DiscoveryPriceStrategy["LIVE"] = "LIVE";
  /** Do not hydrate price. */
  DiscoveryPriceStrategy["NONE"] = "NONE";
})(DiscoveryPriceStrategy || (DiscoveryPriceStrategy = {}));
/** Used to select which parameters should be used to run the inference. */
export var DiscoveryRecommendationInputContext;
(function (DiscoveryRecommendationInputContext) {
  /** Uses the 'destination' section from the context object. */
  DiscoveryRecommendationInputContext["DESTINATION"] = "DESTINATION";
  /** Uses the 'orderId' section from the context object. */
  DiscoveryRecommendationInputContext["ORDER"] = "ORDER";
  /** Uses the 'product' section from the context object. */
  DiscoveryRecommendationInputContext["PRODUCT"] = "PRODUCT";
  /** Personalize the recommendations using the latest products a user saw. */
  DiscoveryRecommendationInputContext["RECENTLY_VIEWED_PRODUCT"] = "RECENTLY_VIEWED_PRODUCT";
  /** Personalize the recommendations using the recent searches of the user. */
  DiscoveryRecommendationInputContext["RECENT_SEARCHES"] = "RECENT_SEARCHES";
  /** Base the recommendations on the user location. */
  DiscoveryRecommendationInputContext["USER_LOCATION"] = "USER_LOCATION";
})(DiscoveryRecommendationInputContext || (DiscoveryRecommendationInputContext = {}));
/** List of all the managed recommendations strategies. */
export var DiscoveryRecommendationStrategy;
(function (DiscoveryRecommendationStrategy) {
  DiscoveryRecommendationStrategy["ALTERNATIVE"] = "ALTERNATIVE";
  DiscoveryRecommendationStrategy["EG_PLACES"] = "EG_PLACES";
  DiscoveryRecommendationStrategy["LOOKUP_AND_ASSEMBLE"] = "LOOKUP_AND_ASSEMBLE";
  DiscoveryRecommendationStrategy["NEARBY"] = "NEARBY";
  DiscoveryRecommendationStrategy["POPULAR"] = "POPULAR";
  DiscoveryRecommendationStrategy["SIMILAR"] = "SIMILAR";
  DiscoveryRecommendationStrategy["TRENDING"] = "TRENDING";
})(DiscoveryRecommendationStrategy || (DiscoveryRecommendationStrategy = {}));
/** Enum of the units of measure and their abbreviations */
export var DistanceUnit;
(function (DistanceUnit) {
  DistanceUnit["KILOMETER"] = "KILOMETER";
  DistanceUnit["MILE"] = "MILE";
})(DistanceUnit || (DistanceUnit = {}));
/** Different types of duration span input validations. */
export var DurationSpanValidationType;
(function (DurationSpanValidationType) {
  /** Used to validate that a maximum input value is greater than a minimum input value. */
  DurationSpanValidationType["MAXIMUM_GREATER_THAN_MINIMUM"] = "MAXIMUM_GREATER_THAN_MINIMUM";
  /** Used to validate that the user input is less than or equal to some specified value. Example: Maximum 10 nights. */
  DurationSpanValidationType["MAXIMUM_VALUE"] = "MAXIMUM_VALUE";
  /** Used to validate that a minimum input value is less than a maximum input value. */
  DurationSpanValidationType["MINIMUM_LESS_THAN_MAXIMUM"] = "MINIMUM_LESS_THAN_MAXIMUM";
  /** Used to validate that the user input is greater than or equal to some specified value. Example: Minimum 2 nights. */
  DurationSpanValidationType["MINIMUM_VALUE"] = "MINIMUM_VALUE";
  /** Used to validate that the user input has a value. */
  DurationSpanValidationType["REQUIRED_VALUE"] = "REQUIRED_VALUE";
})(DurationSpanValidationType || (DurationSpanValidationType = {}));
/** Styles established in EGDS design docs. https://www.figma.com/file/bbPtPOgPN4sttR3BzDaTZc/Buttons */
export var EGDSButtonStyle;
(function (EGDSButtonStyle) {
  EGDSButtonStyle["PRIMARY"] = "PRIMARY";
  EGDSButtonStyle["SECONDARY"] = "SECONDARY";
  EGDSButtonStyle["TERTIARY"] = "TERTIARY";
})(EGDSButtonStyle || (EGDSButtonStyle = {}));
/**
 * Represents the variations of a card. Can be used with EGDSCard union members.
 * https://www.figma.com/file/M3udFrUojCRwrcoAiPnQ3Yaw/Card?node-id=11143%3A833&t=blroVUeSfs4Eqnoj-0
 */
export var EGDSCardThemes;
(function (EGDSCardThemes) {
  EGDSCardThemes["BORDERED"] = "BORDERED";
  EGDSCardThemes["PADDED"] = "PADDED";
})(EGDSCardThemes || (EGDSCardThemes = {}));
/** Defines how checkbox state should be displayed on client. */
export var EGDSCheckBoxState;
(function (EGDSCheckBoxState) {
  EGDSCheckBoxState["CHECKED"] = "CHECKED";
  EGDSCheckBoxState["INDETERMINATE"] = "INDETERMINATE";
  EGDSCheckBoxState["UNCHECKED"] = "UNCHECKED";
})(EGDSCheckBoxState || (EGDSCheckBoxState = {}));
/** Represents the label theme for the date range result. */
export var EGDSDateRangeResultTheme;
(function (EGDSDateRangeResultTheme) {
  EGDSDateRangeResultTheme["LINK"] = "LINK";
  EGDSDateRangeResultTheme["POSITIVE"] = "POSITIVE";
})(EGDSDateRangeResultTheme || (EGDSDateRangeResultTheme = {}));
/** Represents short day name. */
export var EGDSDayName;
(function (EGDSDayName) {
  EGDSDayName["FRI"] = "FRI";
  EGDSDayName["MON"] = "MON";
  EGDSDayName["SAT"] = "SAT";
  EGDSDayName["SUN"] = "SUN";
  EGDSDayName["THU"] = "THU";
  EGDSDayName["TUE"] = "TUE";
  EGDSDayName["WED"] = "WED";
})(EGDSDayName || (EGDSDayName = {}));
/** Represents the type of decorative in the text element. e.g. superscript */
export var EGDSDecorativeText;
(function (EGDSDecorativeText) {
  /** Renders with a background color to highlight the text */
  EGDSDecorativeText["HIGHLIGHT"] = "HIGHLIGHT";
  /** Renders with a line through the text */
  EGDSDecorativeText["LINE_THROUGH"] = "LINE_THROUGH";
  /** Renders as a subscript at the bottom of the text line */
  EGDSDecorativeText["SUBSCRIPT"] = "SUBSCRIPT";
  /** Renders as a superscript at the top of the text line */
  EGDSDecorativeText["SUPERSCRIPT"] = "SUPERSCRIPT";
  /** Renders with a line under the text */
  EGDSDecorativeText["UNDERLINE"] = "UNDERLINE";
})(EGDSDecorativeText || (EGDSDecorativeText = {}));
/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSHeading or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export var EGDSHeadingStyle;
(function (EGDSHeadingStyle) {
  EGDSHeadingStyle["H1"] = "H1";
  EGDSHeadingStyle["H2"] = "H2";
  EGDSHeadingStyle["H3"] = "H3";
  EGDSHeadingStyle["H4"] = "H4";
  EGDSHeadingStyle["H5"] = "H5";
  EGDSHeadingStyle["H6"] = "H6";
  EGDSHeadingStyle["H7"] = "H7";
  EGDSHeadingStyle["H8"] = "H8";
})(EGDSHeadingStyle || (EGDSHeadingStyle = {}));
/** Represents where the icon should be places in a EGDS Standard Link */
export var EGDSIconPosition;
(function (EGDSIconPosition) {
  EGDSIconPosition["LEADING"] = "LEADING";
  EGDSIconPosition["TRAILING"] = "TRAILING";
})(EGDSIconPosition || (EGDSIconPosition = {}));
/** Option for selecting an infant seat on a plane. */
export var EGDSInfantSeat;
(function (EGDSInfantSeat) {
  EGDSInfantSeat["IN_SEAT"] = "IN_SEAT";
  EGDSInfantSeat["ON_LAP"] = "ON_LAP";
})(EGDSInfantSeat || (EGDSInfantSeat = {}));
/** Represents the size of the text in a EGDS Standard Link */
export var EGDSLinkSize;
(function (EGDSLinkSize) {
  EGDSLinkSize["LARGE"] = "LARGE";
  EGDSLinkSize["MEDIUM"] = "MEDIUM";
  EGDSLinkSize["SMALL"] = "SMALL";
})(EGDSLinkSize || (EGDSLinkSize = {}));
/** The type of feature - PLACE OR PROPERTY */
export var EGDSMapFeatureType;
(function (EGDSMapFeatureType) {
  EGDSMapFeatureType["PLACE"] = "PLACE";
  EGDSMapFeatureType["PROPERTY"] = "PROPERTY";
})(EGDSMapFeatureType || (EGDSMapFeatureType = {}));
/** The initial viewport to use for the map when markers have been pushed and just before they are rendered */
export var EGDSMapInitialViewport;
(function (EGDSMapInitialViewport) {
  /** To use bounds value as initial viewport */
  EGDSMapInitialViewport["BOUNDS"] = "BOUNDS";
  /** To compute a bound from a set of options with a specified center */
  EGDSMapInitialViewport["CENTERED_COMPUTED_BOUNDS"] = "CENTERED_COMPUTED_BOUNDS";
  /** To use zoom and center values as initial viewport */
  EGDSMapInitialViewport["CENTER_AND_ZOOM"] = "CENTER_AND_ZOOM";
  /** To compute a bound from a set of options */
  EGDSMapInitialViewport["COMPUTED_BOUNDS"] = "COMPUTED_BOUNDS";
  /** Will center the map to show all markers pushed to the map */
  EGDSMapInitialViewport["FIT_MARKERS"] = "FIT_MARKERS";
})(EGDSMapInitialViewport || (EGDSMapInitialViewport = {}));
/** Marker pin style based on the applied filter and inventory - AVAILABLE, FILTERED, SOLD_OUT or UNKNOWN */
export var EGDSMapMarkerStatus;
(function (EGDSMapMarkerStatus) {
  EGDSMapMarkerStatus["AVAILABLE"] = "AVAILABLE";
  EGDSMapMarkerStatus["FILTERED"] = "FILTERED";
  EGDSMapMarkerStatus["SOLD_OUT"] = "SOLD_OUT";
  EGDSMapMarkerStatus["UNKNOWN"] = "UNKNOWN";
})(EGDSMapMarkerStatus || (EGDSMapMarkerStatus = {}));
/** 'zoomAndCenter' (requires zoom + center) or 'fitBounds' (map will include all rendered markers) */
export var EGDSMapPositionMode;
(function (EGDSMapPositionMode) {
  EGDSMapPositionMode["FIT_BOUNDS"] = "FIT_BOUNDS";
  EGDSMapPositionMode["ZOOM_AND_CENTER"] = "ZOOM_AND_CENTER";
})(EGDSMapPositionMode || (EGDSMapPositionMode = {}));
/** type of maps that can be used */
export var EGDSMapProvider;
(function (EGDSMapProvider) {
  EGDSMapProvider["GOOGLE"] = "GOOGLE";
  EGDSMapProvider["MAPBOX"] = "MAPBOX";
  EGDSMapProvider["MAPKIT"] = "MAPKIT";
})(EGDSMapProvider || (EGDSMapProvider = {}));
export var EGDSMark;
(function (EGDSMark) {
  EGDSMark["AARP"] = "AARP";
  EGDSMark["AARP_MEMBER_BENEFITS"] = "AARP_MEMBER_BENEFITS";
  EGDSMark["ADDON"] = "ADDON";
  EGDSMark["AIR_NEW_ZEALAND"] = "AIR_NEW_ZEALAND";
  EGDSMark["APPLE"] = "APPLE";
  EGDSMark["APPLE_MAPS"] = "APPLE_MAPS";
  EGDSMark["APP_CTX"] = "APP_CTX";
  EGDSMark["APP_EBOOK"] = "APP_EBOOK";
  EGDSMark["APP_EXP"] = "APP_EXP";
  EGDSMark["APP_HOTWIRE"] = "APP_HOTWIRE";
  EGDSMark["APP_ORB"] = "APP_ORB";
  EGDSMark["APP_TVLY"] = "APP_TVLY";
  EGDSMark["APP_WOTIF"] = "APP_WOTIF";
  EGDSMark["BONUS_EBOOK"] = "BONUS_EBOOK";
  EGDSMark["COMMISSION_TIER_FOUR"] = "COMMISSION_TIER_FOUR";
  EGDSMark["COMMISSION_TIER_ONE"] = "COMMISSION_TIER_ONE";
  EGDSMark["COMMISSION_TIER_THREE"] = "COMMISSION_TIER_THREE";
  EGDSMark["COMMISSION_TIER_TWO"] = "COMMISSION_TIER_TWO";
  EGDSMark["FACEBOOK"] = "FACEBOOK";
  EGDSMark["FLAGS__AR"] = "FLAGS__AR";
  EGDSMark["FLAGS__AS"] = "FLAGS__AS";
  EGDSMark["FLAGS__AT"] = "FLAGS__AT";
  EGDSMark["FLAGS__AU"] = "FLAGS__AU";
  EGDSMark["FLAGS__BE"] = "FLAGS__BE";
  EGDSMark["FLAGS__BO"] = "FLAGS__BO";
  EGDSMark["FLAGS__BR"] = "FLAGS__BR";
  EGDSMark["FLAGS__BZ"] = "FLAGS__BZ";
  EGDSMark["FLAGS__CA"] = "FLAGS__CA";
  EGDSMark["FLAGS__CH"] = "FLAGS__CH";
  EGDSMark["FLAGS__CL"] = "FLAGS__CL";
  EGDSMark["FLAGS__CN"] = "FLAGS__CN";
  EGDSMark["FLAGS__CO"] = "FLAGS__CO";
  EGDSMark["FLAGS__CR"] = "FLAGS__CR";
  EGDSMark["FLAGS__CZ"] = "FLAGS__CZ";
  EGDSMark["FLAGS__DE"] = "FLAGS__DE";
  EGDSMark["FLAGS__DK"] = "FLAGS__DK";
  EGDSMark["FLAGS__EC"] = "FLAGS__EC";
  EGDSMark["FLAGS__EE"] = "FLAGS__EE";
  EGDSMark["FLAGS__EG"] = "FLAGS__EG";
  EGDSMark["FLAGS__ES"] = "FLAGS__ES";
  EGDSMark["FLAGS__EU"] = "FLAGS__EU";
  EGDSMark["FLAGS__FI"] = "FLAGS__FI";
  EGDSMark["FLAGS__FR"] = "FLAGS__FR";
  EGDSMark["FLAGS__GR"] = "FLAGS__GR";
  EGDSMark["FLAGS__GT"] = "FLAGS__GT";
  EGDSMark["FLAGS__GY"] = "FLAGS__GY";
  EGDSMark["FLAGS__HK"] = "FLAGS__HK";
  EGDSMark["FLAGS__HN"] = "FLAGS__HN";
  EGDSMark["FLAGS__HR"] = "FLAGS__HR";
  EGDSMark["FLAGS__HU"] = "FLAGS__HU";
  EGDSMark["FLAGS__ID"] = "FLAGS__ID";
  EGDSMark["FLAGS__IE"] = "FLAGS__IE";
  EGDSMark["FLAGS__IL"] = "FLAGS__IL";
  EGDSMark["FLAGS__IN"] = "FLAGS__IN";
  EGDSMark["FLAGS__IS"] = "FLAGS__IS";
  EGDSMark["FLAGS__IT"] = "FLAGS__IT";
  EGDSMark["FLAGS__JP"] = "FLAGS__JP";
  EGDSMark["FLAGS__KR"] = "FLAGS__KR";
  EGDSMark["FLAGS__L1"] = "FLAGS__L1";
  EGDSMark["FLAGS__LT"] = "FLAGS__LT";
  EGDSMark["FLAGS__LV"] = "FLAGS__LV";
  EGDSMark["FLAGS__MX"] = "FLAGS__MX";
  EGDSMark["FLAGS__MY"] = "FLAGS__MY";
  EGDSMark["FLAGS__NI"] = "FLAGS__NI";
  EGDSMark["FLAGS__NL"] = "FLAGS__NL";
  EGDSMark["FLAGS__NO"] = "FLAGS__NO";
  EGDSMark["FLAGS__NZ"] = "FLAGS__NZ";
  EGDSMark["FLAGS__PA"] = "FLAGS__PA";
  EGDSMark["FLAGS__PE"] = "FLAGS__PE";
  EGDSMark["FLAGS__PH"] = "FLAGS__PH";
  EGDSMark["FLAGS__PL"] = "FLAGS__PL";
  EGDSMark["FLAGS__PT"] = "FLAGS__PT";
  EGDSMark["FLAGS__PY"] = "FLAGS__PY";
  EGDSMark["FLAGS__RU"] = "FLAGS__RU";
  EGDSMark["FLAGS__SA"] = "FLAGS__SA";
  EGDSMark["FLAGS__SE"] = "FLAGS__SE";
  EGDSMark["FLAGS__SG"] = "FLAGS__SG";
  EGDSMark["FLAGS__SK"] = "FLAGS__SK";
  EGDSMark["FLAGS__SR"] = "FLAGS__SR";
  EGDSMark["FLAGS__SV"] = "FLAGS__SV";
  EGDSMark["FLAGS__TH"] = "FLAGS__TH";
  EGDSMark["FLAGS__TR"] = "FLAGS__TR";
  EGDSMark["FLAGS__TW"] = "FLAGS__TW";
  EGDSMark["FLAGS__UA"] = "FLAGS__UA";
  EGDSMark["FLAGS__UAE"] = "FLAGS__UAE";
  EGDSMark["FLAGS__UK"] = "FLAGS__UK";
  EGDSMark["FLAGS__US"] = "FLAGS__US";
  EGDSMark["FLAGS__UY"] = "FLAGS__UY";
  EGDSMark["FLAGS__VE"] = "FLAGS__VE";
  EGDSMark["FLAGS__VN"] = "FLAGS__VN";
  EGDSMark["FLAGS__WW"] = "FLAGS__WW";
  EGDSMark["FLAGS__ZA"] = "FLAGS__ZA";
  EGDSMark["GOOGLE"] = "GOOGLE";
  EGDSMark["GOOGLE_LOGO"] = "GOOGLE_LOGO";
  EGDSMark["GOOGLE_MAP"] = "GOOGLE_MAP";
  EGDSMark["GOOGLE_TRANSLATED"] = "GOOGLE_TRANSLATED";
  EGDSMark["HAWAIIAN"] = "HAWAIIAN";
  EGDSMark["HOTWIRE_HOTRATE_CIRCLE"] = "HOTWIRE_HOTRATE_CIRCLE";
  EGDSMark["LINE"] = "LINE";
  EGDSMark["LOYALTY_HOTELS__HIGH_TIER"] = "LOYALTY_HOTELS__HIGH_TIER";
  EGDSMark["LOYALTY_HOTELS__LOW_TIER"] = "LOYALTY_HOTELS__LOW_TIER";
  EGDSMark["LOYALTY_HOTELS__MIDDLE_TIER"] = "LOYALTY_HOTELS__MIDDLE_TIER";
  EGDSMark["LOYALTY_HOTELS__REWARDS"] = "LOYALTY_HOTELS__REWARDS";
  EGDSMark["LOYALTY_HOTELS__STAMP_EMPTY"] = "LOYALTY_HOTELS__STAMP_EMPTY";
  EGDSMark["LOYALTY_HOTELS__STAMP_PENDING"] = "LOYALTY_HOTELS__STAMP_PENDING";
  EGDSMark["LOYALTY_HOTELS__STAMP_SEARCHED"] = "LOYALTY_HOTELS__STAMP_SEARCHED";
  EGDSMark["LOYALTY_TVLY"] = "LOYALTY_TVLY";
  EGDSMark["MAPBOX"] = "MAPBOX";
  EGDSMark["MIP_PRIMARY"] = "MIP_PRIMARY";
  EGDSMark["MIP_REVERSE"] = "MIP_REVERSE";
  EGDSMark["MIP_SECONDARY"] = "MIP_SECONDARY";
  EGDSMark["MOD_CTX"] = "MOD_CTX";
  EGDSMark["MOD_EBOOK"] = "MOD_EBOOK";
  EGDSMark["MOD_EXP"] = "MOD_EXP";
  EGDSMark["MOD_HOTELS"] = "MOD_HOTELS";
  EGDSMark["MOD_ORB"] = "MOD_ORB";
  EGDSMark["MOD_TVLY"] = "MOD_TVLY";
  EGDSMark["MOD_WOTIF"] = "MOD_WOTIF";
  EGDSMark["NAVER"] = "NAVER";
  EGDSMark["ONEKEY__ABRITEL"] = "ONEKEY__ABRITEL";
  EGDSMark["ONEKEY__BLUE"] = "ONEKEY__BLUE";
  EGDSMark["ONEKEY__BOOKABACH"] = "ONEKEY__BOOKABACH";
  EGDSMark["ONEKEY__CASH"] = "ONEKEY__CASH";
  EGDSMark["ONEKEY__EXPEDIA"] = "ONEKEY__EXPEDIA";
  EGDSMark["ONEKEY__FEWODIREKT"] = "ONEKEY__FEWODIREKT";
  EGDSMark["ONEKEY__GOLD"] = "ONEKEY__GOLD";
  EGDSMark["ONEKEY__HOTELS__CHINESE"] = "ONEKEY__HOTELS__CHINESE";
  EGDSMark["ONEKEY__HOTELS__ENGLISH"] = "ONEKEY__HOTELS__ENGLISH";
  EGDSMark["ONEKEY__HOTELS__PORTUGUESE"] = "ONEKEY__HOTELS__PORTUGUESE";
  EGDSMark["ONEKEY__HOTELS__SPANISH"] = "ONEKEY__HOTELS__SPANISH";
  EGDSMark["ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT"] = "ONEKEY__KNOCKEDOUT__ALWAYS_LIGHT";
  EGDSMark["ONEKEY__PLATINUM"] = "ONEKEY__PLATINUM";
  EGDSMark["ONEKEY__SILVER"] = "ONEKEY__SILVER";
  EGDSMark["ONEKEY__STANDARD"] = "ONEKEY__STANDARD";
  EGDSMark["ONEKEY__STANDARD__ALWAYS_LIGHT"] = "ONEKEY__STANDARD__ALWAYS_LIGHT";
  EGDSMark["ONEKEY__STAYZ"] = "ONEKEY__STAYZ";
  EGDSMark["ONEKEY__VRBO"] = "ONEKEY__VRBO";
  EGDSMark["ONEKEY__WORDMARK"] = "ONEKEY__WORDMARK";
  EGDSMark["ONEKEY__WORDMARK__ALWAYS_LIGHT"] = "ONEKEY__WORDMARK__ALWAYS_LIGHT";
  EGDSMark["PAYMENT__7_ELEVEN"] = "PAYMENT__7_ELEVEN";
  EGDSMark["PAYMENT__AFFIRM"] = "PAYMENT__AFFIRM";
  EGDSMark["PAYMENT__AIRPLUS"] = "PAYMENT__AIRPLUS";
  EGDSMark["PAYMENT__ALIPAY"] = "PAYMENT__ALIPAY";
  EGDSMark["PAYMENT__AMEX"] = "PAYMENT__AMEX";
  EGDSMark["PAYMENT__APPLEPAY"] = "PAYMENT__APPLEPAY";
  EGDSMark["PAYMENT__CHASE"] = "PAYMENT__CHASE";
  EGDSMark["PAYMENT__CLICKTOPAY"] = "PAYMENT__CLICKTOPAY";
  EGDSMark["PAYMENT__DINERS_CLUB_INTERNATIONAL"] = "PAYMENT__DINERS_CLUB_INTERNATIONAL";
  EGDSMark["PAYMENT__DISCOVER"] = "PAYMENT__DISCOVER";
  EGDSMark["PAYMENT__GOOGLE_PAY"] = "PAYMENT__GOOGLE_PAY";
  EGDSMark["PAYMENT__IDEAL"] = "PAYMENT__IDEAL";
  EGDSMark["PAYMENT__JAPAN_CREDIT_BUREAU"] = "PAYMENT__JAPAN_CREDIT_BUREAU";
  EGDSMark["PAYMENT__KLARNA"] = "PAYMENT__KLARNA";
  EGDSMark["PAYMENT__MAESTRO"] = "PAYMENT__MAESTRO";
  EGDSMark["PAYMENT__MASTERCARD"] = "PAYMENT__MASTERCARD";
  EGDSMark["PAYMENT__MASTERPASS"] = "PAYMENT__MASTERPASS";
  EGDSMark["PAYMENT__PAYPAL"] = "PAYMENT__PAYPAL";
  EGDSMark["PAYMENT__SAMSUNG_CARD"] = "PAYMENT__SAMSUNG_CARD";
  EGDSMark["PAYMENT__UATP"] = "PAYMENT__UATP";
  EGDSMark["PAYMENT__UNION_PAY"] = "PAYMENT__UNION_PAY";
  EGDSMark["PAYMENT__VISA"] = "PAYMENT__VISA";
  EGDSMark["PLUS_CIRCLE"] = "PLUS_CIRCLE";
  EGDSMark["PLUS_CIRCLE_CTX"] = "PLUS_CIRCLE_CTX";
  EGDSMark["PLUS_CIRCLE_EBOOK"] = "PLUS_CIRCLE_EBOOK";
  EGDSMark["PLUS_CIRCLE_ORB"] = "PLUS_CIRCLE_ORB";
  EGDSMark["PLUS_CIRCLE_TVLY"] = "PLUS_CIRCLE_TVLY";
  EGDSMark["PLUS_CIRCLE_WOTIF"] = "PLUS_CIRCLE_WOTIF";
  EGDSMark["PREMIUM_TVLY"] = "PREMIUM_TVLY";
  EGDSMark["REWARDS_ORB"] = "REWARDS_ORB";
  EGDSMark["TRIPADVISOR"] = "TRIPADVISOR";
  EGDSMark["TRIVAGO"] = "TRIVAGO";
  EGDSMark["VAP_HOTELS__HIGH_TIER"] = "VAP_HOTELS__HIGH_TIER";
  EGDSMark["VAP_HOTELS__LOW_TIER"] = "VAP_HOTELS__LOW_TIER";
  EGDSMark["VAP_HOTELS__MIDDLE_TIER"] = "VAP_HOTELS__MIDDLE_TIER";
  EGDSMark["VIP_BEX"] = "VIP_BEX";
  EGDSMark["VIP_CIRCLE_BEX"] = "VIP_CIRCLE_BEX";
  EGDSMark["VIP_CIRCLE_EBOOKERS"] = "VIP_CIRCLE_EBOOKERS";
  EGDSMark["VIP_CIRCLE_HOTELS"] = "VIP_CIRCLE_HOTELS";
  EGDSMark["VIP_CIRCLE_ORBITZ"] = "VIP_CIRCLE_ORBITZ";
  EGDSMark["VIP_EBOOKERS"] = "VIP_EBOOKERS";
  EGDSMark["VIP_ORBITZ"] = "VIP_ORBITZ";
  EGDSMark["VIRGIN_AU"] = "VIRGIN_AU";
  EGDSMark["VRBO"] = "VRBO";
})(EGDSMark || (EGDSMark = {}));
/**
 * This should only be used in unique design cases where the UX changes frequently and specific product requirements must be met.
 * Most teams should just use String over EGDSParagraph or EGDSText.
 *
 * https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography
 */
export var EGDSParagraphStyle;
(function (EGDSParagraphStyle) {
  EGDSParagraphStyle["P1"] = "P1";
  EGDSParagraphStyle["P2"] = "P2";
  EGDSParagraphStyle["P3"] = "P3";
})(EGDSParagraphStyle || (EGDSParagraphStyle = {}));
/** The type of path for directions */
export var EGDSPathType;
(function (EGDSPathType) {
  EGDSPathType["CYCLING"] = "CYCLING";
  EGDSPathType["DRIVING"] = "DRIVING";
  EGDSPathType["FLYING"] = "FLYING";
  EGDSPathType["TRANSIT"] = "TRANSIT";
  EGDSPathType["WALKING"] = "WALKING";
})(EGDSPathType || (EGDSPathType = {}));
/** Possible camera movement for the photosphere image */
export var EGDSPhotosphereCameraMovement;
(function (EGDSPhotosphereCameraMovement) {
  EGDSPhotosphereCameraMovement["AUTO_PAN"] = "AUTO_PAN";
  EGDSPhotosphereCameraMovement["DISABLED"] = "DISABLED";
  EGDSPhotosphereCameraMovement["FULL_MOVE"] = "FULL_MOVE";
})(EGDSPhotosphereCameraMovement || (EGDSPhotosphereCameraMovement = {}));
/** Type of EGDSSheet */
export var EGDSSheetType;
(function (EGDSSheetType) {
  EGDSSheetType["BOTTOM"] = "BOTTOM";
  EGDSSheetType["CENTERED"] = "CENTERED";
  EGDSSheetType["FULLSCREEN"] = "FULLSCREEN";
  EGDSSheetType["POPOVER"] = "POPOVER";
  EGDSSheetType["SIDE"] = "SIDE";
})(EGDSSheetType || (EGDSSheetType = {}));
export var EGDSTextListItemStyle;
(function (EGDSTextListItemStyle) {
  EGDSTextListItemStyle["DEFAULT"] = "DEFAULT";
  EGDSTextListItemStyle["EMPHASIS"] = "EMPHASIS";
  EGDSTextListItemStyle["LOYALTY"] = "LOYALTY";
  EGDSTextListItemStyle["NEGATIVE"] = "NEGATIVE";
  EGDSTextListItemStyle["POSITIVE"] = "POSITIVE";
})(EGDSTextListItemStyle || (EGDSTextListItemStyle = {}));
/** https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography */
export var EGDSTextListSize;
(function (EGDSTextListSize) {
  EGDSTextListSize["LIST_1"] = "LIST_1";
  EGDSTextListSize["LIST_2"] = "LIST_2";
  EGDSTextListSize["LIST_3"] = "LIST_3";
})(EGDSTextListSize || (EGDSTextListSize = {}));
/**
 * This represents UI variations of EGDS List
 *        figma: https://www.figma.com/file/IHAiPyllJIlO6g4f2qdNW4zq/Typography?node-id=11931%3A11857
 */
export var EGDSTextListType;
(function (EGDSTextListType) {
  EGDSTextListType["BULLET"] = "BULLET";
  EGDSTextListType["ICON"] = "ICON";
  EGDSTextListType["NO_BULLET"] = "NO_BULLET";
  EGDSTextListType["NUMBER"] = "NUMBER";
})(EGDSTextListType || (EGDSTextListType = {}));
/** Travelers types used on travelers selector */
export var EGDSTravelerType;
(function (EGDSTravelerType) {
  EGDSTravelerType["ADULT"] = "ADULT";
  EGDSTravelerType["CHILD"] = "CHILD";
  EGDSTravelerType["INFANT"] = "INFANT";
  EGDSTravelerType["SENIOR"] = "SENIOR";
  EGDSTravelerType["YOUTH"] = "YOUTH";
})(EGDSTravelerType || (EGDSTravelerType = {}));
/** Represents different type of travelers validation. */
export var EGDSTravelersValidationType;
(function (EGDSTravelersValidationType) {
  /** Used to validate child age required. */
  EGDSTravelersValidationType["CHILD_AGE_REQUIRED"] = "CHILD_AGE_REQUIRED";
  /** Used to validate maximum number of allowed infants in seat. */
  EGDSTravelersValidationType["MANY_INFANT_IN_SEAT"] = "MANY_INFANT_IN_SEAT";
  /** Used to validate maximum number of allowed infants on lap. */
  EGDSTravelersValidationType["MANY_INFANT_ON_LAP"] = "MANY_INFANT_ON_LAP";
  /** Used to validate maximum allowed travelers for search. */
  EGDSTravelersValidationType["MAX_TRAVELERS"] = "MAX_TRAVELERS";
})(EGDSTravelersValidationType || (EGDSTravelersValidationType = {}));
/** Defines how typeahead results should be displayed on client. */
export var EGDSTypeaheadRenderType;
(function (EGDSTypeaheadRenderType) {
  EGDSTypeaheadRenderType["ADAPTIVE"] = "ADAPTIVE";
  EGDSTypeaheadRenderType["DIALOG"] = "DIALOG";
  EGDSTypeaheadRenderType["MENU"] = "MENU";
})(EGDSTypeaheadRenderType || (EGDSTypeaheadRenderType = {}));
/**
 * Used to specify event type for an interaction.
 * See https://github.expedia.biz/Brand-Expedia/uis-prime-schemas/blob/master/schemas/micro/platform/referrer.json#L26
 */
export var EGReferrerEventType;
(function (EGReferrerEventType) {
  /** Used to track a click on a UI component. */
  EGReferrerEventType["CLICK"] = "CLICK";
  /** Used to track an impression of a UI component. */
  EGReferrerEventType["IMPRESSION"] = "IMPRESSION";
})(EGReferrerEventType || (EGReferrerEventType = {}));
/** Predefined image sizes */
export var EMImageSize;
(function (EMImageSize) {
  EMImageSize["L"] = "L";
  EMImageSize["M"] = "M";
  EMImageSize["S"] = "S";
  EMImageSize["XL"] = "XL";
  EMImageSize["XS"] = "XS";
})(EMImageSize || (EMImageSize = {}));
export var EmptyStateType;
(function (EmptyStateType) {
  EmptyStateType["ENABLE_PUSH"] = "ENABLE_PUSH";
  EmptyStateType["EXPLORE_TRIPS"] = "EXPLORE_TRIPS";
  EmptyStateType["SIGN_IN"] = "SIGN_IN";
})(EmptyStateType || (EmptyStateType = {}));
export var EventType;
(function (EventType) {
  EventType["CancelledTripsItemDetailViewed"] = "CancelledTripsItemDetailViewed";
  EventType["DeleteTripAlertPresented"] = "DeleteTripAlertPresented";
  EventType["DeleteTripDialogPresented"] = "DeleteTripDialogPresented";
  EventType["DeleteTripErrorToastPresented"] = "DeleteTripErrorToastPresented";
  EventType["DeleteTripFailed"] = "DeleteTripFailed";
  EventType["DeleteTripSucceeded"] = "DeleteTripSucceeded";
  EventType["DeleteTripSuccessToastPresented"] = "DeleteTripSuccessToastPresented";
  EventType["HeroModuleCampaign"] = "HeroModuleCampaign";
  EventType["HeroModuleColdStart"] = "HeroModuleColdStart";
  EventType["ItinActiveCar"] = "ItinActiveCar";
  EventType["ItinActiveCruise"] = "ItinActiveCruise";
  EventType["ItinActiveFlight"] = "ItinActiveFlight";
  EventType["ItinActiveGT"] = "ItinActiveGT";
  EventType["ItinActiveHotel"] = "ItinActiveHotel";
  EventType["ItinActiveLX"] = "ItinActiveLX";
  EventType["ItinActivePackageFH"] = "ItinActivePackageFH";
  EventType["ItinActiveRail"] = "ItinActiveRail";
  EventType["ItinCancellation"] = "ItinCancellation";
  EventType["MoveItemDrawerPresented"] = "MoveItemDrawerPresented";
  EventType["MoveItemErrorToastPresented"] = "MoveItemErrorToastPresented";
  EventType["MoveItemSubmitted"] = "MoveItemSubmitted";
  EventType["MoveItemSuccessToastPresented"] = "MoveItemSuccessToastPresented";
  EventType["MoveItemSuceeded"] = "MoveItemSuceeded";
  EventType["MoveLinkedItemsDialogPresented"] = "MoveLinkedItemsDialogPresented";
  EventType["RemoveItemDialogPresented"] = "RemoveItemDialogPresented";
  EventType["TripItemMenuPresented"] = "TripItemMenuPresented";
  EventType["TripSignInDialogPresented"] = "TripSignInDialogPresented";
  EventType["TripsCancelledItemDetailViewed"] = "TripsCancelledItemDetailViewed";
  EventType["TripsCollabInviteConfirmationViewed"] = "TripsCollabInviteConfirmationViewed";
  EventType["TripsCollabInviteFailureViewed"] = "TripsCollabInviteFailureViewed";
  EventType["TripsCollabInviteSucceeded"] = "TripsCollabInviteSucceeded";
  EventType["TripsCollabJoinGroupFailed"] = "TripsCollabJoinGroupFailed";
  EventType["TripsCollabJoinGroupSucceeded"] = "TripsCollabJoinGroupSucceeded";
  EventType["TripsCollabJoinTripConfirmationViewed"] = "TripsCollabJoinTripConfirmationViewed";
  EventType["TripsCollabJoinTripErrorToastPresented"] = "TripsCollabJoinTripErrorToastPresented";
  EventType["TripsCollabLandingScreenRedirectToTripOverView"] = "TripsCollabLandingScreenRedirectToTripOverView";
  EventType["TripsCollabLandingScreenViewed"] = "TripsCollabLandingScreenViewed";
  EventType["TripsCollabManageGroupViewed"] = "TripsCollabManageGroupViewed";
  EventType["TripsCollabViewPresentedActivities"] = "TripsCollabViewPresentedActivities";
  EventType["TripsCollabViewPresentedCars"] = "TripsCollabViewPresentedCars";
  EventType["TripsCollabViewPresentedCruise"] = "TripsCollabViewPresentedCruise";
  EventType["TripsCollabViewPresentedFlight"] = "TripsCollabViewPresentedFlight";
  EventType["TripsCollabViewPresentedHotel"] = "TripsCollabViewPresentedHotel";
  EventType["TripsCollabViewPresentedVacationRental"] = "TripsCollabViewPresentedVacationRental";
  EventType["TripsEditItemSucceeded"] = "TripsEditItemSucceeded";
  EventType["TripsEditTripErrorToastPresented"] = "TripsEditTripErrorToastPresented";
  EventType["TripsEditTripPresented"] = "TripsEditTripPresented";
  EventType["TripsEditTripSubmitted"] = "TripsEditTripSubmitted";
  EventType["TripsEditTripSuccessToastPresented"] = "TripsEditTripSuccessToastPresented";
  EventType["TripsFlightScheduleChangeBannerDisplayed"] = "TripsFlightScheduleChangeBannerDisplayed";
  EventType["TripsHeroModuleCurrentTrip"] = "TripsHeroModuleCurrentTrip";
  EventType["TripsHeroModulePossibleActivityTrip"] = "TripsHeroModulePossibleActivityTrip";
  EventType["TripsHeroModulePossibleAirTrip"] = "TripsHeroModulePossibleAirTrip";
  EventType["TripsHeroModulePossibleCarTrip"] = "TripsHeroModulePossibleCarTrip";
  EventType["TripsHeroModulePossibleHotelTrip"] = "TripsHeroModulePossibleHotelTrip";
  EventType["TripsHeroModulePossiblePackageHFTrip"] = "TripsHeroModulePossiblePackageHFTrip";
  EventType["TripsHeroModulePossibleTrip"] = "TripsHeroModulePossibleTrip";
  EventType["TripsHeroModulePotentialTrip"] = "TripsHeroModulePotentialTrip";
  EventType["TripsHeroModuleUpcomingTrip"] = "TripsHeroModuleUpcomingTrip";
  EventType["TripsItemDetailViewed"] = "TripsItemDetailViewed";
  EventType["TripsListViewed"] = "TripsListViewed";
  EventType["TripsModuleDestinationGuide"] = "TripsModuleDestinationGuide";
  EventType["TripsModuleRecommendedActivity"] = "TripsModuleRecommendedActivity";
  EventType["TripsModuleRecommendedCar"] = "TripsModuleRecommendedCar";
  EventType["TripsModuleRecommendedHotel"] = "TripsModuleRecommendedHotel";
  EventType["TripsOverviewViewed"] = "TripsOverviewViewed";
  EventType["TripsTravelPlannerItinNumberPresent"] = "TripsTravelPlannerItinNumberPresent";
  EventType["Unknown"] = "Unknown";
})(EventType || (EventType = {}));
export var ExpLineOfBusiness;
(function (ExpLineOfBusiness) {
  ExpLineOfBusiness["ACTIVITIES"] = "ACTIVITIES";
  ExpLineOfBusiness["CAR"] = "CAR";
  ExpLineOfBusiness["CRUISES"] = "CRUISES";
  ExpLineOfBusiness["FLIGHT"] = "FLIGHT";
  ExpLineOfBusiness["GROUNDTRANSFERS"] = "GROUNDTRANSFERS";
  ExpLineOfBusiness["HOTEL"] = "HOTEL";
  ExpLineOfBusiness["PACKAGES"] = "PACKAGES";
  ExpLineOfBusiness["RAILS"] = "RAILS";
  ExpLineOfBusiness["UNCLASSIFIED"] = "UNCLASSIFIED";
})(ExpLineOfBusiness || (ExpLineOfBusiness = {}));
/** Specifies the position of the trigger icon  */
export var ExpandoTriggerPosition;
(function (ExpandoTriggerPosition) {
  ExpandoTriggerPosition["LEADING"] = "LEADING";
  ExpandoTriggerPosition["TRAILING"] = "TRAILING";
})(ExpandoTriggerPosition || (ExpandoTriggerPosition = {}));
export var ExperimentalElements;
(function (ExperimentalElements) {
  /** EGDSStandardMessagingCard. Figma: https://www.figma.com/file/SRnOSnyVYE5dYh7wEQNIfC/Messaging-card-patterns?node-id=1551%3A1450 */
  ExperimentalElements["Card"] = "Card";
  /** Image / Carousel */
  ExperimentalElements["Carousel"] = "Carousel";
  /** Grid layout */
  ExperimentalElements["Grid"] = "Grid";
  /** Title, subtitle and paragraphs */
  ExperimentalElements["InfoSection"] = "InfoSection";
  /** Rating */
  ExperimentalElements["Rating"] = "Rating";
  /** Spacing */
  ExperimentalElements["Spacing"] = "Spacing";
  /** A list with icons and support for context menu. https://shared-ui.expedia.biz/components/web/retail/product/internal/product-text-info-section */
  ExperimentalElements["TextIconTooltip"] = "TextIconTooltip";
})(ExperimentalElements || (ExperimentalElements = {}));
/** Represents the state of the fare */
export var FareState;
(function (FareState) {
  /** Fare is selected on meta search, but it has unselected visual state */
  FareState["META_UNSELECTED"] = "META_UNSELECTED";
  /** Fare is selected */
  FareState["SELECTED"] = "SELECTED";
  /** Fare is selected with PMP */
  FareState["SELECTED_PMP_SELECTED"] = "SELECTED_PMP_SELECTED";
  /** Fare is unselected */
  FareState["UNSELECTED"] = "UNSELECTED";
  /** Fare is unselected with PMP */
  FareState["UNSELECTED_PMP_SELECTED"] = "UNSELECTED_PMP_SELECTED";
})(FareState || (FareState = {}));
export var FeeType;
(function (FeeType) {
  FeeType["CARD_ON_FILE_DAMAGE_LIABILITY"] = "CARD_ON_FILE_DAMAGE_LIABILITY";
  FeeType["DEFAULT"] = "DEFAULT";
  FeeType["DEFAULT_SUPPLIER_COLLECTED"] = "DEFAULT_SUPPLIER_COLLECTED";
  FeeType["GROUPED_MANDATORY_FEES"] = "GROUPED_MANDATORY_FEES";
  FeeType["L26_TAX_BREAKOUT"] = "L26_TAX_BREAKOUT";
  FeeType["NORMAL"] = "NORMAL";
  FeeType["OTHER"] = "OTHER";
  FeeType["PER_PERSON_PER_NIGHT"] = "PER_PERSON_PER_NIGHT";
  FeeType["PROPERTY"] = "PROPERTY";
  FeeType["REFUNDABLE_DAMAGE_DEPOSIT"] = "REFUNDABLE_DAMAGE_DEPOSIT";
  FeeType["RESORT"] = "RESORT";
})(FeeType || (FeeType = {}));
/** The filter placement for the map view */
export var FilterPlacement;
(function (FilterPlacement) {
  /** Display the filters on the bottom, over the map */
  FilterPlacement["OVERLAY_BOTTOM"] = "OVERLAY_BOTTOM";
  /** Display the filters on the top, over the map */
  FilterPlacement["OVERLAY_TOP"] = "OVERLAY_TOP";
  /** Display the filters in the toolbar */
  FilterPlacement["TOOLBAR"] = "TOOLBAR";
})(FilterPlacement || (FilterPlacement = {}));
/** Enum class to represent the type of flexible change policies */
export var FilterPolicyType;
(function (FilterPolicyType) {
  FilterPolicyType["NO_CHANGE_FEE"] = "NO_CHANGE_FEE";
})(FilterPolicyType || (FilterPolicyType = {}));
/** Enum class to represent the type of travel and baggage */
export var FilterTravelAndBaggageType;
(function (FilterTravelAndBaggageType) {
  FilterTravelAndBaggageType["CARRY_ON_BAG"] = "CARRY_ON_BAG";
  FilterTravelAndBaggageType["FIRST_CHECKED_BAG"] = "FIRST_CHECKED_BAG";
  FilterTravelAndBaggageType["NO_CANCEL_FEE"] = "NO_CANCEL_FEE";
  FilterTravelAndBaggageType["NO_CHANGE_FEE"] = "NO_CHANGE_FEE";
  FilterTravelAndBaggageType["SEAT_CHOICE"] = "SEAT_CHOICE";
})(FilterTravelAndBaggageType || (FilterTravelAndBaggageType = {}));
export var FlavorType;
(function (FlavorType) {
  FlavorType["DEMO"] = "DEMO";
  FlavorType["INT"] = "INT";
  FlavorType["LAB"] = "LAB";
  FlavorType["PROD"] = "PROD";
  FlavorType["SANDBOX"] = "SANDBOX";
})(FlavorType || (FlavorType = {}));
/** Controls the alignment along the cross axis. */
export var FlexAlignItems;
(function (FlexAlignItems) {
  FlexAlignItems["CENTER"] = "CENTER";
  FlexAlignItems["END"] = "END";
  FlexAlignItems["START"] = "START";
  FlexAlignItems["STRETCH"] = "STRETCH";
})(FlexAlignItems || (FlexAlignItems = {}));
/** The direction children items are placed inside the flex container, it determines the direction of the main axis (and the cross axis, perpendicular to the main axis). */
export var FlexDirection;
(function (FlexDirection) {
  FlexDirection["ROW"] = "ROW";
})(FlexDirection || (FlexDirection = {}));
/** Controls the alignment along the main axis. */
export var FlexJustifyContent;
(function (FlexJustifyContent) {
  FlexJustifyContent["CENTER"] = "CENTER";
  FlexJustifyContent["END"] = "END";
  FlexJustifyContent["SPACE_AROUND"] = "SPACE_AROUND";
  FlexJustifyContent["SPACE_BETWEEN"] = "SPACE_BETWEEN";
  FlexJustifyContent["START"] = "START";
})(FlexJustifyContent || (FlexJustifyContent = {}));
/** Controls whether the flex container is single-line or multi-line, and the direction of the cross axis. */
export var FlexWrap;
(function (FlexWrap) {
  FlexWrap["NOWRAP"] = "NOWRAP";
})(FlexWrap || (FlexWrap = {}));
/** The trip duration type for the flex search */
export var FlexibleSearchTripDurationType;
(function (FlexibleSearchTripDurationType) {
  FlexibleSearchTripDurationType["MONTH"] = "MONTH";
  FlexibleSearchTripDurationType["WEEK"] = "WEEK";
  FlexibleSearchTripDurationType["WEEKEND"] = "WEEKEND";
})(FlexibleSearchTripDurationType || (FlexibleSearchTripDurationType = {}));
export var FlightCabinClassInfo;
(function (FlightCabinClassInfo) {
  FlightCabinClassInfo["BUSINESS"] = "BUSINESS";
  FlightCabinClassInfo["COACH"] = "COACH";
  FlightCabinClassInfo["FIRST"] = "FIRST";
  FlightCabinClassInfo["PREMIUM_ECONOMY"] = "PREMIUM_ECONOMY";
})(FlightCabinClassInfo || (FlightCabinClassInfo = {}));
/** Represents cross sell product types that will be displayed */
export var FlightCrossSellProductType;
(function (FlightCrossSellProductType) {
  FlightCrossSellProductType["CAR"] = "CAR";
  FlightCrossSellProductType["HOTEL"] = "HOTEL";
})(FlightCrossSellProductType || (FlightCrossSellProductType = {}));
/** Represents the enum for flight journey status */
export var FlightJourneyStatus;
(function (FlightJourneyStatus) {
  /** Represents that the segment status as failure */
  FlightJourneyStatus["FAILURE"] = "FAILURE";
  /** Represents that the segment status as success */
  FlightJourneyStatus["SUCCESS"] = "SUCCESS";
})(FlightJourneyStatus || (FlightJourneyStatus = {}));
export var FlightScheduleStatus;
(function (FlightScheduleStatus) {
  FlightScheduleStatus["CANCELLED"] = "CANCELLED";
  FlightScheduleStatus["DELAYED"] = "DELAYED";
  FlightScheduleStatus["ON_TIME"] = "ON_TIME";
})(FlightScheduleStatus || (FlightScheduleStatus = {}));
/** Represent Type for the values of FlightSelectableAncillaryOption */
export var FlightSelectableAncillaryOptionValuesType;
(function (FlightSelectableAncillaryOptionValuesType) {
  /** Represents NONE value */
  FlightSelectableAncillaryOptionValuesType["NONE"] = "NONE";
  /** Represents a Valid value | eg: upto 15 kg */
  FlightSelectableAncillaryOptionValuesType["VALID"] = "VALID";
})(FlightSelectableAncillaryOptionValuesType || (FlightSelectableAncillaryOptionValuesType = {}));
/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export var FlightsActionDisplayType;
(function (FlightsActionDisplayType) {
  /** Checkbox. Example: To add Price Match Promise */
  FlightsActionDisplayType["CHECKBOX"] = "CHECKBOX";
  /** Primary action. Example: 'Add Hotel Now' button, 'Retry' button */
  FlightsActionDisplayType["PRIMARY"] = "PRIMARY";
  /** Radio Button. Example: To choose seats for a particular traveler */
  FlightsActionDisplayType["RADIO_BUTTON"] = "RADIO_BUTTON";
  /** Secondary action. */
  FlightsActionDisplayType["SECONDARY"] = "SECONDARY";
  /** Switch toggle action. Example: price alerts subscription toggle */
  FlightsActionDisplayType["SWITCH"] = "SWITCH";
  /** Tertiary action. Example: 'No Thanks' */
  FlightsActionDisplayType["TERTIARY"] = "TERTIARY";
  /** Toggle action. Example: seat button in seat map */
  FlightsActionDisplayType["TOGGLE"] = "TOGGLE";
})(FlightsActionDisplayType || (FlightsActionDisplayType = {}));
/** Available action types an actionable element */
export var FlightsActionType;
(function (FlightsActionType) {
  /** Add Price Match Promise to the seleted fare */
  FlightsActionType["ADD_PRICE_MATCH_PROMISE"] = "ADD_PRICE_MATCH_PROMISE";
  /** User has selected seat(s) for all passengers in that leg */
  FlightsActionType["ALL_SEATS_SELECTED_FOR_A_LEG"] = "ALL_SEATS_SELECTED_FOR_A_LEG";
  /** Selects the chosen fare and reloads dynamic elements */
  FlightsActionType["APPLY_FARE"] = "APPLY_FARE";
  /** Highlights the fare chosen by the user */
  FlightsActionType["CHOOSE_FARE"] = "CHOOSE_FARE";
  /** Dialog Box used when customer clicks the 'Next Flight' Button before selecting seats for Current Flight */
  FlightsActionType["CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG"] = "CLICKING_NEXT_FLIGHT_BEFORE_FINISHING_CURRENT_FLIGHT_SEAT_SELECTION_DIALOG";
  /** Dialog Box used when customer clicks the 'Continue Booking' Button before selecting all the seats */
  FlightsActionType["CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG"] = "CONTINUE_BOOKING_WITHOUT_SELECTING_SEATS_DIALOG";
  /** Go to coupon credit page */
  FlightsActionType["COUPON_CREDIT"] = "COUPON_CREDIT";
  /** Dismisses a dialog */
  FlightsActionType["DISMISS"] = "DISMISS";
  /** Activates the suggested filter */
  FlightsActionType["ENABLE_SUGGESTED_FILTER"] = "ENABLE_SUGGESTED_FILTER";
  /** Fetch more search listings */
  FlightsActionType["FETCH_SEARCH_LISTINGS"] = "FETCH_SEARCH_LISTINGS";
  /** Redirect used when customer clicks signin/signup page/module option from 'you might have credits module listing' */
  FlightsActionType["GO_TO_AUTH"] = "GO_TO_AUTH";
  /** Go to Checkout page */
  FlightsActionType["GO_TO_CHECKOUT"] = "GO_TO_CHECKOUT";
  /** Go to the confirmation page of post booking ancillary selection */
  FlightsActionType["GO_TO_CONFIRMATION"] = "GO_TO_CONFIRMATION";
  /** Continues to the standalone details page */
  FlightsActionType["GO_TO_DETAILS"] = "GO_TO_DETAILS";
  /** Go to the merch hub of post booking ancillary selections */
  FlightsActionType["GO_TO_MERCH_HUB"] = "GO_TO_MERCH_HUB";
  /** Continues to the next set of journey results */
  FlightsActionType["GO_TO_NEXT_JOURNEY"] = "GO_TO_NEXT_JOURNEY";
  /** Continues to the packages path */
  FlightsActionType["GO_TO_PACKAGES"] = "GO_TO_PACKAGES";
  /** Redirects to flights search page */
  FlightsActionType["GO_TO_SEARCH"] = "GO_TO_SEARCH";
  /** Redirects back to storefront */
  FlightsActionType["GO_TO_STOREFRONT"] = "GO_TO_STOREFRONT";
  /** Go to the trips overview page */
  FlightsActionType["GO_TO_TRIPS"] = "GO_TO_TRIPS";
  /** Opens a dialog for to display cross sell information */
  FlightsActionType["LOAD_CROSS_SELL_DIALOG"] = "LOAD_CROSS_SELL_DIALOG";
  /** open amenities tray and upsell options for standard offer flight listings */
  FlightsActionType["LOAD_STANDARD_OFFER_FARE_RULE_MODULE"] = "LOAD_STANDARD_OFFER_FARE_RULE_MODULE";
  /** Opens a dialog to display tax breakdown information */
  FlightsActionType["LOAD_TAX_BREAKDOWN_DIALOG"] = "LOAD_TAX_BREAKDOWN_DIALOG";
  /** User has not selected seat(s) for any passengers in that leg */
  FlightsActionType["NO_SEATS_SELECTED_FOR_A_LEG"] = "NO_SEATS_SELECTED_FOR_A_LEG";
  /** Opens bags selection alert dialog on clicking on checkout button on FIS */
  FlightsActionType["OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT"] = "OPEN_BAGS_SELECTION_ALERT_DIALOG_ON_CHECKOUT";
  /** Opens sidesheet for bags selection */
  FlightsActionType["OPEN_BAGS_SELECTION_SHEET"] = "OPEN_BAGS_SELECTION_SHEET";
  /** Opens a dialog to to go to Airlines Site for Booking */
  FlightsActionType["OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG"] = "OPEN_BOOK_DIRECTLY_WITH_AIRLINES_DIALOG";
  /** Dialog Box used when customer clicks the 'Select credit' or 'Change Credit' option from 'you might have credits module listing' */
  FlightsActionType["OPEN_CREDIT_DIALOG"] = "OPEN_CREDIT_DIALOG";
  /** Open Fare Seat information when clicked on required seat button */
  FlightsActionType["OPEN_FARE_SEAT_MAP_SEAT_SHEET"] = "OPEN_FARE_SEAT_MAP_SEAT_SHEET";
  /** Open Fare Seat view to preview the seat map */
  FlightsActionType["OPEN_FARE_SEAT_MAP_VIEW"] = "OPEN_FARE_SEAT_MAP_VIEW";
  /** Open Fare Seat view to select the seat */
  FlightsActionType["OPEN_FARE_SEAT_SELECT_VIEW"] = "OPEN_FARE_SEAT_SELECT_VIEW";
  /** Open Flight leg drop down in seat map view */
  FlightsActionType["OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG"] = "OPEN_FLIGHT_LEG_DROP_DOWN_IN_SEAT_MAP_DIALOG";
  /** Open Legend info sheet in bottom in case of mobile */
  FlightsActionType["OPEN_LEGEND_INFO_SHEET_MOBILE"] = "OPEN_LEGEND_INFO_SHEET_MOBILE";
  /** Open price summary */
  FlightsActionType["OPEN_PRICE_SUMMARY"] = "OPEN_PRICE_SUMMARY";
  /** Opens seat selection alert dialog on clicking on checkout button on FIS */
  FlightsActionType["OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT"] = "OPEN_SEAT_SELECTION_ALERT_DIALOG_ON_CHECKOUT";
  /** Redirects to Airlines Site for Booking */
  FlightsActionType["REDIRECT_TO_AIRLINES_FOR_BOOKING"] = "REDIRECT_TO_AIRLINES_FOR_BOOKING";
  /** Refreshes the current page */
  FlightsActionType["REFRESH"] = "REFRESH";
  /** Actionable item to add a journey */
  FlightsActionType["SEARCH_FORM_ADD_JOURNEY"] = "SEARCH_FORM_ADD_JOURNEY";
  /** Closes the expanded Search Form */
  FlightsActionType["SEARCH_FORM_CLOSE_BUTTON"] = "SEARCH_FORM_CLOSE_BUTTON";
  /** Actionable item to remove a journey */
  FlightsActionType["SEARCH_FORM_REMOVE_JOURNEY"] = "SEARCH_FORM_REMOVE_JOURNEY";
  /** Dialog Box used when customer clicks the 'Close' Button before selecting all the seats */
  FlightsActionType["SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG"] = "SEAT_MAP_CLOSE_WITHOUT_SELECTING_SEATS_DIALOG";
  /** Continues to flight details page after selecting seats for all flights */
  FlightsActionType["SEAT_MAP_CONTINUE_BOOKING"] = "SEAT_MAP_CONTINUE_BOOKING";
  /** Closes the current flight seat selection page and continues for next flight */
  FlightsActionType["SEAT_MAP_GO_TO_NEXT_FLIGHT"] = "SEAT_MAP_GO_TO_NEXT_FLIGHT";
  /** Go to next flight section for selecting seats */
  FlightsActionType["SEAT_MAP_NEXT_FLIGHT"] = "SEAT_MAP_NEXT_FLIGHT";
  /** Saves user's seat preferences and redirects to FIS */
  FlightsActionType["SEAT_MAP_SAVE_AND_EXIT"] = "SEAT_MAP_SAVE_AND_EXIT";
  /** Stays at Page displaying Seat Map when selected by user */
  FlightsActionType["SEAT_MAP_STAY_HERE"] = "SEAT_MAP_STAY_HERE";
  /** Continues to stay on the current flight seat selection page */
  FlightsActionType["SEAT_MAP_STAY_ON_THIS_PAGE"] = "SEAT_MAP_STAY_ON_THIS_PAGE";
  /** Allows User to Continue Booking from the Seat Selection Dialog Box */
  FlightsActionType["SEAT_SELECT_DIALOG_CONTINUE_BOOKING"] = "SEAT_SELECT_DIALOG_CONTINUE_BOOKING";
  /** Displays seat map preview corresponding to each traveler */
  FlightsActionType["SEAT_SELECT_PREVIEW_FOR_TRAVELER"] = "SEAT_SELECT_PREVIEW_FOR_TRAVELER";
  /** Select Flight leg in seat map drop down menu */
  FlightsActionType["SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG"] = "SELECT_FLIGHT_LEG_IN_SEAT_MAP_DIALOG";
  /** Select the seat */
  FlightsActionType["SELECT_SEAT"] = "SELECT_SEAT";
  /** Open Opinion Lab Share Feedback dialogue */
  FlightsActionType["SHARE_FEEDBACK"] = "SHARE_FEEDBACK";
  /** Open a modal showing details of the free Price Match Promise product */
  FlightsActionType["SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS"] = "SHOW_FREE_PRICE_MATCH_PROMISE_DETAILS";
  /** Open a modal showing details of the Price Match Promise product */
  FlightsActionType["SHOW_PRICE_MATCH_PROMISE_DETAILS"] = "SHOW_PRICE_MATCH_PROMISE_DETAILS";
  /** User has selected seat(s) for at least 1 passenger but not all passengers in that leg */
  FlightsActionType["SOME_SEATS_SELECTED_FOR_A_LEG"] = "SOME_SEATS_SELECTED_FOR_A_LEG";
  /** Subscribe to emails */
  FlightsActionType["SUBSCRIBE_TO_EMAILS"] = "SUBSCRIBE_TO_EMAILS";
  /** Subscribe/Unsubscribes from price alerts */
  FlightsActionType["TOGGLE_PRICE_ALERTS"] = "TOGGLE_PRICE_ALERTS";
  /** Unselect the selected seat */
  FlightsActionType["UNSELECT_SEAT"] = "UNSELECT_SEAT";
  /** Opens FIS sidesheet and highlights next fare to upgrade */
  FlightsActionType["UPGRADE_TO_NEXT_FARE"] = "UPGRADE_TO_NEXT_FARE";
})(FlightsActionType || (FlightsActionType = {}));
/** Possible advanced filter types */
export var FlightsAdvancedFilterType;
(function (FlightsAdvancedFilterType) {
  FlightsAdvancedFilterType["NONSTOP"] = "NONSTOP";
  FlightsAdvancedFilterType["REFUNDABLE"] = "REFUNDABLE";
})(FlightsAdvancedFilterType || (FlightsAdvancedFilterType = {}));
/** Enum class to represent the ancillary display action */
export var FlightsAncillaryDisplayAction;
(function (FlightsAncillaryDisplayAction) {
  FlightsAncillaryDisplayAction["NONE"] = "NONE";
  FlightsAncillaryDisplayAction["PREFETCH"] = "PREFETCH";
})(FlightsAncillaryDisplayAction || (FlightsAncillaryDisplayAction = {}));
/** Accessibility message types to be announced post selection */
export var FlightsAncillarySelectionAccessibilityMsgType;
(function (FlightsAncillarySelectionAccessibilityMsgType) {
  /** Ancillary Selection Failed */
  FlightsAncillarySelectionAccessibilityMsgType["SELECTION_FAILED"] = "SELECTION_FAILED";
  /** Ancillary Selection Success */
  FlightsAncillarySelectionAccessibilityMsgType["SELECTION_SUCCESS"] = "SELECTION_SUCCESS";
})(FlightsAncillarySelectionAccessibilityMsgType || (FlightsAncillarySelectionAccessibilityMsgType = {}));
/** Error types which can occur during ancillary selection */
export var FlightsAncillarySelectionErrorType;
(function (FlightsAncillarySelectionErrorType) {
  /** Baggage Details loaded call failed */
  FlightsAncillarySelectionErrorType["BAGGAGE_DETAILS_LOADED_FAILED"] = "BAGGAGE_DETAILS_LOADED_FAILED";
  /** Ancillary details loading failed */
  FlightsAncillarySelectionErrorType["DETAILS_LOADING_FAILED"] = "DETAILS_LOADING_FAILED";
  /** Ancillary Pre-Selection Unavailable */
  FlightsAncillarySelectionErrorType["PRE_SELECTION_FAILED"] = "PRE_SELECTION_FAILED";
  /** Ancillary Selection Failed */
  FlightsAncillarySelectionErrorType["SELECTION_FAILED"] = "SELECTION_FAILED";
  /** Ancillary Selection Unavailable */
  FlightsAncillarySelectionErrorType["SELECTION_UNAVAILABLE"] = "SELECTION_UNAVAILABLE";
})(FlightsAncillarySelectionErrorType || (FlightsAncillarySelectionErrorType = {}));
/** Type of ancillaries supported */
export var FlightsAncillaryType;
(function (FlightsAncillaryType) {
  FlightsAncillaryType["BAGS"] = "BAGS";
  FlightsAncillaryType["BAGS_V2"] = "BAGS_V2";
  FlightsAncillaryType["SEATS"] = "SEATS";
})(FlightsAncillaryType || (FlightsAncillaryType = {}));
/** Represents the theme values for a Badge */
export var FlightsBadgeTheme;
(function (FlightsBadgeTheme) {
  FlightsBadgeTheme["BRAND"] = "BRAND";
  FlightsBadgeTheme["DEAL_BUNDLED"] = "DEAL_BUNDLED";
  FlightsBadgeTheme["DEAL_GENERIC"] = "DEAL_GENERIC";
  FlightsBadgeTheme["DEAL_MEMBER"] = "DEAL_MEMBER";
  FlightsBadgeTheme["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
  FlightsBadgeTheme["NOTIFICATION"] = "NOTIFICATION";
  FlightsBadgeTheme["SAVED"] = "SAVED";
  FlightsBadgeTheme["SPONSORED"] = "SPONSORED";
  FlightsBadgeTheme["SUPPLIER_PROMO"] = "SUPPLIER_PROMO";
  FlightsBadgeTheme["VIEWED"] = "VIEWED";
  FlightsBadgeTheme["VIP"] = "VIP";
})(FlightsBadgeTheme || (FlightsBadgeTheme = {}));
/** Represents the button width in the UI */
export var FlightsButtonWidth;
(function (FlightsButtonWidth) {
  /** Button will take the width it needs */
  FlightsButtonWidth["DEFAULT"] = "DEFAULT";
  /** Button will take the full width of the content */
  FlightsButtonWidth["FULL_WIDTH"] = "FULL_WIDTH";
})(FlightsButtonWidth || (FlightsButtonWidth = {}));
/** Cabin class chosen in flight */
export var FlightsCabinClass;
(function (FlightsCabinClass) {
  FlightsCabinClass["BUSINESS"] = "BUSINESS";
  FlightsCabinClass["COACH"] = "COACH";
  FlightsCabinClass["FIRST"] = "FIRST";
  FlightsCabinClass["PREMIUM_ECONOMY"] = "PREMIUM_ECONOMY";
})(FlightsCabinClass || (FlightsCabinClass = {}));
/** Represents the type of categories */
export var FlightsCategorizedListSectionType;
(function (FlightsCategorizedListSectionType) {
  FlightsCategorizedListSectionType["BAG"] = "BAG";
  FlightsCategorizedListSectionType["SEAT"] = "SEAT";
})(FlightsCategorizedListSectionType || (FlightsCategorizedListSectionType = {}));
/** Enum class to represent cross sort types */
export var FlightsCrossSortType;
(function (FlightsCrossSortType) {
  FlightsCrossSortType["CABIN_CLASS"] = "CABIN_CLASS";
  FlightsCrossSortType["CANCELLATION"] = "CANCELLATION";
  FlightsCrossSortType["CARRY_ON_BAG"] = "CARRY_ON_BAG";
  FlightsCrossSortType["CHANGE_ALLOWED"] = "CHANGE_ALLOWED";
  FlightsCrossSortType["CHECKED_BAG"] = "CHECKED_BAG";
  FlightsCrossSortType["DURATION"] = "DURATION";
  FlightsCrossSortType["NUM_OF_STOPS"] = "NUM_OF_STOPS";
  FlightsCrossSortType["PRICE"] = "PRICE";
  FlightsCrossSortType["SEAT_CHOICE"] = "SEAT_CHOICE";
})(FlightsCrossSortType || (FlightsCrossSortType = {}));
/** Represents flights dialog actions */
export var FlightsDialogAction;
(function (FlightsDialogAction) {
  FlightsDialogAction["CLOSE"] = "CLOSE";
  FlightsDialogAction["OPEN"] = "OPEN";
  FlightsDialogAction["TOGGLE"] = "TOGGLE";
})(FlightsDialogAction || (FlightsDialogAction = {}));
/** Represents the type of animation the dialog will use when displayed */
export var FlightsDialogAnimation;
(function (FlightsDialogAnimation) {
  FlightsDialogAnimation["FADE"] = "FADE";
  FlightsDialogAnimation["NONE"] = "NONE";
})(FlightsDialogAnimation || (FlightsDialogAnimation = {}));
/** Represents IDs for flights dialogs */
export var FlightsDialogId;
(function (FlightsDialogId) {
  /** Represents the Airlines credit dialog */
  FlightsDialogId["AIRLINE_CREDITS"] = "AIRLINE_CREDITS";
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  FlightsDialogId["BAGGAGE_CLOSE_COMPLETE_DIALOG"] = "BAGGAGE_CLOSE_COMPLETE_DIALOG";
  /** Represents the Close button dialog for the baggage details */
  FlightsDialogId["BAGGAGE_CLOSE_DIALOG"] = "BAGGAGE_CLOSE_DIALOG";
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  FlightsDialogId["BAGGAGE_CLOSE_INCOMPLETE_DIALOG"] = "BAGGAGE_CLOSE_INCOMPLETE_DIALOG";
  /** Represents the Continue booking dialog for the baggage details */
  FlightsDialogId["BAGGAGE_CONTINUE_BOOKING"] = "BAGGAGE_CONTINUE_BOOKING";
  /** Represents the dialog ID for Baggage details */
  FlightsDialogId["BAGGAGE_DETAILS_DIALOG"] = "BAGGAGE_DETAILS_DIALOG";
  /** Represents the bags popup dialog on checkout button */
  FlightsDialogId["BAGS_POPUP_ON_CHECKOUT"] = "BAGS_POPUP_ON_CHECKOUT";
  /** Represents the check credits dialog for users coming from MCC and VA */
  FlightsDialogId["CHECK_CREDITS_DIALOG"] = "CHECK_CREDITS_DIALOG";
  /** Represents the Flights Details and Fares dialog */
  FlightsDialogId["FLIGHTS_DETAILS_AND_FARES"] = "FLIGHTS_DETAILS_AND_FARES";
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FlightsDialogId["FORCED_CHOICE_MODAL"] = "FORCED_CHOICE_MODAL";
  /** Represents the How Airlines Work dialog inside Select Credits */
  FlightsDialogId["HOW_CREDITS_WORK"] = "HOW_CREDITS_WORK";
  /** Represents the Leave This Page dialog inside Select Credits */
  FlightsDialogId["LEAVE_TO_COUPONS"] = "LEAVE_TO_COUPONS";
  /** Represents the dialog ID while merchandising selections are being booked */
  FlightsDialogId["MERCHANDISING_SELECTIONS_BOOKING_LOADING"] = "MERCHANDISING_SELECTIONS_BOOKING_LOADING";
  /** Represents the dialog ID for merchandising selections expiry dialog */
  FlightsDialogId["MERCHANDISING_SELECTIONS_EXPIRY"] = "MERCHANDISING_SELECTIONS_EXPIRY";
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  FlightsDialogId["PAID_BAGS_DIALOG"] = "PAID_BAGS_DIALOG";
  /** Represents the Info dialog for Price Match Promise Selected Card */
  FlightsDialogId["PMP_INFO_DIALOG"] = "PMP_INFO_DIALOG";
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  FlightsDialogId["PMP_REMOVE_DIALOG"] = "PMP_REMOVE_DIALOG";
  /** Represents the seats popup dialog on checkout button */
  FlightsDialogId["SEATS_POPUP_ON_CHECKOUT"] = "SEATS_POPUP_ON_CHECKOUT";
  /** Represents the dialog ID for seat cell details dialog */
  FlightsDialogId["SEAT_CELL_DETAILS_DIALOG"] = "SEAT_CELL_DETAILS_DIALOG";
  /** Represents the Close button dialog for the seat details */
  FlightsDialogId["SEAT_CLOSE_COMPLETE_DIALOG"] = "SEAT_CLOSE_COMPLETE_DIALOG";
  /** Represents the Continue booking dialog for the baggage details */
  FlightsDialogId["SEAT_CONTINUE_BOOKING"] = "SEAT_CONTINUE_BOOKING";
  /** Represents the dialog ID for seat legends dialog */
  FlightsDialogId["SEAT_LEGEND_DIALOG"] = "SEAT_LEGEND_DIALOG";
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  FlightsDialogId["SEAT_SELECTION_DIALOG"] = "SEAT_SELECTION_DIALOG";
  /** Represents the dialog on traveler mismatch for credits offer */
  FlightsDialogId["TRAVELER_MISMATCH_DIALOG"] = "TRAVELER_MISMATCH_DIALOG";
})(FlightsDialogId || (FlightsDialogId = {}));
/** Represents a pre action in flights dialog trigger */
export var FlightsDialogPreAction;
(function (FlightsDialogPreAction) {
  FlightsDialogPreAction["CLOSE_ALL_DIALOGS"] = "CLOSE_ALL_DIALOGS";
})(FlightsDialogPreAction || (FlightsDialogPreAction = {}));
/** Represents flights component */
export var FlightsDisplayComponent;
(function (FlightsDisplayComponent) {
  FlightsDisplayComponent["SMART_NFF_ALTERNATE_SUGGESTION"] = "SMART_NFF_ALTERNATE_SUGGESTION";
})(FlightsDisplayComponent || (FlightsDisplayComponent = {}));
/** Css class names for datepicker cell content. */
export var FlightsFareCalendarPriceTheme;
(function (FlightsFareCalendarPriceTheme) {
  FlightsFareCalendarPriceTheme["NEGATIVE"] = "NEGATIVE";
  FlightsFareCalendarPriceTheme["POSITIVE"] = "POSITIVE";
  FlightsFareCalendarPriceTheme["UNDEFINED"] = "UNDEFINED";
})(FlightsFareCalendarPriceTheme || (FlightsFareCalendarPriceTheme = {}));
/** Represent the fares needs to be present in listing results */
export var FlightsFaresSeparationType;
(function (FlightsFaresSeparationType) {
  FlightsFaresSeparationType["BASE_AND_UPSELL"] = "BASE_AND_UPSELL";
  FlightsFaresSeparationType["NONSTOP_BASE_AND_UPSELL"] = "NONSTOP_BASE_AND_UPSELL";
  FlightsFaresSeparationType["NONSTOP_ONLY_BASE"] = "NONSTOP_ONLY_BASE";
  FlightsFaresSeparationType["NONSTOP_ONLY_UPSELL"] = "NONSTOP_ONLY_UPSELL";
  FlightsFaresSeparationType["ONLY_BASE"] = "ONLY_BASE";
  FlightsFaresSeparationType["ONLY_UPSELL"] = "ONLY_UPSELL";
})(FlightsFaresSeparationType || (FlightsFaresSeparationType = {}));
/** Enum class to represent the available filter types */
export var FlightsFilterType;
(function (FlightsFilterType) {
  FlightsFilterType["ARRIVAL_AIRPORT"] = "ARRIVAL_AIRPORT";
  FlightsFilterType["ARRIVAL_TIME"] = "ARRIVAL_TIME";
  FlightsFilterType["ARRIVAL_TIME_SLIDER"] = "ARRIVAL_TIME_SLIDER";
  FlightsFilterType["CARRY_ON_BAG"] = "CARRY_ON_BAG";
  FlightsFilterType["CHECKED_BAG"] = "CHECKED_BAG";
  FlightsFilterType["CREDIT_ELIGIBLE"] = "CREDIT_ELIGIBLE";
  FlightsFilterType["DEPARTURE_AIRPORT"] = "DEPARTURE_AIRPORT";
  FlightsFilterType["DEPARTURE_TIME"] = "DEPARTURE_TIME";
  FlightsFilterType["DEPARTURE_TIME_SLIDER"] = "DEPARTURE_TIME_SLIDER";
  FlightsFilterType["DURATION"] = "DURATION";
  FlightsFilterType["FLEXIBLE_CHANGE_POLICIES"] = "FLEXIBLE_CHANGE_POLICIES";
  FlightsFilterType["LAYOVER_AIRPORT"] = "LAYOVER_AIRPORT";
  FlightsFilterType["LAYOVER_TIME_SLIDER"] = "LAYOVER_TIME_SLIDER";
  FlightsFilterType["NO_CANCEL_FEE"] = "NO_CANCEL_FEE";
  FlightsFilterType["NO_CHANGE_FEE"] = "NO_CHANGE_FEE";
  FlightsFilterType["NUM_OF_STOPS"] = "NUM_OF_STOPS";
  FlightsFilterType["PREFERRED_AIRLINE"] = "PREFERRED_AIRLINE";
  FlightsFilterType["PRICE"] = "PRICE";
  FlightsFilterType["SEAT_CHOICE"] = "SEAT_CHOICE";
  FlightsFilterType["TRAVEL_AND_BAGGAGE"] = "TRAVEL_AND_BAGGAGE";
})(FlightsFilterType || (FlightsFilterType = {}));
/** Represents the flexible grid type */
export var FlightsFlexibleGridType;
(function (FlightsFlexibleGridType) {
  /** Flex Search type shown for OW */
  FlightsFlexibleGridType["FLEX_SEARCH"] = "FLEX_SEARCH";
  /** Flex Search Grid type shown for RT Outbound */
  FlightsFlexibleGridType["FLEX_SEARCH_GRID"] = "FLEX_SEARCH_GRID";
  /** No Flex Search variant shown */
  FlightsFlexibleGridType["FLEX_SEARCH_NOT_APPLICABLE"] = "FLEX_SEARCH_NOT_APPLICABLE";
})(FlightsFlexibleGridType || (FlightsFlexibleGridType = {}));
/** Represent flexible search header cell theme */
export var FlightsFlexibleSearchHeaderCellTheme;
(function (FlightsFlexibleSearchHeaderCellTheme) {
  /** Theme to represent an outbound or inbound departureDate header */
  FlightsFlexibleSearchHeaderCellTheme["DEFAULT"] = "DEFAULT";
  /** Theme to represent an outbound or inbound departureDate that was searched on */
  FlightsFlexibleSearchHeaderCellTheme["SEARCHED_DATE_HEADER"] = "SEARCHED_DATE_HEADER";
})(FlightsFlexibleSearchHeaderCellTheme || (FlightsFlexibleSearchHeaderCellTheme = {}));
/** Represent flexible search legend cell theme */
export var FlightsFlexibleSearchLegendCellTheme;
(function (FlightsFlexibleSearchLegendCellTheme) {
  FlightsFlexibleSearchLegendCellTheme["DEFAULT"] = "DEFAULT";
})(FlightsFlexibleSearchLegendCellTheme || (FlightsFlexibleSearchLegendCellTheme = {}));
/** Represent flexible search result cell theme */
export var FlightsFlexibleSearchResultCellTheme;
(function (FlightsFlexibleSearchResultCellTheme) {
  /** Default theme */
  FlightsFlexibleSearchResultCellTheme["DEFAULT_PRICE"] = "DEFAULT_PRICE";
  /** Theme to represent highest priced cells in the matrix */
  FlightsFlexibleSearchResultCellTheme["HIGHEST_PRICE"] = "HIGHEST_PRICE";
  /** Theme to represent the lowest price displayed in the matrix */
  FlightsFlexibleSearchResultCellTheme["LOWEST_PRICE"] = "LOWEST_PRICE";
  /** Theme to represent when no price is available, 'Search' */
  FlightsFlexibleSearchResultCellTheme["NO_PRICE"] = "NO_PRICE";
  /** Theme to represent the price corresponding to the flight on the input departureDate */
  FlightsFlexibleSearchResultCellTheme["SEARCHED_DATE"] = "SEARCHED_DATE";
  /** Theme to represent a cell that corresponds to the input departureDate and is also lowest price displayed in the matrix */
  FlightsFlexibleSearchResultCellTheme["SEARCHED_DATE_LOWEST_PRICE"] = "SEARCHED_DATE_LOWEST_PRICE";
  /** Theme to represent a cell that corresponds to the input departureDate and is also the price is not available */
  FlightsFlexibleSearchResultCellTheme["SEARCHED_DATE_NO_PRICE"] = "SEARCHED_DATE_NO_PRICE";
  /** Theme to represent a cell that corresponds to the input departureDate and flights dont fly on the given departureDate */
  FlightsFlexibleSearchResultCellTheme["SEARCHED_DATE_UNAVAILABLE_FLIGHTS"] = "SEARCHED_DATE_UNAVAILABLE_FLIGHTS";
  /** Theme to represent the price is unavailable because flights don't fly for the given departureDate and route, 'No Flights' */
  FlightsFlexibleSearchResultCellTheme["UNAVAILABLE_FLIGHTS"] = "UNAVAILABLE_FLIGHTS";
})(FlightsFlexibleSearchResultCellTheme || (FlightsFlexibleSearchResultCellTheme = {}));
/** Enum class to represent the available heading sizes */
export var FlightsHeadingSize;
(function (FlightsHeadingSize) {
  FlightsHeadingSize["EIGHT"] = "EIGHT";
  FlightsHeadingSize["FIVE"] = "FIVE";
  FlightsHeadingSize["FOUR"] = "FOUR";
  FlightsHeadingSize["ONE"] = "ONE";
  FlightsHeadingSize["SEVEN"] = "SEVEN";
  FlightsHeadingSize["SIX"] = "SIX";
  FlightsHeadingSize["THREE"] = "THREE";
})(FlightsHeadingSize || (FlightsHeadingSize = {}));
/** Represents the position of the icon */
export var FlightsIconPosition;
(function (FlightsIconPosition) {
  /** Icon will be rendered at the beginning of the content */
  FlightsIconPosition["LEADING"] = "LEADING";
  /** Icon will be rendered at the end of the content */
  FlightsIconPosition["TRAILING"] = "TRAILING";
})(FlightsIconPosition || (FlightsIconPosition = {}));
/** Target of the Link when clicked */
export var FlightsLinkTarget;
(function (FlightsLinkTarget) {
  /** Link will be opened in an external view e.g. new tab or browser window */
  FlightsLinkTarget["EXTERNAL"] = "EXTERNAL";
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  FlightsLinkTarget["INTERNAL"] = "INTERNAL";
})(FlightsLinkTarget || (FlightsLinkTarget = {}));
/** Represents page load type of FSR */
export var FlightsListingsViewType;
(function (FlightsListingsViewType) {
  FlightsListingsViewType["MIXED"] = "MIXED";
  FlightsListingsViewType["SINGLE"] = "SINGLE";
})(FlightsListingsViewType || (FlightsListingsViewType = {}));
/** Metrics names */
export var FlightsMetricName;
(function (FlightsMetricName) {
  FlightsMetricName["LISTINGS_SUPPLY_RESPONSE_TIME"] = "LISTINGS_SUPPLY_RESPONSE_TIME";
})(FlightsMetricName || (FlightsMetricName = {}));
/** The text style to apply to strings */
export var FlightsPhrasePartStyle;
(function (FlightsPhrasePartStyle) {
  /** Italic styling */
  FlightsPhrasePartStyle["EMPHASIS"] = "EMPHASIS";
  /** Bold styling */
  FlightsPhrasePartStyle["IMPORTANT"] = "IMPORTANT";
  /** Represents no style or regular text */
  FlightsPhrasePartStyle["STANDARD"] = "STANDARD";
})(FlightsPhrasePartStyle || (FlightsPhrasePartStyle = {}));
/** Represents an object to be used to differentiate the type of Placards(Ex : Placards to be shown immediately vs those which are shown during server error */
export var FlightsPlacardDisplayType;
(function (FlightsPlacardDisplayType) {
  /** Represents the placard type to be shown immediately */
  FlightsPlacardDisplayType["IMMEDIATE"] = "IMMEDIATE";
  /** Represents the placard type to be shown during server error of sort and filter action */
  FlightsPlacardDisplayType["SORT_FILTERS_SERVER_ERROR"] = "SORT_FILTERS_SERVER_ERROR";
})(FlightsPlacardDisplayType || (FlightsPlacardDisplayType = {}));
/** Represents different background themes for placard */
export var FlightsPlacardTheme;
(function (FlightsPlacardTheme) {
  FlightsPlacardTheme["HIGHLIGHT"] = "HIGHLIGHT";
  FlightsPlacardTheme["PRIMARY"] = "PRIMARY";
  FlightsPlacardTheme["SECONDARY"] = "SECONDARY";
  FlightsPlacardTheme["STANDARD"] = "STANDARD";
})(FlightsPlacardTheme || (FlightsPlacardTheme = {}));
/** Represents a type of placards the client can request for */
export var FlightsPlacardType;
(function (FlightsPlacardType) {
  /** Represents the placard of type free cancellation */
  FlightsPlacardType["FREE_CANCELLATION"] = "FREE_CANCELLATION";
  /** Represents the placard of type hotel attach */
  FlightsPlacardType["HOTEL_ATTACH"] = "HOTEL_ATTACH";
  /** Represents the placard of type loyalty reward */
  FlightsPlacardType["LOYALTY_REWARD"] = "LOYALTY_REWARD";
  /** Represents the placard of type no change fees */
  FlightsPlacardType["NO_CHANGE_FEES"] = "NO_CHANGE_FEES";
  /** Represents the placard of type passport */
  FlightsPlacardType["PASSPORT"] = "PASSPORT";
  /** Represents the placard of type price change */
  FlightsPlacardType["PRICE_CHANGE"] = "PRICE_CHANGE";
  /** Represents the placard of type split ticket */
  FlightsPlacardType["SPLIT_TICKET"] = "SPLIT_TICKET";
})(FlightsPlacardType || (FlightsPlacardType = {}));
/** Represents the display of progress bar when the results are loading */
export var FlightsProgressBarDisplay;
(function (FlightsProgressBarDisplay) {
  FlightsProgressBarDisplay["DISABLED"] = "DISABLED";
  FlightsProgressBarDisplay["ENABLED"] = "ENABLED";
})(FlightsProgressBarDisplay || (FlightsProgressBarDisplay = {}));
/** Represents the state the client wants to query */
export var FlightsQueryState;
(function (FlightsQueryState) {
  FlightsQueryState["LOADED"] = "LOADED";
  FlightsQueryState["LOADING"] = "LOADING";
})(FlightsQueryState || (FlightsQueryState = {}));
/** Enum class to represent the id associated with the rewards option */
export var FlightsRewardsOptionId;
(function (FlightsRewardsOptionId) {
  FlightsRewardsOptionId["ALTAIR"] = "ALTAIR";
  FlightsRewardsOptionId["AVION"] = "AVION";
  FlightsRewardsOptionId["NONAVION"] = "NONAVION";
})(FlightsRewardsOptionId || (FlightsRewardsOptionId = {}));
/** Represents the mismatched criterion between the current search and servicing need */
export var FlightsSearchCriteriaMismatch;
(function (FlightsSearchCriteriaMismatch) {
  FlightsSearchCriteriaMismatch["TRAVELER"] = "TRAVELER";
})(FlightsSearchCriteriaMismatch || (FlightsSearchCriteriaMismatch = {}));
export var FlightsSearchFormErrorType;
(function (FlightsSearchFormErrorType) {
  /** Age of child is missing */
  FlightsSearchFormErrorType["CHILD_AGE_MISSING"] = "CHILD_AGE_MISSING";
  /** Date before previous date - Multi-dest */
  FlightsSearchFormErrorType["DATE_BEFORE_PREVIOUS_DATE"] = "DATE_BEFORE_PREVIOUS_DATE";
  /** Date must be between a range */
  FlightsSearchFormErrorType["DATE_NOT_IN_VALID_RANGE"] = "DATE_NOT_IN_VALID_RANGE";
  /** Dates must be greater than or equal to default date/checkin date. */
  FlightsSearchFormErrorType["DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE"] = "DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE";
  /** Age of infant is missing */
  FlightsSearchFormErrorType["INFANT_AGE_MISSING"] = "INFANT_AGE_MISSING";
  /** Date must be in the correct format */
  FlightsSearchFormErrorType["INVALID_DATE_FORMAT"] = "INVALID_DATE_FORMAT";
  /** Total traveler count must be equal or lower than max */
  FlightsSearchFormErrorType["INVALID_TRAVELER_COUNT"] = "INVALID_TRAVELER_COUNT";
  /** At least 1 traveler required in a booking */
  FlightsSearchFormErrorType["LESS_THAN_MINIMUM_ADULT"] = "LESS_THAN_MINIMUM_ADULT";
  /** Location must not be blank */
  FlightsSearchFormErrorType["LOCATION_EMPTY"] = "LOCATION_EMPTY";
  /** Origin and destination location must not be the same */
  FlightsSearchFormErrorType["LOCATION_SAME"] = "LOCATION_SAME";
  /** Dates must be no more than 26 days apart */
  FlightsSearchFormErrorType["MAX_STAY_DURATION_ERROR"] = "MAX_STAY_DURATION_ERROR";
  /** Origin and Destination city cannot be same */
  FlightsSearchFormErrorType["SAME_CITY"] = "SAME_CITY";
  /** Special characters are not allowed */
  FlightsSearchFormErrorType["SPECIAL_CHARACTER_NOT_ALLOWED"] = "SPECIAL_CHARACTER_NOT_ALLOWED";
  /** Enter at least 3 characters of the airport name */
  FlightsSearchFormErrorType["TOO_SHORT_AIRPORT_STRING"] = "TOO_SHORT_AIRPORT_STRING";
  /** Number of infant in lap must be equal or lower than number of adults */
  FlightsSearchFormErrorType["UNATTENDED_INFANT_IN_LAP"] = "UNATTENDED_INFANT_IN_LAP";
  /** There can't be more than 2 infants per traveler (age 12+) in a booking */
  FlightsSearchFormErrorType["UNATTENDED_INFANT_IN_SEAT"] = "UNATTENDED_INFANT_IN_SEAT";
})(FlightsSearchFormErrorType || (FlightsSearchFormErrorType = {}));
/** Represents the enum to handle different styles for the card */
export var FlightsSeatCardStyles;
(function (FlightsSeatCardStyles) {
  /** Represents that the card should have border */
  FlightsSeatCardStyles["BORDER"] = "BORDER";
  /** Represents that the card should not have a border */
  FlightsSeatCardStyles["WITHOUT_BORDER"] = "WITHOUT_BORDER";
})(FlightsSeatCardStyles || (FlightsSeatCardStyles = {}));
/** Error types which can occur during seat selection */
export var FlightsSeatSelectionErrorType;
(function (FlightsSeatSelectionErrorType) {
  /** Seat Selection Failed */
  FlightsSeatSelectionErrorType["SELECTION_FAILED"] = "SELECTION_FAILED";
  /** Seat Selection Unavailable */
  FlightsSeatSelectionErrorType["SELECTION_UNAVAILABLE"] = "SELECTION_UNAVAILABLE";
})(FlightsSeatSelectionErrorType || (FlightsSeatSelectionErrorType = {}));
/** Represents the enum for handling whether new seats experience should be enabled or not */
export var FlightsSeatsExperienceType;
(function (FlightsSeatsExperienceType) {
  /** Represents frontend to show old seats experience */
  FlightsSeatsExperienceType["CURRENT_SEATS_EXPERIENCE"] = "CURRENT_SEATS_EXPERIENCE";
  /** Represents frontend to show new seats experience */
  FlightsSeatsExperienceType["NEW_SEATS_EXPERIENCE"] = "NEW_SEATS_EXPERIENCE";
  /** Represents frontend to show rich content experience */
  FlightsSeatsExperienceType["SEATS_RICH_CONTENT_EXPERIENCE"] = "SEATS_RICH_CONTENT_EXPERIENCE";
})(FlightsSeatsExperienceType || (FlightsSeatsExperienceType = {}));
/** Represents the button width in the UI */
export var FlightsSmartShoppingButtonWidth;
(function (FlightsSmartShoppingButtonWidth) {
  /** Button will take the width it needs */
  FlightsSmartShoppingButtonWidth["DEFAULT"] = "DEFAULT";
  /** Button will take the full width of the content */
  FlightsSmartShoppingButtonWidth["FULL_WIDTH"] = "FULL_WIDTH";
})(FlightsSmartShoppingButtonWidth || (FlightsSmartShoppingButtonWidth = {}));
/** Represents flights dialog actions */
export var FlightsSmartShoppingDialogAction;
(function (FlightsSmartShoppingDialogAction) {
  FlightsSmartShoppingDialogAction["CLOSE"] = "CLOSE";
  FlightsSmartShoppingDialogAction["OPEN"] = "OPEN";
  FlightsSmartShoppingDialogAction["TOGGLE"] = "TOGGLE";
})(FlightsSmartShoppingDialogAction || (FlightsSmartShoppingDialogAction = {}));
/** Represents IDs for flights dialogs */
export var FlightsSmartShoppingDialogId;
(function (FlightsSmartShoppingDialogId) {
  /** Represents the Airlines credit dialog */
  FlightsSmartShoppingDialogId["AIRLINE_CREDITS"] = "AIRLINE_CREDITS";
  /** Represents the Close button dialog for the baggage details when complete selections have been made */
  FlightsSmartShoppingDialogId["BAGGAGE_CLOSE_COMPLETE_DIALOG"] = "BAGGAGE_CLOSE_COMPLETE_DIALOG";
  /** Represents the Close button dialog for the baggage details when incomplete selections have been made */
  FlightsSmartShoppingDialogId["BAGGAGE_CLOSE_INCOMPLETE_DIALOG"] = "BAGGAGE_CLOSE_INCOMPLETE_DIALOG";
  /** Represents the Continue booking dialog for the baggage details */
  FlightsSmartShoppingDialogId["BAGGAGE_CONTINUE_BOOKING"] = "BAGGAGE_CONTINUE_BOOKING";
  /** Represents the dialog ID for Baggage details */
  FlightsSmartShoppingDialogId["BAGGAGE_DETAILS_DIALOG"] = "BAGGAGE_DETAILS_DIALOG";
  /** Represents the bags popup dialog on checkout button */
  FlightsSmartShoppingDialogId["BAGS_POPUP_ON_CHECKOUT"] = "BAGS_POPUP_ON_CHECKOUT";
  /** Represents the check credits dialog for users coming from MCC and VA */
  FlightsSmartShoppingDialogId["CHECK_CREDITS_DIALOG"] = "CHECK_CREDITS_DIALOG";
  /** Represents the Flights Details and Fares dialog */
  FlightsSmartShoppingDialogId["FLIGHTS_DETAILS_AND_FARES"] = "FLIGHTS_DETAILS_AND_FARES";
  /** The Forced choice modal that appears in large breakpoints when going to FIS */
  FlightsSmartShoppingDialogId["FORCED_CHOICE_MODAL"] = "FORCED_CHOICE_MODAL";
  /** Represents the How Airlines Work dialog inside Select Credits */
  FlightsSmartShoppingDialogId["HOW_CREDITS_WORK"] = "HOW_CREDITS_WORK";
  /** Represents the Leave This Page dialog inside Select Credits */
  FlightsSmartShoppingDialogId["LEAVE_TO_COUPONS"] = "LEAVE_TO_COUPONS";
  /** Represents the bags opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  FlightsSmartShoppingDialogId["PAID_BAGS_DIALOG"] = "PAID_BAGS_DIALOG";
  /** Represents the Info dialog for Price Match Promise Selected Card */
  FlightsSmartShoppingDialogId["PMP_INFO_DIALOG"] = "PMP_INFO_DIALOG";
  /** Represents the Remove dialog for Price Match Promise Selected Card */
  FlightsSmartShoppingDialogId["PMP_REMOVE_DIALOG"] = "PMP_REMOVE_DIALOG";
  /** Represents the seats popup dialog on checkout button */
  FlightsSmartShoppingDialogId["SEATS_POPUP_ON_CHECKOUT"] = "SEATS_POPUP_ON_CHECKOUT";
  /** Represents the Close button dialog for the seat details */
  FlightsSmartShoppingDialogId["SEAT_CLOSE_COMPLETE_DIALOG"] = "SEAT_CLOSE_COMPLETE_DIALOG";
  /** Represents the Continue booking dialog for the baggage details */
  FlightsSmartShoppingDialogId["SEAT_CONTINUE_BOOKING"] = "SEAT_CONTINUE_BOOKING";
  /** Represents the seats opening dialog eg:- sidesheet for desktop , fullscreendialog for mobile */
  FlightsSmartShoppingDialogId["SEAT_SELECTION_DIALOG"] = "SEAT_SELECTION_DIALOG";
  /** Represents the dialog on traveler mismatch for credits offer */
  FlightsSmartShoppingDialogId["TRAVELER_MISMATCH_DIALOG"] = "TRAVELER_MISMATCH_DIALOG";
})(FlightsSmartShoppingDialogId || (FlightsSmartShoppingDialogId = {}));
/** Represents the position of the icon */
export var FlightsSmartShoppingIconPosition;
(function (FlightsSmartShoppingIconPosition) {
  /** Icon will be rendered at the beginning of the content */
  FlightsSmartShoppingIconPosition["LEADING"] = "LEADING";
  /** Icon will be rendered at the end of the content */
  FlightsSmartShoppingIconPosition["TRAILING"] = "TRAILING";
})(FlightsSmartShoppingIconPosition || (FlightsSmartShoppingIconPosition = {}));
/** Target of the Link when clicked */
export var FlightsSmartShoppingLinkTarget;
(function (FlightsSmartShoppingLinkTarget) {
  /** Link will be opened in an external view e.g. new tab or browser window */
  FlightsSmartShoppingLinkTarget["EXTERNAL"] = "EXTERNAL";
  /** Link will be opened in the same view where the user is currently e.g. same tab or webview inside an app */
  FlightsSmartShoppingLinkTarget["INTERNAL"] = "INTERNAL";
})(FlightsSmartShoppingLinkTarget || (FlightsSmartShoppingLinkTarget = {}));
/** Enum which lists the sort orders */
export var FlightsSortOrder;
(function (FlightsSortOrder) {
  FlightsSortOrder["DECREASING"] = "DECREASING";
  FlightsSortOrder["INCREASING"] = "INCREASING";
})(FlightsSortOrder || (FlightsSortOrder = {}));
/** Enum class which lists all the supported sorting criteria */
export var FlightsSortType;
(function (FlightsSortType) {
  FlightsSortType["ARRIVAL"] = "ARRIVAL";
  FlightsSortType["BEST_BETS"] = "BEST_BETS";
  FlightsSortType["BEST_SORT"] = "BEST_SORT";
  FlightsSortType["CROSS_SORT"] = "CROSS_SORT";
  FlightsSortType["DEPARTURE"] = "DEPARTURE";
  FlightsSortType["DURATION"] = "DURATION";
  FlightsSortType["NONSTOP"] = "NONSTOP";
  FlightsSortType["PRICE"] = "PRICE";
  FlightsSortType["RECOMMENDED"] = "RECOMMENDED";
})(FlightsSortType || (FlightsSortType = {}));
/** Enum class to represent the operation associated with num of stops */
export var FlightsStopFilterOperation;
(function (FlightsStopFilterOperation) {
  FlightsStopFilterOperation["EQUAL"] = "EQUAL";
  FlightsStopFilterOperation["GREATER_THAN_EQUAL"] = "GREATER_THAN_EQUAL";
  FlightsStopFilterOperation["LESS_THAN_EQUAL"] = "LESS_THAN_EQUAL";
})(FlightsStopFilterOperation || (FlightsStopFilterOperation = {}));
/** This represents a decorator that can be applied to a section */
export var FlightsTextSectionDecorator;
(function (FlightsTextSectionDecorator) {
  /** This represents a separator that renders after the text section */
  FlightsTextSectionDecorator["BOTTOMSEPARATOR"] = "BOTTOMSEPARATOR";
  /** This represents a separator that renders above the text section */
  FlightsTextSectionDecorator["TOPSEPARATOR"] = "TOPSEPARATOR";
})(FlightsTextSectionDecorator || (FlightsTextSectionDecorator = {}));
/** Enum representing the various time slots in a day  */
export var FlightsTimeOfDay;
(function (FlightsTimeOfDay) {
  FlightsTimeOfDay["AFTERNOON"] = "AFTERNOON";
  FlightsTimeOfDay["EARLY_MORNING"] = "EARLY_MORNING";
  FlightsTimeOfDay["EVENING"] = "EVENING";
  FlightsTimeOfDay["MORNING"] = "MORNING";
})(FlightsTimeOfDay || (FlightsTimeOfDay = {}));
export var FlightsTimePeriodOfDay;
(function (FlightsTimePeriodOfDay) {
  FlightsTimePeriodOfDay["AFTERNOON"] = "AFTERNOON";
  FlightsTimePeriodOfDay["EARLY_MORNING"] = "EARLY_MORNING";
  FlightsTimePeriodOfDay["EVENING"] = "EVENING";
  FlightsTimePeriodOfDay["MORNING"] = "MORNING";
})(FlightsTimePeriodOfDay || (FlightsTimePeriodOfDay = {}));
/** Represent all the possible traveler types */
export var FlightsTravelerType;
(function (FlightsTravelerType) {
  FlightsTravelerType["ADULT"] = "ADULT";
  FlightsTravelerType["CHILD"] = "CHILD";
  FlightsTravelerType["INFANT_IN_LAP"] = "INFANT_IN_LAP";
  FlightsTravelerType["INFANT_IN_SEAT"] = "INFANT_IN_SEAT";
})(FlightsTravelerType || (FlightsTravelerType = {}));
/** Trip type chosen in flight search */
export var FlightsTripType;
(function (FlightsTripType) {
  FlightsTripType["MULTI_DESTINATION"] = "MULTI_DESTINATION";
  FlightsTripType["ONE_WAY"] = "ONE_WAY";
  FlightsTripType["ROUND_TRIP"] = "ROUND_TRIP";
})(FlightsTripType || (FlightsTripType = {}));
export var FooterButtonType;
(function (FooterButtonType) {
  FooterButtonType["PRIMARY"] = "PRIMARY";
  FooterButtonType["SECONDARY"] = "SECONDARY";
  FooterButtonType["TERTIARY"] = "TERTIARY";
})(FooterButtonType || (FooterButtonType = {}));
export var FooterSeparatorType;
(function (FooterSeparatorType) {
  FooterSeparatorType["HORIZONTAL_RULE"] = "HORIZONTAL_RULE";
})(FooterSeparatorType || (FooterSeparatorType = {}));
/** Represents all the common information in the journey review block on FIS  */
export var FreeCancellationApplicability;
(function (FreeCancellationApplicability) {
  FreeCancellationApplicability["ALL_JOURNEYS"] = "ALL_JOURNEYS";
  FreeCancellationApplicability["CURRENT_JOUNRNEY"] = "CURRENT_JOUNRNEY";
  FreeCancellationApplicability["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(FreeCancellationApplicability || (FreeCancellationApplicability = {}));
export var FunnelLocation;
(function (FunnelLocation) {
  FunnelLocation["CHECKOUT"] = "CHECKOUT";
  FunnelLocation["CHECKOUT_ERROR"] = "CHECKOUT_ERROR";
  FunnelLocation["CONFIRMATION"] = "CONFIRMATION";
  FunnelLocation["DETAILS"] = "DETAILS";
  FunnelLocation["ENTRY"] = "ENTRY";
  FunnelLocation["FEATURES"] = "FEATURES";
  FunnelLocation["PAYMENT_ERROR"] = "PAYMENT_ERROR";
  FunnelLocation["POST_BOOKING"] = "POST_BOOKING";
  FunnelLocation["SEARCH_RESULTS"] = "SEARCH_RESULTS";
  FunnelLocation["SYSTEM"] = "SYSTEM";
  FunnelLocation["USER"] = "USER";
})(FunnelLocation || (FunnelLocation = {}));
/** Possible direction types for ground transfers */
export var GeoType;
(function (GeoType) {
  GeoType["AIRPORT"] = "AIRPORT";
  GeoType["DESTINATION"] = "DESTINATION";
  GeoType["PROPERTY"] = "PROPERTY";
})(GeoType || (GeoType = {}));
/** Line of business that is querying the global navigation elements. */
export var GlobalNavigationLineOfBusiness;
(function (GlobalNavigationLineOfBusiness) {
  GlobalNavigationLineOfBusiness["ACTIVITY"] = "ACTIVITY";
  GlobalNavigationLineOfBusiness["CAR"] = "CAR";
  GlobalNavigationLineOfBusiness["CRUISE"] = "CRUISE";
  GlobalNavigationLineOfBusiness["FLIGHT"] = "FLIGHT";
  GlobalNavigationLineOfBusiness["HOTEL"] = "HOTEL";
  GlobalNavigationLineOfBusiness["PACKAGE"] = "PACKAGE";
  GlobalNavigationLineOfBusiness["UNKNOWN"] = "UNKNOWN";
})(GlobalNavigationLineOfBusiness || (GlobalNavigationLineOfBusiness = {}));
export var GroundTransfersBadgeTheme;
(function (GroundTransfersBadgeTheme) {
  GroundTransfersBadgeTheme["DEAL_BUNDLED"] = "DEAL_BUNDLED";
  GroundTransfersBadgeTheme["DEAL_GENERIC"] = "DEAL_GENERIC";
  GroundTransfersBadgeTheme["DEAL_MEMBER"] = "DEAL_MEMBER";
})(GroundTransfersBadgeTheme || (GroundTransfersBadgeTheme = {}));
/** Possible direction types for ground transfers */
export var GroundTransfersDirection;
(function (GroundTransfersDirection) {
  GroundTransfersDirection["FROM_AIRPORT"] = "FROM_AIRPORT";
  GroundTransfersDirection["ROUNDTRIP"] = "ROUNDTRIP";
  GroundTransfersDirection["TO_AIRPORT"] = "TO_AIRPORT";
})(GroundTransfersDirection || (GroundTransfersDirection = {}));
export var GroundTransfersGroupViewType;
(function (GroundTransfersGroupViewType) {
  GroundTransfersGroupViewType["CARDS_LIST"] = "CARDS_LIST";
})(GroundTransfersGroupViewType || (GroundTransfersGroupViewType = {}));
export var GroundTransfersMapTransitOption;
(function (GroundTransfersMapTransitOption) {
  GroundTransfersMapTransitOption["BUS"] = "BUS";
  GroundTransfersMapTransitOption["NONE"] = "NONE";
  GroundTransfersMapTransitOption["TRAIN"] = "TRAIN";
})(GroundTransfersMapTransitOption || (GroundTransfersMapTransitOption = {}));
export var GroundTransfersMapTravelMode;
(function (GroundTransfersMapTravelMode) {
  GroundTransfersMapTravelMode["DRIVING"] = "DRIVING";
  GroundTransfersMapTravelMode["TRANSIT"] = "TRANSIT";
})(GroundTransfersMapTravelMode || (GroundTransfersMapTravelMode = {}));
export var GroundTransfersSectionStyle;
(function (GroundTransfersSectionStyle) {
  GroundTransfersSectionStyle["BULLETED"] = "BULLETED";
  GroundTransfersSectionStyle["STANDARD"] = "STANDARD";
})(GroundTransfersSectionStyle || (GroundTransfersSectionStyle = {}));
/** Text style to apply to text */
export var GroundTransfersStyle;
(function (GroundTransfersStyle) {
  /** Bold styling */
  GroundTransfersStyle["EMPHASISED"] = "EMPHASISED";
  /** Loyalty messages styling */
  GroundTransfersStyle["LOYALTY"] = "LOYALTY";
  /** Green text styling */
  GroundTransfersStyle["POSITIVE"] = "POSITIVE";
  /** Regular text with no styling, default Value */
  GroundTransfersStyle["STANDARD"] = "STANDARD";
})(GroundTransfersStyle || (GroundTransfersStyle = {}));
/** Possible traveler details types */
export var GroundTransfersTravelerDetailsType;
(function (GroundTransfersTravelerDetailsType) {
  GroundTransfersTravelerDetailsType["ADULT"] = "ADULT";
  GroundTransfersTravelerDetailsType["CHILD"] = "CHILD";
  GroundTransfersTravelerDetailsType["INFANT"] = "INFANT";
})(GroundTransfersTravelerDetailsType || (GroundTransfersTravelerDetailsType = {}));
/** Header section alignment of elements to either the start or end of the section container. */
export var HeaderAlignment;
(function (HeaderAlignment) {
  HeaderAlignment["END"] = "END";
  HeaderAlignment["START"] = "START";
})(HeaderAlignment || (HeaderAlignment = {}));
/** Determines the type of button to display.  Primary or tertiary. */
export var HeaderButtonType;
(function (HeaderButtonType) {
  HeaderButtonType["PRIMARY"] = "PRIMARY";
  HeaderButtonType["SECONDARY"] = "SECONDARY";
  HeaderButtonType["TERTIARY"] = "TERTIARY";
})(HeaderButtonType || (HeaderButtonType = {}));
/** Used to position the header menu dropdown as well as icons in links and buttons.  Options are LEFT or RIGHT. */
export var HeaderItemPosition;
(function (HeaderItemPosition) {
  HeaderItemPosition["LEFT"] = "LEFT";
  HeaderItemPosition["RIGHT"] = "RIGHT";
})(HeaderItemPosition || (HeaderItemPosition = {}));
/** Header layout. */
export var HeaderLayout;
(function (HeaderLayout) {
  HeaderLayout["DEFAULT"] = "DEFAULT";
  HeaderLayout["MINIMAL"] = "MINIMAL";
  HeaderLayout["SIMPLIFIED"] = "SIMPLIFIED";
})(HeaderLayout || (HeaderLayout = {}));
/** Inserts a separator in header menus. */
export var HeaderSeparatorType;
(function (HeaderSeparatorType) {
  HeaderSeparatorType["HORIZONTAL_RULE"] = "HORIZONTAL_RULE";
})(HeaderSeparatorType || (HeaderSeparatorType = {}));
/** Heading text size. Small or large. */
export var HeaderTextSize;
(function (HeaderTextSize) {
  HeaderTextSize["LARGE"] = "LARGE";
  HeaderTextSize["SMALL"] = "SMALL";
})(HeaderTextSize || (HeaderTextSize = {}));
/** Type of text.  Heading or subheading. */
export var HeaderTextType;
(function (HeaderTextType) {
  HeaderTextType["HEADING"] = "HEADING";
  HeaderTextType["SUBHEADING"] = "SUBHEADING";
})(HeaderTextType || (HeaderTextType = {}));
/** Different viewport sizes to display the header. */
export var HeaderViewSize;
(function (HeaderViewSize) {
  HeaderViewSize["EXTRA_LARGE"] = "EXTRA_LARGE";
  HeaderViewSize["LARGE"] = "LARGE";
  HeaderViewSize["MEDIUM"] = "MEDIUM";
  HeaderViewSize["SMALL"] = "SMALL";
})(HeaderViewSize || (HeaderViewSize = {}));
export var HelpAndFeedbackHelpCenterOptionsType;
(function (HelpAndFeedbackHelpCenterOptionsType) {
  HelpAndFeedbackHelpCenterOptionsType["OWNER"] = "OWNER";
  HelpAndFeedbackHelpCenterOptionsType["PROPERTY_MANAGER"] = "PROPERTY_MANAGER";
  HelpAndFeedbackHelpCenterOptionsType["TRAVELER"] = "TRAVELER";
  HelpAndFeedbackHelpCenterOptionsType["TRUST_AND_SAFETY"] = "TRUST_AND_SAFETY";
})(HelpAndFeedbackHelpCenterOptionsType || (HelpAndFeedbackHelpCenterOptionsType = {}));
export var HelpAndFeedbackOptionsType;
(function (HelpAndFeedbackOptionsType) {
  HelpAndFeedbackOptionsType["BRAND_CALL"] = "BRAND_CALL";
  HelpAndFeedbackOptionsType["CHAT_NOW"] = "CHAT_NOW";
  HelpAndFeedbackOptionsType["CREDIT_CARD"] = "CREDIT_CARD";
  HelpAndFeedbackOptionsType["RATE_OUR_APP"] = "RATE_OUR_APP";
  HelpAndFeedbackOptionsType["SHARE_YOUR_FEEDBACK"] = "SHARE_YOUR_FEEDBACK";
  HelpAndFeedbackOptionsType["VISIT_HELP_CENTER"] = "VISIT_HELP_CENTER";
})(HelpAndFeedbackOptionsType || (HelpAndFeedbackOptionsType = {}));
export var HelperConfigMap;
(function (HelperConfigMap) {
  HelperConfigMap["And"] = "And";
  HelperConfigMap["CapitalizeFirst"] = "CapitalizeFirst";
  HelperConfigMap["DeviceTypeEvaluator"] = "DeviceTypeEvaluator";
  HelperConfigMap["Equals"] = "Equals";
  HelperConfigMap["EvaluateExperiment"] = "EvaluateExperiment";
  HelperConfigMap["EvaluateExperimentAndLog"] = "EvaluateExperimentAndLog";
  HelperConfigMap["ExperimentEvaluator"] = "ExperimentEvaluator";
  HelperConfigMap["GetSystemTimeInMs"] = "GetSystemTimeInMs";
  HelperConfigMap["GetUsableURN"] = "GetUsableURN";
  HelperConfigMap["Greater"] = "Greater";
  HelperConfigMap["GreaterAndEquals"] = "GreaterAndEquals";
  HelperConfigMap["HTTPLink"] = "HTTPLink";
  HelperConfigMap["Join"] = "Join";
  HelperConfigMap["Limit"] = "Limit";
  HelperConfigMap["Localize"] = "Localize";
  HelperConfigMap["Not"] = "Not";
  HelperConfigMap["Or"] = "Or";
})(HelperConfigMap || (HelperConfigMap = {}));
export var HistoryType;
(function (HistoryType) {
  HistoryType["ACTIVITY_DETAIL"] = "ACTIVITY_DETAIL";
  HistoryType["ACTIVITY_SEARCH"] = "ACTIVITY_SEARCH";
  HistoryType["CAR_DETAIL"] = "CAR_DETAIL";
  HistoryType["CAR_SEARCH"] = "CAR_SEARCH";
  HistoryType["CRUISE_SEARCH"] = "CRUISE_SEARCH";
  HistoryType["FLIGHT_DETAIL"] = "FLIGHT_DETAIL";
  HistoryType["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
  HistoryType["PACKAGE_SEARCH"] = "PACKAGE_SEARCH";
  HistoryType["PROPERTY_DETAIL"] = "PROPERTY_DETAIL";
  HistoryType["PROPERTY_SEARCH"] = "PROPERTY_SEARCH";
})(HistoryType || (HistoryType = {}));
export var HttpStatus;
(function (HttpStatus) {
  HttpStatus["ACCEPTED"] = "ACCEPTED";
  HttpStatus["ALREADY_REPORTED"] = "ALREADY_REPORTED";
  HttpStatus["BAD_GATEWAY"] = "BAD_GATEWAY";
  HttpStatus["BAD_REQUEST"] = "BAD_REQUEST";
  HttpStatus["BANDWIDTH_LIMIT_EXCEEDED"] = "BANDWIDTH_LIMIT_EXCEEDED";
  HttpStatus["CHECKPOINT"] = "CHECKPOINT";
  HttpStatus["CONFLICT"] = "CONFLICT";
  HttpStatus["CONTINUE"] = "CONTINUE";
  HttpStatus["CREATED"] = "CREATED";
  HttpStatus["DESTINATION_LOCKED"] = "DESTINATION_LOCKED";
  HttpStatus["EXPECTATION_FAILED"] = "EXPECTATION_FAILED";
  HttpStatus["FAILED_DEPENDENCY"] = "FAILED_DEPENDENCY";
  HttpStatus["FORBIDDEN"] = "FORBIDDEN";
  HttpStatus["FOUND"] = "FOUND";
  HttpStatus["GATEWAY_TIMEOUT"] = "GATEWAY_TIMEOUT";
  HttpStatus["GONE"] = "GONE";
  HttpStatus["HTTP_VERSION_NOT_SUPPORTED"] = "HTTP_VERSION_NOT_SUPPORTED";
  HttpStatus["IM_USED"] = "IM_USED";
  HttpStatus["INSUFFICIENT_SPACE_ON_RESOURCE"] = "INSUFFICIENT_SPACE_ON_RESOURCE";
  HttpStatus["INSUFFICIENT_STORAGE"] = "INSUFFICIENT_STORAGE";
  HttpStatus["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
  HttpStatus["I_AM_A_TEAPOT"] = "I_AM_A_TEAPOT";
  HttpStatus["LENGTH_REQUIRED"] = "LENGTH_REQUIRED";
  HttpStatus["LOCKED"] = "LOCKED";
  HttpStatus["LOOP_DETECTED"] = "LOOP_DETECTED";
  HttpStatus["METHOD_FAILURE"] = "METHOD_FAILURE";
  HttpStatus["METHOD_NOT_ALLOWED"] = "METHOD_NOT_ALLOWED";
  HttpStatus["MOVED_PERMANENTLY"] = "MOVED_PERMANENTLY";
  HttpStatus["MOVED_TEMPORARILY"] = "MOVED_TEMPORARILY";
  HttpStatus["MULTIPLE_CHOICES"] = "MULTIPLE_CHOICES";
  HttpStatus["MULTI_STATUS"] = "MULTI_STATUS";
  HttpStatus["NETWORK_AUTHENTICATION_REQUIRED"] = "NETWORK_AUTHENTICATION_REQUIRED";
  HttpStatus["NON_AUTHORITATIVE_INFORMATION"] = "NON_AUTHORITATIVE_INFORMATION";
  HttpStatus["NOT_ACCEPTABLE"] = "NOT_ACCEPTABLE";
  HttpStatus["NOT_EXTENDED"] = "NOT_EXTENDED";
  HttpStatus["NOT_FOUND"] = "NOT_FOUND";
  HttpStatus["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
  HttpStatus["NOT_MODIFIED"] = "NOT_MODIFIED";
  HttpStatus["NO_CONTENT"] = "NO_CONTENT";
  HttpStatus["OK"] = "OK";
  HttpStatus["PARTIAL_CONTENT"] = "PARTIAL_CONTENT";
  HttpStatus["PAYLOAD_TOO_LARGE"] = "PAYLOAD_TOO_LARGE";
  HttpStatus["PAYMENT_REQUIRED"] = "PAYMENT_REQUIRED";
  HttpStatus["PERMANENT_REDIRECT"] = "PERMANENT_REDIRECT";
  HttpStatus["PRECONDITION_FAILED"] = "PRECONDITION_FAILED";
  HttpStatus["PRECONDITION_REQUIRED"] = "PRECONDITION_REQUIRED";
  HttpStatus["PROCESSING"] = "PROCESSING";
  HttpStatus["PROXY_AUTHENTICATION_REQUIRED"] = "PROXY_AUTHENTICATION_REQUIRED";
  HttpStatus["REQUESTED_RANGE_NOT_SATISFIABLE"] = "REQUESTED_RANGE_NOT_SATISFIABLE";
  HttpStatus["REQUEST_ENTITY_TOO_LARGE"] = "REQUEST_ENTITY_TOO_LARGE";
  HttpStatus["REQUEST_HEADER_FIELDS_TOO_LARGE"] = "REQUEST_HEADER_FIELDS_TOO_LARGE";
  HttpStatus["REQUEST_TIMEOUT"] = "REQUEST_TIMEOUT";
  HttpStatus["REQUEST_URI_TOO_LONG"] = "REQUEST_URI_TOO_LONG";
  HttpStatus["RESET_CONTENT"] = "RESET_CONTENT";
  HttpStatus["SEE_OTHER"] = "SEE_OTHER";
  HttpStatus["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
  HttpStatus["SWITCHING_PROTOCOLS"] = "SWITCHING_PROTOCOLS";
  HttpStatus["TEMPORARY_REDIRECT"] = "TEMPORARY_REDIRECT";
  HttpStatus["TOO_EARLY"] = "TOO_EARLY";
  HttpStatus["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
  HttpStatus["UNAUTHORIZED"] = "UNAUTHORIZED";
  HttpStatus["UNAVAILABLE_FOR_LEGAL_REASONS"] = "UNAVAILABLE_FOR_LEGAL_REASONS";
  HttpStatus["UNPROCESSABLE_ENTITY"] = "UNPROCESSABLE_ENTITY";
  HttpStatus["UNSUPPORTED_MEDIA_TYPE"] = "UNSUPPORTED_MEDIA_TYPE";
  HttpStatus["UPGRADE_REQUIRED"] = "UPGRADE_REQUIRED";
  HttpStatus["URI_TOO_LONG"] = "URI_TOO_LONG";
  HttpStatus["USE_PROXY"] = "USE_PROXY";
  HttpStatus["VARIANT_ALSO_NEGOTIATES"] = "VARIANT_ALSO_NEGOTIATES";
})(HttpStatus || (HttpStatus = {}));
export var IFJ_ContactUsOptionType;
(function (IFJ_ContactUsOptionType) {
  IFJ_ContactUsOptionType["CALL_BACK_WITH_AGENT"] = "CALL_BACK_WITH_AGENT";
  IFJ_ContactUsOptionType["CALL_TO_AGENT"] = "CALL_TO_AGENT";
  IFJ_ContactUsOptionType["CHAT_BACK_WITH_AGENT"] = "CHAT_BACK_WITH_AGENT";
  IFJ_ContactUsOptionType["CHAT_WITH_AGENT"] = "CHAT_WITH_AGENT";
  IFJ_ContactUsOptionType["SEND_EMAIL_AGENT"] = "SEND_EMAIL_AGENT";
})(IFJ_ContactUsOptionType || (IFJ_ContactUsOptionType = {}));
/** supported sizes of icons */
export var IconSize;
(function (IconSize) {
  IconSize["EXTRA_SMALL"] = "EXTRA_SMALL";
  IconSize["LARGE"] = "LARGE";
  IconSize["MEDIUM"] = "MEDIUM";
  IconSize["MEDIUM_LARGE"] = "MEDIUM_LARGE";
  IconSize["SMALL"] = "SMALL";
  IconSize["XLARGE"] = "XLARGE";
})(IconSize || (IconSize = {}));
/** Supported themes of spotlights. See the prop definitions here: https://www.figma.com/file/Cq6XtgvVIEriWmWmVIMPzNOE/Icons?node-id=6402%3A115 */
export var IconSpotLight;
(function (IconSpotLight) {
  IconSpotLight["INFO"] = "INFO";
  IconSpotLight["POSITIVE"] = "POSITIVE";
  IconSpotLight["STANDARD"] = "STANDARD";
  IconSpotLight["WARNING"] = "WARNING";
})(IconSpotLight || (IconSpotLight = {}));
/** Supported themes of icons. See the prop definitions here: http://uitk-react.tools.expedia.com/expedia/en_US/components/icons */
export var IconTheme;
(function (IconTheme) {
  IconTheme["default"] = "default";
  IconTheme["emphasis"] = "emphasis";
  IconTheme["inverse"] = "inverse";
  IconTheme["negative"] = "negative";
  IconTheme["positive"] = "positive";
})(IconTheme || (IconTheme = {}));
/** Enum to specify the type for nputId */
export var IdentifierType;
(function (IdentifierType) {
  IdentifierType["ACTIVITY_ID"] = "ACTIVITY_ID";
  IdentifierType["CART_ID"] = "CART_ID";
  IdentifierType["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
  IdentifierType["ENTITY_ID"] = "ENTITY_ID";
  IdentifierType["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
  IdentifierType["OFFER_ID"] = "OFFER_ID";
  IdentifierType["ORDER_ID"] = "ORDER_ID";
  IdentifierType["PROPERTY_ID"] = "PROPERTY_ID";
})(IdentifierType || (IdentifierType = {}));
export var IdentityAccountCreationState;
(function (IdentityAccountCreationState) {
  IdentityAccountCreationState["INVALID"] = "INVALID";
  IdentityAccountCreationState["NOT_UPGRADED"] = "NOT_UPGRADED";
  IdentityAccountCreationState["UPGRADED"] = "UPGRADED";
})(IdentityAccountCreationState || (IdentityAccountCreationState = {}));
export var IdentityAccountCreationType;
(function (IdentityAccountCreationType) {
  IdentityAccountCreationType["INVALID"] = "INVALID";
  IdentityAccountCreationType["REGISTERED"] = "REGISTERED";
  IdentityAccountCreationType["UNREGISTERED"] = "UNREGISTERED";
})(IdentityAccountCreationType || (IdentityAccountCreationType = {}));
export var IdentityAccountTakeOverDeviceType;
(function (IdentityAccountTakeOverDeviceType) {
  IdentityAccountTakeOverDeviceType["TRUST_WIDGET"] = "TRUST_WIDGET";
})(IdentityAccountTakeOverDeviceType || (IdentityAccountTakeOverDeviceType = {}));
export var IdentityAccountTakeOverType;
(function (IdentityAccountTakeOverType) {
  IdentityAccountTakeOverType["CAPTCHA_SAFETYNET_ANDROID"] = "CAPTCHA_SAFETYNET_ANDROID";
  IdentityAccountTakeOverType["CSRF"] = "CSRF";
  IdentityAccountTakeOverType["DEVICE_CHECK"] = "DEVICE_CHECK";
  IdentityAccountTakeOverType["TRUST_WIDGET"] = "TRUST_WIDGET";
})(IdentityAccountTakeOverType || (IdentityAccountTakeOverType = {}));
export var IdentityChannelType;
(function (IdentityChannelType) {
  IdentityChannelType["ANDROID"] = "ANDROID";
  IdentityChannelType["DESKTOP"] = "DESKTOP";
  IdentityChannelType["IOS"] = "IOS";
})(IdentityChannelType || (IdentityChannelType = {}));
export var IdentityLayout;
(function (IdentityLayout) {
  IdentityLayout["FORGOT_PASSWORD"] = "FORGOT_PASSWORD";
  IdentityLayout["GET_RESENT_OTP_ATO"] = "GET_RESENT_OTP_ATO";
  IdentityLayout["GET_SEND_OTP_ATO"] = "GET_SEND_OTP_ATO";
  IdentityLayout["GET_SET_PASSWORD_ATO"] = "GET_SET_PASSWORD_ATO";
  IdentityLayout["GET_SIGN_IN_ATO"] = "GET_SIGN_IN_ATO";
  IdentityLayout["GET_SIGN_IN_VERIFY_OTP_ATO"] = "GET_SIGN_IN_VERIFY_OTP_ATO";
  IdentityLayout["GET_SIGN_UP_VERIFY_OTP_ATO"] = "GET_SIGN_UP_VERIFY_OTP_ATO";
  IdentityLayout["GET_SOCIAL_LOGIN_APPLE_ATO"] = "GET_SOCIAL_LOGIN_APPLE_ATO";
  IdentityLayout["GET_SOCIAL_LOGIN_FACEBOOK_ATO"] = "GET_SOCIAL_LOGIN_FACEBOOK_ATO";
  IdentityLayout["GET_SOCIAL_LOGIN_GOOGLE_ATO"] = "GET_SOCIAL_LOGIN_GOOGLE_ATO";
  IdentityLayout["GET_USER_DETAILS_ATO"] = "GET_USER_DETAILS_ATO";
  IdentityLayout["LAUNCH_ONE_IDENTITY"] = "LAUNCH_ONE_IDENTITY";
  IdentityLayout["RESET_PASSWORD"] = "RESET_PASSWORD";
  IdentityLayout["SIGNIN"] = "SIGNIN";
  IdentityLayout["SIGNUP"] = "SIGNUP";
})(IdentityLayout || (IdentityLayout = {}));
export var IdentityLoginScenario;
(function (IdentityLoginScenario) {
  IdentityLoginScenario["SIGN_IN"] = "SIGN_IN";
  IdentityLoginScenario["SIGN_UP"] = "SIGN_UP";
})(IdentityLoginScenario || (IdentityLoginScenario = {}));
export var IdentitySocialButtonType;
(function (IdentitySocialButtonType) {
  IdentitySocialButtonType["PRIMARY"] = "PRIMARY";
  IdentitySocialButtonType["SECONDARY"] = "SECONDARY";
})(IdentitySocialButtonType || (IdentitySocialButtonType = {}));
export var IdentitySocialTokenType;
(function (IdentitySocialTokenType) {
  IdentitySocialTokenType["Access"] = "Access";
  IdentitySocialTokenType["AuthCode"] = "AuthCode";
  IdentitySocialTokenType["ID"] = "ID";
})(IdentitySocialTokenType || (IdentitySocialTokenType = {}));
export var IdentitySocialType;
(function (IdentitySocialType) {
  IdentitySocialType["APPLE"] = "APPLE";
  IdentitySocialType["FACEBOOK"] = "FACEBOOK";
  IdentitySocialType["GOOGLE"] = "GOOGLE";
})(IdentitySocialType || (IdentitySocialType = {}));
/** EG Universal Login spacing definition */
export var IdentitySpaceSize;
(function (IdentitySpaceSize) {
  IdentitySpaceSize["S0X"] = "S0X";
  IdentitySpaceSize["S0XH"] = "S0XH";
  IdentitySpaceSize["S10X"] = "S10X";
  IdentitySpaceSize["S11X"] = "S11X";
  IdentitySpaceSize["S12X"] = "S12X";
  IdentitySpaceSize["S14X"] = "S14X";
  IdentitySpaceSize["S16X"] = "S16X";
  IdentitySpaceSize["S18X"] = "S18X";
  IdentitySpaceSize["S1X"] = "S1X";
  IdentitySpaceSize["S2X"] = "S2X";
  IdentitySpaceSize["S3X"] = "S3X";
  IdentitySpaceSize["S4X"] = "S4X";
  IdentitySpaceSize["S5X"] = "S5X";
  IdentitySpaceSize["S6X"] = "S6X";
  IdentitySpaceSize["S8X"] = "S8X";
})(IdentitySpaceSize || (IdentitySpaceSize = {}));
export var IdentitySuccessType;
(function (IdentitySuccessType) {
  IdentitySuccessType["ONE_KEY_ONBOARDING"] = "ONE_KEY_ONBOARDING";
  IdentitySuccessType["ORIGIN"] = "ORIGIN";
})(IdentitySuccessType || (IdentitySuccessType = {}));
export var InquiryProminence;
(function (InquiryProminence) {
  InquiryProminence["HIGH"] = "HIGH";
  InquiryProminence["LOW"] = "LOW";
  InquiryProminence["MEDIUM"] = "MEDIUM";
})(InquiryProminence || (InquiryProminence = {}));
/** Represents insurance dialog action types */
export var InsurTechDialogActionType;
(function (InsurTechDialogActionType) {
  InsurTechDialogActionType["CLOSE"] = "CLOSE";
  InsurTechDialogActionType["OPEN"] = "OPEN";
  InsurTechDialogActionType["OPEN_QUERY"] = "OPEN_QUERY";
})(InsurTechDialogActionType || (InsurTechDialogActionType = {}));
/** Represents insurance dialog trigger types link or button */
export var InsurTechExperienceDialogTriggerType;
(function (InsurTechExperienceDialogTriggerType) {
  InsurTechExperienceDialogTriggerType["BUTTON"] = "BUTTON";
  InsurTechExperienceDialogTriggerType["LINK"] = "LINK";
})(InsurTechExperienceDialogTriggerType || (InsurTechExperienceDialogTriggerType = {}));
/** Placement of the component inside the page */
export var InsurTechPagePlacementType;
(function (InsurTechPagePlacementType) {
  InsurTechPagePlacementType["LISTING"] = "LISTING";
})(InsurTechPagePlacementType || (InsurTechPagePlacementType = {}));
export var InsuranceListLayout;
(function (InsuranceListLayout) {
  InsuranceListLayout["SINGLE_COLUMN"] = "SINGLE_COLUMN";
})(InsuranceListLayout || (InsuranceListLayout = {}));
export var InsuranceListType;
(function (InsuranceListType) {
  InsuranceListType["ORDERED"] = "ORDERED";
  InsuranceListType["UNORDERED"] = "UNORDERED";
})(InsuranceListType || (InsuranceListType = {}));
export var InsuranceListTypeOld;
(function (InsuranceListTypeOld) {
  InsuranceListTypeOld["ICON"] = "ICON";
  InsuranceListTypeOld["NUMBERED"] = "NUMBERED";
})(InsuranceListTypeOld || (InsuranceListTypeOld = {}));
export var InsuranceMessageType;
(function (InsuranceMessageType) {
  InsuranceMessageType["ERROR"] = "ERROR";
  InsuranceMessageType["INFO"] = "INFO";
  InsuranceMessageType["WARNING"] = "WARNING";
})(InsuranceMessageType || (InsuranceMessageType = {}));
export var InsuranceMutationStatus;
(function (InsuranceMutationStatus) {
  InsuranceMutationStatus["FAILED"] = "FAILED";
  InsuranceMutationStatus["SUCCESS"] = "SUCCESS";
})(InsuranceMutationStatus || (InsuranceMutationStatus = {}));
export var InsuranceMutationType;
(function (InsuranceMutationType) {
  InsuranceMutationType["ADD_INSURANCE"] = "ADD_INSURANCE";
  InsuranceMutationType["REMOVE_INSURANCE"] = "REMOVE_INSURANCE";
})(InsuranceMutationType || (InsuranceMutationType = {}));
export var InsurancePhrasePartStyle;
(function (InsurancePhrasePartStyle) {
  /** Green */
  InsurancePhrasePartStyle["COLOR_GREEN"] = "COLOR_GREEN";
  /** Red */
  InsurancePhrasePartStyle["COLOR_RED"] = "COLOR_RED";
  /** Italic styling */
  InsurancePhrasePartStyle["EMPHASIS"] = "EMPHASIS";
  /** Bold styling */
  InsurancePhrasePartStyle["IMPORTANT"] = "IMPORTANT";
  /** Represents no style or regular text */
  InsurancePhrasePartStyle["STANDARD"] = "STANDARD";
})(InsurancePhrasePartStyle || (InsurancePhrasePartStyle = {}));
export var InsuranceRewardsPointSelectionEnum;
(function (InsuranceRewardsPointSelectionEnum) {
  InsuranceRewardsPointSelectionEnum["APPLY_REWARD_POINTS"] = "APPLY_REWARD_POINTS";
  InsuranceRewardsPointSelectionEnum["DO_NOT_APPLY_REWARD_POINTS"] = "DO_NOT_APPLY_REWARD_POINTS";
})(InsuranceRewardsPointSelectionEnum || (InsuranceRewardsPointSelectionEnum = {}));
/** Client Id Possibilities */
export var InsurtechClientId;
(function (InsurtechClientId) {
  InsurtechClientId["CAR_INFO_SITE"] = "CAR_INFO_SITE";
  InsurtechClientId["EG_CHECKOUT"] = "EG_CHECKOUT";
  InsurtechClientId["FCR_CHECKOUT"] = "FCR_CHECKOUT";
})(InsurtechClientId || (InsurtechClientId = {}));
/** Enum having action type details available to execute */
export var InsurtechGenericActionType;
(function (InsurtechGenericActionType) {
  InsurtechGenericActionType["REDIRECT_CHECKOUT_URL"] = "REDIRECT_CHECKOUT_URL";
})(InsurtechGenericActionType || (InsurtechGenericActionType = {}));
/** Insurtech Link Type */
export var InsurtechLinkType;
(function (InsurtechLinkType) {
  InsurtechLinkType["MORE_INFO"] = "MORE_INFO";
  InsurtechLinkType["STANDARD_LINK"] = "STANDARD_LINK";
})(InsurtechLinkType || (InsurtechLinkType = {}));
/** Status Possibilities */
export var InsurtechMutationStatus;
(function (InsurtechMutationStatus) {
  InsurtechMutationStatus["FAILED"] = "FAILED";
  InsurtechMutationStatus["SUCCESS"] = "SUCCESS";
})(InsurtechMutationStatus || (InsurtechMutationStatus = {}));
/** State represents teh status whether offer is already added, not added or some different offer is added */
export var InsurtechOfferState;
(function (InsurtechOfferState) {
  InsurtechOfferState["CHANGED_OFFER"] = "CHANGED_OFFER";
  InsurtechOfferState["NOT_SELECTED"] = "NOT_SELECTED";
  InsurtechOfferState["UNCHANGED_OFFER"] = "UNCHANGED_OFFER";
})(InsurtechOfferState || (InsurtechOfferState = {}));
export var InsurtechPrimingCardViewType;
(function (InsurtechPrimingCardViewType) {
  InsurtechPrimingCardViewType["BASIC_PRIMING_CARD"] = "BASIC_PRIMING_CARD";
})(InsurtechPrimingCardViewType || (InsurtechPrimingCardViewType = {}));
/** Enum having criteria type details available for trip */
export var InsurtechShoppingIdentifierType;
(function (InsurtechShoppingIdentifierType) {
  InsurtechShoppingIdentifierType["JCID"] = "JCID";
  InsurtechShoppingIdentifierType["OFFER_TOKEN"] = "OFFER_TOKEN";
  InsurtechShoppingIdentifierType["TRIP_ID"] = "TRIP_ID";
})(InsurtechShoppingIdentifierType || (InsurtechShoppingIdentifierType = {}));
/** Enum having shopping view type details */
export var InsurtechShoppingViewType;
(function (InsurtechShoppingViewType) {
  InsurtechShoppingViewType["CHECKOUT_SHOPPING"] = "CHECKOUT_SHOPPING";
  InsurtechShoppingViewType["DETAILS_SHOPPING"] = "DETAILS_SHOPPING";
  InsurtechShoppingViewType["SUMMARY"] = "SUMMARY";
})(InsurtechShoppingViewType || (InsurtechShoppingViewType = {}));
/** Enum having operation type details */
export var InsurtechUpdateOperationType;
(function (InsurtechUpdateOperationType) {
  InsurtechUpdateOperationType["ADD"] = "ADD";
  InsurtechUpdateOperationType["REMOVE"] = "REMOVE";
})(InsurtechUpdateOperationType || (InsurtechUpdateOperationType = {}));
/** Interaction to publish an event for */
export var InteractionEventName;
(function (InteractionEventName) {
  InteractionEventName["BOOK"] = "BOOK";
  InteractionEventName["CHECKOUT_PAGE_LOAD"] = "CHECKOUT_PAGE_LOAD";
  InteractionEventName["CONFIRMATION_PAGE_LOAD"] = "CONFIRMATION_PAGE_LOAD";
})(InteractionEventName || (InteractionEventName = {}));
/** InteractionMode will hold status of input for the session  */
export var InteractionMode;
(function (InteractionMode) {
  InteractionMode["FREE"] = "FREE";
  InteractionMode["RESTRICTED"] = "RESTRICTED";
})(InteractionMode || (InteractionMode = {}));
/** Indicate the inventory type of a given offer */
export var InventoryType;
(function (InventoryType) {
  InventoryType["AICTRAVELGROUP"] = "AICTRAVELGROUP";
  InventoryType["AMOMA"] = "AMOMA";
  InventoryType["ANA"] = "ANA";
  InventoryType["BESTBUYHOTEL"] = "BESTBUYHOTEL";
  InventoryType["BONOTEL"] = "BONOTEL";
  InventoryType["CNTRAVEL"] = "CNTRAVEL";
  InventoryType["CTRIP"] = "CTRIP";
  InventoryType["DESPEGAR"] = "DESPEGAR";
  InventoryType["DIDATRAVEL"] = "DIDATRAVEL";
  InventoryType["DIRECT_AGENCY"] = "DIRECT_AGENCY";
  InventoryType["EUROPLAYAS"] = "EUROPLAYAS";
  InventoryType["EXCITEHOLIDAYS"] = "EXCITEHOLIDAYS";
  InventoryType["EZZEGO_1"] = "EZZEGO_1";
  InventoryType["GETAROOM"] = "GETAROOM";
  InventoryType["HOME_AWAY"] = "HOME_AWAY";
  InventoryType["HOTELDOBESTDAYTRAVEL"] = "HOTELDOBESTDAYTRAVEL";
  InventoryType["HOTEL_BEDS"] = "HOTEL_BEDS";
  InventoryType["HRS"] = "HRS";
  InventoryType["JAC_TRAVEL"] = "JAC_TRAVEL";
  InventoryType["JAL"] = "JAL";
  InventoryType["JALAN"] = "JALAN";
  InventoryType["JTB"] = "JTB";
  InventoryType["JUMBOTOURS"] = "JUMBOTOURS";
  InventoryType["MAGICROOMS"] = "MAGICROOMS";
  InventoryType["MERCHANT"] = "MERCHANT";
  InventoryType["MGBEDBANK"] = "MGBEDBANK";
  InventoryType["MIKI"] = "MIKI";
  InventoryType["MTS"] = "MTS";
  InventoryType["NTA"] = "NTA";
  InventoryType["NUITEE"] = "NUITEE";
  InventoryType["OPAQUE"] = "OPAQUE";
  InventoryType["OSTROVOK"] = "OSTROVOK";
  InventoryType["PEGASUS"] = "PEGASUS";
  InventoryType["RAKUTEN"] = "RAKUTEN";
  InventoryType["RESTEL"] = "RESTEL";
  InventoryType["ROOMER"] = "ROOMER";
  InventoryType["SMYROOMS"] = "SMYROOMS";
  InventoryType["SUNHOTELS"] = "SUNHOTELS";
  InventoryType["THOMASCOOK_EUR"] = "THOMASCOOK_EUR";
  InventoryType["THOMASCOOK_UK"] = "THOMASCOOK_UK";
  InventoryType["TOURICO"] = "TOURICO";
  InventoryType["TRAVELLANDA"] = "TRAVELLANDA";
  InventoryType["TRAVELREPUBLIC"] = "TRAVELREPUBLIC";
  InventoryType["VENERE"] = "VENERE";
  InventoryType["VRBO"] = "VRBO";
  InventoryType["VRBO_MUVR"] = "VRBO_MUVR";
  InventoryType["WELCOME_BEDS"] = "WELCOME_BEDS";
  InventoryType["WOORI"] = "WOORI";
  InventoryType["WORLDHOTELLINK"] = "WORLDHOTELLINK";
  InventoryType["WORLDSPAN"] = "WORLDSPAN";
  InventoryType["WOTIF"] = "WOTIF";
  InventoryType["YOUTRAVEL"] = "YOUTRAVEL";
  InventoryType["ZUMATA"] = "ZUMATA";
})(InventoryType || (InventoryType = {}));
export var KeyPhrasesClientType;
(function (KeyPhrasesClientType) {
  KeyPhrasesClientType["DEFAULT"] = "DEFAULT";
  KeyPhrasesClientType["FILTER"] = "FILTER";
  KeyPhrasesClientType["SNIPPET"] = "SNIPPET";
})(KeyPhrasesClientType || (KeyPhrasesClientType = {}));
export var LayoutPosition;
(function (LayoutPosition) {
  LayoutPosition["CENTER"] = "CENTER";
  LayoutPosition["LEFT"] = "LEFT";
})(LayoutPosition || (LayoutPosition = {}));
export var LegalConcept;
(function (LegalConcept) {
  LegalConcept["LEGAL_CONCEPT_COOKIES"] = "LEGAL_CONCEPT_COOKIES";
  LegalConcept["LEGAL_CONCEPT_INVALID"] = "LEGAL_CONCEPT_INVALID";
  LegalConcept["LEGAL_CONCEPT_PRIVACY"] = "LEGAL_CONCEPT_PRIVACY";
  LegalConcept["LEGAL_CONCEPT_SORT_AND_FILTER"] = "LEGAL_CONCEPT_SORT_AND_FILTER";
  LegalConcept["LEGAL_CONCEPT_TERMS_AND_CONDITIONS"] = "LEGAL_CONCEPT_TERMS_AND_CONDITIONS";
})(LegalConcept || (LegalConcept = {}));
/** Line of business */
export var LineOfBusinessDomain;
(function (LineOfBusinessDomain) {
  LineOfBusinessDomain["ACTIVITIES"] = "ACTIVITIES";
  LineOfBusinessDomain["CAR"] = "CAR";
  LineOfBusinessDomain["CRUISES"] = "CRUISES";
  LineOfBusinessDomain["FLIGHT"] = "FLIGHT";
  LineOfBusinessDomain["GROUNDTRANSFERS"] = "GROUNDTRANSFERS";
  LineOfBusinessDomain["LODGING"] = "LODGING";
  LineOfBusinessDomain["PACKAGES"] = "PACKAGES";
  LineOfBusinessDomain["RAILS"] = "RAILS";
  LineOfBusinessDomain["UNCLASSIFIED"] = "UNCLASSIFIED";
})(LineOfBusinessDomain || (LineOfBusinessDomain = {}));
/** ADs related property search options  */
export var Listings;
(function (Listings) {
  /** Only return travelAds */
  Listings["ADS_ONLY"] = "ADS_ONLY";
})(Listings || (Listings = {}));
export var LiveAnnouncePoliteness;
(function (LiveAnnouncePoliteness) {
  LiveAnnouncePoliteness["ASSERTIVE"] = "ASSERTIVE";
  LiveAnnouncePoliteness["OFF"] = "OFF";
  LiveAnnouncePoliteness["POLITE"] = "POLITE";
})(LiveAnnouncePoliteness || (LiveAnnouncePoliteness = {}));
export var LodgingCompareRowTheme;
(function (LodgingCompareRowTheme) {
  LodgingCompareRowTheme["COMBINE_NEXT"] = "COMBINE_NEXT";
  LodgingCompareRowTheme["STANDARD"] = "STANDARD";
})(LodgingCompareRowTheme || (LodgingCompareRowTheme = {}));
/** Describes the type of product (line of business) that is being sold */
export var LodgingCrossSellProductType;
(function (LodgingCrossSellProductType) {
  LodgingCrossSellProductType["CAR"] = "CAR";
})(LodgingCrossSellProductType || (LodgingCrossSellProductType = {}));
export var LodgingFormMethod;
(function (LodgingFormMethod) {
  LodgingFormMethod["GET"] = "GET";
  LodgingFormMethod["POST"] = "POST";
})(LodgingFormMethod || (LodgingFormMethod = {}));
export var LodgingInputType;
(function (LodgingInputType) {
  LodgingInputType["EMAIL"] = "EMAIL";
  LodgingInputType["HIDDEN"] = "HIDDEN";
  LodgingInputType["PASSWORD"] = "PASSWORD";
  LodgingInputType["TEL"] = "TEL";
  LodgingInputType["TEXT"] = "TEXT";
  LodgingInputType["URL"] = "URL";
})(LodgingInputType || (LodgingInputType = {}));
/** Theme information for a message. */
export var LodgingMessageTheme;
(function (LodgingMessageTheme) {
  /** To be used for warnings/errors; typically red. */
  LodgingMessageTheme["AGGRESSIVE"] = "AGGRESSIVE";
  /** To be used for emphasis; typically both bold and larger font. */
  LodgingMessageTheme["EMPHASIS"] = "EMPHASIS";
  /** To be used for success/perks; typically green. */
  LodgingMessageTheme["HIGHLIGHT"] = "HIGHLIGHT";
  /** To be used for emphasis; typically bold. */
  LodgingMessageTheme["STRONG"] = "STRONG";
})(LodgingMessageTheme || (LodgingMessageTheme = {}));
export var LodgingStepperState;
(function (LodgingStepperState) {
  LodgingStepperState["COMPLETE"] = "COMPLETE";
  LodgingStepperState["CURRENT"] = "CURRENT";
  LodgingStepperState["INCOMPLETE"] = "INCOMPLETE";
})(LodgingStepperState || (LodgingStepperState = {}));
export var LodgingTrackPosition;
(function (LodgingTrackPosition) {
  LodgingTrackPosition["END"] = "END";
  LodgingTrackPosition["STANDARD"] = "STANDARD";
  LodgingTrackPosition["START"] = "START";
})(LodgingTrackPosition || (LodgingTrackPosition = {}));
export var LoyaltyExperienceStrategy;
(function (LoyaltyExperienceStrategy) {
  LoyaltyExperienceStrategy["HIDE_TRAVELER_INFO_AND_REWARDS_LINK"] = "HIDE_TRAVELER_INFO_AND_REWARDS_LINK";
  LoyaltyExperienceStrategy["SHOW_TRAVELER_INFO_AND_REWARDS_LINK"] = "SHOW_TRAVELER_INFO_AND_REWARDS_LINK";
})(LoyaltyExperienceStrategy || (LoyaltyExperienceStrategy = {}));
/** Enumeration for 2fa/mfa verification method */
export var MFAVerificationMethod;
(function (MFAVerificationMethod) {
  MFAVerificationMethod["SMS"] = "SMS";
  MFAVerificationMethod["CALL"] = "CALL";
})(MFAVerificationMethod || (MFAVerificationMethod = {}));
export var MODERATION_RULE;
(function (MODERATION_RULE) {
  MODERATION_RULE["BLOCK"] = "BLOCK";
  MODERATION_RULE["ADVISE"] = "ADVISE";
})(MODERATION_RULE || (MODERATION_RULE = {}));
export var MODERATION_TYPE;
(function (MODERATION_TYPE) {
  MODERATION_TYPE["WORD"] = "WORD";
  MODERATION_TYPE["CHARACTER"] = "CHARACTER";
})(MODERATION_TYPE || (MODERATION_TYPE = {}));
/** The UDS icon used for the map marker */
export var MapIconType;
(function (MapIconType) {
  MapIconType["AIRPORT"] = "AIRPORT";
  MapIconType["CIRCLE"] = "CIRCLE";
  MapIconType["GROCERY"] = "GROCERY";
  MapIconType["HOTEL"] = "HOTEL";
  MapIconType["LANDMARK"] = "LANDMARK";
  MapIconType["METRO"] = "METRO";
  MapIconType["RESTAURANT"] = "RESTAURANT";
  MapIconType["SOLD_OUT"] = "SOLD_OUT";
  MapIconType["TRAIN"] = "TRAIN";
  MapIconType["VACATION_RENTAL"] = "VACATION_RENTAL";
})(MapIconType || (MapIconType = {}));
/** Toolbar action type */
export var MapToolbarActionsType;
(function (MapToolbarActionsType) {
  /** Show filters button in the toolbar */
  MapToolbarActionsType["FILTERS"] = "FILTERS";
})(MapToolbarActionsType || (MapToolbarActionsType = {}));
/** The type of map marker */
export var MarkerType;
(function (MarkerType) {
  MarkerType["HOTEL"] = "HOTEL";
  MarkerType["POI"] = "POI";
})(MarkerType || (MarkerType = {}));
/** Used to indicate what type of markup a field contains */
export var MarkupTextType;
(function (MarkupTextType) {
  /** Hypertext markup language */
  MarkupTextType["HTML"] = "HTML";
})(MarkupTextType || (MarkupTextType = {}));
export var MealPlanFilterAmenity;
(function (MealPlanFilterAmenity) {
  MealPlanFilterAmenity["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  MealPlanFilterAmenity["FREE_BREAKFAST"] = "FREE_BREAKFAST";
  MealPlanFilterAmenity["FULL_BOARD"] = "FULL_BOARD";
  MealPlanFilterAmenity["HALF_BOARD"] = "HALF_BOARD";
})(MealPlanFilterAmenity || (MealPlanFilterAmenity = {}));
export var MediaType;
(function (MediaType) {
  MediaType["IMAGE"] = "IMAGE";
  MediaType["VIDEO"] = "VIDEO";
})(MediaType || (MediaType = {}));
export var MemberWalletBadgeTheme;
(function (MemberWalletBadgeTheme) {
  MemberWalletBadgeTheme["LOYALTY_HIGH_TIER"] = "LOYALTY_HIGH_TIER";
  MemberWalletBadgeTheme["LOYALTY_LOW_TIER"] = "LOYALTY_LOW_TIER";
  MemberWalletBadgeTheme["LOYALTY_MIDDLE_TIER"] = "LOYALTY_MIDDLE_TIER";
})(MemberWalletBadgeTheme || (MemberWalletBadgeTheme = {}));
/** Represents path where merchandising details card component to be use. */
export var MerchandisingDetailsCardPath;
(function (MerchandisingDetailsCardPath) {
  MerchandisingDetailsCardPath["CHECKOUT"] = "CHECKOUT";
  MerchandisingDetailsCardPath["CONFIRMATION"] = "CONFIRMATION";
})(MerchandisingDetailsCardPath || (MerchandisingDetailsCardPath = {}));
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export var MessageType;
(function (MessageType) {
  MessageType["ADDON"] = "ADDON";
  MessageType["BRANDED_THEME_ACCENT"] = "BRANDED_THEME_ACCENT";
  MessageType["BRANDED_THEME_DARK"] = "BRANDED_THEME_DARK";
  MessageType["BRANDED_THEME_LIGHT"] = "BRANDED_THEME_LIGHT";
  MessageType["COMPRESSION"] = "COMPRESSION";
  MessageType["COUPON"] = "COUPON";
  MessageType["DOUBLE_POINTS"] = "DOUBLE_POINTS";
  MessageType["FREE_CANCELLATION"] = "FREE_CANCELLATION";
  MessageType["FREE_LX"] = "FREE_LX";
  MessageType["HOTRATE"] = "HOTRATE";
  MessageType["LEGAL"] = "LEGAL";
  MessageType["LOGIN"] = "LOGIN";
  MessageType["LOYALTY"] = "LOYALTY";
  MessageType["NO_CC"] = "NO_CC";
  MessageType["OVERFILTERED"] = "OVERFILTERED";
  MessageType["PARTNER_LINKOFF"] = "PARTNER_LINKOFF";
  MessageType["VACATION_RENTALS"] = "VACATION_RENTALS";
})(MessageType || (MessageType = {}));
/** The type of button to display */
export var MishopUIDialogButtonType;
(function (MishopUIDialogButtonType) {
  MishopUIDialogButtonType["PRIMARY"] = "PRIMARY";
  MishopUIDialogButtonType["TERTIARY"] = "TERTIARY";
})(MishopUIDialogButtonType || (MishopUIDialogButtonType = {}));
export var MishopUIPlacardType;
(function (MishopUIPlacardType) {
  MishopUIPlacardType["PRICE_CHANGE"] = "PRICE_CHANGE";
})(MishopUIPlacardType || (MishopUIPlacardType = {}));
export var MishopUIProductType;
(function (MishopUIProductType) {
  MishopUIProductType["ACTIVITY"] = "ACTIVITY";
  MishopUIProductType["CAR"] = "CAR";
  MishopUIProductType["FLIGHT"] = "FLIGHT";
  MishopUIProductType["GROUND_TRANSFER"] = "GROUND_TRANSFER";
  MishopUIProductType["PROPERTY"] = "PROPERTY";
})(MishopUIProductType || (MishopUIProductType = {}));
/** ID used to identify a month for queries that bucket data by month */
export var MonthId;
(function (MonthId) {
  MonthId["APRIL"] = "APRIL";
  MonthId["AUGUST"] = "AUGUST";
  MonthId["DECEMBER"] = "DECEMBER";
  MonthId["FEBRUARY"] = "FEBRUARY";
  MonthId["JANUARY"] = "JANUARY";
  MonthId["JULY"] = "JULY";
  MonthId["JUNE"] = "JUNE";
  MonthId["MARCH"] = "MARCH";
  MonthId["MAY"] = "MAY";
  MonthId["NOVEMBER"] = "NOVEMBER";
  MonthId["OCTOBER"] = "OCTOBER";
  MonthId["SEPTEMBER"] = "SEPTEMBER";
})(MonthId || (MonthId = {}));
/** NavigationType provides collapse/expanded state of toolbar, specific to bottom sheet */
export var NavigationType;
(function (NavigationType) {
  NavigationType["COLLAPSE"] = "COLLAPSE";
  NavigationType["EXPAND"] = "EXPAND";
})(NavigationType || (NavigationType = {}));
/** Enum class to represent the type of no cancel fee */
export var NoCancelFeeType;
(function (NoCancelFeeType) {
  NoCancelFeeType["NO_CANCEL_FEE"] = "NO_CANCEL_FEE";
})(NoCancelFeeType || (NoCancelFeeType = {}));
/** Enum class to represent the type of no change fee */
export var NoChangeFeeType;
(function (NoChangeFeeType) {
  NoChangeFeeType["NO_CHANGE_FEE"] = "NO_CHANGE_FEE";
})(NoChangeFeeType || (NoChangeFeeType = {}));
/** The button type of the Customer notification submit button */
export var NotificationFormButtonType;
(function (NotificationFormButtonType) {
  /** Type of floating action button */
  NotificationFormButtonType["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  /** Type of primary button */
  NotificationFormButtonType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  /** Type of secondary button */
  NotificationFormButtonType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  /** Type of tertiary button */
  NotificationFormButtonType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(NotificationFormButtonType || (NotificationFormButtonType = {}));
export var NotificationInModuleMessageName;
(function (NotificationInModuleMessageName) {
  NotificationInModuleMessageName["CPM_CC_ON_FILE_MESSAGE"] = "CPM_CC_ON_FILE_MESSAGE";
  NotificationInModuleMessageName["CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE"] = "CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE";
  NotificationInModuleMessageName["CPM_NO_PAYMENT_DUE_MESSAGE"] = "CPM_NO_PAYMENT_DUE_MESSAGE";
  NotificationInModuleMessageName["CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE"] = "CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_OKC_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_CC_ON_FILE_OKC_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_OKC_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_OKC_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_OKC_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_OKC_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName["PAY_NOW_OKC_TOTAL_AMOUNT"] = "PAY_NOW_OKC_TOTAL_AMOUNT";
})(NotificationInModuleMessageName || (NotificationInModuleMessageName = {}));
export var NotificationInModuleModuleName;
(function (NotificationInModuleModuleName) {
  NotificationInModuleModuleName["COMMON_PAYMENT_MODULE"] = "COMMON_PAYMENT_MODULE";
})(NotificationInModuleModuleName || (NotificationInModuleModuleName = {}));
/** Represents the target of the link */
export var NotificationLinkTarget;
(function (NotificationLinkTarget) {
  NotificationLinkTarget["NEW_TAB"] = "NEW_TAB";
  NotificationLinkTarget["SAME_TAB"] = "SAME_TAB";
})(NotificationLinkTarget || (NotificationLinkTarget = {}));
/** Represents the link type */
export var NotificationLinkType;
(function (NotificationLinkType) {
  NotificationLinkType["ANCHOR"] = "ANCHOR";
  NotificationLinkType["APP_DOWNLOAD_LINK"] = "APP_DOWNLOAD_LINK";
  NotificationLinkType["BUTTON"] = "BUTTON";
  NotificationLinkType["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  NotificationLinkType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  NotificationLinkType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  NotificationLinkType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(NotificationLinkType || (NotificationLinkType = {}));
export var NotificationLocation;
(function (NotificationLocation) {
  NotificationLocation["AFTER_HEADER"] = "AFTER_HEADER";
  NotificationLocation["AFTER_WIZARD"] = "AFTER_WIZARD";
  NotificationLocation["FOOTER"] = "FOOTER";
  NotificationLocation["IN_PAGE"] = "IN_PAGE";
  NotificationLocation["IN_PAGE_AD"] = "IN_PAGE_AD";
  NotificationLocation["LEGAL"] = "LEGAL";
  NotificationLocation["POPUP"] = "POPUP";
  NotificationLocation["PRE_HEADER"] = "PRE_HEADER";
})(NotificationLocation || (NotificationLocation = {}));
export var NotificationLocationOnPage;
(function (NotificationLocationOnPage) {
  NotificationLocationOnPage["AFTER_HEADER"] = "AFTER_HEADER";
  NotificationLocationOnPage["AFTER_WIZARD"] = "AFTER_WIZARD";
  NotificationLocationOnPage["ERROR"] = "ERROR";
  NotificationLocationOnPage["FOOTER"] = "FOOTER";
  NotificationLocationOnPage["IN_MODULE"] = "IN_MODULE";
  NotificationLocationOnPage["IN_PAGE"] = "IN_PAGE";
  NotificationLocationOnPage["IN_PAGE_AD"] = "IN_PAGE_AD";
  NotificationLocationOnPage["LEGAL"] = "LEGAL";
  NotificationLocationOnPage["POPUP"] = "POPUP";
  NotificationLocationOnPage["PRE_HEADER"] = "PRE_HEADER";
})(NotificationLocationOnPage || (NotificationLocationOnPage = {}));
/** Enumeration of possible layout types */
export var NotificationMessageCardLayout;
(function (NotificationMessageCardLayout) {
  NotificationMessageCardLayout["ICON_ON_SIDE"] = "ICON_ON_SIDE";
  NotificationMessageCardLayout["ICON_ON_TOP"] = "ICON_ON_TOP";
  NotificationMessageCardLayout["WITH_BORDER"] = "WITH_BORDER";
})(NotificationMessageCardLayout || (NotificationMessageCardLayout = {}));
/** The display type of the Customer notification message */
export var NotificationMessageDisplayType;
(function (NotificationMessageDisplayType) {
  /** Display the message for the form */
  NotificationMessageDisplayType["FORM"] = "FORM";
  /** Dislay message on the page level, eg: fly-in message on the page */
  NotificationMessageDisplayType["PAGE"] = "PAGE";
})(NotificationMessageDisplayType || (NotificationMessageDisplayType = {}));
/** The level type of the Customer notification message */
export var NotificationMessageLevel;
(function (NotificationMessageLevel) {
  /** Type of error for the message */
  NotificationMessageLevel["ERROR"] = "ERROR";
  /** Type of info for the message */
  NotificationMessageLevel["INFO"] = "INFO";
  /** Type of success for the message */
  NotificationMessageLevel["SUCCESS"] = "SUCCESS";
  /** Type of warning for the message */
  NotificationMessageLevel["WARNING"] = "WARNING";
})(NotificationMessageLevel || (NotificationMessageLevel = {}));
export var NotificationMessageType;
(function (NotificationMessageType) {
  /** INVALID_INPUT message */
  NotificationMessageType["INVALID_INPUT"] = "INVALID_INPUT";
  /** SERVICE_ERROR message */
  NotificationMessageType["SERVICE_ERROR"] = "SERVICE_ERROR";
  /** SUCCESS message */
  NotificationMessageType["SUCCESS"] = "SUCCESS";
})(NotificationMessageType || (NotificationMessageType = {}));
/** The style to apply to phrase links */
export var NotificationPhraseLinkStyle;
(function (NotificationPhraseLinkStyle) {
  NotificationPhraseLinkStyle["FLOATING_ACTION_BUTTON"] = "FLOATING_ACTION_BUTTON";
  NotificationPhraseLinkStyle["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  NotificationPhraseLinkStyle["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  NotificationPhraseLinkStyle["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(NotificationPhraseLinkStyle || (NotificationPhraseLinkStyle = {}));
/** The theme to apply to phrase links */
export var NotificationPhraseLinkTheme;
(function (NotificationPhraseLinkTheme) {
  NotificationPhraseLinkTheme["DEFAULT"] = "DEFAULT";
  NotificationPhraseLinkTheme["INVERSE"] = "INVERSE";
})(NotificationPhraseLinkTheme || (NotificationPhraseLinkTheme = {}));
/** The text style to apply to strings */
export var NotificationPhrasePartStyle;
(function (NotificationPhrasePartStyle) {
  /** Italic styling */
  NotificationPhrasePartStyle["EMPHASIS"] = "EMPHASIS";
  /** Bold styling */
  NotificationPhrasePartStyle["IMPORTANT"] = "IMPORTANT";
  /** Represents no style or regular text */
  NotificationPhrasePartStyle["STANDARD"] = "STANDARD";
})(NotificationPhrasePartStyle || (NotificationPhrasePartStyle = {}));
/** Represent notification preference */
export var NotificationPreferenceType;
(function (NotificationPreferenceType) {
  NotificationPreferenceType["EMAIL"] = "EMAIL";
  NotificationPreferenceType["PUSH"] = "PUSH";
})(NotificationPreferenceType || (NotificationPreferenceType = {}));
export var NotificationState;
(function (NotificationState) {
  NotificationState["READ"] = "READ";
  NotificationState["SEEN"] = "SEEN";
  NotificationState["UNKNOWN"] = "UNKNOWN";
  NotificationState["UNSEEN"] = "UNSEEN";
})(NotificationState || (NotificationState = {}));
export var NotificationSubType;
(function (NotificationSubType) {
  NotificationSubType["COUPON_CAMPAIGN"] = "COUPON_CAMPAIGN";
  NotificationSubType["DEFAULT"] = "DEFAULT";
})(NotificationSubType || (NotificationSubType = {}));
export var NotificationType;
(function (NotificationType) {
  NotificationType["ALERT"] = "ALERT";
  NotificationType["APP_DOWNLOAD"] = "APP_DOWNLOAD";
  NotificationType["APP_HERO"] = "APP_HERO";
  NotificationType["BOTTOM_SHEET"] = "BOTTOM_SHEET";
  NotificationType["CENTERED_SHEET"] = "CENTERED_SHEET";
  NotificationType["CITI_COBRAND"] = "CITI_COBRAND";
  NotificationType["CITI_COBRAND_VERTICAL"] = "CITI_COBRAND_VERTICAL";
  NotificationType["CLEANLINESS"] = "CLEANLINESS";
  NotificationType["CONFIGURABLE"] = "CONFIGURABLE";
  NotificationType["ERROR"] = "ERROR";
  NotificationType["FULL_SHEET"] = "FULL_SHEET";
  NotificationType["GENERIC"] = "GENERIC";
  NotificationType["HEADER"] = "HEADER";
  NotificationType["INBOX"] = "INBOX";
  NotificationType["MAD_MARQUEE"] = "MAD_MARQUEE";
  NotificationType["NONE"] = "NONE";
  NotificationType["ONETRUST"] = "ONETRUST";
  NotificationType["ONE_KEY"] = "ONE_KEY";
  NotificationType["OSANO"] = "OSANO";
  NotificationType["RAF_BANNER"] = "RAF_BANNER";
  NotificationType["TAKEOVER"] = "TAKEOVER";
  NotificationType["TRAVEL_ADVISORY"] = "TRAVEL_ADVISORY";
  NotificationType["TRUST_MSG_BANNER"] = "TRUST_MSG_BANNER";
  NotificationType["UNRECOVERABLE_ERROR"] = "UNRECOVERABLE_ERROR";
})(NotificationType || (NotificationType = {}));
export var NotificationUserActionType;
(function (NotificationUserActionType) {
  NotificationUserActionType["DELETE"] = "DELETE";
  NotificationUserActionType["MARK_AS_READ"] = "MARK_AS_READ";
  NotificationUserActionType["MARK_AS_UNREAD"] = "MARK_AS_UNREAD";
  NotificationUserActionType["UNKNOWN"] = "UNKNOWN";
})(NotificationUserActionType || (NotificationUserActionType = {}));
export var NotificationsType;
(function (NotificationsType) {
  NotificationsType["ALL"] = "ALL";
})(NotificationsType || (NotificationsType = {}));
export var OfferAttributeType;
(function (OfferAttributeType) {
  OfferAttributeType["FREE_BREAKFAST"] = "FREE_BREAKFAST";
  OfferAttributeType["FREE_CANCELLATION"] = "FREE_CANCELLATION";
  OfferAttributeType["NO_CC_REQUIRED"] = "NO_CC_REQUIRED";
  OfferAttributeType["PAYMENT_CHOICE"] = "PAYMENT_CHOICE";
  OfferAttributeType["VIP"] = "VIP";
})(OfferAttributeType || (OfferAttributeType = {}));
/** The identity to get or update insurtech offers could be both */
export var OfferIdentityType;
(function (OfferIdentityType) {
  OfferIdentityType["EG_OFFER_ID"] = "EG_OFFER_ID";
  OfferIdentityType["EG_OFFER_TOKEN"] = "EG_OFFER_TOKEN";
})(OfferIdentityType || (OfferIdentityType = {}));
export var OffersRecommendationContainerType;
(function (OffersRecommendationContainerType) {
  OffersRecommendationContainerType["CAROUSEL"] = "CAROUSEL";
  OffersRecommendationContainerType["GRID"] = "GRID";
})(OffersRecommendationContainerType || (OffersRecommendationContainerType = {}));
export var OffersRecommendationStrategy;
(function (OffersRecommendationStrategy) {
  OffersRecommendationStrategy["ALTERNATE"] = "ALTERNATE";
  OffersRecommendationStrategy["ATTACH"] = "ATTACH";
  OffersRecommendationStrategy["CO_CLICK"] = "CO_CLICK";
  OffersRecommendationStrategy["NEARBY"] = "NEARBY";
  OffersRecommendationStrategy["POPULAR"] = "POPULAR";
  OffersRecommendationStrategy["TRENDING"] = "TRENDING";
})(OffersRecommendationStrategy || (OffersRecommendationStrategy = {}));
export var OneKeyOnboardingOperationStatus;
(function (OneKeyOnboardingOperationStatus) {
  OneKeyOnboardingOperationStatus["FAILED"] = "FAILED";
  OneKeyOnboardingOperationStatus["SUCCEEDED"] = "SUCCEEDED";
  OneKeyOnboardingOperationStatus["TIMED_OUT"] = "TIMED_OUT";
})(OneKeyOnboardingOperationStatus || (OneKeyOnboardingOperationStatus = {}));
export var Operation;
(function (Operation) {
  Operation["ADDITION"] = "ADDITION";
  Operation["MULTIPLICATION"] = "MULTIPLICATION";
})(Operation || (Operation = {}));
export var OperationStatus;
(function (OperationStatus) {
  OperationStatus["FAILURE"] = "FAILURE";
  OperationStatus["INVALID_INPUT"] = "INVALID_INPUT";
  OperationStatus["SUCCESS"] = "SUCCESS";
})(OperationStatus || (OperationStatus = {}));
/** Possible values for UITK mark's orientation prop */
export var Orientation;
(function (Orientation) {
  /** Landscape orientation */
  Orientation["LANDSCAPE"] = "LANDSCAPE";
  /** Portrait orientation */
  Orientation["PORTRAIT"] = "PORTRAIT";
})(Orientation || (Orientation = {}));
export var PackageSort;
(function (PackageSort) {
  PackageSort["PRICE_HIGH_TO_LOW"] = "PRICE_HIGH_TO_LOW";
  PackageSort["PRICE_LOW_TO_HIGH"] = "PRICE_LOW_TO_HIGH";
  PackageSort["RECOMMENDED"] = "RECOMMENDED";
})(PackageSort || (PackageSort = {}));
export var PackageType;
(function (PackageType) {
  PackageType["FLIGHT_CAR"] = "FLIGHT_CAR";
  PackageType["FLIGHT_HOTEL"] = "FLIGHT_HOTEL";
  PackageType["FLIGHT_HOTEL_CAR"] = "FLIGHT_HOTEL_CAR";
  PackageType["HOTEL_CAR"] = "HOTEL_CAR";
})(PackageType || (PackageType = {}));
/** Page identity */
export var PageLocation;
(function (PageLocation) {
  /** All checkout related pages */
  PageLocation["CHECKOUT"] = "CHECKOUT";
  /** Checkout error pages for all LOBs */
  PageLocation["CHECKOUT_ERROR"] = "CHECKOUT_ERROR";
  /** Order confirmation pages for all LOBs */
  PageLocation["CONFIRMATION"] = "CONFIRMATION";
  /** All product detail pages are identified as DETAILS */
  PageLocation["DETAILS"] = "DETAILS";
  /** All landing, launch, published and any other page that will lead a user down to a search or detail page regardless of LOB */
  PageLocation["ENTRY"] = "ENTRY";
  /** Pages that are not in the main shopping flow or that show up all across the flow such as Ads, Recommendation, Urgency, Scratchpad, etc. */
  PageLocation["FEATURES"] = "FEATURES";
  /** Insurance details page that comes after LOB details pages */
  PageLocation["INSURANCE_DETAILS"] = "INSURANCE_DETAILS";
  /** Payment error pages for all LOBs */
  PageLocation["PAYMENT_ERROR"] = "PAYMENT_ERROR";
  /** Post booking pages including itin, trip summary, trip details, customer service etc */
  PageLocation["POST_BOOKING"] = "POST_BOOKING";
  /** All LOB search result pages are identified as SEARCH_RESULTS */
  PageLocation["SEARCH_RESULTS"] = "SEARCH_RESULTS";
  /** All pages that are not customer facing, that are for internal system or monitoring such as isWorking, health check, dev tools page, etc */
  PageLocation["SYSTEM"] = "SYSTEM";
  /** User pages including sign-in, my account and rewards */
  PageLocation["USER"] = "USER";
})(PageLocation || (PageLocation = {}));
/** Input for travelGuidePageContextInput pageType parameter */
export var PageType;
(function (PageType) {
  PageType["HOME_PAGE"] = "HOME_PAGE";
  PageType["TRAVEL_GUIDE"] = "TRAVEL_GUIDE";
})(PageType || (PageType = {}));
export var PasswordWithStrengthMeterInputStrength;
(function (PasswordWithStrengthMeterInputStrength) {
  PasswordWithStrengthMeterInputStrength["STRONG"] = "STRONG";
  PasswordWithStrengthMeterInputStrength["VERY_STRONG"] = "VERY_STRONG";
  PasswordWithStrengthMeterInputStrength["WEAK"] = "WEAK";
})(PasswordWithStrengthMeterInputStrength || (PasswordWithStrengthMeterInputStrength = {}));
export var PasswordWithStrengthMeterProgressBarTheme;
(function (PasswordWithStrengthMeterProgressBarTheme) {
  PasswordWithStrengthMeterProgressBarTheme["MUTED"] = "MUTED";
  PasswordWithStrengthMeterProgressBarTheme["POSITIVE"] = "POSITIVE";
})(PasswordWithStrengthMeterProgressBarTheme || (PasswordWithStrengthMeterProgressBarTheme = {}));
export var PaymentEntryURN;
(function (PaymentEntryURN) {
  PaymentEntryURN["PAYMENT_BILLING_ZIPCODE"] = "PAYMENT_BILLING_ZIPCODE";
})(PaymentEntryURN || (PaymentEntryURN = {}));
export var PaymentMethodType;
(function (PaymentMethodType) {
  PaymentMethodType["AFFIRM"] = "AFFIRM";
  PaymentMethodType["CREDIT_CARD"] = "CREDIT_CARD";
  PaymentMethodType["GIFT_CARD"] = "GIFT_CARD";
  PaymentMethodType["INVALID"] = "INVALID";
  PaymentMethodType["LOYALTY"] = "LOYALTY";
  PaymentMethodType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PaymentMethodType || (PaymentMethodType = {}));
export var PaymentNotificationLocation;
(function (PaymentNotificationLocation) {
  PaymentNotificationLocation["IN_MODULE"] = "IN_MODULE";
})(PaymentNotificationLocation || (PaymentNotificationLocation = {}));
export var PaymentNotificationMessageName;
(function (PaymentNotificationMessageName) {
  PaymentNotificationMessageName["CPM_CC_ON_FILE_MESSAGE"] = "CPM_CC_ON_FILE_MESSAGE";
  PaymentNotificationMessageName["CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE"] = "CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE";
  PaymentNotificationMessageName["CPM_NO_PAYMENT_DUE_MESSAGE"] = "CPM_NO_PAYMENT_DUE_MESSAGE";
  PaymentNotificationMessageName["CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE"] = "CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE";
  PaymentNotificationMessageName["INVALID_MESSAGE"] = "INVALID_MESSAGE";
})(PaymentNotificationMessageName || (PaymentNotificationMessageName = {}));
export var PaymentNotificationModuleName;
(function (PaymentNotificationModuleName) {
  PaymentNotificationModuleName["COMMON_PAYMENT_MODULE"] = "COMMON_PAYMENT_MODULE";
})(PaymentNotificationModuleName || (PaymentNotificationModuleName = {}));
export var PaymentPayType;
(function (PaymentPayType) {
  PaymentPayType["PAY_LATER"] = "PAY_LATER";
  PaymentPayType["PAY_NOW"] = "PAY_NOW";
})(PaymentPayType || (PaymentPayType = {}));
/** Represents the payment source of FlightsRefundCalculatorInput */
export var PaymentSource;
(function (PaymentSource) {
  PaymentSource["FTC"] = "FTC";
  PaymentSource["REFUND"] = "REFUND";
})(PaymentSource || (PaymentSource = {}));
export var PaymentState;
(function (PaymentState) {
  PaymentState["STATE_CANCELLED"] = "STATE_CANCELLED";
  PaymentState["STATE_DISABLED"] = "STATE_DISABLED";
  PaymentState["STATE_INVALID"] = "STATE_INVALID";
  PaymentState["STATE_REMOVED"] = "STATE_REMOVED";
  PaymentState["STATE_SELECTED"] = "STATE_SELECTED";
  PaymentState["STATE_UNSELECTED"] = "STATE_UNSELECTED";
  PaymentState["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PaymentState || (PaymentState = {}));
export var PaymentType;
(function (PaymentType) {
  PaymentType["COUPON_ELIGIBLE"] = "COUPON_ELIGIBLE";
  PaymentType["FREE_CANCELLATION"] = "FREE_CANCELLATION";
  PaymentType["GIFT_CARD"] = "GIFT_CARD";
  PaymentType["PAY_LATER"] = "PAY_LATER";
  PaymentType["PAY_LATER_WITH_DEPOSIT"] = "PAY_LATER_WITH_DEPOSIT";
  PaymentType["PAY_WITHOUT_CREDITCARD"] = "PAY_WITHOUT_CREDITCARD";
})(PaymentType || (PaymentType = {}));
/** Represents the logo size used by the client to render */
export var PaymentTypeLogoSize;
(function (PaymentTypeLogoSize) {
  PaymentTypeLogoSize["LARGE"] = "LARGE";
  PaymentTypeLogoSize["SMALL"] = "SMALL";
})(PaymentTypeLogoSize || (PaymentTypeLogoSize = {}));
export var PickerTriggerDisplayType;
(function (PickerTriggerDisplayType) {
  PickerTriggerDisplayType["GLOBAL_NAV_BUTTON"] = "GLOBAL_NAV_BUTTON";
  PickerTriggerDisplayType["GLOBAL_NAV_LINK"] = "GLOBAL_NAV_LINK";
})(PickerTriggerDisplayType || (PickerTriggerDisplayType = {}));
export var PickerTriggerPlacementType;
(function (PickerTriggerPlacementType) {
  PickerTriggerPlacementType["MENU_ITEM"] = "MENU_ITEM";
  PickerTriggerPlacementType["NAV_LINK"] = "NAV_LINK";
})(PickerTriggerPlacementType || (PickerTriggerPlacementType = {}));
export var Placement;
(function (Placement) {
  /** Horizontal Orientation of Images in the List */
  Placement["Horizontal"] = "Horizontal";
  /** Vertical Orientation of Images in the List */
  Placement["Vertical"] = "Vertical";
})(Placement || (Placement = {}));
/**
 * Languages vary in how they handle plurals of nouns or unit expressions ("hour" vs "hours", and so on).
 * Some languages have two forms, like English; some languages have only a single form; and some languages have multiple forms. CLDR uses short, mnemonic tags for these plural categories.
 * http://cldr.unicode.org/index/cldr-spec/plural-rules
 */
export var PluralCategory;
(function (PluralCategory) {
  PluralCategory["FEW"] = "FEW";
  PluralCategory["MANY"] = "MANY";
  PluralCategory["ONE"] = "ONE";
  PluralCategory["OTHER"] = "OTHER";
  PluralCategory["TWO"] = "TWO";
  PluralCategory["ZERO"] = "ZERO";
})(PluralCategory || (PluralCategory = {}));
/** Points related property search options  */
export var Points;
(function (Points) {
  /** Don't use loyalty points to calculate the strikeout price. */
  Points["SHOP_WITHOUT_POINTS"] = "SHOP_WITHOUT_POINTS";
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  Points["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
})(Points || (Points = {}));
/** Options that alter behavior of mutation - for backward compatibility */
export var PrepareCheckoutResponseOption;
(function (PrepareCheckoutResponseOption) {
  PrepareCheckoutResponseOption["ALTERNATIVE_ACTION_ON_FAILURE"] = "ALTERNATIVE_ACTION_ON_FAILURE";
})(PrepareCheckoutResponseOption || (PrepareCheckoutResponseOption = {}));
export var PriceMatchPromiseChartType;
(function (PriceMatchPromiseChartType) {
  PriceMatchPromiseChartType["BAR"] = "BAR";
  PriceMatchPromiseChartType["LINE"] = "LINE";
})(PriceMatchPromiseChartType || (PriceMatchPromiseChartType = {}));
export var PriceMatchPromiseScaleType;
(function (PriceMatchPromiseScaleType) {
  PriceMatchPromiseScaleType["DATE"] = "DATE";
  PriceMatchPromiseScaleType["LABEL"] = "LABEL";
  PriceMatchPromiseScaleType["TIME"] = "TIME";
})(PriceMatchPromiseScaleType || (PriceMatchPromiseScaleType = {}));
/** Represents the state for the PMP module */
export var PriceMatchPromiseState;
(function (PriceMatchPromiseState) {
  /** Represents when the PMP module is removable */
  PriceMatchPromiseState["REMOVABLE"] = "REMOVABLE";
  /** Represents when the PMP module is selectable */
  PriceMatchPromiseState["SELECTABLE"] = "SELECTABLE";
  /** Represents when the PMP module is static */
  PriceMatchPromiseState["STATIC"] = "STATIC";
  /** Represents when the PMP module is toggleable */
  PriceMatchPromiseState["TOGGLEABLE"] = "TOGGLEABLE";
})(PriceMatchPromiseState || (PriceMatchPromiseState = {}));
export var PricingSchemeType;
(function (PricingSchemeType) {
  PricingSchemeType["DAILY_RATE"] = "DAILY_RATE";
  PricingSchemeType["TOTAL_RATE"] = "TOTAL_RATE";
})(PricingSchemeType || (PricingSchemeType = {}));
export var PricingType;
(function (PricingType) {
  PricingType["PerDayPricing"] = "PerDayPricing";
  PricingType["OccupancyBasedPricing"] = "OccupancyBasedPricing";
})(PricingType || (PricingType = {}));
/** User preference for data sharing with third parties which users may update */
export var PrivacySellState;
(function (PrivacySellState) {
  PrivacySellState["CAN_NOT_SELL"] = "CAN_NOT_SELL";
  PrivacySellState["CAN_SELL"] = "CAN_SELL";
})(PrivacySellState || (PrivacySellState = {}));
/** Privacy tracking user preference. We can retrieve info on if the site allows tracking from Site Info and null can also be used to represent a selection or not */
export var PrivacyTrackingState;
(function (PrivacyTrackingState) {
  PrivacyTrackingState["CAN_NOT_TRACK"] = "CAN_NOT_TRACK";
  PrivacyTrackingState["CAN_TRACK"] = "CAN_TRACK";
})(PrivacyTrackingState || (PrivacyTrackingState = {}));
/** Enum to specify image width for product image */
export var ProductImageFitment;
(function (ProductImageFitment) {
  ProductImageFitment["CONTAIN"] = "CONTAIN";
  ProductImageFitment["COVER"] = "COVER";
})(ProductImageFitment || (ProductImageFitment = {}));
/** Enum to specify image width for product image */
export var ProductImageWidth;
(function (ProductImageWidth) {
  ProductImageWidth["FULL_WIDTH"] = "FULL_WIDTH";
  ProductImageWidth["HALF_WIDTH"] = "HALF_WIDTH";
  ProductImageWidth["QUARTER_WIDTH"] = "QUARTER_WIDTH";
  ProductImageWidth["THIRD_WIDTH"] = "THIRD_WIDTH";
})(ProductImageWidth || (ProductImageWidth = {}));
export var ProductLine;
(function (ProductLine) {
  ProductLine["ACTIVITY"] = "ACTIVITY";
  ProductLine["CAR"] = "CAR";
  ProductLine["CRUISE"] = "CRUISE";
  ProductLine["FLIGHT"] = "FLIGHT";
  ProductLine["GROUND_TRANSFER"] = "GROUND_TRANSFER";
  ProductLine["INSURANCE"] = "INSURANCE";
  ProductLine["LODGING"] = "LODGING";
  ProductLine["PACKAGE"] = "PACKAGE";
  ProductLine["PRODUCT_LINE_INVALID"] = "PRODUCT_LINE_INVALID";
  ProductLine["RAIL"] = "RAIL";
  ProductLine["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ProductLine || (ProductLine = {}));
export var ProductQuestionTopic;
(function (ProductQuestionTopic) {
  ProductQuestionTopic["HOTEL"] = "HOTEL";
})(ProductQuestionTopic || (ProductQuestionTopic = {}));
export var ProductType;
(function (ProductType) {
  ProductType["ARTICLE"] = "ARTICLE";
  ProductType["CAR_DETAILS"] = "CAR_DETAILS";
  ProductType["DESTINATION"] = "DESTINATION";
  ProductType["DESTINATION_EXPERIENCE"] = "DESTINATION_EXPERIENCE";
  ProductType["EXPERIENCE"] = "EXPERIENCE";
  ProductType["EXPERT_TIP"] = "EXPERT_TIP";
  ProductType["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
  ProductType["LX_DETAILS"] = "LX_DETAILS";
  ProductType["NEIGHBORHOOD"] = "NEIGHBORHOOD";
  ProductType["POI_GAIA"] = "POI_GAIA";
  ProductType["PROPERTY_DETAILS"] = "PROPERTY_DETAILS";
})(ProductType || (ProductType = {}));
/** Represents layout of buttons. */
export var ProfileButtonLayout;
(function (ProfileButtonLayout) {
  /** Horizontally stacked buttons. */
  ProfileButtonLayout["INLINE"] = "INLINE";
  /** Vertically stacked buttons. */
  ProfileButtonLayout["STACKED"] = "STACKED";
})(ProfileButtonLayout || (ProfileButtonLayout = {}));
/** Specifies whether to open the link in the same user interface context or in a different context */
export var ProfileLinkTarget;
(function (ProfileLinkTarget) {
  ProfileLinkTarget["EXTERNAL"] = "EXTERNAL";
  ProfileLinkTarget["INTERNAL"] = "INTERNAL";
})(ProfileLinkTarget || (ProfileLinkTarget = {}));
/** Possible actions for the Activities Cross Sell links that will be shown as a sticky card on PDP  */
export var PropertyActivitiesCrossSellActionType;
(function (PropertyActivitiesCrossSellActionType) {
  PropertyActivitiesCrossSellActionType["DISMISS"] = "DISMISS";
  PropertyActivitiesCrossSellActionType["EDIT"] = "EDIT";
  PropertyActivitiesCrossSellActionType["OPEN"] = "OPEN";
  PropertyActivitiesCrossSellActionType["REMOVE"] = "REMOVE";
})(PropertyActivitiesCrossSellActionType || (PropertyActivitiesCrossSellActionType = {}));
/** Type that represents the amenity category icons for the property */
export var PropertyAmenityCategoryType;
(function (PropertyAmenityCategoryType) {
  PropertyAmenityCategoryType["ACCESSIBLE_ROLL_IN_SHOWER"] = "ACCESSIBLE_ROLL_IN_SHOWER";
  PropertyAmenityCategoryType["AIR_CONDITIONING"] = "AIR_CONDITIONING";
  PropertyAmenityCategoryType["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  PropertyAmenityCategoryType["ARCADE"] = "ARCADE";
  PropertyAmenityCategoryType["BABYSITTING"] = "BABYSITTING";
  PropertyAmenityCategoryType["BAR"] = "BAR";
  PropertyAmenityCategoryType["BOWLING"] = "BOWLING";
  PropertyAmenityCategoryType["BREAKFAST_AVAILABLE"] = "BREAKFAST_AVAILABLE";
  PropertyAmenityCategoryType["BUSINESS_SERVICES"] = "BUSINESS_SERVICES";
  PropertyAmenityCategoryType["CHILDREN_CLUB"] = "CHILDREN_CLUB";
  PropertyAmenityCategoryType["DAILY_HOUSEKEEPING"] = "DAILY_HOUSEKEEPING";
  PropertyAmenityCategoryType["EXTRA_BED"] = "EXTRA_BED";
  PropertyAmenityCategoryType["FITNESS_EQUIPMENT"] = "FITNESS_EQUIPMENT";
  PropertyAmenityCategoryType["FREE_AIRPORT_TRANSPORTATION"] = "FREE_AIRPORT_TRANSPORTATION";
  PropertyAmenityCategoryType["FREE_BREAKFAST"] = "FREE_BREAKFAST";
  PropertyAmenityCategoryType["FREE_PARKING"] = "FREE_PARKING";
  PropertyAmenityCategoryType["FREE_WELCOME_DRINK"] = "FREE_WELCOME_DRINK";
  PropertyAmenityCategoryType["FRONT_DESK_24_HOURS"] = "FRONT_DESK_24_HOURS";
  PropertyAmenityCategoryType["GROCERY"] = "GROCERY";
  PropertyAmenityCategoryType["HIGH_SPEED_INTERNET"] = "HIGH_SPEED_INTERNET";
  PropertyAmenityCategoryType["HOT_TUB"] = "HOT_TUB";
  PropertyAmenityCategoryType["IN_ROOM_INTERNET"] = "IN_ROOM_INTERNET";
  PropertyAmenityCategoryType["KIDS_POOL"] = "KIDS_POOL";
  PropertyAmenityCategoryType["KITCHEN"] = "KITCHEN";
  PropertyAmenityCategoryType["LAUNDRY"] = "LAUNDRY";
  PropertyAmenityCategoryType["LIVING_AREA"] = "LIVING_AREA";
  PropertyAmenityCategoryType["MICROWAVE"] = "MICROWAVE";
  PropertyAmenityCategoryType["MINI_GOLF"] = "MINI_GOLF";
  PropertyAmenityCategoryType["PARKING"] = "PARKING";
  PropertyAmenityCategoryType["PETS_ALLOWED"] = "PETS_ALLOWED";
  PropertyAmenityCategoryType["PLAYGROUND"] = "PLAYGROUND";
  PropertyAmenityCategoryType["POOL"] = "POOL";
  PropertyAmenityCategoryType["RESTAURANT_IN_HOTEL"] = "RESTAURANT_IN_HOTEL";
  PropertyAmenityCategoryType["ROOM_SERVICE"] = "ROOM_SERVICE";
  PropertyAmenityCategoryType["SMOKE_FREE"] = "SMOKE_FREE";
  PropertyAmenityCategoryType["SOUNDPROOF_ROOM"] = "SOUNDPROOF_ROOM";
  PropertyAmenityCategoryType["SPA_SERVICES_ON_SITE"] = "SPA_SERVICES_ON_SITE";
  PropertyAmenityCategoryType["SPECIAL_DEAL"] = "SPECIAL_DEAL";
  PropertyAmenityCategoryType["TENNIS_COURT"] = "TENNIS_COURT";
  PropertyAmenityCategoryType["TOYS"] = "TOYS";
  PropertyAmenityCategoryType["WATERSLIDE"] = "WATERSLIDE";
})(PropertyAmenityCategoryType || (PropertyAmenityCategoryType = {}));
export var PropertyAmenityType;
(function (PropertyAmenityType) {
  PropertyAmenityType["ACCESSIBILITY"] = "ACCESSIBILITY";
  PropertyAmenityType["BATHROOM"] = "BATHROOM";
  PropertyAmenityType["BEDROOM"] = "BEDROOM";
  PropertyAmenityType["BUSINESS_SERVICES"] = "BUSINESS_SERVICES";
  PropertyAmenityType["CONVENIENCES"] = "CONVENIENCES";
  PropertyAmenityType["ENTERTAINMENT"] = "ENTERTAINMENT";
  PropertyAmenityType["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
  PropertyAmenityType["FOOD_DRINK"] = "FOOD_DRINK";
  PropertyAmenityType["GUEST_SERVICES"] = "GUEST_SERVICES";
  PropertyAmenityType["INTERNET"] = "INTERNET";
  PropertyAmenityType["MORE"] = "MORE";
  PropertyAmenityType["OUTDOOR"] = "OUTDOOR";
  PropertyAmenityType["OUTDOOR_SPACE"] = "OUTDOOR_SPACE";
  PropertyAmenityType["PARKING"] = "PARKING";
  PropertyAmenityType["PROPERTY"] = "PROPERTY";
  PropertyAmenityType["ROOM"] = "ROOM";
  PropertyAmenityType["SPA"] = "SPA";
  PropertyAmenityType["THINGS_TO_DO"] = "THINGS_TO_DO";
})(PropertyAmenityType || (PropertyAmenityType = {}));
export var PropertyCalendarPriceTrend;
(function (PropertyCalendarPriceTrend) {
  /** Negative price trend */
  PropertyCalendarPriceTrend["NEGATIVE"] = "NEGATIVE";
  /** Positive price trend */
  PropertyCalendarPriceTrend["POSITIVE"] = "POSITIVE";
})(PropertyCalendarPriceTrend || (PropertyCalendarPriceTrend = {}));
export var PropertyCancellationPolicyType;
(function (PropertyCancellationPolicyType) {
  PropertyCancellationPolicyType["NON_REFUNDABLE"] = "NON_REFUNDABLE";
  PropertyCancellationPolicyType["REFUNDABLE_WITH_NO_PENALTY"] = "REFUNDABLE_WITH_NO_PENALTY";
  PropertyCancellationPolicyType["REFUNDABLE_WITH_PENALTY"] = "REFUNDABLE_WITH_PENALTY";
})(PropertyCancellationPolicyType || (PropertyCancellationPolicyType = {}));
export var PropertyContentSectionRef;
(function (PropertyContentSectionRef) {
  PropertyContentSectionRef["AVAILABILITY_CALENDAR_START_DATE"] = "AVAILABILITY_CALENDAR_START_DATE";
  PropertyContentSectionRef["PRICE_DISPLAY_SERVICE_RESPONSE"] = "PRICE_DISPLAY_SERVICE_RESPONSE";
  PropertyContentSectionRef["RECOMMENDED_OFFER"] = "RECOMMENDED_OFFER";
  PropertyContentSectionRef["ROOMS_AND_RATES"] = "ROOMS_AND_RATES";
})(PropertyContentSectionRef || (PropertyContentSectionRef = {}));
export var PropertyContentType;
(function (PropertyContentType) {
  /** Detailed view that appears in expanded modal. */
  PropertyContentType["DETAILED"] = "DETAILED";
  /** Simplified view that appears flat on page. */
  PropertyContentType["SUMMARY"] = "SUMMARY";
})(PropertyContentType || (PropertyContentType = {}));
export var PropertyDetailsPropertyType;
(function (PropertyDetailsPropertyType) {
  PropertyDetailsPropertyType["HOTEL"] = "HOTEL";
  PropertyDetailsPropertyType["VACATION_RENTAL"] = "VACATION_RENTAL";
})(PropertyDetailsPropertyType || (PropertyDetailsPropertyType = {}));
export var PropertyFilterAccessibility;
(function (PropertyFilterAccessibility) {
  PropertyFilterAccessibility["ACCESSIBLE_BATHROOM"] = "ACCESSIBLE_BATHROOM";
  PropertyFilterAccessibility["ACCESSIBLE_PARKING"] = "ACCESSIBLE_PARKING";
  PropertyFilterAccessibility["ELEVATOR"] = "ELEVATOR";
  PropertyFilterAccessibility["IN_ROOM_ACCESSIBLE"] = "IN_ROOM_ACCESSIBLE";
  PropertyFilterAccessibility["ROLL_IN_SHOWER"] = "ROLL_IN_SHOWER";
  PropertyFilterAccessibility["SERVICE_ANIMAL"] = "SERVICE_ANIMAL";
  PropertyFilterAccessibility["SIGN_LANGUAGE_INTERPRETER"] = "SIGN_LANGUAGE_INTERPRETER";
  PropertyFilterAccessibility["STAIR_FREE_PATH"] = "STAIR_FREE_PATH";
})(PropertyFilterAccessibility || (PropertyFilterAccessibility = {}));
export var PropertyFilterAmenity;
(function (PropertyFilterAmenity) {
  PropertyFilterAmenity["AIR_CONDITIONING"] = "AIR_CONDITIONING";
  PropertyFilterAmenity["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  PropertyFilterAmenity["BALCONY_OR_TERRACE"] = "BALCONY_OR_TERRACE";
  PropertyFilterAmenity["BAR"] = "BAR";
  PropertyFilterAmenity["BEACH"] = "BEACH";
  PropertyFilterAmenity["CASINO"] = "CASINO";
  PropertyFilterAmenity["CRIB"] = "CRIB";
  PropertyFilterAmenity["ELECTRIC_CAR"] = "ELECTRIC_CAR";
  PropertyFilterAmenity["FREE_AIRPORT_TRANSPORTATION"] = "FREE_AIRPORT_TRANSPORTATION";
  PropertyFilterAmenity["FREE_BREAKFAST"] = "FREE_BREAKFAST";
  PropertyFilterAmenity["FREE_PARKING"] = "FREE_PARKING";
  PropertyFilterAmenity["GOLF"] = "GOLF";
  PropertyFilterAmenity["GYM"] = "GYM";
  PropertyFilterAmenity["HOT_SPRING"] = "HOT_SPRING";
  PropertyFilterAmenity["HOT_TUB"] = "HOT_TUB";
  PropertyFilterAmenity["KITCHEN_KITCHEN"] = "KITCHEN_KITCHEN";
  PropertyFilterAmenity["KITCHEN_KITCHENETTE"] = "KITCHEN_KITCHENETTE";
  PropertyFilterAmenity["OCEAN_VIEW"] = "OCEAN_VIEW";
  PropertyFilterAmenity["PARKING"] = "PARKING";
  PropertyFilterAmenity["PETS"] = "PETS";
  PropertyFilterAmenity["POOL"] = "POOL";
  PropertyFilterAmenity["RESTAURANT_IN_HOTEL"] = "RESTAURANT_IN_HOTEL";
  PropertyFilterAmenity["SPA_ON_SITE"] = "SPA_ON_SITE";
  PropertyFilterAmenity["TELEVISION"] = "TELEVISION";
  PropertyFilterAmenity["WASHER_DRYER"] = "WASHER_DRYER";
  PropertyFilterAmenity["WATER_PARK"] = "WATER_PARK";
  PropertyFilterAmenity["WIFI"] = "WIFI";
})(PropertyFilterAmenity || (PropertyFilterAmenity = {}));
/** Options that are not filters. Refer @code { SearchOptions } */
export var PropertyInfoOptions;
(function (PropertyInfoOptions) {
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  PropertyInfoOptions["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
})(PropertyInfoOptions || (PropertyInfoOptions = {}));
export var PropertyPaymentFlags;
(function (PropertyPaymentFlags) {
  PropertyPaymentFlags["ARTIFICIALLY_FENCED_RATE"] = "ARTIFICIALLY_FENCED_RATE";
  PropertyPaymentFlags["MIXED_RATE_PLAN"] = "MIXED_RATE_PLAN";
  PropertyPaymentFlags["NO_CREDIT_CARD"] = "NO_CREDIT_CARD";
})(PropertyPaymentFlags || (PropertyPaymentFlags = {}));
export var PropertyPaymentModel;
(function (PropertyPaymentModel) {
  PropertyPaymentModel["PAY_LATER"] = "PAY_LATER";
  PropertyPaymentModel["PAY_LATER_WITH_DEPOSIT"] = "PAY_LATER_WITH_DEPOSIT";
  PropertyPaymentModel["PAY_NOW"] = "PAY_NOW";
})(PropertyPaymentModel || (PropertyPaymentModel = {}));
/** Indicate what are the payment options for a given offer */
export var PropertyPaymentType;
(function (PropertyPaymentType) {
  PropertyPaymentType["PAY_LATER"] = "PAY_LATER";
  PropertyPaymentType["PAY_LATER_WITH_DEPOSIT"] = "PAY_LATER_WITH_DEPOSIT";
  PropertyPaymentType["PAY_NOW"] = "PAY_NOW";
})(PropertyPaymentType || (PropertyPaymentType = {}));
export var PropertyRecommendationStrategy;
(function (PropertyRecommendationStrategy) {
  PropertyRecommendationStrategy["NEARBY_PROPERTIES"] = "NEARBY_PROPERTIES";
  PropertyRecommendationStrategy["SIMILAR_PROPERTIES"] = "SIMILAR_PROPERTIES";
})(PropertyRecommendationStrategy || (PropertyRecommendationStrategy = {}));
/** Filters review results by category type */
export var PropertyReviewCategory;
(function (PropertyReviewCategory) {
  PropertyReviewCategory["BUSINESS_TRAVELERS"] = "BUSINESS_TRAVELERS";
  PropertyReviewCategory["COUPLES"] = "COUPLES";
  PropertyReviewCategory["EVERYONE"] = "EVERYONE";
  PropertyReviewCategory["FAMILIES"] = "FAMILIES";
  PropertyReviewCategory["GETAWAY_WITH_FRIENDS"] = "GETAWAY_WITH_FRIENDS";
  PropertyReviewCategory["GOLF"] = "GOLF";
  PropertyReviewCategory["OTHER"] = "OTHER";
  PropertyReviewCategory["OVERNIGHT_STAY"] = "OVERNIGHT_STAY";
  PropertyReviewCategory["PERSONAL_EVENT"] = "PERSONAL_EVENT";
  PropertyReviewCategory["SHOPPING"] = "SHOPPING";
  PropertyReviewCategory["SPA"] = "SPA";
  PropertyReviewCategory["STUDENTS"] = "STUDENTS";
})(PropertyReviewCategory || (PropertyReviewCategory = {}));
/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export var PropertyReviewSort;
(function (PropertyReviewSort) {
  PropertyReviewSort["HIGHEST_TO_LOWEST_RATED"] = "HIGHEST_TO_LOWEST_RATED";
  PropertyReviewSort["LOWEST_TO_HIGHEST_RATED"] = "LOWEST_TO_HIGHEST_RATED";
  PropertyReviewSort["NEWEST_TO_OLDEST"] = "NEWEST_TO_OLDEST";
  PropertyReviewSort["NEWEST_TO_OLDEST_BY_LANGUAGE"] = "NEWEST_TO_OLDEST_BY_LANGUAGE";
  PropertyReviewSort["OLDEST_TO_NEWEST"] = "OLDEST_TO_NEWEST";
  PropertyReviewSort["OLDEST_TO_NEWEST_BY_LANGUAGE"] = "OLDEST_TO_NEWEST_BY_LANGUAGE";
})(PropertyReviewSort || (PropertyReviewSort = {}));
/** [Optional] Review filter type */
export var PropertyReviewType;
(function (PropertyReviewType) {
  /** filter reviews by rating <= 2 */
  PropertyReviewType["CRITICAL"] = "CRITICAL";
  /** filter reviews by rating >= 3 */
  PropertyReviewType["POSITIVE"] = "POSITIVE";
  /** filter reviews by latest date */
  PropertyReviewType["RECENT"] = "RECENT";
})(PropertyReviewType || (PropertyReviewType = {}));
/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export var PropertySearchOptions;
(function (PropertySearchOptions) {
  /** Only return travelAds, excluding this will result in a mixed set of organic listings and ads */
  PropertySearchOptions["ADS_ONLY"] = "ADS_ONLY";
  /** Use loyalty points to calculate the strikeout price. aka `swpApplied=true` */
  PropertySearchOptions["SHOP_WITH_POINTS"] = "SHOP_WITH_POINTS";
})(PropertySearchOptions || (PropertySearchOptions = {}));
export var PropertySectionRef;
(function (PropertySectionRef) {
  PropertySectionRef["AVAILABILITY_CALENDAR_START_DATE"] = "AVAILABILITY_CALENDAR_START_DATE";
  PropertySectionRef["PRICE_DISPLAY_SERVICE_RESPONSE"] = "PRICE_DISPLAY_SERVICE_RESPONSE";
  PropertySectionRef["RECOMMENDED_OFFER"] = "RECOMMENDED_OFFER";
  PropertySectionRef["ROOMS_AND_RATES"] = "ROOMS_AND_RATES";
})(PropertySectionRef || (PropertySectionRef = {}));
/** Hotel sort types */
export var PropertySort;
(function (PropertySort) {
  PropertySort["AARP_MEMBER_DISCOUNT"] = "AARP_MEMBER_DISCOUNT";
  PropertySort["BEST_DEAL"] = "BEST_DEAL";
  PropertySort["DISTANCE"] = "DISTANCE";
  PropertySort["MAXIMUM_SAVINGS"] = "MAXIMUM_SAVINGS";
  PropertySort["MAXIMUM_SAVINGS_PERCENT"] = "MAXIMUM_SAVINGS_PERCENT";
  PropertySort["MEMBER_PRICING"] = "MEMBER_PRICING";
  PropertySort["PACKAGE_SAVINGS"] = "PACKAGE_SAVINGS";
  PropertySort["PRICE_HIGH_TO_LOW"] = "PRICE_HIGH_TO_LOW";
  PropertySort["PRICE_LOW_TO_HIGH"] = "PRICE_LOW_TO_HIGH";
  PropertySort["PRICE_RELEVANT"] = "PRICE_RELEVANT";
  PropertySort["PROPERTY_CLASS"] = "PROPERTY_CLASS";
  PropertySort["PROPERTY_NAME"] = "PROPERTY_NAME";
  PropertySort["RECOMMENDED"] = "RECOMMENDED";
  PropertySort["REVIEW"] = "REVIEW";
  PropertySort["REVIEW_COUNT"] = "REVIEW_COUNT";
  PropertySort["REVIEW_PRICE"] = "REVIEW_PRICE";
  PropertySort["REVIEW_RELEVANT"] = "REVIEW_RELEVANT";
  PropertySort["VACATION_RENTAL"] = "VACATION_RENTAL";
})(PropertySort || (PropertySort = {}));
export var PropertyStyle;
(function (PropertyStyle) {
  PropertyStyle["BOUTIQUE"] = "BOUTIQUE";
  PropertyStyle["HOMES"] = "HOMES";
  PropertyStyle["HOTELS"] = "HOTELS";
  PropertyStyle["LGBT"] = "LGBT";
  PropertyStyle["LUXURY"] = "LUXURY";
  PropertyStyle["OUTDOOR"] = "OUTDOOR";
  PropertyStyle["UNIQUE"] = "UNIQUE";
})(PropertyStyle || (PropertyStyle = {}));
export var QuestionSortType;
(function (QuestionSortType) {
  QuestionSortType["NEWEST_TO_OLDEST"] = "NEWEST_TO_OLDEST";
  QuestionSortType["OLDEST_TO_NEWEST"] = "OLDEST_TO_NEWEST";
})(QuestionSortType || (QuestionSortType = {}));
export var QuoteBuilderType;
(function (QuoteBuilderType) {
  QuoteBuilderType["BOTTOM"] = "BOTTOM";
  QuoteBuilderType["RIGHT_SIDE"] = "RIGHT_SIDE";
  QuoteBuilderType["SIDE"] = "SIDE";
})(QuoteBuilderType || (QuoteBuilderType = {}));
/** Theme information for a range indicator segment. */
export var RangeIndicatorSegmentStyle;
(function (RangeIndicatorSegmentStyle) {
  RangeIndicatorSegmentStyle["EMPHASIS"] = "EMPHASIS";
})(RangeIndicatorSegmentStyle || (RangeIndicatorSegmentStyle = {}));
/** Style information for a range indicator segment. */
export var RangeIndicatorSegmentTheme;
(function (RangeIndicatorSegmentTheme) {
  RangeIndicatorSegmentTheme["NEGATIVE"] = "NEGATIVE";
  RangeIndicatorSegmentTheme["NEUTRAL"] = "NEUTRAL";
  RangeIndicatorSegmentTheme["POSITIVE"] = "POSITIVE";
  RangeIndicatorSegmentTheme["VERY_POSITIVE"] = "VERY_POSITIVE";
})(RangeIndicatorSegmentTheme || (RangeIndicatorSegmentTheme = {}));
export var RateAdjustmentType;
(function (RateAdjustmentType) {
  RateAdjustmentType["Amount"] = "Amount";
  RateAdjustmentType["Percent"] = "Percent";
})(RateAdjustmentType || (RateAdjustmentType = {}));
export var RateDiscountType;
(function (RateDiscountType) {
  RateDiscountType["MEMBER_DEAL"] = "MEMBER_DEAL";
  RateDiscountType["MOBILE_EXCLUSIVE"] = "MOBILE_EXCLUSIVE";
  RateDiscountType["REGULAR"] = "REGULAR";
  RateDiscountType["TONIGHT_ONLY"] = "TONIGHT_ONLY";
})(RateDiscountType || (RateDiscountType = {}));
export var RecentActivityType;
(function (RecentActivityType) {
  RecentActivityType["BROWSING_HISTORY"] = "BROWSING_HISTORY";
  RecentActivityType["RECENT_SEARCHES"] = "RECENT_SEARCHES";
  RecentActivityType["VIEWED_OFFERS"] = "VIEWED_OFFERS";
  RecentActivityType["VIEWED_PRODUCTS"] = "VIEWED_PRODUCTS";
})(RecentActivityType || (RecentActivityType = {}));
export var RecommendedType;
(function (RecommendedType) {
  RecommendedType["BESPOKE"] = "BESPOKE";
  RecommendedType["DESTINATIONS"] = "DESTINATIONS";
  RecommendedType["OFFERS"] = "OFFERS";
})(RecommendedType || (RecommendedType = {}));
export var RefundStatus;
(function (RefundStatus) {
  RefundStatus["Failure"] = "Failure";
  RefundStatus["Success"] = "Success";
})(RefundStatus || (RefundStatus = {}));
export var RefundableType;
(function (RefundableType) {
  RefundableType["FULLY"] = "FULLY";
  RefundableType["NON"] = "NON";
  RefundableType["PARTIALLY"] = "PARTIALLY";
  RefundableType["UNKNOWN"] = "UNKNOWN";
})(RefundableType || (RefundableType = {}));
/** Enumerated Gaia geographic region types */
export var RegionType;
(function (RegionType) {
  RegionType["ADDRESS"] = "ADDRESS";
  RegionType["AIRPORT"] = "AIRPORT";
  RegionType["CITY"] = "CITY";
  RegionType["CONTINENT"] = "CONTINENT";
  RegionType["COUNTRY"] = "COUNTRY";
  RegionType["HIGH_LEVEL_REGION"] = "HIGH_LEVEL_REGION";
  RegionType["METRO_STATION"] = "METRO_STATION";
  RegionType["MULTI_CITY_VICINITY"] = "MULTI_CITY_VICINITY";
  RegionType["NEIGHBORHOOD"] = "NEIGHBORHOOD";
  RegionType["POINT_OF_INTEREST"] = "POINT_OF_INTEREST";
  RegionType["PROVINCE_STATE"] = "PROVINCE_STATE";
  RegionType["TRAIN_STATION"] = "TRAIN_STATION";
  RegionType["UNKNOWN"] = "UNKNOWN";
})(RegionType || (RegionType = {}));
export var ReservationModifiersCancellationFeeOptionType;
(function (ReservationModifiersCancellationFeeOptionType) {
  ReservationModifiersCancellationFeeOptionType["FULL_FEE"] = "FULL_FEE";
  ReservationModifiersCancellationFeeOptionType["NO_FEE"] = "NO_FEE";
  ReservationModifiersCancellationFeeOptionType["CUSTOM_FEE"] = "CUSTOM_FEE";
})(ReservationModifiersCancellationFeeOptionType || (ReservationModifiersCancellationFeeOptionType = {}));
export var ReservationModifiersRefundAmountOptionType;
(function (ReservationModifiersRefundAmountOptionType) {
  ReservationModifiersRefundAmountOptionType["CUSTOM_AMOUNT"] = "CUSTOM_AMOUNT";
  ReservationModifiersRefundAmountOptionType["PERCENTAGE_AMOUNT"] = "PERCENTAGE_AMOUNT";
})(ReservationModifiersRefundAmountOptionType || (ReservationModifiersRefundAmountOptionType = {}));
export var ReservationModifiersScreenType;
(function (ReservationModifiersScreenType) {
  ReservationModifiersScreenType["MENU"] = "MENU";
  ReservationModifiersScreenType["SET_CANCELLATION_REASON"] = "SET_CANCELLATION_REASON";
  ReservationModifiersScreenType["SET_CANCELLATION_FEE"] = "SET_CANCELLATION_FEE";
  ReservationModifiersScreenType["SET_REFUND_REASON"] = "SET_REFUND_REASON";
  ReservationModifiersScreenType["SET_REFUND_AMOUNT"] = "SET_REFUND_AMOUNT";
  ReservationModifiersScreenType["SET_STAY_DATES"] = "SET_STAY_DATES";
  ReservationModifiersScreenType["SET_MESSAGE_TO_GUEST"] = "SET_MESSAGE_TO_GUEST";
  ReservationModifiersScreenType["REVIEW_CHANGES"] = "REVIEW_CHANGES";
  ReservationModifiersScreenType["SUCCESS"] = "SUCCESS";
})(ReservationModifiersScreenType || (ReservationModifiersScreenType = {}));
export var ReservationModifiersType;
(function (ReservationModifiersType) {
  ReservationModifiersType["NO_SHOW"] = "NO_SHOW";
  ReservationModifiersType["CANCEL"] = "CANCEL";
  ReservationModifiersType["CHANGE_DATES"] = "CHANGE_DATES";
  ReservationModifiersType["GUEST_SATISFACTION_REFUND"] = "GUEST_SATISFACTION_REFUND";
})(ReservationModifiersType || (ReservationModifiersType = {}));
export var ResidencyState;
(function (ResidencyState) {
  ResidencyState["APPLIED"] = "APPLIED";
  ResidencyState["AVAILABLE"] = "AVAILABLE";
})(ResidencyState || (ResidencyState = {}));
/** Tags Associated with the response */
export var ResponseTagType;
(function (ResponseTagType) {
  ResponseTagType["CACHE_SOURCE_AIRBLAZE"] = "CACHE_SOURCE_AIRBLAZE";
  ResponseTagType["CACHE_SOURCE_BYOT_AIRBLAZE"] = "CACHE_SOURCE_BYOT_AIRBLAZE";
  ResponseTagType["EXPERIENCE_SEARCH_CACHE_HYDRATOR"] = "EXPERIENCE_SEARCH_CACHE_HYDRATOR";
  ResponseTagType["LISTINGS_PAGINATED_SLICED"] = "LISTINGS_PAGINATED_SLICED";
  ResponseTagType["LISTING_CACHE_SOURCE"] = "LISTING_CACHE_SOURCE";
  ResponseTagType["LISTING_DOWNLEVEL_SOURCE"] = "LISTING_DOWNLEVEL_SOURCE";
  ResponseTagType["MAIN_SEARCH_STACK"] = "MAIN_SEARCH_STACK";
  ResponseTagType["RESPONSE_SUMMARY_CACHED_CONFIG"] = "RESPONSE_SUMMARY_CACHED_CONFIG";
  ResponseTagType["RESPONSE_SUMMARY_CACHED_ML"] = "RESPONSE_SUMMARY_CACHED_ML";
  ResponseTagType["RESPONSE_SUMMARY_HYBRID"] = "RESPONSE_SUMMARY_HYBRID";
  ResponseTagType["RESPONSE_SUMMARY_LIVE"] = "RESPONSE_SUMMARY_LIVE";
  ResponseTagType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ResponseTagType || (ResponseTagType = {}));
export var Result;
(function (Result) {
  Result["ERROR"] = "ERROR";
  Result["SUCCESS"] = "SUCCESS";
})(Result || (Result = {}));
/** Enum of types of review interactions */
export var ReviewInteractionType;
(function (ReviewInteractionType) {
  ReviewInteractionType["HELPFUL_REVIEW"] = "HELPFUL_REVIEW";
  ReviewInteractionType["REVIEW_REPORT_FLAG"] = "REVIEW_REPORT_FLAG";
})(ReviewInteractionType || (ReviewInteractionType = {}));
/** The Enum to tell the review source */
export var ReviewSource;
(function (ReviewSource) {
  ReviewSource["EXTERNAL_REVIEWS"] = "EXTERNAL_REVIEWS";
  ReviewSource["INTERNAL_REVIEWS"] = "INTERNAL_REVIEWS";
})(ReviewSource || (ReviewSource = {}));
export var RewardsOption;
(function (RewardsOption) {
  RewardsOption["ALTAIR"] = "ALTAIR";
  RewardsOption["AVION"] = "AVION";
  RewardsOption["NONAVION"] = "NONAVION";
})(RewardsOption || (RewardsOption = {}));
export var RewardsPointSelectionEnum;
(function (RewardsPointSelectionEnum) {
  RewardsPointSelectionEnum["APPLY_REWARD_POINTS"] = "APPLY_REWARD_POINTS";
  RewardsPointSelectionEnum["DO_NOT_APPLY_REWARD_POINTS"] = "DO_NOT_APPLY_REWARD_POINTS";
})(RewardsPointSelectionEnum || (RewardsPointSelectionEnum = {}));
/** Possible user's state regarding the loyalty program */
export var RewardsProgramState;
(function (RewardsProgramState) {
  RewardsProgramState["ENROLLED"] = "ENROLLED";
  RewardsProgramState["NOT_ENROLLED"] = "NOT_ENROLLED";
})(RewardsProgramState || (RewardsProgramState = {}));
export var RouteType;
(function (RouteType) {
  RouteType["MULTI_DESTINATION"] = "MULTI_DESTINATION";
  RouteType["ONE_WAY"] = "ONE_WAY";
  RouteType["ROUND_TRIP"] = "ROUND_TRIP";
})(RouteType || (RouteType = {}));
/** Search form product types */
export var SearchFormProductType;
(function (SearchFormProductType) {
  SearchFormProductType["ACTIVITIES"] = "ACTIVITIES";
  SearchFormProductType["CARS"] = "CARS";
  SearchFormProductType["CRUISES"] = "CRUISES";
  SearchFormProductType["FLIGHTS"] = "FLIGHTS";
  SearchFormProductType["LODGING"] = "LODGING";
  SearchFormProductType["PACKAGES"] = "PACKAGES";
})(SearchFormProductType || (SearchFormProductType = {}));
/** Search history grouping day range. */
export var SearchHistoryDayRange;
(function (SearchHistoryDayRange) {
  /** Grouping using searches made 7 days from most recent search in same region */
  SearchHistoryDayRange["SEVEN_DAYS"] = "SEVEN_DAYS";
  /** Grouping using searches made 3 days from most recent search in same region */
  SearchHistoryDayRange["THREE_DAYS"] = "THREE_DAYS";
})(SearchHistoryDayRange || (SearchHistoryDayRange = {}));
/** Search history grouping destination type. */
export var SearchHistoryDestinationType;
(function (SearchHistoryDestinationType) {
  /** Grouping using multi_city_vicinity destination type for searches. */
  SearchHistoryDestinationType["METRO_CITY"] = "METRO_CITY";
})(SearchHistoryDestinationType || (SearchHistoryDestinationType = {}));
/** Enum class to represent the type of seat choice */
export var SeatChoiceType;
(function (SeatChoiceType) {
  SeatChoiceType["SEAT_CHOICE"] = "SEAT_CHOICE";
})(SeatChoiceType || (SeatChoiceType = {}));
/** Enum class to represent the seat type variant. */
export var SeatVariant;
(function (SeatVariant) {
  SeatVariant["ACCESSIBLE"] = "ACCESSIBLE";
  SeatVariant["AISLE"] = "AISLE";
  SeatVariant["AVAILABLE"] = "AVAILABLE";
  SeatVariant["COLUMN"] = "COLUMN";
  SeatVariant["EXIT"] = "EXIT";
  SeatVariant["GALLEY"] = "GALLEY";
  SeatVariant["PREFERRED"] = "PREFERRED";
  SeatVariant["RESTROOM"] = "RESTROOM";
  SeatVariant["ROW"] = "ROW";
  SeatVariant["SELECTED"] = "SELECTED";
  SeatVariant["UNAVAILABLE"] = "UNAVAILABLE";
})(SeatVariant || (SeatVariant = {}));
/** Type for Selected Baggage template */
export var SelectedAncillaryTemplateType;
(function (SelectedAncillaryTemplateType) {
  SelectedAncillaryTemplateType["MULTIPLE"] = "MULTIPLE";
  SelectedAncillaryTemplateType["NONE"] = "NONE";
  SelectedAncillaryTemplateType["ONE"] = "ONE";
})(SelectedAncillaryTemplateType || (SelectedAncillaryTemplateType = {}));
export var ServiceAutomationToolbarElevation;
(function (ServiceAutomationToolbarElevation) {
  ServiceAutomationToolbarElevation["FLAT"] = "FLAT";
  ServiceAutomationToolbarElevation["FLOATING"] = "FLOATING";
})(ServiceAutomationToolbarElevation || (ServiceAutomationToolbarElevation = {}));
export var ServiceAutomationToolbarNavType;
(function (ServiceAutomationToolbarNavType) {
  ServiceAutomationToolbarNavType["BACK"] = "BACK";
  ServiceAutomationToolbarNavType["CLOSE"] = "CLOSE";
  ServiceAutomationToolbarNavType["EXPAND_UP"] = "EXPAND_UP";
})(ServiceAutomationToolbarNavType || (ServiceAutomationToolbarNavType = {}));
/** SheetState represent sheet state like expanded/collapsed */
export var SheetState;
(function (SheetState) {
  SheetState["COLLAPSED"] = "COLLAPSED";
  SheetState["FULL"] = "FULL";
  SheetState["HALF"] = "HALF";
})(SheetState || (SheetState = {}));
/** An enum to represent the style of button */
export var ShoppingButtonType;
(function (ShoppingButtonType) {
  ShoppingButtonType["PRIMARY"] = "PRIMARY";
  ShoppingButtonType["SECONDARY"] = "SECONDARY";
  ShoppingButtonType["TERTIARY"] = "TERTIARY";
})(ShoppingButtonType || (ShoppingButtonType = {}));
/** An enum to represent shopping function type */
export var ShoppingFunctionType;
(function (ShoppingFunctionType) {
  ShoppingFunctionType["CALLBACK"] = "CALLBACK";
  ShoppingFunctionType["SHARED_UI"] = "SHARED_UI";
})(ShoppingFunctionType || (ShoppingFunctionType = {}));
/** Indicate the shopping path of a given offer */
export var ShoppingPathType;
(function (ShoppingPathType) {
  ShoppingPathType["ATTACH"] = "ATTACH";
  ShoppingPathType["PACKAGE"] = "PACKAGE";
  ShoppingPathType["STANDALONE"] = "STANDALONE";
})(ShoppingPathType || (ShoppingPathType = {}));
/** Valid actions on Sort and Filter Modal */
export var ShoppingSortAndFilterActionType;
(function (ShoppingSortAndFilterActionType) {
  /** Stay on the Sort & Filter Modal but set to default state. Eg used for clear button */
  ShoppingSortAndFilterActionType["CLEAR_DATA"] = "CLEAR_DATA";
  /** Close Sort & Filter Modal and apply user selected filters. Eg used for Apply/Done buttons */
  ShoppingSortAndFilterActionType["CLOSE_AND_APPLY"] = "CLOSE_AND_APPLY";
  /** Close Sort & Filter Modal. Eg used for Back/Cross buttons */
  ShoppingSortAndFilterActionType["CLOSE_AND_DO_NOT_APPLY"] = "CLOSE_AND_DO_NOT_APPLY";
  /**
   * Open the modal window associated with the component on which action has been performed.
   * Example: on click of Sort & Filter reveal button it should open Sort & Filter Modal and
   *        on click of Input Field it should open Typeahead Modal
   */
  ShoppingSortAndFilterActionType["OPEN_MODAL"] = "OPEN_MODAL";
})(ShoppingSortAndFilterActionType || (ShoppingSortAndFilterActionType = {}));
/** Type of Slider on Sort and Filter Modal */
export var ShoppingSortAndFilterSliderType;
(function (ShoppingSortAndFilterSliderType) {
  /** Dual Sort & Filter Slider, slider will be dual Ticked and both min & max value can be adjusted */
  ShoppingSortAndFilterSliderType["DUAL"] = "DUAL";
  /** Single Sort & Filter Slider, slider will be single Ticked and only max value can be adjusted */
  ShoppingSortAndFilterSliderType["SINGLE"] = "SINGLE";
})(ShoppingSortAndFilterSliderType || (ShoppingSortAndFilterSliderType = {}));
export var SideSheetType;
(function (SideSheetType) {
  SideSheetType["BREAKFAST"] = "BREAKFAST";
  SideSheetType["NONREFUNDABLE"] = "NONREFUNDABLE";
  SideSheetType["PACKAGE"] = "PACKAGE";
})(SideSheetType || (SideSheetType = {}));
export var SignalType;
(function (SignalType) {
  SignalType["BOOKING_SUCCESS"] = "BOOKING_SUCCESS";
  SignalType["CONFIGURATION_ADDED"] = "CONFIGURATION_ADDED";
  SignalType["DUPLICATE_REQUEST"] = "DUPLICATE_REQUEST";
  SignalType["INVALID_EMAIL"] = "INVALID_EMAIL";
  SignalType["OFFER_ADDED"] = "OFFER_ADDED";
  SignalType["OFFER_CHANGED"] = "OFFER_CHANGED";
  SignalType["OFFER_REMOVED"] = "OFFER_REMOVED";
  SignalType["OFFER_UNAVAILABLE"] = "OFFER_UNAVAILABLE";
  SignalType["OPERATION_FAILED"] = "OPERATION_FAILED";
  SignalType["PAYMENT_ERROR"] = "PAYMENT_ERROR";
  SignalType["PAYMENT_METHODS_APPLIED"] = "PAYMENT_METHODS_APPLIED";
  SignalType["PAYMENT_METHOD_UPDATED"] = "PAYMENT_METHOD_UPDATED";
  SignalType["PRICE_ADJUSTED"] = "PRICE_ADJUSTED";
  SignalType["PRICE_CHANGED"] = "PRICE_CHANGED";
  SignalType["REQUEST_CONFLICT"] = "REQUEST_CONFLICT";
  SignalType["SESSION_EXPIRED"] = "SESSION_EXPIRED";
  SignalType["SESSION_TOKEN_UPDATED"] = "SESSION_TOKEN_UPDATED";
  SignalType["SIGNAL_TYPE_INVALID"] = "SIGNAL_TYPE_INVALID";
  SignalType["UNRECOGNIZED"] = "UNRECOGNIZED";
  SignalType["UNRECOVERABLE_FAILURE"] = "UNRECOVERABLE_FAILURE";
})(SignalType || (SignalType = {}));
export var SmartFormHeadingSizeInput;
(function (SmartFormHeadingSizeInput) {
  SmartFormHeadingSizeInput["EIGHT"] = "EIGHT";
  SmartFormHeadingSizeInput["FIVE"] = "FIVE";
  SmartFormHeadingSizeInput["FOUR"] = "FOUR";
  SmartFormHeadingSizeInput["ONE"] = "ONE";
  SmartFormHeadingSizeInput["SEVEN"] = "SEVEN";
  SmartFormHeadingSizeInput["SIX"] = "SIX";
  SmartFormHeadingSizeInput["THREE"] = "THREE";
  SmartFormHeadingSizeInput["TWO"] = "TWO";
})(SmartFormHeadingSizeInput || (SmartFormHeadingSizeInput = {}));
export var SmartFormHeadingTagInput;
(function (SmartFormHeadingTagInput) {
  SmartFormHeadingTagInput["H1"] = "H1";
  SmartFormHeadingTagInput["H2"] = "H2";
  SmartFormHeadingTagInput["H3"] = "H3";
  SmartFormHeadingTagInput["H4"] = "H4";
  SmartFormHeadingTagInput["H5"] = "H5";
  SmartFormHeadingTagInput["H6"] = "H6";
})(SmartFormHeadingTagInput || (SmartFormHeadingTagInput = {}));
/** To define which type of keystrokes will be considered by this input. */
export var SmartFormTextInputVariant;
(function (SmartFormTextInputVariant) {
  SmartFormTextInputVariant["EMAIL"] = "EMAIL";
  SmartFormTextInputVariant["NUMERIC"] = "NUMERIC";
  SmartFormTextInputVariant["TEL"] = "TEL";
  SmartFormTextInputVariant["TEXT"] = "TEXT";
  SmartFormTextInputVariant["TEXTAREA"] = "TEXTAREA";
})(SmartFormTextInputVariant || (SmartFormTextInputVariant = {}));
/**
 * "
 *     Type of operation to perform.
 */
export var SortAndFilterBasicFilterPayloadType;
(function (SortAndFilterBasicFilterPayloadType) {
  /** Check selected filter option */
  SortAndFilterBasicFilterPayloadType["OPTION"] = "OPTION";
  /** Remove selected filter */
  SortAndFilterBasicFilterPayloadType["REMOVE"] = "REMOVE";
})(SortAndFilterBasicFilterPayloadType || (SortAndFilterBasicFilterPayloadType = {}));
/** Specifies when a signal should be emitted */
export var SortAndFilterSignalCondition;
(function (SortAndFilterSignalCondition) {
  /** When a filter value changes from the default value to a non default value */
  SortAndFilterSignalCondition["DEFAULT_TO_NON_DEFAULT"] = "DEFAULT_TO_NON_DEFAULT";
  /** When a filter value changes from a non default value to the default value */
  SortAndFilterSignalCondition["NON_DEFAULT_TO_DEFAULT"] = "NON_DEFAULT_TO_DEFAULT";
  /** When a filter value changes from a non default value to a different non default value */
  SortAndFilterSignalCondition["NON_DEFAULT_TO_NON_DEFAULT"] = "NON_DEFAULT_TO_NON_DEFAULT";
  /** When a filter state changes from unselected to selected */
  SortAndFilterSignalCondition["SELECTED"] = "SELECTED";
  /** When a filter state changes from selected to unselected */
  SortAndFilterSignalCondition["UNSELECTED"] = "UNSELECTED";
})(SortAndFilterSignalCondition || (SortAndFilterSignalCondition = {}));
/** Contains the different views for Sort and Filters, where each of them is meant to be on a specific page section or viewport. */
export var SortAndFiltersViewType;
(function (SortAndFiltersViewType) {
  /**
   * Represent a view where it's displayed applied filters as removable pills.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  SortAndFiltersViewType["APPLIED_FILTERS"] = "APPLIED_FILTERS";
  /**
   * Represent a view where it's only displayed a list of filters.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, in the left side of the results on a Search Results Page.
   */
  SortAndFiltersViewType["FILTERS"] = "FILTERS";
  /**
   * Represent a view where the list of filters are displayed as pills.
   * Used for all viewport sizes, on top of the results on a Search Results Page.
   */
  SortAndFiltersViewType["FILTERS_PILLS"] = "FILTERS_PILLS";
  /**
   * Represent a view where it displays a filter bar with an All Filters button.
   * Used for all viewport sizes, above the results in the Vrbex SRP split view template.
   */
  SortAndFiltersViewType["FILTER_BAR"] = "FILTER_BAR";
  /**
   * Represent a view where it displays a dialog with only `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for all viewport sizes, inside toolbars.
   */
  SortAndFiltersViewType["FILTER_DIALOG"] = "FILTER_DIALOG";
  /**
   * Represent a view where it's only displayed a list of sort fields, it usually contains a single section with a sort field.
   * Used for `LARGE` and `EXTRA_LARGE` viewport sizes, above the results in a Search Results Page.
   */
  SortAndFiltersViewType["SORT"] = "SORT";
  /**
   * Represent a view of a combined list of the `sort` and `filters` sections, which are hidden and will be displayed (within a Dialog) once a trigger is clicked by the user.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  SortAndFiltersViewType["SORT_AND_FILTERS"] = "SORT_AND_FILTERS";
  /**
   * Represent a view where sort options are displayed as tabs with each tab displaying the sorted results based on the selected tab.
   * Used for all viewport sizes.
   */
  SortAndFiltersViewType["SORT_TABS"] = "SORT_TABS";
  /**
   * Represent a view where apply rewards is displayed as a toggle.
   * Used for `SMALL` and `MEDIUM` viewport sizes, above the results in a Search Results Page.
   */
  SortAndFiltersViewType["USE_REWARDS"] = "USE_REWARDS";
})(SortAndFiltersViewType || (SortAndFiltersViewType = {}));
export var SourceType;
(function (SourceType) {
  SourceType["ESR"] = "ESR";
  SourceType["GDS"] = "GDS";
})(SourceType || (SourceType = {}));
export var Space;
(function (Space) {
  Space["four"] = "four";
  Space["half"] = "half";
  Space["one"] = "one";
  Space["six"] = "six";
  Space["three"] = "three";
  Space["twelve"] = "twelve";
  Space["two"] = "two";
})(Space || (Space = {}));
export var Spacing;
(function (Spacing) {
  Spacing["four"] = "four";
  Spacing["half"] = "half";
  Spacing["one"] = "one";
  Spacing["six"] = "six";
  Spacing["sixteen"] = "sixteen";
  Spacing["three"] = "three";
  Spacing["twelve"] = "twelve";
  Spacing["two"] = "two";
  Spacing["unset"] = "unset";
})(Spacing || (Spacing = {}));
/** Possible equipment requested by the customer */
export var SpecialEquipment;
(function (SpecialEquipment) {
  SpecialEquipment["ADDITIONAL_DRIVER"] = "ADDITIONAL_DRIVER";
  SpecialEquipment["BICYCLE_RACK"] = "BICYCLE_RACK";
  SpecialEquipment["BOOSTER_SEAT"] = "BOOSTER_SEAT";
  SpecialEquipment["INFANT_SEAT"] = "INFANT_SEAT";
  SpecialEquipment["LEFT_HAND_CONTROL"] = "LEFT_HAND_CONTROL";
  SpecialEquipment["LUGGAGE_RACK"] = "LUGGAGE_RACK";
  SpecialEquipment["NAV_SYSTEM"] = "NAV_SYSTEM";
  SpecialEquipment["RIGHT_HAND_CONTROL"] = "RIGHT_HAND_CONTROL";
  SpecialEquipment["ROAD_CONGESTION_PAYMENT_SCHEME"] = "ROAD_CONGESTION_PAYMENT_SCHEME";
  SpecialEquipment["SATELLITE_RADIO"] = "SATELLITE_RADIO";
  SpecialEquipment["SKI_RACK"] = "SKI_RACK";
  SpecialEquipment["SNOW_CHAINS"] = "SNOW_CHAINS";
  SpecialEquipment["SNOW_TIRES"] = "SNOW_TIRES";
  SpecialEquipment["TODDLER_SEAT"] = "TODDLER_SEAT";
  SpecialEquipment["TOLL_PAYMENT_TAG_PASS"] = "TOLL_PAYMENT_TAG_PASS";
  SpecialEquipment["TRAILER_HITCH"] = "TRAILER_HITCH";
  SpecialEquipment["WIFI_ACCESS"] = "WIFI_ACCESS";
  SpecialEquipment["WINTER_PACKAGE"] = "WINTER_PACKAGE";
})(SpecialEquipment || (SpecialEquipment = {}));
/** Location resolution by type */
export var SponsoredContentLocationResolver;
(function (SponsoredContentLocationResolver) {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  SponsoredContentLocationResolver["GAIA"] = "GAIA";
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  SponsoredContentLocationResolver["TLA"] = "TLA";
})(SponsoredContentLocationResolver || (SponsoredContentLocationResolver = {}));
/** Location resolution by type */
export var SponsoredContentLocationResolverInput;
(function (SponsoredContentLocationResolverInput) {
  /** Gaia regionId. Ex. 178248 (Chicago (and vicinity)) */
  SponsoredContentLocationResolverInput["GAIA"] = "GAIA";
  /** Airport code. Ex. ORD (TLA code for Chicago O'Hare Airport) */
  SponsoredContentLocationResolverInput["TLA"] = "TLA";
})(SponsoredContentLocationResolverInput || (SponsoredContentLocationResolverInput = {}));
/** The type of the ad placement */
export var SponsoredContentProductType;
(function (SponsoredContentProductType) {
  SponsoredContentProductType["ALTERNATE_DESTINATIONS_CAROUSEL"] = "ALTERNATE_DESTINATIONS_CAROUSEL";
  SponsoredContentProductType["BRAND_RESULT_LISTING"] = "BRAND_RESULT_LISTING";
  SponsoredContentProductType["BRAND_RESULT_LISTING_CARS"] = "BRAND_RESULT_LISTING_CARS";
  SponsoredContentProductType["BRAND_RESULT_LISTING_CRUISES"] = "BRAND_RESULT_LISTING_CRUISES";
  SponsoredContentProductType["BRAND_RESULT_LISTING_FLIGHTS"] = "BRAND_RESULT_LISTING_FLIGHTS";
  SponsoredContentProductType["BRAND_RESULT_LISTING_LODGING"] = "BRAND_RESULT_LISTING_LODGING";
  SponsoredContentProductType["BRAND_RESULT_LISTING_LX"] = "BRAND_RESULT_LISTING_LX";
  SponsoredContentProductType["DESTINATION_EXPERIENCE"] = "DESTINATION_EXPERIENCE";
  SponsoredContentProductType["MULTI_LISTING_AD"] = "MULTI_LISTING_AD";
  SponsoredContentProductType["SPONSORED_PROPERTIES_CAROUSEL"] = "SPONSORED_PROPERTIES_CAROUSEL";
})(SponsoredContentProductType || (SponsoredContentProductType = {}));
/** Property search filtering options */
export var StayType;
(function (StayType) {
  StayType["CONVENTIONAL"] = "CONVENTIONAL";
  StayType["VACATION_RENTALS"] = "VACATION_RENTALS";
})(StayType || (StayType = {}));
export var StepReviewInlineEditingSheetButtonType;
(function (StepReviewInlineEditingSheetButtonType) {
  StepReviewInlineEditingSheetButtonType["PRIMARY"] = "PRIMARY";
  StepReviewInlineEditingSheetButtonType["SECONDARY"] = "SECONDARY";
})(StepReviewInlineEditingSheetButtonType || (StepReviewInlineEditingSheetButtonType = {}));
export var StrikeOutType;
(function (StrikeOutType) {
  StrikeOutType["ATTACH"] = "ATTACH";
  StrikeOutType["INVALID"] = "INVALID";
  StrikeOutType["LOYALTY"] = "LOYALTY";
  StrikeOutType["PACKAGE"] = "PACKAGE";
  StrikeOutType["PRICE_SURVEY"] = "PRICE_SURVEY";
  StrikeOutType["STANDALONE"] = "STANDALONE";
})(StrikeOutType || (StrikeOutType = {}));
export var StructureType;
(function (StructureType) {
  StructureType["AGRITOURISM"] = "AGRITOURISM";
  StructureType["ALL_INCLUSIVE"] = "ALL_INCLUSIVE";
  StructureType["APARTMENT"] = "APARTMENT";
  StructureType["APART_HOTEL"] = "APART_HOTEL";
  StructureType["BED_AND_BREAKFAST"] = "BED_AND_BREAKFAST";
  StructureType["CABIN"] = "CABIN";
  StructureType["CAPSULE_HOTEL"] = "CAPSULE_HOTEL";
  StructureType["CARAVAN_PARK"] = "CARAVAN_PARK";
  StructureType["CASTLE"] = "CASTLE";
  StructureType["CHALET"] = "CHALET";
  StructureType["CONDO"] = "CONDO";
  StructureType["CONDO_RESORT"] = "CONDO_RESORT";
  StructureType["COTTAGE"] = "COTTAGE";
  StructureType["COUNTRY_HOUSE"] = "COUNTRY_HOUSE";
  StructureType["CRUISE"] = "CRUISE";
  StructureType["ECO_HOTEL"] = "ECO_HOTEL";
  StructureType["GUEST_HOUSE"] = "GUEST_HOUSE";
  StructureType["HOLIDAY_PARK"] = "HOLIDAY_PARK";
  StructureType["HOSTAL"] = "HOSTAL";
  StructureType["HOSTEL"] = "HOSTEL";
  StructureType["HOTEL"] = "HOTEL";
  StructureType["HOTEL_RESORT"] = "HOTEL_RESORT";
  StructureType["HOUSE_BOAT"] = "HOUSE_BOAT";
  StructureType["INN"] = "INN";
  StructureType["LODGE"] = "LODGE";
  StructureType["LONGHOUSE"] = "LONGHOUSE";
  StructureType["MOBILE_HOME"] = "MOBILE_HOME";
  StructureType["MOTEL"] = "MOTEL";
  StructureType["OVERWATER"] = "OVERWATER";
  StructureType["PALACE"] = "PALACE";
  StructureType["PENSION"] = "PENSION";
  StructureType["POUSADA_BRAZIL"] = "POUSADA_BRAZIL";
  StructureType["POUSADA_PORTUGAL"] = "POUSADA_PORTUGAL";
  StructureType["RANCH"] = "RANCH";
  StructureType["RESIDENCE"] = "RESIDENCE";
  StructureType["RIAD"] = "RIAD";
  StructureType["RYOKAN"] = "RYOKAN";
  StructureType["SAFARI"] = "SAFARI";
  StructureType["SERVICED_APARTMENT"] = "SERVICED_APARTMENT";
  StructureType["TOWNHOUSE"] = "TOWNHOUSE";
  StructureType["TRADITIONAL_BUILDING"] = "TRADITIONAL_BUILDING";
  StructureType["TREE_HOUSE"] = "TREE_HOUSE";
  StructureType["UNKNOWN"] = "UNKNOWN";
  StructureType["VACATION_HOME"] = "VACATION_HOME";
  StructureType["VACATION_RENTAL"] = "VACATION_RENTAL";
  StructureType["VACATION_RENTALS"] = "VACATION_RENTALS";
  StructureType["VILLA"] = "VILLA";
  StructureType["VIP"] = "VIP";
})(StructureType || (StructureType = {}));
export var SupplyContentDescriptionSectionName;
(function (SupplyContentDescriptionSectionName) {
  SupplyContentDescriptionSectionName["PROPERTY_NAME"] = "PROPERTY_NAME";
  SupplyContentDescriptionSectionName["HEADLINE"] = "HEADLINE";
  SupplyContentDescriptionSectionName["DESCRIPTION"] = "DESCRIPTION";
  SupplyContentDescriptionSectionName["MANUAL_TRANSLATION"] = "MANUAL_TRANSLATION";
  SupplyContentDescriptionSectionName["ABOUT_YOU"] = "ABOUT_YOU";
  SupplyContentDescriptionSectionName["WHY_THIS_PROPERTY"] = "WHY_THIS_PROPERTY";
  SupplyContentDescriptionSectionName["UNIQUE_BENEFITS"] = "UNIQUE_BENEFITS";
  SupplyContentDescriptionSectionName["BATHROOMS_ADDITIONAL_INFO"] = "BATHROOMS_ADDITIONAL_INFO";
  SupplyContentDescriptionSectionName["BEDROOMS_ADDITIONAL_INFO"] = "BEDROOMS_ADDITIONAL_INFO";
  SupplyContentDescriptionSectionName["PROPERTY_ADDITIONAL_INFO"] = "PROPERTY_ADDITIONAL_INFO";
  SupplyContentDescriptionSectionName["PROPERTY_TYPE"] = "PROPERTY_TYPE";
  SupplyContentDescriptionSectionName["INTERIOR_SIZE"] = "INTERIOR_SIZE";
  SupplyContentDescriptionSectionName["SUITABILITY_AMENITY"] = "SUITABILITY_AMENITY";
})(SupplyContentDescriptionSectionName || (SupplyContentDescriptionSectionName = {}));
export var SupplyContentManualTranslationOperation;
(function (SupplyContentManualTranslationOperation) {
  SupplyContentManualTranslationOperation["ADD"] = "ADD";
  SupplyContentManualTranslationOperation["DELETE"] = "DELETE";
  SupplyContentManualTranslationOperation["UPDATE"] = "UPDATE";
})(SupplyContentManualTranslationOperation || (SupplyContentManualTranslationOperation = {}));
export var SupplyContractingAlignment;
(function (SupplyContractingAlignment) {
  SupplyContractingAlignment["CENTER"] = "CENTER";
  SupplyContractingAlignment["LEFT"] = "LEFT";
})(SupplyContractingAlignment || (SupplyContractingAlignment = {}));
export var SupplyContractingDividerType;
(function (SupplyContractingDividerType) {
  SupplyContractingDividerType["WIDE"] = "WIDE";
})(SupplyContractingDividerType || (SupplyContractingDividerType = {}));
export var SupplyContractingResponseStatus;
(function (SupplyContractingResponseStatus) {
  SupplyContractingResponseStatus["FAIL"] = "FAIL";
  SupplyContractingResponseStatus["SUCCESS"] = "SUCCESS";
})(SupplyContractingResponseStatus || (SupplyContractingResponseStatus = {}));
export var SupplyContractingToolbarNavType;
(function (SupplyContractingToolbarNavType) {
  SupplyContractingToolbarNavType["BACK"] = "BACK";
  SupplyContractingToolbarNavType["CLOSE"] = "CLOSE";
})(SupplyContractingToolbarNavType || (SupplyContractingToolbarNavType = {}));
export var SupplyDashboardType;
(function (SupplyDashboardType) {
  SupplyDashboardType["DASHBOARD"] = "DASHBOARD";
  SupplyDashboardType["LEGACY"] = "LEGACY";
})(SupplyDashboardType || (SupplyDashboardType = {}));
export var SupplyNavigationHeaderMenuType;
(function (SupplyNavigationHeaderMenuType) {
  SupplyNavigationHeaderMenuType["PROPERTY_DETAILS"] = "PROPERTY_DETAILS";
  SupplyNavigationHeaderMenuType["NOTIFICATIONS"] = "NOTIFICATIONS";
  SupplyNavigationHeaderMenuType["PROPERTY_FILTER"] = "PROPERTY_FILTER";
  SupplyNavigationHeaderMenuType["SEARCH"] = "SEARCH";
})(SupplyNavigationHeaderMenuType || (SupplyNavigationHeaderMenuType = {}));
export var SupplyOnboardingAvailabilityType;
(function (SupplyOnboardingAvailabilityType) {
  SupplyOnboardingAvailabilityType["OPEN"] = "OPEN";
  SupplyOnboardingAvailabilityType["BLOCK"] = "BLOCK";
})(SupplyOnboardingAvailabilityType || (SupplyOnboardingAvailabilityType = {}));
export var SupplyOnboardingButtonType;
(function (SupplyOnboardingButtonType) {
  SupplyOnboardingButtonType["BACK"] = "BACK";
  SupplyOnboardingButtonType["SKIP"] = "SKIP";
  SupplyOnboardingButtonType["NEXT"] = "NEXT";
  SupplyOnboardingButtonType["LINK"] = "LINK";
  SupplyOnboardingButtonType["DONE"] = "DONE";
})(SupplyOnboardingButtonType || (SupplyOnboardingButtonType = {}));
export var SupplyOnboardingTipCardId;
(function (SupplyOnboardingTipCardId) {
  SupplyOnboardingTipCardId["AMENITIES"] = "AMENITIES";
  SupplyOnboardingTipCardId["REGULATORY"] = "REGULATORY";
  SupplyOnboardingTipCardId["PHOTOS"] = "PHOTOS";
  SupplyOnboardingTipCardId["HEADLINE"] = "HEADLINE";
  SupplyOnboardingTipCardId["DESCRIPTION"] = "DESCRIPTION";
})(SupplyOnboardingTipCardId || (SupplyOnboardingTipCardId = {}));
export var SupplyPartnerLifeCycleStage;
(function (SupplyPartnerLifeCycleStage) {
  SupplyPartnerLifeCycleStage["LIFE_CYCLE_STAGE_BABY"] = "LIFE_CYCLE_STAGE_BABY";
  SupplyPartnerLifeCycleStage["LIFE_CYCLE_STAGE_KID"] = "LIFE_CYCLE_STAGE_KID";
  SupplyPartnerLifeCycleStage["LIFE_CYCLE_STAGE_TEENAGER"] = "LIFE_CYCLE_STAGE_TEENAGER";
  SupplyPartnerLifeCycleStage["LIFE_CYCLE_STAGE_YOUNG_ADULT"] = "LIFE_CYCLE_STAGE_YOUNG_ADULT";
  SupplyPartnerLifeCycleStage["LIFE_CYCLE_STAGE_ALL_GROWN_UP"] = "LIFE_CYCLE_STAGE_ALL_GROWN_UP";
  SupplyPartnerLifeCycleStage["UNRECOGNIZED"] = "UNRECOGNIZED";
})(SupplyPartnerLifeCycleStage || (SupplyPartnerLifeCycleStage = {}));
export var SupplyPaymentDetailsExpandoPositioning;
(function (SupplyPaymentDetailsExpandoPositioning) {
  SupplyPaymentDetailsExpandoPositioning["TRAILING"] = "TRAILING";
  SupplyPaymentDetailsExpandoPositioning["LEADING"] = "LEADING";
})(SupplyPaymentDetailsExpandoPositioning || (SupplyPaymentDetailsExpandoPositioning = {}));
export var SupplyPaymentDisplayToolbarIcon;
(function (SupplyPaymentDisplayToolbarIcon) {
  SupplyPaymentDisplayToolbarIcon["CLOSE"] = "CLOSE";
  SupplyPaymentDisplayToolbarIcon["BACK"] = "BACK";
})(SupplyPaymentDisplayToolbarIcon || (SupplyPaymentDisplayToolbarIcon = {}));
export var SupplyPhotosActionType;
(function (SupplyPhotosActionType) {
  SupplyPhotosActionType["PRIMARY_BUTTON"] = "PRIMARY_BUTTON";
  SupplyPhotosActionType["SECONDARY_BUTTON"] = "SECONDARY_BUTTON";
  SupplyPhotosActionType["TOOL_BAR_BUTTON"] = "TOOL_BAR_BUTTON";
  SupplyPhotosActionType["LINK_BUTTON"] = "LINK_BUTTON";
  SupplyPhotosActionType["LINK"] = "LINK";
  SupplyPhotosActionType["TERTIARY_BUTTON"] = "TERTIARY_BUTTON";
})(SupplyPhotosActionType || (SupplyPhotosActionType = {}));
export var SupplyPhotosPhotoStatus;
(function (SupplyPhotosPhotoStatus) {
  SupplyPhotosPhotoStatus["ACTIVE"] = "ACTIVE";
  SupplyPhotosPhotoStatus["PROCESSING"] = "PROCESSING";
})(SupplyPhotosPhotoStatus || (SupplyPhotosPhotoStatus = {}));
export var SupplyProductCreationPopularRateType;
(function (SupplyProductCreationPopularRateType) {
  SupplyProductCreationPopularRateType["BREAKFAST"] = "BREAKFAST";
  SupplyProductCreationPopularRateType["NONREFUNDABLE"] = "NONREFUNDABLE";
  SupplyProductCreationPopularRateType["PACKAGE"] = "PACKAGE";
  SupplyProductCreationPopularRateType["MOD"] = "MOD";
})(SupplyProductCreationPopularRateType || (SupplyProductCreationPopularRateType = {}));
export var SupplyProductCreationRoomNameAttributeCategoryName;
(function (SupplyProductCreationRoomNameAttributeCategoryName) {
  SupplyProductCreationRoomNameAttributeCategoryName["ROOM_TYPE"] = "ROOM_TYPE";
  SupplyProductCreationRoomNameAttributeCategoryName["ROOM_CLASS"] = "ROOM_CLASS";
  SupplyProductCreationRoomNameAttributeCategoryName["BEDROOM_DETAILS"] = "BEDROOM_DETAILS";
  SupplyProductCreationRoomNameAttributeCategoryName["OTHER_BEDROOM_DETAILS"] = "OTHER_BEDROOM_DETAILS";
  SupplyProductCreationRoomNameAttributeCategoryName["VIEW"] = "VIEW";
  SupplyProductCreationRoomNameAttributeCategoryName["SMOKING_POLICY"] = "SMOKING_POLICY";
  SupplyProductCreationRoomNameAttributeCategoryName["ACCESSIBILITY"] = "ACCESSIBILITY";
  SupplyProductCreationRoomNameAttributeCategoryName["FEATURE_AMENITY"] = "FEATURE_AMENITY";
  SupplyProductCreationRoomNameAttributeCategoryName["OUTDOOR_SPACE"] = "OUTDOOR_SPACE";
  SupplyProductCreationRoomNameAttributeCategoryName["AREA"] = "AREA";
})(SupplyProductCreationRoomNameAttributeCategoryName || (SupplyProductCreationRoomNameAttributeCategoryName = {}));
export var SupplyPromotionNotificationType;
(function (SupplyPromotionNotificationType) {
  SupplyPromotionNotificationType["ERROR"] = "ERROR";
  SupplyPromotionNotificationType["SUCCESS"] = "SUCCESS";
})(SupplyPromotionNotificationType || (SupplyPromotionNotificationType = {}));
export var SupplyPromotionReservationMode;
(function (SupplyPromotionReservationMode) {
  SupplyPromotionReservationMode["ADVANCED"] = "ADVANCED";
  SupplyPromotionReservationMode["STANDARD"] = "STANDARD";
})(SupplyPromotionReservationMode || (SupplyPromotionReservationMode = {}));
export var SupplyPromotionResponseStatus;
(function (SupplyPromotionResponseStatus) {
  SupplyPromotionResponseStatus["FAIL"] = "FAIL";
  SupplyPromotionResponseStatus["SUCCESS"] = "SUCCESS";
})(SupplyPromotionResponseStatus || (SupplyPromotionResponseStatus = {}));
export var SupplyQuickActionComparisonType;
(function (SupplyQuickActionComparisonType) {
  SupplyQuickActionComparisonType["LESSER_THAN"] = "LESSER_THAN";
  SupplyQuickActionComparisonType["GREATER_THAN"] = "GREATER_THAN";
})(SupplyQuickActionComparisonType || (SupplyQuickActionComparisonType = {}));
/** Allowed operations on subscribe event */
export var SupplyQuickActionElementVisibility;
(function (SupplyQuickActionElementVisibility) {
  SupplyQuickActionElementVisibility["HIDE_SELF"] = "HIDE_SELF";
  SupplyQuickActionElementVisibility["SHOW_SELF"] = "SHOW_SELF";
})(SupplyQuickActionElementVisibility || (SupplyQuickActionElementVisibility = {}));
/** Allowed operations on subscribe event */
export var SupplyQuickActionFieldProcessorOperation;
(function (SupplyQuickActionFieldProcessorOperation) {
  SupplyQuickActionFieldProcessorOperation["PLAIN_REPLACE"] = "PLAIN_REPLACE";
  SupplyQuickActionFieldProcessorOperation["PERCENT_CALC_AND_REPLACE"] = "PERCENT_CALC_AND_REPLACE";
  SupplyQuickActionFieldProcessorOperation["SUBTRACT_AND_REPLACE"] = "SUBTRACT_AND_REPLACE";
})(SupplyQuickActionFieldProcessorOperation || (SupplyQuickActionFieldProcessorOperation = {}));
export var SupplyQuickActionFieldSetDirection;
(function (SupplyQuickActionFieldSetDirection) {
  SupplyQuickActionFieldSetDirection["HORIZONTAL"] = "HORIZONTAL";
  SupplyQuickActionFieldSetDirection["VERTICAL"] = "VERTICAL";
})(SupplyQuickActionFieldSetDirection || (SupplyQuickActionFieldSetDirection = {}));
/**
 * SupplyQuickActionSpacingSize
 * Note: only 0X_HALF, 1X, 2X, 3X, 4X, 6X, 12X, 16X are supported for desktop.
 * Using other sizes may render differently different on mobile and desktop
 */
export var SupplyQuickActionSpacingSize;
(function (SupplyQuickActionSpacingSize) {
  SupplyQuickActionSpacingSize["SPACING__0X__HALF"] = "SPACING__0X__HALF";
  SupplyQuickActionSpacingSize["SPACING__10X"] = "SPACING__10X";
  SupplyQuickActionSpacingSize["SPACING__11X"] = "SPACING__11X";
  SupplyQuickActionSpacingSize["SPACING__12X"] = "SPACING__12X";
  SupplyQuickActionSpacingSize["SPACING__14X"] = "SPACING__14X";
  SupplyQuickActionSpacingSize["SPACING__16X"] = "SPACING__16X";
  SupplyQuickActionSpacingSize["SPACING__1X"] = "SPACING__1X";
  SupplyQuickActionSpacingSize["SPACING__2X"] = "SPACING__2X";
  SupplyQuickActionSpacingSize["SPACING__3X"] = "SPACING__3X";
  SupplyQuickActionSpacingSize["SPACING__4X"] = "SPACING__4X";
  SupplyQuickActionSpacingSize["SPACING__5X"] = "SPACING__5X";
  SupplyQuickActionSpacingSize["SPACING__6X"] = "SPACING__6X";
  SupplyQuickActionSpacingSize["SPACING__8X"] = "SPACING__8X";
})(SupplyQuickActionSpacingSize || (SupplyQuickActionSpacingSize = {}));
export var SupplyQuickActionTableItemCellType;
(function (SupplyQuickActionTableItemCellType) {
  SupplyQuickActionTableItemCellType["NORMAL"] = "NORMAL";
  SupplyQuickActionTableItemCellType["STRIKETHROUGH"] = "STRIKETHROUGH";
})(SupplyQuickActionTableItemCellType || (SupplyQuickActionTableItemCellType = {}));
export var SupplyRegulatoryStatus;
(function (SupplyRegulatoryStatus) {
  SupplyRegulatoryStatus["COMPLIANT"] = "COMPLIANT";
  SupplyRegulatoryStatus["NOT_COMPLIANT"] = "NOT_COMPLIANT";
  SupplyRegulatoryStatus["NONE"] = "NONE";
})(SupplyRegulatoryStatus || (SupplyRegulatoryStatus = {}));
export var SupplyReservationDetailsComponentType;
(function (SupplyReservationDetailsComponentType) {
  SupplyReservationDetailsComponentType["STAY_DETAILS"] = "STAY_DETAILS";
  SupplyReservationDetailsComponentType["PARTNER_NOTES"] = "PARTNER_NOTES";
  SupplyReservationDetailsComponentType["RENTAL_AGREEMENT"] = "RENTAL_AGREEMENT";
  SupplyReservationDetailsComponentType["PAYMENT_SUMMARY"] = "PAYMENT_SUMMARY";
  SupplyReservationDetailsComponentType["PAYMENT_SCHEDULE"] = "PAYMENT_SCHEDULE";
  SupplyReservationDetailsComponentType["TRAVELER_INFO"] = "TRAVELER_INFO";
  SupplyReservationDetailsComponentType["DAMAGE_DEPOSIT"] = "DAMAGE_DEPOSIT";
  SupplyReservationDetailsComponentType["PAYMENT_DETAILS"] = "PAYMENT_DETAILS";
  SupplyReservationDetailsComponentType["ACCESS_INSTRUCTIONS"] = "ACCESS_INSTRUCTIONS";
  SupplyReservationDetailsComponentType["CANCELLATION_POLICY"] = "CANCELLATION_POLICY";
  SupplyReservationDetailsComponentType["MINI_AVAILABILITY_CALENDAR"] = "MINI_AVAILABILITY_CALENDAR";
})(SupplyReservationDetailsComponentType || (SupplyReservationDetailsComponentType = {}));
export var SupplyReservationStatusType;
(function (SupplyReservationStatusType) {
  SupplyReservationStatusType["BOOKED"] = "BOOKED";
  SupplyReservationStatusType["INQUIRY"] = "INQUIRY";
  SupplyReservationStatusType["CANCELED"] = "CANCELED";
  SupplyReservationStatusType["ARRIVING_TODAY"] = "ARRIVING_TODAY";
  SupplyReservationStatusType["CURRENT_STAY"] = "CURRENT_STAY";
  SupplyReservationStatusType["POST_STAY"] = "POST_STAY";
  SupplyReservationStatusType["CANCELLATION_REQUEST"] = "CANCELLATION_REQUEST";
  SupplyReservationStatusType["REQUEST_WITHDRAWN"] = "REQUEST_WITHDRAWN";
  SupplyReservationStatusType["PRE_APPROVED"] = "PRE_APPROVED";
  SupplyReservationStatusType["BOOKING_REQUEST"] = "BOOKING_REQUEST";
  SupplyReservationStatusType["BOOKING_REQUEST_EXPIRED"] = "BOOKING_REQUEST_EXPIRED";
  SupplyReservationStatusType["PRE_APPROVAL_EXPIRED"] = "PRE_APPROVAL_EXPIRED";
  SupplyReservationStatusType["BOOKING_REQUEST_DECLINED"] = "BOOKING_REQUEST_DECLINED";
  SupplyReservationStatusType["UNKNOWN"] = "UNKNOWN";
})(SupplyReservationStatusType || (SupplyReservationStatusType = {}));
export var SupplyReservationsAccessTypes;
(function (SupplyReservationsAccessTypes) {
  SupplyReservationsAccessTypes["SMART_LOCK"] = "SMART_LOCK";
  SupplyReservationsAccessTypes["LOCKBOX"] = "LOCKBOX";
  SupplyReservationsAccessTypes["KEYPAD"] = "KEYPAD";
  SupplyReservationsAccessTypes["PICKUP"] = "PICKUP";
  SupplyReservationsAccessTypes["DOORMAN"] = "DOORMAN";
  SupplyReservationsAccessTypes["OTHER"] = "OTHER";
})(SupplyReservationsAccessTypes || (SupplyReservationsAccessTypes = {}));
export var SupplyReservationsActionType;
(function (SupplyReservationsActionType) {
  SupplyReservationsActionType["ACCESS_INSTRUCTIONS_ADD"] = "ACCESS_INSTRUCTIONS_ADD";
  SupplyReservationsActionType["ACCESS_INSTRUCTIONS_EDIT"] = "ACCESS_INSTRUCTIONS_EDIT";
  SupplyReservationsActionType["HEADER_MARK_AS_UNREAD"] = "HEADER_MARK_AS_UNREAD";
  SupplyReservationsActionType["HEADER_MARK_AS_READ"] = "HEADER_MARK_AS_READ";
  SupplyReservationsActionType["HEADER_MARK_AS_SPAM"] = "HEADER_MARK_AS_SPAM";
  SupplyReservationsActionType["HEADER_ARCHIVE"] = "HEADER_ARCHIVE";
  SupplyReservationsActionType["HEADER_UNARCHIVE"] = "HEADER_UNARCHIVE";
  SupplyReservationsActionType["HEADER_PRINT"] = "HEADER_PRINT";
  SupplyReservationsActionType["HEADER_SHARE"] = "HEADER_SHARE";
  SupplyReservationsActionType["HEADER_FEEDBACK"] = "HEADER_FEEDBACK";
  SupplyReservationsActionType["HEADER_HELP_CENTER"] = "HEADER_HELP_CENTER";
  SupplyReservationsActionType["HEADER_DETAILS"] = "HEADER_DETAILS";
  SupplyReservationsActionType["DAMAGE_PROTECTION_REPORT_DAMAGE"] = "DAMAGE_PROTECTION_REPORT_DAMAGE";
  SupplyReservationsActionType["DAMAGE_PROTECTION_REFUND_DEPOSIT"] = "DAMAGE_PROTECTION_REFUND_DEPOSIT";
  SupplyReservationsActionType["DAMAGE_PROTECTION_SEE_POLICY"] = "DAMAGE_PROTECTION_SEE_POLICY";
  SupplyReservationsActionType["DAMAGE_PROTECTION_SEE_DAMAGE_REPORT"] = "DAMAGE_PROTECTION_SEE_DAMAGE_REPORT";
  SupplyReservationsActionType["DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL"] = "DAMAGE_PROTECTION_REPORT_DAMAGE_EXTERNAL";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_MARK_PAID"] = "PAYMENT_SCHEDULE_MARK_PAID";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_RESEND_REQUEST"] = "PAYMENT_SCHEDULE_RESEND_REQUEST";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST"] = "PAYMENT_SCHEDULE_CANCEL_PAYMENT_REQUEST";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE"] = "PAYMENT_SCHEDULE_EDIT_PAYMENT_SCHEDULE";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE"] = "PAYMENT_SCHEDULE_ADD_EXTRA_CHARGE";
  SupplyReservationsActionType["PAYMENT_SCHEDULE_SEND_A_REFUND"] = "PAYMENT_SCHEDULE_SEND_A_REFUND";
  SupplyReservationsActionType["GUEST_INFO_EMAIL"] = "GUEST_INFO_EMAIL";
  SupplyReservationsActionType["GUEST_INFO_PHONE"] = "GUEST_INFO_PHONE";
  SupplyReservationsActionType["GUEST_INFO_VIEW_PROFILE"] = "GUEST_INFO_VIEW_PROFILE";
  SupplyReservationsActionType["RENTAL_AGREEMENT_VIEW"] = "RENTAL_AGREEMENT_VIEW";
  SupplyReservationsActionType["PAYMENT_SUMMARY_VIEW"] = "PAYMENT_SUMMARY_VIEW";
  SupplyReservationsActionType["NOTES_EDIT"] = "NOTES_EDIT";
  SupplyReservationsActionType["NOTES_ADD"] = "NOTES_ADD";
  SupplyReservationsActionType["NOTES_CANCEL"] = "NOTES_CANCEL";
  SupplyReservationsActionType["NOTES_SAVE"] = "NOTES_SAVE";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_BACK"] = "RESERVATION_MODIFIERS_BACK";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_CLOSE"] = "RESERVATION_MODIFIERS_CLOSE";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_NEXT"] = "RESERVATION_MODIFIERS_NEXT";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_SAVE_NO_SHOW"] = "RESERVATION_MODIFIERS_SAVE_NO_SHOW";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_SAVE_CANCEL"] = "RESERVATION_MODIFIERS_SAVE_CANCEL";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_SAVE_CHANGE_DATES"] = "RESERVATION_MODIFIERS_SAVE_CHANGE_DATES";
  SupplyReservationsActionType["RESERVATION_MODIFIERS_SAVE_GUEST_SATISFACTION_REFUND"] = "RESERVATION_MODIFIERS_SAVE_GUEST_SATISFACTION_REFUND";
  SupplyReservationsActionType["STAY_DETAILS_CHANGE_DATES"] = "STAY_DETAILS_CHANGE_DATES";
  SupplyReservationsActionType["STAY_DETAILS_EDIT_RESERVATION"] = "STAY_DETAILS_EDIT_RESERVATION";
  SupplyReservationsActionType["STAY_DETAILS_CHANGE_TIME"] = "STAY_DETAILS_CHANGE_TIME";
  SupplyReservationsActionType["STAY_DETAILS_ADD_REMOVE_GUESTS"] = "STAY_DETAILS_ADD_REMOVE_GUESTS";
  SupplyReservationsActionType["STAY_DETAILS_CANCEL_RESERVATION"] = "STAY_DETAILS_CANCEL_RESERVATION";
  SupplyReservationsActionType["STAY_DETAILS_CONFIRM_CANCELLATION"] = "STAY_DETAILS_CONFIRM_CANCELLATION";
  SupplyReservationsActionType["STAY_DETAILS_SEND_PRE_APPROVAL"] = "STAY_DETAILS_SEND_PRE_APPROVAL";
  SupplyReservationsActionType["STAY_DETAILS_EDIT_QUOTE"] = "STAY_DETAILS_EDIT_QUOTE";
  SupplyReservationsActionType["STAY_DETAILS_ACCEPT"] = "STAY_DETAILS_ACCEPT";
  SupplyReservationsActionType["STAY_DETAILS_DECLINE"] = "STAY_DETAILS_DECLINE";
  SupplyReservationsActionType["STAY_DETAILS_EDIT_DATES"] = "STAY_DETAILS_EDIT_DATES";
  SupplyReservationsActionType["STAY_DETAILS_CANCEL_PRE_APPROVAL"] = "STAY_DETAILS_CANCEL_PRE_APPROVAL";
  SupplyReservationsActionType["EVC_MANAGE_RESERVATION_DETAILS"] = "EVC_MANAGE_RESERVATION_DETAILS";
  SupplyReservationsActionType["EVC_MANAGE_CARD_MORE_INFO"] = "EVC_MANAGE_CARD_MORE_INFO";
  SupplyReservationsActionType["EVC_MANAGE_CARD_SEARCH"] = "EVC_MANAGE_CARD_SEARCH";
  SupplyReservationsActionType["EVC_MANAGE_FEEDBACK"] = "EVC_MANAGE_FEEDBACK";
  SupplyReservationsActionType["AUTO_CANCEL_WAIVERS_SAVE_CHANGES"] = "AUTO_CANCEL_WAIVERS_SAVE_CHANGES";
  SupplyReservationsActionType["AUTO_CANCEL_WAIVERS_CANCEL_CHANGES"] = "AUTO_CANCEL_WAIVERS_CANCEL_CHANGES";
})(SupplyReservationsActionType || (SupplyReservationsActionType = {}));
export var SupplyReservationsEvcManagerTabType;
(function (SupplyReservationsEvcManagerTabType) {
  SupplyReservationsEvcManagerTabType["EVC_LOOKUP"] = "EVC_LOOKUP";
  SupplyReservationsEvcManagerTabType["EVC_MANAGE"] = "EVC_MANAGE";
})(SupplyReservationsEvcManagerTabType || (SupplyReservationsEvcManagerTabType = {}));
export var SupplyReservationsEvcManagerTableType;
(function (SupplyReservationsEvcManagerTableType) {
  SupplyReservationsEvcManagerTableType["EVC_CARDS_TO_REFUND"] = "EVC_CARDS_TO_REFUND";
  SupplyReservationsEvcManagerTableType["EVC_CARDS_TO_CHARGE"] = "EVC_CARDS_TO_CHARGE";
})(SupplyReservationsEvcManagerTableType || (SupplyReservationsEvcManagerTableType = {}));
export var SupplyReservationsEvcSearchInputType;
(function (SupplyReservationsEvcSearchInputType) {
  SupplyReservationsEvcSearchInputType["EVC_NUMBER"] = "EVC_NUMBER";
  SupplyReservationsEvcSearchInputType["RESERVATION_ID"] = "RESERVATION_ID";
})(SupplyReservationsEvcSearchInputType || (SupplyReservationsEvcSearchInputType = {}));
export var SupplyReservationsInteractionChatImageSize;
(function (SupplyReservationsInteractionChatImageSize) {
  SupplyReservationsInteractionChatImageSize["SMALL"] = "SMALL";
  SupplyReservationsInteractionChatImageSize["LARGE"] = "LARGE";
})(SupplyReservationsInteractionChatImageSize || (SupplyReservationsInteractionChatImageSize = {}));
export var SupplyReservationsInteractionListActionDialogFooterActionType;
(function (SupplyReservationsInteractionListActionDialogFooterActionType) {
  SupplyReservationsInteractionListActionDialogFooterActionType["PRIMARY"] = "PRIMARY";
  SupplyReservationsInteractionListActionDialogFooterActionType["TERTIARY"] = "TERTIARY";
})(SupplyReservationsInteractionListActionDialogFooterActionType || (SupplyReservationsInteractionListActionDialogFooterActionType = {}));
export var SupplyReservationsInteractionListColumnHorizontalAlign;
(function (SupplyReservationsInteractionListColumnHorizontalAlign) {
  SupplyReservationsInteractionListColumnHorizontalAlign["LEFT"] = "LEFT";
  SupplyReservationsInteractionListColumnHorizontalAlign["RIGHT"] = "RIGHT";
  SupplyReservationsInteractionListColumnHorizontalAlign["CENTER"] = "CENTER";
  SupplyReservationsInteractionListColumnHorizontalAlign["JUSTIFY"] = "JUSTIFY";
  SupplyReservationsInteractionListColumnHorizontalAlign["JUSTIFY_ALL"] = "JUSTIFY_ALL";
  SupplyReservationsInteractionListColumnHorizontalAlign["START"] = "START";
  SupplyReservationsInteractionListColumnHorizontalAlign["END"] = "END";
  SupplyReservationsInteractionListColumnHorizontalAlign["MATCH_PARENT"] = "MATCH_PARENT";
})(SupplyReservationsInteractionListColumnHorizontalAlign || (SupplyReservationsInteractionListColumnHorizontalAlign = {}));
export var SupplyReservationsInteractionListColumnVerticalAlign;
(function (SupplyReservationsInteractionListColumnVerticalAlign) {
  SupplyReservationsInteractionListColumnVerticalAlign["BASELINE"] = "BASELINE";
  SupplyReservationsInteractionListColumnVerticalAlign["SUB"] = "SUB";
  SupplyReservationsInteractionListColumnVerticalAlign["SUPER"] = "SUPER";
  SupplyReservationsInteractionListColumnVerticalAlign["TEXT_TOP"] = "TEXT_TOP";
  SupplyReservationsInteractionListColumnVerticalAlign["TEXT_BOTTOM"] = "TEXT_BOTTOM";
  SupplyReservationsInteractionListColumnVerticalAlign["MIDDLE"] = "MIDDLE";
  SupplyReservationsInteractionListColumnVerticalAlign["TOP"] = "TOP";
  SupplyReservationsInteractionListColumnVerticalAlign["BOTTOM"] = "BOTTOM";
})(SupplyReservationsInteractionListColumnVerticalAlign || (SupplyReservationsInteractionListColumnVerticalAlign = {}));
export var SupplyReservationsInteractionListItemAction;
(function (SupplyReservationsInteractionListItemAction) {
  SupplyReservationsInteractionListItemAction["UNREAD"] = "UNREAD";
  SupplyReservationsInteractionListItemAction["READ"] = "READ";
  SupplyReservationsInteractionListItemAction["SPAM"] = "SPAM";
  SupplyReservationsInteractionListItemAction["ARCHIVE"] = "ARCHIVE";
  SupplyReservationsInteractionListItemAction["UNARCHIVE"] = "UNARCHIVE";
})(SupplyReservationsInteractionListItemAction || (SupplyReservationsInteractionListItemAction = {}));
export var SupplyReservationsInteractionListSwipeActionEdge;
(function (SupplyReservationsInteractionListSwipeActionEdge) {
  SupplyReservationsInteractionListSwipeActionEdge["LEADING"] = "LEADING";
  SupplyReservationsInteractionListSwipeActionEdge["TRAILING"] = "TRAILING";
})(SupplyReservationsInteractionListSwipeActionEdge || (SupplyReservationsInteractionListSwipeActionEdge = {}));
export var SupplyReservationsInteractionMessageMode;
(function (SupplyReservationsInteractionMessageMode) {
  SupplyReservationsInteractionMessageMode["INCOMING"] = "INCOMING";
  SupplyReservationsInteractionMessageMode["OUTGOING"] = "OUTGOING";
})(SupplyReservationsInteractionMessageMode || (SupplyReservationsInteractionMessageMode = {}));
export var SupplyReservationsInteractionViewType;
(function (SupplyReservationsInteractionViewType) {
  SupplyReservationsInteractionViewType["LIST_VIEW"] = "LIST_VIEW";
  SupplyReservationsInteractionViewType["CAROUSEL_VIEW"] = "CAROUSEL_VIEW";
})(SupplyReservationsInteractionViewType || (SupplyReservationsInteractionViewType = {}));
export var SupplyReservationsInteractionsSort;
(function (SupplyReservationsInteractionsSort) {
  SupplyReservationsInteractionsSort["GUEST_ASC"] = "GUEST_ASC";
  SupplyReservationsInteractionsSort["GUEST_DESC"] = "GUEST_DESC";
  SupplyReservationsInteractionsSort["CHECKIN_DATE_ASC"] = "CHECKIN_DATE_ASC";
  SupplyReservationsInteractionsSort["CHECKIN_DATE_DESC"] = "CHECKIN_DATE_DESC";
  SupplyReservationsInteractionsSort["RECEIVED_ON_ASC"] = "RECEIVED_ON_ASC";
  SupplyReservationsInteractionsSort["RECEIVED_ON_DESC"] = "RECEIVED_ON_DESC";
})(SupplyReservationsInteractionsSort || (SupplyReservationsInteractionsSort = {}));
export var SupplyReservationsPaymentDetailsExpandoPositioning;
(function (SupplyReservationsPaymentDetailsExpandoPositioning) {
  SupplyReservationsPaymentDetailsExpandoPositioning["TRAILING"] = "TRAILING";
  SupplyReservationsPaymentDetailsExpandoPositioning["LEADING"] = "LEADING";
})(SupplyReservationsPaymentDetailsExpandoPositioning || (SupplyReservationsPaymentDetailsExpandoPositioning = {}));
export var SupplyReservationsPaymentDisplayToolbarIcon;
(function (SupplyReservationsPaymentDisplayToolbarIcon) {
  SupplyReservationsPaymentDisplayToolbarIcon["CLOSE"] = "CLOSE";
  SupplyReservationsPaymentDisplayToolbarIcon["BACK"] = "BACK";
})(SupplyReservationsPaymentDisplayToolbarIcon || (SupplyReservationsPaymentDisplayToolbarIcon = {}));
export var SupplyReservationsRenderHint;
(function (SupplyReservationsRenderHint) {
  SupplyReservationsRenderHint["COLLAPSED"] = "COLLAPSED";
  SupplyReservationsRenderHint["LIST"] = "LIST";
})(SupplyReservationsRenderHint || (SupplyReservationsRenderHint = {}));
export var SupplyReservationsStayDetailsMessageTimerType;
(function (SupplyReservationsStayDetailsMessageTimerType) {
  SupplyReservationsStayDetailsMessageTimerType["COUNT_DOWN"] = "COUNT_DOWN";
  SupplyReservationsStayDetailsMessageTimerType["COUNT_UP"] = "COUNT_UP";
})(SupplyReservationsStayDetailsMessageTimerType || (SupplyReservationsStayDetailsMessageTimerType = {}));
export var SupplyRoomTypeMappingSpacingSize;
(function (SupplyRoomTypeMappingSpacingSize) {
  SupplyRoomTypeMappingSpacingSize["SPACING__0X__HALF"] = "SPACING__0X__HALF";
  SupplyRoomTypeMappingSpacingSize["SPACING__1X"] = "SPACING__1X";
  SupplyRoomTypeMappingSpacingSize["SPACING__2X"] = "SPACING__2X";
  SupplyRoomTypeMappingSpacingSize["SPACING__3X"] = "SPACING__3X";
  SupplyRoomTypeMappingSpacingSize["SPACING__4X"] = "SPACING__4X";
  SupplyRoomTypeMappingSpacingSize["SPACING__5X"] = "SPACING__5X";
  SupplyRoomTypeMappingSpacingSize["SPACING__6X"] = "SPACING__6X";
  SupplyRoomTypeMappingSpacingSize["SPACING__8X"] = "SPACING__8X";
})(SupplyRoomTypeMappingSpacingSize || (SupplyRoomTypeMappingSpacingSize = {}));
export var SupplyRoomTypeMappingUserAction;
(function (SupplyRoomTypeMappingUserAction) {
  SupplyRoomTypeMappingUserAction["CONFIRM"] = "CONFIRM";
  SupplyRoomTypeMappingUserAction["REJECT"] = "REJECT";
})(SupplyRoomTypeMappingUserAction || (SupplyRoomTypeMappingUserAction = {}));
export var SupplyRoomTypeMappingViewPhase;
(function (SupplyRoomTypeMappingViewPhase) {
  SupplyRoomTypeMappingViewPhase["VIEW_PROPERTY_MAPPING"] = "VIEW_PROPERTY_MAPPING";
  SupplyRoomTypeMappingViewPhase["VIEW_ROOM_TYPE_MAPPING"] = "VIEW_ROOM_TYPE_MAPPING";
})(SupplyRoomTypeMappingViewPhase || (SupplyRoomTypeMappingViewPhase = {}));
export var SupplyRoomTypeMappingViewType;
(function (SupplyRoomTypeMappingViewType) {
  SupplyRoomTypeMappingViewType["DIALOG"] = "DIALOG";
})(SupplyRoomTypeMappingViewType || (SupplyRoomTypeMappingViewType = {}));
export var SupplyScoreFactorBmlAuditItemObervationType;
(function (SupplyScoreFactorBmlAuditItemObervationType) {
  SupplyScoreFactorBmlAuditItemObervationType["RATE"] = "RATE";
  SupplyScoreFactorBmlAuditItemObervationType["AVAILABILITY"] = "AVAILABILITY";
})(SupplyScoreFactorBmlAuditItemObervationType || (SupplyScoreFactorBmlAuditItemObervationType = {}));
export var SupplyScoreFactorNotificationType;
(function (SupplyScoreFactorNotificationType) {
  SupplyScoreFactorNotificationType["DOING_GREAT"] = "DOING_GREAT";
  SupplyScoreFactorNotificationType["NEEDS_ATTENTION"] = "NEEDS_ATTENTION";
  SupplyScoreFactorNotificationType["NEXT_BEST_FACTOR"] = "NEXT_BEST_FACTOR";
})(SupplyScoreFactorNotificationType || (SupplyScoreFactorNotificationType = {}));
/** Description of a SupplyScoreMessaging's card */
export var SupplyScoreMessagingTheme;
(function (SupplyScoreMessagingTheme) {
  SupplyScoreMessagingTheme["MESSAGE"] = "MESSAGE";
  SupplyScoreMessagingTheme["INFO"] = "INFO";
  SupplyScoreMessagingTheme["WARNING"] = "WARNING";
})(SupplyScoreMessagingTheme || (SupplyScoreMessagingTheme = {}));
export var SupplyTaxesType;
(function (SupplyTaxesType) {
  SupplyTaxesType["AMOUNT"] = "AMOUNT";
  SupplyTaxesType["PERCENT"] = "PERCENT";
  SupplyTaxesType["NOT_INCLUDED"] = "NOT_INCLUDED";
})(SupplyTaxesType || (SupplyTaxesType = {}));
/** Represents the selection status of a tab */
export var TabStatus;
(function (TabStatus) {
  /** Represents the status of not being selected */
  TabStatus["NOT_SELECTED"] = "NOT_SELECTED";
  /** Represents the status of being selected */
  TabStatus["SELECTED"] = "SELECTED";
})(TabStatus || (TabStatus = {}));
/** The text direction of the locale e.g. ltr or rtl */
export var TextDirection;
(function (TextDirection) {
  TextDirection["LTR"] = "LTR";
  TextDirection["RTL"] = "RTL";
})(TextDirection || (TextDirection = {}));
/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export var TextTheme;
(function (TextTheme) {
  TextTheme["EMPHASIS"] = "EMPHASIS";
  TextTheme["INVERSE"] = "INVERSE";
  TextTheme["LOYALTY"] = "LOYALTY";
  TextTheme["NEGATIVE"] = "NEGATIVE";
  TextTheme["POSITIVE"] = "POSITIVE";
  TextTheme["PRIMARY"] = "PRIMARY";
  TextTheme["SECONDARY"] = "SECONDARY";
})(TextTheme || (TextTheme = {}));
/** Used to highlight or convey information. For example, Payable amount in the price summary module of the checkout page. */
export var TextWeight;
(function (TextWeight) {
  TextWeight["BOLD"] = "BOLD";
  TextWeight["MEDIUM"] = "MEDIUM";
  TextWeight["REGULAR"] = "REGULAR";
})(TextWeight || (TextWeight = {}));
export var Theme;
(function (Theme) {
  Theme["BRAND"] = "BRAND";
  Theme["BRANDED_DEAL"] = "BRANDED_DEAL";
  Theme["DEAL_ADD_ON"] = "DEAL_ADD_ON";
  Theme["DEAL_BUNDLED"] = "DEAL_BUNDLED";
  Theme["DEAL_GENERIC"] = "DEAL_GENERIC";
  Theme["DEAL_MEMBER"] = "DEAL_MEMBER";
  Theme["FAMILY_FRIENDLY"] = "FAMILY_FRIENDLY";
  Theme["INFO"] = "INFO";
  Theme["LINK"] = "LINK";
  Theme["LOYALTY"] = "LOYALTY";
  Theme["LOYALTY_EXTRA_HIGH_TIER"] = "LOYALTY_EXTRA_HIGH_TIER";
  Theme["LOYALTY_GLOBAL_EXTRA_HIGH_TIER"] = "LOYALTY_GLOBAL_EXTRA_HIGH_TIER";
  Theme["LOYALTY_GLOBAL_HIGH_TIER"] = "LOYALTY_GLOBAL_HIGH_TIER";
  Theme["LOYALTY_GLOBAL_LOW_TIER"] = "LOYALTY_GLOBAL_LOW_TIER";
  Theme["LOYALTY_GLOBAL_MIDDLE_TIER"] = "LOYALTY_GLOBAL_MIDDLE_TIER";
  Theme["LOYALTY_HIGH_TIER"] = "LOYALTY_HIGH_TIER";
  Theme["LOYALTY_LOW_TIER"] = "LOYALTY_LOW_TIER";
  Theme["LOYALTY_MIDDLE_TIER"] = "LOYALTY_MIDDLE_TIER";
  Theme["NOTIFICATION"] = "NOTIFICATION";
  Theme["PROMOTED"] = "PROMOTED";
  Theme["SAVED"] = "SAVED";
  Theme["SPONSORED"] = "SPONSORED";
  Theme["STANDARD"] = "STANDARD";
  Theme["SUCCESS"] = "SUCCESS";
  Theme["SUCCESS_MEDIUM"] = "SUCCESS_MEDIUM";
  Theme["SUPPLIER_PROMO"] = "SUPPLIER_PROMO";
  Theme["URGENT"] = "URGENT";
  Theme["VIEWED"] = "VIEWED";
  Theme["VIP"] = "VIP";
  Theme["VIP_ACCESS"] = "VIP_ACCESS";
})(Theme || (Theme = {}));
export var ToolbarNavType;
(function (ToolbarNavType) {
  ToolbarNavType["CLOSE"] = "CLOSE";
  ToolbarNavType["EXPAND_DOWN"] = "EXPAND_DOWN";
  ToolbarNavType["EXPAND_UP"] = "EXPAND_UP";
})(ToolbarNavType || (ToolbarNavType = {}));
export var TopTaskTypes;
(function (TopTaskTypes) {
  TopTaskTypes["BOOKING_REQUEST"] = "BOOKING_REQUEST";
  TopTaskTypes["INQUIRY"] = "INQUIRY";
  TopTaskTypes["CURRENT_STAY"] = "CURRENT_STAY";
  TopTaskTypes["ARRIVING"] = "ARRIVING";
  TopTaskTypes["CANCELLATION_REQUEST"] = "CANCELLATION_REQUEST";
  TopTaskTypes["RATE_TRAVELER"] = "RATE_TRAVELER";
  TopTaskTypes["CANCELLATION"] = "CANCELLATION";
  TopTaskTypes["BANK_DETAILS"] = "BANK_DETAILS";
  TopTaskTypes["TAX_FORM"] = "TAX_FORM";
  TopTaskTypes["DIRECT_DEBIT"] = "DIRECT_DEBIT";
  TopTaskTypes["CONFIRM_IDENTITY"] = "CONFIRM_IDENTITY";
  TopTaskTypes["OPPORTUNITY"] = "OPPORTUNITY";
  TopTaskTypes["LOWER_FEES"] = "LOWER_FEES";
  TopTaskTypes["ADD_PHOTOS"] = "ADD_PHOTOS";
  TopTaskTypes["ADD_AMENITIES"] = "ADD_AMENITIES";
  TopTaskTypes["ADD_MINIMUM_STAY"] = "ADD_MINIMUM_STAY";
  TopTaskTypes["VRPAYMENTS_TIP"] = "VRPAYMENTS_TIP";
  TopTaskTypes["UPDATE_TAX_INFORMATION"] = "UPDATE_TAX_INFORMATION";
})(TopTaskTypes || (TopTaskTypes = {}));
/** Possible traveler details types */
export var TravelerDetailsType;
(function (TravelerDetailsType) {
  TravelerDetailsType["ADULT"] = "ADULT";
  TravelerDetailsType["CHILD"] = "CHILD";
  TravelerDetailsType["INFANT_IN_LAP"] = "INFANT_IN_LAP";
  TravelerDetailsType["INFANT_IN_SEAT"] = "INFANT_IN_SEAT";
})(TravelerDetailsType || (TravelerDetailsType = {}));
export var TravelerType;
(function (TravelerType) {
  TravelerType["BUSINESS"] = "BUSINESS";
  TravelerType["ECO_CERTIFIED"] = "ECO_CERTIFIED";
  TravelerType["FAMILY"] = "FAMILY";
  TravelerType["LGBT"] = "LGBT";
  TravelerType["ROMANTIC"] = "ROMANTIC";
})(TravelerType || (TravelerType = {}));
export var TripCareButtonAction;
(function (TripCareButtonAction) {
  TripCareButtonAction["BACK"] = "BACK";
  TripCareButtonAction["CANCEL_POLICY"] = "CANCEL_POLICY";
  TripCareButtonAction["DISMISS_POPUP"] = "DISMISS_POPUP";
  TripCareButtonAction["POPUP"] = "POPUP";
  TripCareButtonAction["RELOAD"] = "RELOAD";
})(TripCareButtonAction || (TripCareButtonAction = {}));
export var TripCareButtonState;
(function (TripCareButtonState) {
  TripCareButtonState["DISABLED"] = "DISABLED";
  TripCareButtonState["ENABLED"] = "ENABLED";
})(TripCareButtonState || (TripCareButtonState = {}));
export var TripCareLayoutStyle;
(function (TripCareLayoutStyle) {
  TripCareLayoutStyle["CARD_BORDER_TOP"] = "CARD_BORDER_TOP";
})(TripCareLayoutStyle || (TripCareLayoutStyle = {}));
export var TripCareListType;
(function (TripCareListType) {
  TripCareListType["BULLET"] = "BULLET";
  TripCareListType["NO_BULLET"] = "NO_BULLET";
  TripCareListType["NUMBERED"] = "NUMBERED";
})(TripCareListType || (TripCareListType = {}));
export var TripCarePhraseStyle;
(function (TripCarePhraseStyle) {
  TripCarePhraseStyle["BOLD"] = "BOLD";
  TripCarePhraseStyle["HR_DIVIDER_BOTTOM"] = "HR_DIVIDER_BOTTOM";
  TripCarePhraseStyle["HR_DIVIDER_TOP"] = "HR_DIVIDER_TOP";
  TripCarePhraseStyle["SIZE_100"] = "SIZE_100";
  TripCarePhraseStyle["SIZE_200"] = "SIZE_200";
  TripCarePhraseStyle["SIZE_300"] = "SIZE_300";
  TripCarePhraseStyle["SIZE_400"] = "SIZE_400";
  TripCarePhraseStyle["SIZE_500"] = "SIZE_500";
  TripCarePhraseStyle["SIZE_600"] = "SIZE_600";
  TripCarePhraseStyle["SIZE_700"] = "SIZE_700";
  TripCarePhraseStyle["SIZE_800"] = "SIZE_800";
  TripCarePhraseStyle["SIZE_900"] = "SIZE_900";
  TripCarePhraseStyle["SMALL"] = "SMALL";
  TripCarePhraseStyle["SPACING_FOUR"] = "SPACING_FOUR";
  TripCarePhraseStyle["SPACING_HALF"] = "SPACING_HALF";
  TripCarePhraseStyle["SPACING_ONE"] = "SPACING_ONE";
  TripCarePhraseStyle["SPACING_SIX"] = "SPACING_SIX";
  TripCarePhraseStyle["SPACING_THREE"] = "SPACING_THREE";
  TripCarePhraseStyle["SPACING_TWO"] = "SPACING_TWO";
  TripCarePhraseStyle["THEME_EMPHASIS"] = "THEME_EMPHASIS";
  TripCarePhraseStyle["THEME_NEGATIVE"] = "THEME_NEGATIVE";
  TripCarePhraseStyle["THEME_POSITIVE"] = "THEME_POSITIVE";
  TripCarePhraseStyle["WEIGHT_BOLD"] = "WEIGHT_BOLD";
  TripCarePhraseStyle["WEIGHT_MEDIUM"] = "WEIGHT_MEDIUM";
  TripCarePhraseStyle["WEIGHT_REGULAR"] = "WEIGHT_REGULAR";
})(TripCarePhraseStyle || (TripCarePhraseStyle = {}));
export var TripCarePhraseType;
(function (TripCarePhraseType) {
  TripCarePhraseType["BUTTON"] = "BUTTON";
  TripCarePhraseType["LINK"] = "LINK";
  TripCarePhraseType["TEXT"] = "TEXT";
})(TripCarePhraseType || (TripCarePhraseType = {}));
export var TripCreationEntryPoint;
(function (TripCreationEntryPoint) {
  TripCreationEntryPoint["HOTEL_SEARCH_RESULTS"] = "HOTEL_SEARCH_RESULTS";
  TripCreationEntryPoint["TRIPS_LIST"] = "TRIPS_LIST";
  TripCreationEntryPoint["TRIP_OVERVIEW"] = "TRIP_OVERVIEW";
})(TripCreationEntryPoint || (TripCreationEntryPoint = {}));
/** The TripEntity defines a list of supported items which can be can be saved to a trip. */
export var TripEntity;
(function (TripEntity) {
  TripEntity["ACTIVITY_PRODUCT"] = "ACTIVITY_PRODUCT";
  TripEntity["CAR_PRODUCT"] = "CAR_PRODUCT";
  TripEntity["FLIGHT_SEARCH"] = "FLIGHT_SEARCH";
  TripEntity["LODGING_PRODUCT"] = "LODGING_PRODUCT";
})(TripEntity || (TripEntity = {}));
export var TripIntentPersonType;
(function (TripIntentPersonType) {
  TripIntentPersonType["ADULT"] = "ADULT";
  TripIntentPersonType["CHILD"] = "CHILD";
})(TripIntentPersonType || (TripIntentPersonType = {}));
export var TripScheduleChangeStatus;
(function (TripScheduleChangeStatus) {
  TripScheduleChangeStatus["FLIGHT_SCHEDULE_CHANGE"] = "FLIGHT_SCHEDULE_CHANGE";
  TripScheduleChangeStatus["NO_CHANGE"] = "NO_CHANGE";
})(TripScheduleChangeStatus || (TripScheduleChangeStatus = {}));
/** Represents different avatar sizes. */
export var TripsAvatarSize;
(function (TripsAvatarSize) {
  TripsAvatarSize["EXTRA_LARGE"] = "EXTRA_LARGE";
  TripsAvatarSize["LARGE"] = "LARGE";
  TripsAvatarSize["MEDIUM"] = "MEDIUM";
  TripsAvatarSize["SMALL"] = "SMALL";
})(TripsAvatarSize || (TripsAvatarSize = {}));
/** Supported Trips badge themes */
export var TripsBadgeTheme;
(function (TripsBadgeTheme) {
  TripsBadgeTheme["LOYALTY_HIGH_TIER"] = "LOYALTY_HIGH_TIER";
  TripsBadgeTheme["LOYALTY_LOW_TIER"] = "LOYALTY_LOW_TIER";
  TripsBadgeTheme["LOYALTY_MIDDLE_TIER"] = "LOYALTY_MIDDLE_TIER";
  TripsBadgeTheme["SAVED"] = "SAVED";
  TripsBadgeTheme["STATUS_NEGATIVE"] = "STATUS_NEGATIVE";
  TripsBadgeTheme["STATUS_POSITIVE"] = "STATUS_POSITIVE";
  TripsBadgeTheme["UTILITY_STANDARD"] = "UTILITY_STANDARD";
  TripsBadgeTheme["VIP"] = "VIP";
})(TripsBadgeTheme || (TripsBadgeTheme = {}));
export var TripsButtonWidth;
(function (TripsButtonWidth) {
  TripsButtonWidth["MATCH_PARENT_CONTAINER"] = "MATCH_PARENT_CONTAINER";
  TripsButtonWidth["WRAP_CONTENT"] = "WRAP_CONTENT";
})(TripsButtonWidth || (TripsButtonWidth = {}));
export var TripsCalendarSelectionType;
(function (TripsCalendarSelectionType) {
  TripsCalendarSelectionType["SINGLE"] = "SINGLE";
  TripsCalendarSelectionType["START_AND_END"] = "START_AND_END";
  TripsCalendarSelectionType["START_AND_END_WITH_SAME_DATE"] = "START_AND_END_WITH_SAME_DATE";
})(TripsCalendarSelectionType || (TripsCalendarSelectionType = {}));
export var TripsCancellationType;
(function (TripsCancellationType) {
  TripsCancellationType["ACTIVITY"] = "ACTIVITY";
  TripsCancellationType["CAR"] = "CAR";
  TripsCancellationType["CRUISE"] = "CRUISE";
  TripsCancellationType["HOTEL"] = "HOTEL";
  TripsCancellationType["INSURANCE"] = "INSURANCE";
})(TripsCancellationType || (TripsCancellationType = {}));
/** Represents a TripsCard's selection/active state */
export var TripsCardState;
(function (TripsCardState) {
  TripsCardState["SELECTED"] = "SELECTED";
  TripsCardState["UNSELECTED"] = "UNSELECTED";
})(TripsCardState || (TripsCardState = {}));
/** Type of the drawer/sheet we want the client to render. CENTER is for desktop where we want to show the drawer as a center sheet/dialogBOTTOM is for app and mweb where the drawer comes from the bottom of the screenSIDE is for desktop where the sheet comes from the right of the screen. eg. plan, moveFULL is equivalent to sidesheet on mweb where the sheet will cover the whole page */
export var TripsComposableDrawerType;
(function (TripsComposableDrawerType) {
  TripsComposableDrawerType["BOTTOM"] = "BOTTOM";
  TripsComposableDrawerType["CENTER"] = "CENTER";
  TripsComposableDrawerType["FULL"] = "FULL";
  TripsComposableDrawerType["SIDE"] = "SIDE";
})(TripsComposableDrawerType || (TripsComposableDrawerType = {}));
/** Display theme for trips content */
export var TripsContentTheme;
(function (TripsContentTheme) {
  /** The Unordered List should be displayed with bullets */
  TripsContentTheme["BULLETS"] = "BULLETS";
  /** The Unordered List should be displayed with no bullets */
  TripsContentTheme["NO_BULLETS"] = "NO_BULLETS";
  /** The ordered list should always be displayed with numbers */
  TripsContentTheme["ORDERED"] = "ORDERED";
  /** Paragraph type list */
  TripsContentTheme["PARAGRAPH"] = "PARAGRAPH";
})(TripsContentTheme || (TripsContentTheme = {}));
export var TripsContentType;
(function (TripsContentType) {
  TripsContentType["PDF"] = "PDF";
})(TripsContentType || (TripsContentType = {}));
export var TripsContentUnorderedListTheme;
(function (TripsContentUnorderedListTheme) {
  /** The Unordered List should be displayed with bullets */
  TripsContentUnorderedListTheme["BULLETS"] = "BULLETS";
  /** The Unordered List should be displayed with no bullets */
  TripsContentUnorderedListTheme["NO_BULLETS"] = "NO_BULLETS";
})(TripsContentUnorderedListTheme || (TripsContentUnorderedListTheme = {}));
export var TripsCustomerNotificationTripScheduleChangeStatus;
(function (TripsCustomerNotificationTripScheduleChangeStatus) {
  TripsCustomerNotificationTripScheduleChangeStatus["FLIGHT_SCHEDULE_CHANGE"] = "FLIGHT_SCHEDULE_CHANGE";
  TripsCustomerNotificationTripScheduleChangeStatus["NO_CHANGE"] = "NO_CHANGE";
})(TripsCustomerNotificationTripScheduleChangeStatus || (TripsCustomerNotificationTripScheduleChangeStatus = {}));
/** Represents layout of buttons on a modal dialog */
export var TripsDialogButtonLayout;
(function (TripsDialogButtonLayout) {
  /** Dialog with horizontally stacked buttons */
  TripsDialogButtonLayout["INLINE"] = "INLINE";
  /** Dialog with vertically stacked buttons */
  TripsDialogButtonLayout["STACKED"] = "STACKED";
})(TripsDialogButtonLayout || (TripsDialogButtonLayout = {}));
export var TripsDisplayMode;
(function (TripsDisplayMode) {
  TripsDisplayMode["DEFAULT"] = "DEFAULT";
  TripsDisplayMode["MODAL"] = "MODAL";
  TripsDisplayMode["NEW_TAB"] = "NEW_TAB";
})(TripsDisplayMode || (TripsDisplayMode = {}));
/** Controls the width of the divider */
export var TripsDivider;
(function (TripsDivider) {
  TripsDivider["NARROW"] = "NARROW";
  TripsDivider["WIDE"] = "WIDE";
})(TripsDivider || (TripsDivider = {}));
export var TripsFindItineraryNumberView;
(function (TripsFindItineraryNumberView) {
  TripsFindItineraryNumberView["FIND_ITINERARY_OTHER_EMAIL"] = "FIND_ITINERARY_OTHER_EMAIL";
  TripsFindItineraryNumberView["FIND_ITINERARY_USER_EMAIL"] = "FIND_ITINERARY_USER_EMAIL";
  TripsFindItineraryNumberView["RESULT"] = "RESULT";
})(TripsFindItineraryNumberView || (TripsFindItineraryNumberView = {}));
/** This enum is to indicate what type of image is being placed into TripsFittedImageCard. UitkLayoutGrid would apply onto BARCODE */
export var TripsFittedImageType;
(function (TripsFittedImageType) {
  TripsFittedImageType["BARCODE"] = "BARCODE";
  TripsFittedImageType["E_FRANKING_STAMP"] = "E_FRANKING_STAMP";
  TripsFittedImageType["QR_CODE"] = "QR_CODE";
})(TripsFittedImageType || (TripsFittedImageType = {}));
/** This enum is to indicate whether the form container should have padding or it should fit right inside the parent component */
export var TripsFormContainerTheme;
(function (TripsFormContainerTheme) {
  TripsFormContainerTheme["MATCH_PARENT"] = "MATCH_PARENT";
  TripsFormContainerTheme["WRAP_CONTENT"] = "WRAP_CONTENT";
})(TripsFormContainerTheme || (TripsFormContainerTheme = {}));
export var TripsFormType;
(function (TripsFormType) {
  TripsFormType["CREATE_NEW_TRIP_FROM_ITEM"] = "CREATE_NEW_TRIP_FROM_ITEM";
  TripsFormType["FIND_ITINERARY_NUMBER"] = "FIND_ITINERARY_NUMBER";
  TripsFormType["INVITE"] = "INVITE";
  TripsFormType["SAVE_NEW_TRIP"] = "SAVE_NEW_TRIP";
  TripsFormType["SEARCH_BOOKING"] = "SEARCH_BOOKING";
  TripsFormType["SEND_ITINERARY_EMAIL"] = "SEND_ITINERARY_EMAIL";
  TripsFormType["UPDATE_TRIP"] = "UPDATE_TRIP";
})(TripsFormType || (TripsFormType = {}));
/** Enum to represent the number of lines that the text field supports. Defaulted to one line (single) if no changes are made. */
export var TripsInputType;
(function (TripsInputType) {
  TripsInputType["MULTIPLE"] = "MULTIPLE";
  TripsInputType["SINGLE"] = "SINGLE";
})(TripsInputType || (TripsInputType = {}));
export var TripsLinkTarget;
(function (TripsLinkTarget) {
  TripsLinkTarget["EXTERNAL"] = "EXTERNAL";
  TripsLinkTarget["INTERNAL"] = "INTERNAL";
})(TripsLinkTarget || (TripsLinkTarget = {}));
/** The type of map marker */
export var TripsMarkerType;
(function (TripsMarkerType) {
  TripsMarkerType["ActivityEventMarker"] = "ActivityEventMarker";
  TripsMarkerType["ActivityGuestPickupMarker"] = "ActivityGuestPickupMarker";
  TripsMarkerType["ActivityLocationMarker"] = "ActivityLocationMarker";
  TripsMarkerType["ActivityRedemptionMarker"] = "ActivityRedemptionMarker";
  TripsMarkerType["AirportMarker"] = "AirportMarker";
  TripsMarkerType["CarMarker"] = "CarMarker";
  TripsMarkerType["CruiseMarker"] = "CruiseMarker";
  TripsMarkerType["HotelMarker"] = "HotelMarker";
  TripsMarkerType["PlaceMarker"] = "PlaceMarker";
})(TripsMarkerType || (TripsMarkerType = {}));
/** The `TripsPlanSourceType` defines a list of supported pages or views from which an item can be saved to a trip. */
export var TripsPlanSourceType;
(function (TripsPlanSourceType) {
  TripsPlanSourceType["ACTIVITY_DETAILS"] = "ACTIVITY_DETAILS";
  TripsPlanSourceType["ACTIVITY_SEARCH"] = "ACTIVITY_SEARCH";
  TripsPlanSourceType["CAR_INFOSITE"] = "CAR_INFOSITE";
  TripsPlanSourceType["CAR_INFOSITE_V2"] = "CAR_INFOSITE_V2";
  TripsPlanSourceType["CAR_SEARCH"] = "CAR_SEARCH";
  TripsPlanSourceType["CAR_SEARCH_V2"] = "CAR_SEARCH_V2";
  TripsPlanSourceType["HOTEL_SEARCH"] = "HOTEL_SEARCH";
  TripsPlanSourceType["LODGING_DETAILS"] = "LODGING_DETAILS";
  TripsPlanSourceType["LODGING_SEARCH"] = "LODGING_SEARCH";
  TripsPlanSourceType["TRIP_OVERVIEW"] = "TRIP_OVERVIEW";
})(TripsPlanSourceType || (TripsPlanSourceType = {}));
export var TripsResponseStatus;
(function (TripsResponseStatus) {
  TripsResponseStatus["FAIL"] = "FAIL";
  TripsResponseStatus["SUCCESS"] = "SUCCESS";
})(TripsResponseStatus || (TripsResponseStatus = {}));
export var TripsSaveItemVariant;
(function (TripsSaveItemVariant) {
  TripsSaveItemVariant["CONTROL"] = "CONTROL";
  TripsSaveItemVariant["VARIANT_B"] = "VARIANT_B";
  TripsSaveItemVariant["VARIANT_C"] = "VARIANT_C";
})(TripsSaveItemVariant || (TripsSaveItemVariant = {}));
export var TripsScreen;
(function (TripsScreen) {
  TripsScreen["INVITE_LANDING_PAGE"] = "INVITE_LANDING_PAGE";
  TripsScreen["TRIP_ITEM_DETAILS"] = "TRIP_ITEM_DETAILS";
  TripsScreen["TRIP_ITEM_ITINERARY"] = "TRIP_ITEM_ITINERARY";
  TripsScreen["TRIP_ITEM_MANAGE_BOOKING"] = "TRIP_ITEM_MANAGE_BOOKING";
  TripsScreen["TRIP_ITEM_PRICING_REWARDS"] = "TRIP_ITEM_PRICING_REWARDS";
  TripsScreen["TRIP_ITEM_RECEIPT"] = "TRIP_ITEM_RECEIPT";
  TripsScreen["TRIP_MANAGE_GUESTS"] = "TRIP_MANAGE_GUESTS";
  TripsScreen["TRIP_OVERVIEW"] = "TRIP_OVERVIEW";
  TripsScreen["TRIP_OVERVIEW_ITINERARY"] = "TRIP_OVERVIEW_ITINERARY";
})(TripsScreen || (TripsScreen = {}));
export var TripsSearchBookingView;
(function (TripsSearchBookingView) {
  TripsSearchBookingView["SEARCH_BY_ITINERARY_NUMBER"] = "SEARCH_BY_ITINERARY_NUMBER";
  TripsSearchBookingView["SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL"] = "SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL";
  TripsSearchBookingView["SEARCH_RESULT"] = "SEARCH_RESULT";
})(TripsSearchBookingView || (TripsSearchBookingView = {}));
/** This enum represents the different fields that a TripsSignalPair relates to. */
export var TripsSignalPairKey;
(function (TripsSignalPairKey) {
  TripsSignalPairKey["PRIMARY"] = "PRIMARY";
  TripsSignalPairKey["SECONDARY"] = "SECONDARY";
  TripsSignalPairKey["STATUS"] = "STATUS";
})(TripsSignalPairKey || (TripsSignalPairKey = {}));
/** This enum represents the different category types of signals registered within the platform. */
export var TripsSignalType;
(function (TripsSignalType) {
  TripsSignalType["REMOVE"] = "REMOVE";
  TripsSignalType["UPDATE"] = "UPDATE";
})(TripsSignalType || (TripsSignalType = {}));
/** Represents a toggle's state. */
export var TripsToggleStatus;
(function (TripsToggleStatus) {
  TripsToggleStatus["DISABLED"] = "DISABLED";
  TripsToggleStatus["ENABLED"] = "ENABLED";
})(TripsToggleStatus || (TripsToggleStatus = {}));
/** Input to be used for fetching based on variant type of savings */
export var TripsUIAttachSavingsVariant;
(function (TripsUIAttachSavingsVariant) {
  TripsUIAttachSavingsVariant["BANNER"] = "BANNER";
  TripsUIAttachSavingsVariant["SHEET"] = "SHEET";
})(TripsUIAttachSavingsVariant || (TripsUIAttachSavingsVariant = {}));
/** Alignment for the buttons in a dialog's footer */
export var TripsUIDialogFooterButtonLayout;
(function (TripsUIDialogFooterButtonLayout) {
  TripsUIDialogFooterButtonLayout["INLINE"] = "INLINE";
  TripsUIDialogFooterButtonLayout["STACKED"] = "STACKED";
})(TripsUIDialogFooterButtonLayout || (TripsUIDialogFooterButtonLayout = {}));
export var TripsUIMessagingBannerCardTheme;
(function (TripsUIMessagingBannerCardTheme) {
  TripsUIMessagingBannerCardTheme["CRITICAL"] = "CRITICAL";
  TripsUIMessagingBannerCardTheme["DEFAULT"] = "DEFAULT";
  TripsUIMessagingBannerCardTheme["ERROR"] = "ERROR";
})(TripsUIMessagingBannerCardTheme || (TripsUIMessagingBannerCardTheme = {}));
export var TripsUIResponseStatus;
(function (TripsUIResponseStatus) {
  TripsUIResponseStatus["FAIL"] = "FAIL";
  TripsUIResponseStatus["SUCCESS"] = "SUCCESS";
})(TripsUIResponseStatus || (TripsUIResponseStatus = {}));
export var TripsViewType;
(function (TripsViewType) {
  TripsViewType["ACTIVITIES_SEARCH_RESULTS"] = "ACTIVITIES_SEARCH_RESULTS";
  TripsViewType["ASC_CANCEL"] = "ASC_CANCEL";
  TripsViewType["BOOKING_FLIGHT_CANCEL"] = "BOOKING_FLIGHT_CANCEL";
  TripsViewType["BOOKING_FLIGHT_CHANGE"] = "BOOKING_FLIGHT_CHANGE";
  TripsViewType["CAMPAIGNS"] = "CAMPAIGNS";
  TripsViewType["CARS_SEARCH_RESULTS"] = "CARS_SEARCH_RESULTS";
  TripsViewType["FILTERED"] = "FILTERED";
  TripsViewType["FIND_ITINERARY_BY_OTHER_EMAIL"] = "FIND_ITINERARY_BY_OTHER_EMAIL";
  TripsViewType["FIND_ITINERARY_BY_USER_EMAIL"] = "FIND_ITINERARY_BY_USER_EMAIL";
  TripsViewType["FLIGHTS_SEARCH_RESULTS"] = "FLIGHTS_SEARCH_RESULTS";
  TripsViewType["ITEM_DETAILS"] = "ITEM_DETAILS";
  TripsViewType["ITEM_ESSENTIAL_INFO"] = "ITEM_ESSENTIAL_INFO";
  TripsViewType["ITEM_PRICING_AND_REWARDS"] = "ITEM_PRICING_AND_REWARDS";
  TripsViewType["ITEM_VOUCHER"] = "ITEM_VOUCHER";
  TripsViewType["ITINERARY"] = "ITINERARY";
  TripsViewType["LOB_SELECTION_VIEW"] = "LOB_SELECTION_VIEW";
  TripsViewType["LODGING_SEARCH_RESULTS"] = "LODGING_SEARCH_RESULTS";
  TripsViewType["LOGIN_PROMPT"] = "LOGIN_PROMPT";
  TripsViewType["MANAGE_BOOKING"] = "MANAGE_BOOKING";
  TripsViewType["MANAGE_GUESTS"] = "MANAGE_GUESTS";
  TripsViewType["OVERVIEW"] = "OVERVIEW";
  TripsViewType["PACKAGES_FC_SEARCH_RESULTS"] = "PACKAGES_FC_SEARCH_RESULTS";
  TripsViewType["PACKAGES_FHC_SEARCH_RESULTS"] = "PACKAGES_FHC_SEARCH_RESULTS";
  TripsViewType["PACKAGES_HC_SEARCH_RESULTS"] = "PACKAGES_HC_SEARCH_RESULTS";
  TripsViewType["PACKAGES_HF_SEARCH_RESULTS"] = "PACKAGES_HF_SEARCH_RESULTS";
  TripsViewType["PENDING_INVITE"] = "PENDING_INVITE";
  TripsViewType["SEARCH_BY_ITINERARY_NUMBER"] = "SEARCH_BY_ITINERARY_NUMBER";
  TripsViewType["SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL"] = "SEARCH_BY_ITINERARY_NUMBER_AND_EMAIL";
  TripsViewType["TRIPS_LIST"] = "TRIPS_LIST";
})(TripsViewType || (TripsViewType = {}));
/** Specifies whether to open the link in the same user interface context or in a different context */
export var UILinkTarget;
(function (UILinkTarget) {
  UILinkTarget["EXTERNAL"] = "EXTERNAL";
  UILinkTarget["INTERNAL"] = "INTERNAL";
})(UILinkTarget || (UILinkTarget = {}));
export var UISignal;
(function (UISignal) {
  UISignal["BOOKING_SUCCESS"] = "BOOKING_SUCCESS";
  UISignal["DUPLICATE_REQUEST"] = "DUPLICATE_REQUEST";
  UISignal["GENERIC_DOWNSTREAM_ERROR"] = "GENERIC_DOWNSTREAM_ERROR";
  UISignal["INSURANCE_UNAVAILABLE"] = "INSURANCE_UNAVAILABLE";
  UISignal["INVALID_EMAIL"] = "INVALID_EMAIL";
  UISignal["OFFER_ADDED"] = "OFFER_ADDED";
  UISignal["OFFER_REMOVED"] = "OFFER_REMOVED";
  UISignal["OFFER_UNAVAILABLE"] = "OFFER_UNAVAILABLE";
  UISignal["PAYMENT_ERROR"] = "PAYMENT_ERROR";
  UISignal["PRICE_ADJUSTED"] = "PRICE_ADJUSTED";
  UISignal["PRICE_CHANGED"] = "PRICE_CHANGED";
  UISignal["UNKNOWN"] = "UNKNOWN";
  UISignal["UNRECOVERABLE_FAILURE"] = "UNRECOVERABLE_FAILURE";
})(UISignal || (UISignal = {}));
export var UniversalProfileAccountManagementOptionType;
(function (UniversalProfileAccountManagementOptionType) {
  UniversalProfileAccountManagementOptionType["TRAVELER_ARRANGER"] = "TRAVELER_ARRANGER";
})(UniversalProfileAccountManagementOptionType || (UniversalProfileAccountManagementOptionType = {}));
export var UniversalProfileAccountTakeOverWidgetTypeRequest;
(function (UniversalProfileAccountTakeOverWidgetTypeRequest) {
  UniversalProfileAccountTakeOverWidgetTypeRequest["CAPTCHA"] = "CAPTCHA";
  UniversalProfileAccountTakeOverWidgetTypeRequest["CSRF"] = "CSRF";
})(UniversalProfileAccountTakeOverWidgetTypeRequest || (UniversalProfileAccountTakeOverWidgetTypeRequest = {}));
export var UniversalProfileAnalyticsEventSubType;
(function (UniversalProfileAnalyticsEventSubType) {
  UniversalProfileAnalyticsEventSubType["BLURRED"] = "BLURRED";
  UniversalProfileAnalyticsEventSubType["FOCUSED"] = "FOCUSED";
  UniversalProfileAnalyticsEventSubType["INPUTTED"] = "INPUTTED";
  UniversalProfileAnalyticsEventSubType["SUCCEEDED"] = "SUCCEEDED";
})(UniversalProfileAnalyticsEventSubType || (UniversalProfileAnalyticsEventSubType = {}));
export var UniversalProfileCategorySwitchOperator;
(function (UniversalProfileCategorySwitchOperator) {
  UniversalProfileCategorySwitchOperator["OFF"] = "OFF";
  UniversalProfileCategorySwitchOperator["ON"] = "ON";
})(UniversalProfileCategorySwitchOperator || (UniversalProfileCategorySwitchOperator = {}));
export var UniversalProfileCheckboxAnalyticsEventSubType;
(function (UniversalProfileCheckboxAnalyticsEventSubType) {
  UniversalProfileCheckboxAnalyticsEventSubType["DESELECTED"] = "DESELECTED";
  UniversalProfileCheckboxAnalyticsEventSubType["SELECTED"] = "SELECTED";
})(UniversalProfileCheckboxAnalyticsEventSubType || (UniversalProfileCheckboxAnalyticsEventSubType = {}));
export var UniversalProfileClientType;
(function (UniversalProfileClientType) {
  UniversalProfileClientType["ANDROID"] = "ANDROID";
  UniversalProfileClientType["IOS"] = "IOS";
  UniversalProfileClientType["WEB"] = "WEB";
})(UniversalProfileClientType || (UniversalProfileClientType = {}));
export var UniversalProfileCommunicationPreferencesCategoryType;
(function (UniversalProfileCommunicationPreferencesCategoryType) {
  UniversalProfileCommunicationPreferencesCategoryType["ACCOUNT_SUPPORT"] = "ACCOUNT_SUPPORT";
  UniversalProfileCommunicationPreferencesCategoryType["CONFIRMATION_AND_CRITICAL_UPDATES"] = "CONFIRMATION_AND_CRITICAL_UPDATES";
  UniversalProfileCommunicationPreferencesCategoryType["OFFERS_AND_INSPIRATION"] = "OFFERS_AND_INSPIRATION";
  UniversalProfileCommunicationPreferencesCategoryType["ONE_KEY"] = "ONE_KEY";
  UniversalProfileCommunicationPreferencesCategoryType["ONE_KEY_MONTHLY_STATEMENTS"] = "ONE_KEY_MONTHLY_STATEMENTS";
  UniversalProfileCommunicationPreferencesCategoryType["ONE_KEY_REWARD_ACCOUNT_UPDATES"] = "ONE_KEY_REWARD_ACCOUNT_UPDATES";
  UniversalProfileCommunicationPreferencesCategoryType["PARTNERS_OFFERS_WITH_US"] = "PARTNERS_OFFERS_WITH_US";
  UniversalProfileCommunicationPreferencesCategoryType["PERSONALIZED_TRIP_RECOMMENDATIONS"] = "PERSONALIZED_TRIP_RECOMMENDATIONS";
  UniversalProfileCommunicationPreferencesCategoryType["REVIEWS"] = "REVIEWS";
  UniversalProfileCommunicationPreferencesCategoryType["SURVEYS"] = "SURVEYS";
  UniversalProfileCommunicationPreferencesCategoryType["THE_TRAVEL_EDIT"] = "THE_TRAVEL_EDIT";
  UniversalProfileCommunicationPreferencesCategoryType["TRIP_BOARD_ACTIVITY"] = "TRIP_BOARD_ACTIVITY";
  UniversalProfileCommunicationPreferencesCategoryType["TRIP_PLANNING_ASSISTANCE"] = "TRIP_PLANNING_ASSISTANCE";
})(UniversalProfileCommunicationPreferencesCategoryType || (UniversalProfileCommunicationPreferencesCategoryType = {}));
export var UniversalProfileCommunicationPreferencesFormType;
(function (UniversalProfileCommunicationPreferencesFormType) {
  UniversalProfileCommunicationPreferencesFormType["COMMUNICATION_PREFERENCE_CATEGORY_FORM"] = "COMMUNICATION_PREFERENCE_CATEGORY_FORM";
  UniversalProfileCommunicationPreferencesFormType["COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM"] = "COMMUNICATION_PREFERENCE_MANAGE_EMAIL_FORM";
  UniversalProfileCommunicationPreferencesFormType["COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM"] = "COMMUNICATION_PREFERENCE_UNSUBSCRIBE_CATEGORY_FORM";
  UniversalProfileCommunicationPreferencesFormType["COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM"] = "COMMUNICATION_PREFERENCE_UNSUBSCRIBE_STRICT_FORM";
})(UniversalProfileCommunicationPreferencesFormType || (UniversalProfileCommunicationPreferencesFormType = {}));
export var UniversalProfileDashboardOptionType;
(function (UniversalProfileDashboardOptionType) {
  UniversalProfileDashboardOptionType["COMMUNICATIONS"] = "COMMUNICATIONS";
  UniversalProfileDashboardOptionType["COUPONS"] = "COUPONS";
  UniversalProfileDashboardOptionType["CREDITS"] = "CREDITS";
  UniversalProfileDashboardOptionType["HELP"] = "HELP";
  UniversalProfileDashboardOptionType["LEGAL"] = "LEGAL";
  UniversalProfileDashboardOptionType["PAYMENTS"] = "PAYMENTS";
  UniversalProfileDashboardOptionType["PROFILE"] = "PROFILE";
  UniversalProfileDashboardOptionType["REVIEWS"] = "REVIEWS";
  UniversalProfileDashboardOptionType["SETTINGS"] = "SETTINGS";
})(UniversalProfileDashboardOptionType || (UniversalProfileDashboardOptionType = {}));
export var UniversalProfileDependsOnFieldIdentificationCriteriaOperator;
(function (UniversalProfileDependsOnFieldIdentificationCriteriaOperator) {
  UniversalProfileDependsOnFieldIdentificationCriteriaOperator["EXCLUDES"] = "EXCLUDES";
  UniversalProfileDependsOnFieldIdentificationCriteriaOperator["INCLUDES"] = "INCLUDES";
})(UniversalProfileDependsOnFieldIdentificationCriteriaOperator || (UniversalProfileDependsOnFieldIdentificationCriteriaOperator = {}));
export var UniversalProfileExperienceType;
(function (UniversalProfileExperienceType) {
  UniversalProfileExperienceType["ADDITIONAL_TRAVELER"] = "ADDITIONAL_TRAVELER";
  UniversalProfileExperienceType["COMMUNICATION_PREFERENCES"] = "COMMUNICATION_PREFERENCES";
  UniversalProfileExperienceType["HELP"] = "HELP";
  UniversalProfileExperienceType["LEGAL"] = "LEGAL";
  UniversalProfileExperienceType["PROFILE"] = "PROFILE";
  UniversalProfileExperienceType["SETTINGS"] = "SETTINGS";
})(UniversalProfileExperienceType || (UniversalProfileExperienceType = {}));
export var UniversalProfileInformationFormType;
(function (UniversalProfileInformationFormType) {
  UniversalProfileInformationFormType["COMMUNICATION_PREFERENCE_UNSUB"] = "COMMUNICATION_PREFERENCE_UNSUB";
  UniversalProfileInformationFormType["UPDATE_ADDITIONAL_TRAVELER_INFO"] = "UPDATE_ADDITIONAL_TRAVELER_INFO";
  UniversalProfileInformationFormType["UPDATE_BASIC_INFORMATION"] = "UPDATE_BASIC_INFORMATION";
  UniversalProfileInformationFormType["UPDATE_COMMUNICATION_PREFERENCE"] = "UPDATE_COMMUNICATION_PREFERENCE";
  UniversalProfileInformationFormType["UPDATE_CONTACT_INFORMATION"] = "UPDATE_CONTACT_INFORMATION";
  UniversalProfileInformationFormType["UPDATE_CONTACT_INFORMATION_EMAIL"] = "UPDATE_CONTACT_INFORMATION_EMAIL";
  UniversalProfileInformationFormType["UPDATE_CONTACT_INFORMATION_PHONE_NUMBER"] = "UPDATE_CONTACT_INFORMATION_PHONE_NUMBER";
  UniversalProfileInformationFormType["UPDATE_TRAVELER_DOCUMENT"] = "UPDATE_TRAVELER_DOCUMENT";
  UniversalProfileInformationFormType["UPDATE_TSA_INFORMATION"] = "UPDATE_TSA_INFORMATION";
})(UniversalProfileInformationFormType || (UniversalProfileInformationFormType = {}));
export var UniversalProfileLocationAndLanguageOptionType;
(function (UniversalProfileLocationAndLanguageOptionType) {
  UniversalProfileLocationAndLanguageOptionType["COUNTY"] = "COUNTY";
  UniversalProfileLocationAndLanguageOptionType["CURRENCY"] = "CURRENCY";
  UniversalProfileLocationAndLanguageOptionType["LANGUAGE"] = "LANGUAGE";
})(UniversalProfileLocationAndLanguageOptionType || (UniversalProfileLocationAndLanguageOptionType = {}));
export var UniversalProfileLoginInformationSettingsOptionType;
(function (UniversalProfileLoginInformationSettingsOptionType) {
  UniversalProfileLoginInformationSettingsOptionType["CHANGE_PASSWORD"] = "CHANGE_PASSWORD";
  UniversalProfileLoginInformationSettingsOptionType["CONNECTED_DEVICES"] = "CONNECTED_DEVICES";
  UniversalProfileLoginInformationSettingsOptionType["EMAIL"] = "EMAIL";
})(UniversalProfileLoginInformationSettingsOptionType || (UniversalProfileLoginInformationSettingsOptionType = {}));
export var UniversalProfileMoreDetailsOptionType;
(function (UniversalProfileMoreDetailsOptionType) {
  UniversalProfileMoreDetailsOptionType["AIRPORT_SECURITY"] = "AIRPORT_SECURITY";
  UniversalProfileMoreDetailsOptionType["FLIGHT_PREFERENCES"] = "FLIGHT_PREFERENCES";
  UniversalProfileMoreDetailsOptionType["REWARD_PROGRAM"] = "REWARD_PROGRAM";
  UniversalProfileMoreDetailsOptionType["TRAVELER_DOCUMENTS"] = "TRAVELER_DOCUMENTS";
})(UniversalProfileMoreDetailsOptionType || (UniversalProfileMoreDetailsOptionType = {}));
export var UniversalProfilePreferencesOptionType;
(function (UniversalProfilePreferencesOptionType) {
  UniversalProfilePreferencesOptionType["COUNTRY"] = "COUNTRY";
  UniversalProfilePreferencesOptionType["CURRENCY"] = "CURRENCY";
  UniversalProfilePreferencesOptionType["DISPLAY_APPEARANCE"] = "DISPLAY_APPEARANCE";
  UniversalProfilePreferencesOptionType["LANGUAGE"] = "LANGUAGE";
})(UniversalProfilePreferencesOptionType || (UniversalProfilePreferencesOptionType = {}));
export var UniversalProfileSettingsFormType;
(function (UniversalProfileSettingsFormType) {
  UniversalProfileSettingsFormType["DELETE_ACCOUNT"] = "DELETE_ACCOUNT";
  UniversalProfileSettingsFormType["UPDATE_COUNTRY"] = "UPDATE_COUNTRY";
  UniversalProfileSettingsFormType["UPDATE_EMAIL"] = "UPDATE_EMAIL";
  UniversalProfileSettingsFormType["UPDATE_LANGUAGE"] = "UPDATE_LANGUAGE";
  UniversalProfileSettingsFormType["UPDATE_PASSWORD"] = "UPDATE_PASSWORD";
})(UniversalProfileSettingsFormType || (UniversalProfileSettingsFormType = {}));
export var UniversalProfileSubExperienceType;
(function (UniversalProfileSubExperienceType) {
  UniversalProfileSubExperienceType["COMMUNICATION_PREFERENCES_EXPEDIA"] = "COMMUNICATION_PREFERENCES_EXPEDIA";
  UniversalProfileSubExperienceType["COMMUNICATION_PREFERENCES_HOTELS"] = "COMMUNICATION_PREFERENCES_HOTELS";
  UniversalProfileSubExperienceType["COMMUNICATION_PREFERENCES_VRBO"] = "COMMUNICATION_PREFERENCES_VRBO";
  UniversalProfileSubExperienceType["VISIT_HELP_CENTER"] = "VISIT_HELP_CENTER";
})(UniversalProfileSubExperienceType || (UniversalProfileSubExperienceType = {}));
export var UpdateAction;
(function (UpdateAction) {
  UpdateAction["ACCEPT"] = "ACCEPT";
  UpdateAction["SHARE"] = "SHARE";
})(UpdateAction || (UpdateAction = {}));
/** Enum for holding values with reference to page stack history */
export var UpdateHistory;
(function (UpdateHistory) {
  UpdateHistory["REMOVE"] = "REMOVE";
})(UpdateHistory || (UpdateHistory = {}));
export var UpdateTripType;
(function (UpdateTripType) {
  UpdateTripType["ADD"] = "ADD";
  UpdateTripType["REMOVE"] = "REMOVE";
})(UpdateTripType || (UpdateTripType = {}));
export var UriClassification;
(function (UriClassification) {
  UriClassification["CLASSIFICATION_DEALS"] = "CLASSIFICATION_DEALS";
  UriClassification["CLASSIFICATION_INVALID"] = "CLASSIFICATION_INVALID";
  UriClassification["CLASSIFICATION_LEGAL"] = "CLASSIFICATION_LEGAL";
})(UriClassification || (UriClassification = {}));
/** Represents the status of response */
export var VirtualAgentCheckoutStatus;
(function (VirtualAgentCheckoutStatus) {
  VirtualAgentCheckoutStatus["FAILED"] = "FAILED";
  VirtualAgentCheckoutStatus["SUCCESS"] = "SUCCESS";
})(VirtualAgentCheckoutStatus || (VirtualAgentCheckoutStatus = {}));
export var VirtualAgentControlAnalyticEventSubType;
(function (VirtualAgentControlAnalyticEventSubType) {
  VirtualAgentControlAnalyticEventSubType["BLURRED"] = "BLURRED";
  VirtualAgentControlAnalyticEventSubType["FOCUSED"] = "FOCUSED";
  VirtualAgentControlAnalyticEventSubType["INPUTTED"] = "INPUTTED";
  VirtualAgentControlAnalyticEventSubType["SUCCEEDED"] = "SUCCEEDED";
})(VirtualAgentControlAnalyticEventSubType || (VirtualAgentControlAnalyticEventSubType = {}));
/** Represents event type, used by the mutation to send event data */
export var VirtualAgentControlEventType;
(function (VirtualAgentControlEventType) {
  /** Represents a conversation read event type */
  VirtualAgentControlEventType["CONVERSATION_READ"] = "CONVERSATION_READ";
  /** Represents a typing indicator event type */
  VirtualAgentControlEventType["TYPING_INDICATOR"] = "TYPING_INDICATOR";
})(VirtualAgentControlEventType || (VirtualAgentControlEventType = {}));
export var VirtualAgentControlMessageTriggerLocation;
(function (VirtualAgentControlMessageTriggerLocation) {
  VirtualAgentControlMessageTriggerLocation["EXTERNAL"] = "EXTERNAL";
  VirtualAgentControlMessageTriggerLocation["INTERNAL"] = "INTERNAL";
})(VirtualAgentControlMessageTriggerLocation || (VirtualAgentControlMessageTriggerLocation = {}));
export var VirtualAgentControlMessageType;
(function (VirtualAgentControlMessageType) {
  VirtualAgentControlMessageType["FILE"] = "FILE";
  VirtualAgentControlMessageType["INTENT"] = "INTENT";
  VirtualAgentControlMessageType["POSTBACK"] = "POSTBACK";
  VirtualAgentControlMessageType["TEXT"] = "TEXT";
})(VirtualAgentControlMessageType || (VirtualAgentControlMessageType = {}));
/** Represents the waiving source of FlightsRefundCalculatorInput */
export var WaivingSource;
(function (WaivingSource) {
  WaivingSource["EXPEDIA"] = "EXPEDIA";
  WaivingSource["INSURANCE"] = "INSURANCE";
  WaivingSource["NO_WAIVER"] = "NO_WAIVER";
  WaivingSource["SUPPLIER"] = "SUPPLIER";
})(WaivingSource || (WaivingSource = {}));
/** seasons of the year */
export var WishlistSeason;
(function (WishlistSeason) {
  WishlistSeason["FALL"] = "FALL";
  WishlistSeason["SPRING"] = "SPRING";
  WishlistSeason["SUMMER"] = "SUMMER";
  WishlistSeason["WINTER"] = "WINTER";
})(WishlistSeason || (WishlistSeason = {}));
export const MapToolbarFragmentFragmentDoc = gql`
    fragment MapToolbarFragment on MapToolbar {
  title
  subtitle
  __typename
}
    `;
export const LodgingEGDSBasicCheckBoxFragmentFragmentDoc = gql`
    fragment LodgingEGDSBasicCheckBoxFragment on EGDSBasicCheckBox {
  egdsElementId
  description
  enabled
  checkedAnalytics {
    linkName
    referrerId
    __typename
  }
  uncheckedAnalytics {
    linkName
    referrerId
    __typename
  }
  label {
    text
    __typename
  }
  name
  required
  state
  __typename
}
    `;
export const LodgingEGDSCheckboxFragmentFragmentDoc = gql`
    fragment LodgingEGDSCheckboxFragment on EGDSBasicCheckBox {
  ...LodgingEGDSBasicCheckBoxFragment
  __typename
}
    ${LodgingEGDSBasicCheckBoxFragmentFragmentDoc}`;
export const ClientSideAnalyticsFragmentFragmentDoc = gql`
    fragment ClientSideAnalyticsFragment on ClientSideAnalytics {
  eventType
  linkName
  referrerId
  uisPrimeMessages {
    schemaName
    messageContent
  }
}
    `;
export const LodgingUILinkActionFragmentFragmentDoc = gql`
    fragment LodgingUILinkActionFragment on UILinkAction {
  resource {
    ... on HttpURI {
      relativePath
      value
    }
  }
  target
  useRelativePath
}
    `;
export const LodgingEGDSIconFragmentFragmentDoc = gql`
    fragment LodgingEGDSIconFragment on Icon {
  __typename
  description
  id
  size
  theme
  spotLight
}
    `;
export const LodgingEGDSFloatingButtonFragmentFragmentDoc = gql`
    fragment LodgingEGDSFloatingButtonFragment on UIPrimaryButton {
  accessibility
  analytics {
    ...ClientSideAnalyticsFragment
    __typename
  }
  disabled
  primary
  action {
    ...LodgingUILinkActionFragment
    __typename
  }
  icon {
    ...LodgingEGDSIconFragment
    __typename
  }
  egdsElementId
  __typename
}
    ${ClientSideAnalyticsFragmentFragmentDoc}
${LodgingUILinkActionFragmentFragmentDoc}
${LodgingEGDSIconFragmentFragmentDoc}`;
export const DynamicMapFragmentFragmentDoc = gql`
    fragment DynamicMapFragment on EGDSBasicMap {
  label
  initialViewport
  center {
    latitude
    longitude
  }
  zoom
  bounds {
    northeast {
      latitude
      longitude
    }
    southwest {
      latitude
      longitude
    }
  }
  computedBoundsOptions {
    coordinates {
      latitude
      longitude
    }
    gaiaId
    lowerQuantile
    upperQuantile
    marginMultiplier
    minMargin
    minimumPins
    interpolationRatio
  }
  config {
    ... on EGDSDynamicMapConfig {
      accessToken
      egdsMapProvider
      externalConfigEndpoint {
        value
      }
      mapId
    }
  }
  markers {
    ... on EGDSMapFeature {
      id
      description
      markerPosition {
        latitude
        longitude
      }
      type
      markerStatus
      qualifiers
      text
      clientSideAnalytics {
        linkName
        referrerId
      }
      onSelectAccessibilityMessage
      onEnterAccessibilityMessage
    }
  }
}
    `;
export const MapTriggerFragmentFragmentDoc = gql`
    fragment MapTriggerFragment on LodgingMapTrigger {
  icon {
    id
    title
    token
  }
  label
  small {
    description
    url
  }
  medium {
    description
    url
  }
  large {
    description
    url
  }
  clientSideAnalytics {
    linkName
    referrerId
  }
}
    `;
export const CommonDateFieldsFragmentDoc = gql`
    fragment CommonDateFields on Date {
  year
  month
  day
}
    `;
export const MultiItemPropertySearchContextFieldsFragmentDoc = gql`
    fragment MultiItemPropertySearchContextFields on MultiItemSearchContext {
  properties {
    primary {
      rooms {
        adults
      }
      destination {
        regionId
        regionName
      }
      dateRange {
        checkInDate {
          ...CommonDateFields
        }
        checkOutDate {
          ...CommonDateFields
        }
      }
    }
  }
}
    ${CommonDateFieldsFragmentDoc}`;
export const MessageTitleFieldsFragmentDoc = gql`
    fragment MessageTitleFields on MessagingResultTitle {
  text
  icon {
    description
    id
    size
    spotLight
  }
  egdsMark {
    id
    description
    url {
      value
    }
  }
  illustration {
    assetUri {
      value
    }
    description
  }
}
    `;
export const MessagingActionFieldsFragmentDoc = gql`
    fragment MessagingActionFields on MessagingAction {
  actionDetails {
    action
    details
    name
    title
    accessibilityLabel
  }
  analytics {
    referrerId
    linkName
  }
  linkUrl
  referrerId
  text
}
    `;
export const MessageFieldsFragmentDoc = gql`
    fragment MessageFields on MessageResult {
  __typename
  title {
    ...MessageTitleFields
  }
  subtitle {
    ...MessageTitleFields
  }
  action {
    primary {
      ...MessagingActionFields
    }
    secondary {
      ...MessagingActionFields
    }
  }
  footerText
  type
}
    ${MessageTitleFieldsFragmentDoc}
${MessagingActionFieldsFragmentDoc}`;
export const LodgingIntentCardFieldsFragmentDoc = gql`
    fragment LodgingIntentCardFields on LodgingIntentCard {
  __typename
  headingTitle
  cardMessage: message
  gallery {
    media {
      id
      media {
        ... on Image {
          thumbnailClickAnalytics {
            linkName
            referrerId
            uisPrimeMessages {
              messageContent
              schemaName
            }
          }
          url
          description
        }
      }
    }
  }
  primaryButton {
    primary
    action {
      analytics {
        __typename
        linkName
        referrerId
      }
    }
  }
  impressionAnalyticsTracking: impressionTracking {
    __typename
    event
    referrerId
  }
}
    `;
export const OfferBadgeFragmentFragmentDoc = gql`
    fragment OfferBadgeFragment on Badge {
  text
  theme_temp
  icon_temp {
    id
    description
    title
  }
  mark {
    id
    description
  }
}
    `;
export const DisplayPriceFragmentFragmentDoc = gql`
    fragment DisplayPriceFragment on DisplayPrice {
  __typename
  role
  price {
    formatted
    accessibilityLabel
  }
  disclaimer {
    content
    primaryUIButton {
      accessibility
      primary
    }
  }
}
    `;
export const EnrichedMessageFragmentFragmentDoc = gql`
    fragment EnrichedMessageFragment on LodgingEnrichedMessage {
  __typename
  value
  state
}
    `;
export const CommonPropertyCardFieldsFragmentDoc = gql`
    fragment CommonPropertyCardFields on Property {
  id
  name
  propertyImage {
    image {
      description
      url
    }
    fallbackImage {
      description
      url
    }
  }
  offerBadge {
    primary {
      ...OfferBadgeFragment
    }
    secondary {
      ...OfferBadgeFragment
    }
    tertiary {
      ...OfferBadgeFragment
    }
  }
  price {
    displayMessages {
      lineItems {
        ...DisplayPriceFragment
        ...EnrichedMessageFragment
      }
    }
    lead {
      formatted
    }
    strikeOutType
    strikeOut {
      formatted
    }
    disclaimer {
      value
    }
    roomNightMessage
    priceMessages {
      value
    }
    marketingFeeDetails {
      tierName
      tierIcon
      marketingFeeMessage {
        value
      }
    }
    options {
      leadingCaption
      displayPrice {
        formatted
      }
      strikeOut {
        formatted
      }
      loyaltyPrice {
        amount {
          formatted
        }
        totalStrikeOutPoints {
          formatted
        }
        unit
      }
      disclaimer {
        value
      }
    }
  }
  reviews {
    scoreDenominator
    score
    localizedScore
    total
    localizedTotal
    superlative
    localizedSubtitle
    localizedSubtitleA11y {
      accessibilityLabel
      value
    }
    mark {
      id
      description
    }
  }
  destinationInfo {
    distanceFromMessaging
  }
  vipMessaging
  propertyDetailsLink {
    uri {
      value
      relativePath
    }
    clientSideAnalytics {
      referrerId
      linkName
    }
  }
  sponsoredListing {
    id
    clickRedirectTrackingUrl
    clickTrackingUrl
    details
    detailsHeadline
    hotelImage
    impressionTrackingUrl
    trackingData
    brand
    clickRedirectLinkoffTrackingUrl
    logo
    lotagline
    rating
    slots
    vanityUrl
    rank
    position
  }
}
    ${OfferBadgeFragmentFragmentDoc}
${DisplayPriceFragmentFragmentDoc}
${EnrichedMessageFragmentFragmentDoc}`;
export const CommonDateTimeFieldsFragmentDoc = gql`
    fragment CommonDateTimeFields on DateTime {
  year
  month
  day
  hour
  minute
  second
}
    `;
export const featuredMessageFragmentDoc = gql`
    fragment featuredMessage on LodgingEnrichedMessage {
  icon {
    id
    description
    size
  }
  value
}
    `;
export const EGDSIconTextFragmentFragmentDoc = gql`
    fragment EGDSIconTextFragment on EGDSIconText {
  icon {
    ...LodgingEGDSIconFragment
  }
  text
}
    ${LodgingEGDSIconFragmentFragmentDoc}`;
export const LodgingEGDSHeadingFragmentFragmentDoc = gql`
    fragment LodgingEGDSHeadingFragment on EGDSHeading {
  __typename
  text
}
    `;
export const LodgingProductAmenityFragmentFragmentDoc = gql`
    fragment LodgingProductAmenityFragment on EGDSIconText {
  icon {
    ...LodgingEGDSIconFragment
  }
  text
}
    ${LodgingEGDSIconFragmentFragmentDoc}`;
export const LodgingEGDSParagraphFragmentFragmentDoc = gql`
    fragment LodgingEGDSParagraphFragment on EGDSParagraph {
  __typename
  text
}
    `;
export const EGDSStylizedTextFragmentFragmentDoc = gql`
    fragment EGDSStylizedTextFragment on EGDSStylizedText {
  __typename
  text
  theme
  weight
  size
  decorative
  accessibility
}
    `;
export const LodgingEGDSTextFragmentFragmentDoc = gql`
    fragment LodgingEGDSTextFragment on EGDSText {
  ... on EGDSPlainText {
    __typename
    text
  }
  ... on EGDSParagraph {
    ...LodgingEGDSParagraphFragment
  }
  ... on EGDSStylizedText {
    ...EGDSStylizedTextFragment
  }
  ... on EGDSInlineLink {
    __typename
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        value
      }
      target
    }
    disabled
    linkSize: size
    text
  }
}
    ${LodgingEGDSParagraphFragmentFragmentDoc}
${EGDSStylizedTextFragmentFragmentDoc}`;
export const LodgingCardPropertyDescriptionSectionFragmentFragmentDoc = gql`
    fragment LodgingCardPropertyDescriptionSectionFragment on LodgingCardPropertyDescriptionSection {
  heading {
    text
  }
  description {
    text
  }
  link {
    action {
      resource {
        value
      }
    }
  }
}
    `;
export const EGDSDialogToolbarFragmentFragmentDoc = gql`
    fragment EGDSDialogToolbarFragment on EGDSDialogToolbar {
  closeText
  title
}
    `;
export const LodgingCardMoreDetailsTriggerFragmentFragmentDoc = gql`
    fragment LodgingCardMoreDetailsTriggerFragment on LodgingCardMoreDetailsTrigger {
  accessibilityLabel
  analytics {
    linkName
    referrerId
  }
  icon {
    ...LodgingEGDSIconFragment
  }
  label
}
    ${LodgingEGDSIconFragmentFragmentDoc}`;
export const LodgingCardChangeUnitDialogActionFragmentFragmentDoc = gql`
    fragment LodgingCardChangeUnitDialogActionFragment on LodgingCardChangeUnitDialogAction {
  dialog {
    closeAnalytics {
      linkName
      referrerId
    }
    toolbar {
      ...EGDSDialogToolbarFragment
    }
  }
  trigger {
    ...LodgingCardMoreDetailsTriggerFragment
  }
}
    ${EGDSDialogToolbarFragmentFragmentDoc}
${LodgingCardMoreDetailsTriggerFragmentFragmentDoc}`;
export const LodgingCardChangeUnitSheetActionFragmentFragmentDoc = gql`
    fragment LodgingCardChangeUnitSheetActionFragment on LodgingCardChangeUnitSheetAction {
  sheet {
    closeAnalytics {
      linkName
      referrerId
    }
    closeText
  }
  trigger {
    ...LodgingCardMoreDetailsTriggerFragment
  }
}
    ${LodgingCardMoreDetailsTriggerFragmentFragmentDoc}`;
export const LodgingCardMoreDetailsLinkTriggerFragmentFragmentDoc = gql`
    fragment LodgingCardMoreDetailsLinkTriggerFragment on LodgingCardMoreDetailsTrigger {
  accessibilityLabel
  analytics {
    linkName
    referrerId
  }
  icon {
    ...LodgingEGDSIconFragment
  }
  label
}
    ${LodgingEGDSIconFragmentFragmentDoc}`;
export const LodgingCardUnitDetailsDialogActionFragmentFragmentDoc = gql`
    fragment LodgingCardUnitDetailsDialogActionFragment on LodgingCardUnitDetailsDialog {
  dialog {
    closeAnalytics {
      linkName
      referrerId
    }
    toolbar {
      ...EGDSDialogToolbarFragment
    }
  }
  trigger {
    ...LodgingCardMoreDetailsLinkTriggerFragment
  }
}
    ${EGDSDialogToolbarFragmentFragmentDoc}
${LodgingCardMoreDetailsLinkTriggerFragmentFragmentDoc}`;
export const LodgingCardPropertyDetailsDialogActionFragmentFragmentDoc = gql`
    fragment LodgingCardPropertyDetailsDialogActionFragment on LodgingCardPropertyDetailsDialog {
  dialog {
    closeAnalytics {
      linkName
      referrerId
    }
    toolbar {
      ...EGDSDialogToolbarFragment
    }
  }
  trigger {
    ...LodgingCardMoreDetailsLinkTriggerFragment
  }
}
    ${EGDSDialogToolbarFragmentFragmentDoc}
${LodgingCardMoreDetailsLinkTriggerFragmentFragmentDoc}`;
export const LodgingCardPropertyDialogActionFragmentFragmentDoc = gql`
    fragment LodgingCardPropertyDialogActionFragment on LodgingCardDetailsAction {
  __typename
  ... on LodgingCardUnitDetailsDialog {
    ...LodgingCardUnitDetailsDialogActionFragment
  }
  ... on LodgingCardPropertyDetailsDialog {
    ...LodgingCardPropertyDetailsDialogActionFragment
  }
}
    ${LodgingCardUnitDetailsDialogActionFragmentFragmentDoc}
${LodgingCardPropertyDetailsDialogActionFragmentFragmentDoc}`;
export const EGDSIconRatingFragmentFragmentDoc = gql`
    fragment EGDSIconRatingFragment on EGDSIconRating {
  __typename
  accessibility
  icon {
    token
    theme
    size
  }
  rating
}
    `;
export const EGDSBadgeFragmentFragmentDoc = gql`
    fragment EGDSBadgeFragment on EGDSBadge {
  accessibility
  text
  badgeSize: size
  badgeTheme: theme
}
    `;
export const LodgingCardBadgedRatingFragmentFragmentDoc = gql`
    fragment LodgingCardBadgedRatingFragment on LodgingCardBadgedRating {
  badge {
    ...EGDSBadgeFragment
  }
  phrases {
    phraseParts {
      ...EGDSStylizedTextFragment
    }
  }
}
    ${EGDSBadgeFragmentFragmentDoc}
${EGDSStylizedTextFragmentFragmentDoc}`;
export const ShoppingActionableIconFragmentFragmentDoc = gql`
    fragment ShoppingActionableIconFragment on ShoppingActionableIcon {
  __typename
  actionId
  icon {
    id
    token
    theme
    size
  }
}
    `;
export const LodgingCardRatingFragmentFragmentDoc = gql`
    fragment LodgingCardRatingFragment on LodgingCardRating {
  badge {
    ...EGDSBadgeFragment
  }
  phrases {
    phraseParts {
      ...EGDSIconRatingFragment
      ...EGDSStylizedTextFragment
      ...ShoppingActionableIconFragment
    }
  }
}
    ${EGDSBadgeFragmentFragmentDoc}
${EGDSIconRatingFragmentFragmentDoc}
${EGDSStylizedTextFragmentFragmentDoc}
${ShoppingActionableIconFragmentFragmentDoc}`;
export const LodgingProductFooterMessagesFragmentFragmentDoc = gql`
    fragment LodgingProductFooterMessagesFragment on EGDSTextWithMarkListItem {
  __typename
  mark {
    description
    id
    token
    url {
      value
    }
  }
  style
  text
}
    `;
export const LodgingProductSpannableFooterMessagesFragmentFragmentDoc = gql`
    fragment LodgingProductSpannableFooterMessagesFragment on EarnMessageContainerListItem {
  __typename
  graphic {
    ... on Mark {
      __typename
      description
      id
      token
      url {
        value
        relativePath
      }
    }
    ... on Icon {
      __typename
      description
      id
      size
      theme
      title
    }
    ... on Illustration {
      __typename
      id
      description
    }
  }
  style
  text
  stylizedText {
    ... on EGDSSpannableText {
      __typename
      text
      contents {
        ... on EGDSPlainText {
          __typename
          text
        }
        ... on EGDSStylizedText {
          __typename
          text
          theme
          weight
          size
          decorative
        }
      }
      inlineContent {
        ... on EGDSPlainText {
          __typename
          text
        }
        ... on EGDSStylizedText {
          __typename
          text
          theme
          weight
          size
          decorative
        }
      }
    }
  }
}
    `;
export const LodgingCardProductSummarySectionFragmentFragmentDoc = gql`
    fragment LodgingCardProductSummarySectionFragment on LodgingCardProductSummarySection {
  heading {
    ...LodgingEGDSHeadingFragment
  }
  amenities {
    ...LodgingProductAmenityFragment
  }
  messages {
    ...LodgingEGDSTextFragment
  }
  descriptionSection {
    ...LodgingCardPropertyDescriptionSectionFragment
  }
  changeActionDialog {
    ...LodgingCardChangeUnitDialogActionFragment
  }
  changeActionSheet {
    ...LodgingCardChangeUnitSheetActionFragment
  }
  detailsAction {
    ...LodgingCardPropertyDialogActionFragment
  }
  guestRating {
    accessibilityLabel
    parts {
      ...LodgingEGDSTextFragment
    }
    phraseParts {
      ...EGDSIconRatingFragment
    }
  }
  guestRatingSection {
    __typename
    ... on LodgingCardPhrase {
      accessibilityLabel
      parts {
        ...LodgingEGDSTextFragment
      }
      phraseParts {
        ...EGDSStylizedTextFragment
        ...EGDSIconRatingFragment
      }
    }
    ... on LodgingCardBadgedRating {
      ...LodgingCardBadgedRatingFragment
    }
  }
  guestRatingSectionV2 {
    __typename
    ... on LodgingCardPhrase {
      accessibilityLabel
      parts {
        ...LodgingEGDSTextFragment
      }
      phraseParts {
        ...EGDSStylizedTextFragment
        ...EGDSIconRatingFragment
      }
    }
    ... on LodgingCardRating {
      ...LodgingCardRatingFragment
    }
  }
  footerMessages {
    listItems {
      ...LodgingProductFooterMessagesFragment
      ...LodgingProductSpannableFooterMessagesFragment
    }
  }
}
    ${LodgingEGDSHeadingFragmentFragmentDoc}
${LodgingProductAmenityFragmentFragmentDoc}
${LodgingEGDSTextFragmentFragmentDoc}
${LodgingCardPropertyDescriptionSectionFragmentFragmentDoc}
${LodgingCardChangeUnitDialogActionFragmentFragmentDoc}
${LodgingCardChangeUnitSheetActionFragmentFragmentDoc}
${LodgingCardPropertyDialogActionFragmentFragmentDoc}
${EGDSIconRatingFragmentFragmentDoc}
${EGDSStylizedTextFragmentFragmentDoc}
${LodgingCardBadgedRatingFragmentFragmentDoc}
${LodgingCardRatingFragmentFragmentDoc}
${LodgingProductFooterMessagesFragmentFragmentDoc}
${LodgingProductSpannableFooterMessagesFragmentFragmentDoc}`;
export const LodgingEGDSRatingFragmentFragmentDoc = gql`
    fragment LodgingEGDSRatingFragment on EGDSRating {
  accessibility
  rating
  ... on EGDSIconRating {
    icon {
      id
    }
  }
}
    `;
export const LodgingCardFeaturedMessageFragmentFragmentDoc = gql`
    fragment LodgingCardFeaturedMessageFragment on LodgingCardFeaturedMessage {
  icon {
    id
    description
    size
  }
  text
}
    `;
export const LodgingEGDSLoyaltyBadgeFragmentFragmentDoc = gql`
    fragment LodgingEGDSLoyaltyBadgeFragment on EGDSLoyaltyBadge {
  accessibility
  text
  theme
  impressionAnalytics {
    event
    referrerId
  }
}
    `;
export const LodgingCardHeadingSectionFragmentFragmentDoc = gql`
    fragment LodgingCardHeadingSectionFragment on LodgingCardHeadingSection {
  heading
  productRating {
    ...LodgingEGDSRatingFragment
  }
  featuredMessages {
    ...LodgingCardFeaturedMessageFragment
  }
  messages {
    ...LodgingEGDSTextFragment
  }
  amenities {
    ...LodgingProductAmenityFragment
  }
  perkBadges {
    ...LodgingEGDSLoyaltyBadgeFragment
  }
  missingFilters {
    ...LodgingEGDSTextFragment
  }
}
    ${LodgingEGDSRatingFragmentFragmentDoc}
${LodgingCardFeaturedMessageFragmentFragmentDoc}
${LodgingEGDSTextFragmentFragmentDoc}
${LodgingProductAmenityFragmentFragmentDoc}
${LodgingEGDSLoyaltyBadgeFragmentFragmentDoc}`;
export const LodgingCardLinkActionFragmentFragmentDoc = gql`
    fragment LodgingCardLinkActionFragment on LodgingCardLinkAction {
  __typename
  link {
    text
    action {
      target
      resource {
        __typename
        ... on HttpURI {
          value
          relativePath
        }
      }
      useRelativePath
      analytics {
        referrerId
        linkName
      }
    }
    icon {
      id
    }
  }
}
    `;
export const ShoppingLinkFragmentFragmentDoc = gql`
    fragment ShoppingLinkFragment on ShoppingLink {
  actionId
  text
}
    `;
export const ProductCardFooterLineItemFragmentFragmentDoc = gql`
    fragment ProductCardFooterLineItemFragment on ShoppingProductCardFooterLineItem {
  texts {
    ...EGDSStylizedTextFragment
  }
  actions {
    ...ShoppingLinkFragment
  }
}
    ${EGDSStylizedTextFragmentFragmentDoc}
${ShoppingLinkFragmentFragmentDoc}`;
export const LodgingEGDSImageFragmentFragmentDoc = gql`
    fragment LodgingEGDSImageFragment on Image {
  description
  url
  __typename
  thumbnailClickAnalytics {
    referrerId
    linkName
    __typename
  }
}
    `;
export const LodgingMediaItemFragmentFragmentDoc = gql`
    fragment LodgingMediaItemFragment on LodgingMediaItem {
  id
  media {
    __typename
    ... on Image {
      ...LodgingEGDSImageFragment
      __typename
    }
  }
  trackingId
  __typename
}
    ${LodgingEGDSImageFragmentFragmentDoc}`;
export const LodgingAdaptExAnalyticsEventFragmentFragmentDoc = gql`
    fragment LodgingAdaptExAnalyticsEventFragment on LodgingAdaptExAnalyticsEvent {
  __typename
  campaignId
  clientSideAnalytics {
    __typename
    referrerId
    eventType
    linkName
  }
  events {
    __typename
    eventType
    eventTarget
    banditDisplayed
    payloadId
  }
}
    `;
export const LodgingGalleryCarouselFragmentFragmentDoc = gql`
    fragment LodgingGalleryCarouselFragment on LodgingGalleryCarousel {
  accessibilityHeadingText
  navClickAnalytics {
    linkName
    referrerId
  }
  intersectionAnalytics {
    linkName
    referrerId
    uisPrimeMessages {
      messageContent
      schemaName
    }
  }
  media {
    ...LodgingMediaItemFragment
    __typename
  }
  nextButtonText
  previousButtonText
  adaptExAnalyticsAttemptEvents {
    ...LodgingAdaptExAnalyticsEventFragment
  }
  adaptExAnalyticsSuccessEvents {
    ...LodgingAdaptExAnalyticsEventFragment
  }
}
    ${LodgingMediaItemFragmentFragmentDoc}
${LodgingAdaptExAnalyticsEventFragmentFragmentDoc}`;
export const LodgingEGDSStandardBadgeFragmentFragmentDoc = gql`
    fragment LodgingEGDSStandardBadgeFragment on EGDSStandardBadge {
  __typename
  graphic {
    ... on Icon {
      __typename
      description
      id
    }
    ... on Mark {
      __typename
      description
      id
    }
  }
  text
  theme
  size
}
    `;
export const AdaptexCampaignTrackingDetailFragmentFragmentDoc = gql`
    fragment AdaptexCampaignTrackingDetailFragment on AdaptexCampaignTrackingDetail {
  campaignId
  eventTarget
}
    `;
export const TripsSaveItemPropertiesFragmentFragmentDoc = gql`
    fragment TripsSaveItemPropertiesFragment on TripsSaveItemProperties {
  accessibility
  analytics {
    linkName
    referrerId
    uisPrimeMessages {
      messageContent
      schemaName
    }
  }
  adaptexSuccessCampaignIds {
    ...AdaptexCampaignTrackingDetailFragment
  }
  label
}
    ${AdaptexCampaignTrackingDetailFragmentFragmentDoc}`;
export const TripsSaveStayAttributesFragmentFragmentDoc = gql`
    fragment TripsSaveStayAttributesFragment on TripsSaveStayAttributes {
  regionId
  roomConfiguration {
    childAges
    numberOfAdults
  }
  checkInDate {
    ...CommonDateFields
  }
  checkoutDate {
    ...CommonDateFields
  }
}
    ${CommonDateFieldsFragmentDoc}`;
export const TripsSaveActivityAttributesFragmentFragmentDoc = gql`
    fragment TripsSaveActivityAttributesFragment on TripsSaveActivityAttributes {
  regionId
  dateRange {
    start {
      ...CommonDateFields
    }
    end {
      ...CommonDateFields
    }
  }
}
    ${CommonDateFieldsFragmentDoc}`;
export const LodgingCardMediaSectionFragmentFragmentDoc = gql`
    fragment LodgingCardMediaSectionFragment on LodgingCardMediaSection {
  gallery {
    ...LodgingGalleryCarouselFragment
  }
  badges {
    primaryBadge {
      ...LodgingEGDSStandardBadgeFragment
    }
    secondaryBadge {
      ...LodgingEGDSStandardBadgeFragment
    }
    tertiaryBadge {
      ...LodgingEGDSStandardBadgeFragment
    }
  }
  saveItem {
    analytics {
      linkName
      referrerId
    }
    initialChecked
    items {
      itemId
    }
    labels {
      removeLabel
      saveLabel
    }
    messages {
      removeMessage
      saveMessage
    }
  }
  saveTripItem {
    initialChecked
    itemId
    source
    save {
      ...TripsSaveItemPropertiesFragment
    }
    remove {
      ...TripsSaveItemPropertiesFragment
    }
    attributes {
      __typename
      ...TripsSaveStayAttributesFragment
      ...TripsSaveActivityAttributesFragment
    }
  }
}
    ${LodgingGalleryCarouselFragmentFragmentDoc}
${LodgingEGDSStandardBadgeFragmentFragmentDoc}
${TripsSaveItemPropertiesFragmentFragmentDoc}
${TripsSaveStayAttributesFragmentFragmentDoc}
${TripsSaveActivityAttributesFragmentFragmentDoc}`;
export const LodgingCardDateSectionFragmentFragmentDoc = gql`
    fragment LodgingCardDateSectionFragment on LodgingCardDateSection {
  __typename
  date {
    ... on EGDSStylizedText {
      ...EGDSStylizedTextFragment
    }
  }
}
    ${EGDSStylizedTextFragmentFragmentDoc}`;
export const LodgingCardCompareSectionFragmentFragmentDoc = gql`
    fragment LodgingCardCompareSectionFragment on LodgingCardCompareSection {
  __typename
  compareAction {
    ... on EGDSBasicCheckBox {
      __typename
      label {
        text
      }
      checkedAnalytics {
        ...ClientSideAnalyticsFragment
      }
      uncheckedAnalytics {
        ...ClientSideAnalyticsFragment
      }
    }
  }
}
    ${ClientSideAnalyticsFragmentFragmentDoc}`;
export const PriceMessageFragmentFragmentDoc = gql`
    fragment PriceMessageFragment on DisplayPrice {
  __typename
  role
  price {
    formatted
    accessibilityLabel
  }
  disclaimer {
    content
    primaryUIButton {
      accessibility
      primary
    }
  }
}
    `;
export const PriceSummaryFragmentFragmentDoc = gql`
    fragment PriceSummaryFragment on PropertyPrice {
  displayMessages {
    lineItems {
      ...PriceMessageFragment
      ...EnrichedMessageFragment
    }
  }
  options {
    leadingCaption
    displayPrice {
      formatted
    }
    disclaimer {
      value
    }
    priceDisclaimer {
      content
      primaryButton {
        text
      }
      trigger {
        icon {
          description
        }
      }
    }
    accessibilityLabel
    strikeOut {
      formatted
    }
    loyaltyPrice {
      unit
      amount {
        formatted
      }
      totalStrikeOutPoints {
        formatted
      }
    }
    priceHeaderDialog {
      title
      content
      primaryUIButton {
        primary
        __typename
      }
      trigger {
        icon {
          id
          token
          description
          __typename
        }
        dialogTrigger {
          dialogName
          __typename
        }
        value
        __typename
      }
      __typename
    }
  }
  priceMessaging {
    value
    theme
  }
  marketingFeeDetails {
    tierMessage {
      accessibilityLabel
      value
      egdsMark {
        id
      }
    }
    marketingFeeMessageDialog {
      content
      dialog {
        footer {
          buttons {
            primary
          }
        }
      }
    }
  }
}
    ${PriceMessageFragmentFragmentDoc}
${EnrichedMessageFragmentFragmentDoc}`;
export const LodgingstandardBadgeFragmentDocFragmentDoc = gql`
    fragment LodgingstandardBadgeFragmentDoc on LodgingStandardBadge {
  __typename
  standardBadge {
    __typename
    graphic {
      ... on Icon {
        __typename
        description
        id
      }
      ... on Mark {
        __typename
        description
        id
      }
    }
    text
    theme
    size
  }
  impressionEventAnalytics {
    __typename
    referrerId
    linkName
    event
  }
}
    `;
export const ClickstreamEventFragmentFragmentDoc = gql`
    fragment ClickstreamEventFragment on EGClickstreamEvent {
  eventCategory
  eventName
  eventType
  eventVersion
}
    `;
export const ProductListFragmentFragmentDoc = gql`
    fragment ProductListFragment on LodgingProduct {
  product_id
}
    `;
export const RequestFragmentFragmentDoc = gql`
    fragment RequestFragment on LodgingSearchRequest {
  search_id
}
    `;
export const ProductEventFragmentFragmentDoc = gql`
    fragment ProductEventFragment on LodgingProductEvent {
  event {
    ...ClickstreamEventFragment
  }
  product_list {
    ...ProductListFragment
  }
  search_request {
    ...RequestFragment
  }
}
    ${ClickstreamEventFragmentFragmentDoc}
${ProductListFragmentFragmentDoc}
${RequestFragmentFragmentDoc}`;
export const ShoppingProductCardSheetFragmentFragmentDoc = gql`
    fragment ShoppingProductCardSheetFragment on EGDSSheet {
  closeAnalytics {
    linkName
    referrerId
  }
  closeText
  sheetType
}
    `;
export const ProductCardOverLayFragmentFragmentDoc = gql`
    fragment ProductCardOverLayFragment on ShoppingOverlayContainer {
  overlayId
  contentId
  overlay {
    __typename
    ...ShoppingProductCardSheetFragment
  }
}
    ${ShoppingProductCardSheetFragmentFragmentDoc}`;
export const ProductCardSheetListBodySectionFragmentFragmentDoc = gql`
    fragment ProductCardSheetListBodySectionFragment on ShoppingProductCardSheetListBodySection {
  heading {
    icon {
      description
      id
      size
    }
    text
    theme
  }
  items {
    listItems {
      style
      text
    }
  }
}
    `;
export const ShoppingPriceFragmentFragmentDoc = gql`
    fragment ShoppingPriceFragment on ShoppingPrice {
  __typename
  displayMessages {
    __typename
    lineItems {
      ... on ShoppingDisplayPrice {
        __typename
        clickActionId
        price {
          __typename
          accessibilityLabel
          formatted
        }
        role
      }
      ... on ShoppingEnrichedMessage {
        __typename
        state
        value
      }
    }
  }
}
    `;
export const ProductCardSheetFooterFragmentFragmentDoc = gql`
    fragment ProductCardSheetFooterFragment on ShoppingProductCardSheetPriceAndButtonFooter {
  priceSection {
    ...ShoppingPriceFragment
  }
  button {
    accessibility
    actionId
    disabled
    icon {
      id
      description
      size
    }
    primary
    buttonType
  }
}
    ${ShoppingPriceFragmentFragmentDoc}`;
export const ProductCardSheetListContentFragmentFragmentDoc = gql`
    fragment ProductCardSheetListContentFragment on ShoppingProductCardSheetListContent {
  title
  subtitle
  body {
    ...ProductCardSheetListBodySectionFragment
  }
  footer {
    ...ProductCardSheetFooterFragment
  }
}
    ${ProductCardSheetListBodySectionFragmentFragmentDoc}
${ProductCardSheetFooterFragmentFragmentDoc}`;
export const ProductCardSheetTabularContentFragmentFragmentDoc = gql`
    fragment ProductCardSheetTabularContentFragment on ShoppingProductCardSheetTabularContent {
  title
  subtitle
  tabularBody: body {
    selectedTabId
    tabs {
      accessibility
      label
      tabId
      clickAnalytics {
        linkName
        referrerId
      }
      contentId
    }
  }
  footer {
    ...ProductCardSheetFooterFragment
  }
}
    ${ProductCardSheetFooterFragmentFragmentDoc}`;
export const ProductCardSheetTabListContentFragmentFragmentDoc = gql`
    fragment ProductCardSheetTabListContentFragment on ShoppingProductCardSheetTabListContent {
  content {
    ...ProductCardSheetListBodySectionFragment
  }
}
    ${ProductCardSheetListBodySectionFragmentFragmentDoc}`;
export const LodgingEGDSPlainTextFragmentFragmentDoc = gql`
    fragment LodgingEGDSPlainTextFragment on EGDSPlainText {
  __typename
  text
}
    `;
export const MarkFragmentsFragmentDoc = gql`
    fragment MarkFragments on Mark {
  description
  id
  markSize: size
  url {
    ... on HttpURI {
      __typename
      relativePath
      value
    }
  }
}
    `;
export const IllustrationFragmentsFragmentDoc = gql`
    fragment IllustrationFragments on Illustration {
  description
  id
  link: url
}
    `;
export const UIGraphicFragmentFragmentDoc = gql`
    fragment UIGraphicFragment on UIGraphic {
  ... on Icon {
    ...LodgingEGDSIconFragment
  }
  ... on Mark {
    ...MarkFragments
  }
  ... on Illustration {
    ...IllustrationFragments
  }
}
    ${LodgingEGDSIconFragmentFragmentDoc}
${MarkFragmentsFragmentDoc}
${IllustrationFragmentsFragmentDoc}`;
export const EGDSGraphicTextFragmentFragmentDoc = gql`
    fragment EGDSGraphicTextFragment on EGDSGraphicText {
  text
  textGraphic: graphic {
    ...UIGraphicFragment
  }
  trailingGraphics {
    ...UIGraphicFragment
  }
}
    ${UIGraphicFragmentFragmentDoc}`;
export const EGDSHeadingFragmentFragmentDoc = gql`
    fragment EGDSHeadingFragment on EGDSHeading {
  text
  headingType
}
    `;
export const EGDSInlineLinkFragmentFragmentDoc = gql`
    fragment EGDSInlineLinkFragment on EGDSInlineLink {
  __typename
  action {
    accessibility
    analytics {
      linkName
      referrerId
    }
    resource {
      value
    }
    target
  }
  disabled
  linkSize: size
  text
}
    `;
export const EGDSStandardLinkFragmentFragmentDoc = gql`
    fragment EGDSStandardLinkFragment on EGDSStandardLink {
  text
  icon {
    id
    size
    title
  }
  action {
    accessibility
    analytics {
      linkName
      referrerId
    }
    resource {
      value
    }
  }
}
    `;
export const EGDSSpannableTextContentFragmentFragmentDoc = gql`
    fragment EGDSSpannableTextContentFragment on EGDSText {
  ...EGDSGraphicTextFragment
  ...EGDSHeadingFragment
  ...EGDSInlineLinkFragment
  ...LodgingEGDSPlainTextFragment
  ...EGDSStandardLinkFragment
  ...EGDSStylizedTextFragment
}
    ${EGDSGraphicTextFragmentFragmentDoc}
${EGDSHeadingFragmentFragmentDoc}
${EGDSInlineLinkFragmentFragmentDoc}
${LodgingEGDSPlainTextFragmentFragmentDoc}
${EGDSStandardLinkFragmentFragmentDoc}
${EGDSStylizedTextFragmentFragmentDoc}`;
export const EGDSSpannableTextFragmentFragmentDoc = gql`
    fragment EGDSSpannableTextFragment on EGDSSpannableText {
  text
  contents {
    ...LodgingEGDSPlainTextFragment
  }
  inlineContent {
    ...EGDSSpannableTextContentFragment
  }
}
    ${LodgingEGDSPlainTextFragmentFragmentDoc}
${EGDSSpannableTextContentFragmentFragmentDoc}`;
export const ProductCardSheetSectionLineItemFragmentFragmentDoc = gql`
    fragment ProductCardSheetSectionLineItemFragment on ShoppingProductCardSheetSectionLineItem {
  icons {
    ...LodgingEGDSIconFragment
  }
  price {
    ...ShoppingPriceFragment
  }
  texts {
    ...EGDSStylizedTextFragment
  }
}
    ${LodgingEGDSIconFragmentFragmentDoc}
${ShoppingPriceFragmentFragmentDoc}
${EGDSStylizedTextFragmentFragmentDoc}`;
export const ProductCardSheetSectionFragmentFragmentDoc = gql`
    fragment ProductCardSheetSectionFragment on ShoppingProductCardSheetSection {
  lineItems {
    ...ProductCardSheetSectionLineItemFragment
  }
}
    ${ProductCardSheetSectionLineItemFragmentFragmentDoc}`;
export const ProductCardSheetSectionalContentFragmentFragmentDoc = gql`
    fragment ProductCardSheetSectionalContentFragment on ShoppingProductCardSheetSectionalContent {
  __typename
  header {
    ...EGDSSpannableTextFragment
  }
  sections {
    ...ProductCardSheetSectionFragment
  }
}
    ${EGDSSpannableTextFragmentFragmentDoc}
${ProductCardSheetSectionFragmentFragmentDoc}`;
export const ProductCardContentFragmentFragmentDoc = gql`
    fragment ProductCardContentFragment on ShoppingProductCardContentContainer {
  contentId
  content {
    __typename
    ...ProductCardSheetListContentFragment
    ...ProductCardSheetTabularContentFragment
    ...ProductCardSheetTabListContentFragment
    ...ProductCardSheetSectionalContentFragment
    ... on ShoppingLoadSharedUI {
      componentName
    }
  }
}
    ${ProductCardSheetListContentFragmentFragmentDoc}
${ProductCardSheetTabularContentFragmentFragmentDoc}
${ProductCardSheetTabListContentFragmentFragmentDoc}
${ProductCardSheetSectionalContentFragmentFragmentDoc}`;
export const LodgingCardFieldsFragmentDoc = gql`
    fragment LodgingCardFields on LodgingCard {
  __typename
  id
  featuredHeader {
    header {
      text
    }
  }
  cardLink {
    accessibility
    resource {
      __typename
      ... on HttpURI {
        relativePath
        value
      }
    }
    analytics {
      linkName
      referrerId
      uisPrimeMessages {
        messageContent
        schemaName
      }
      urls
    }
    useRelativePath
    target
  }
  summarySections {
    ...LodgingCardProductSummarySectionFragment
  }
  headingSection {
    ...LodgingCardHeadingSectionFragment
  }
  footerActions {
    ...LodgingCardLinkActionFragment
  }
  footers {
    ...ProductCardFooterLineItemFragment
  }
  mediaSection {
    ...LodgingCardMediaSectionFragment
  }
  dateSection {
    ...LodgingCardDateSectionFragment
  }
  compareSection {
    ...LodgingCardCompareSectionFragment
  }
  callOut {
    ...LodgingEGDSTextFragment
  }
  priceSection {
    priceSummary {
      ...PriceSummaryFragment
    }
    badge {
      ...LodgingEGDSStandardBadgeFragment
    }
    standardBadge {
      ...LodgingstandardBadgeFragmentDoc
    }
    button {
      accessibility
      action {
        analytics {
          linkName
          referrerId
        }
        resource {
          value
        }
      }
      analytics {
        linkName
        referrerId
      }
      disabled
      icon {
        description
        id
      }
      primary
      attemptEvents {
        campaignId
        clientSideAnalytics {
          linkName
          eventType
          referrerId
        }
        events {
          eventType
          eventTarget
          banditDisplayed
          payloadId
        }
      }
      successEvents {
        campaignId
        clientSideAnalytics {
          linkName
          eventType
          referrerId
        }
        events {
          eventType
          eventTarget
          banditDisplayed
          payloadId
        }
      }
      adaptexSuccessActionTracking {
        ...AdaptexCampaignTrackingDetailFragment
      }
    }
  }
  clickstreamEvents {
    productPresented {
      ...ProductEventFragment
    }
    productSelected {
      ...ProductEventFragment
    }
  }
  impressionAnalytics {
    url
    referrerId
    linkName
    uisPrimeMessages {
      messageContent
      schemaName
    }
  }
  adaptexSuccessActionTracking {
    ...AdaptexCampaignTrackingDetailFragment
  }
  clickActionId
  shoppingJoinListContainer {
    actions {
      ... on ShoppingNavigateToOverlay {
        accessibility
        analytics {
          linkName
          referrerId
          __typename
        }
        actionId
        overlayId
        __typename
      }
      ... on ShoppingNavigateToURI {
        accessibility
        analytics {
          linkName
          referrerId
        }
        actionId
        resource {
          value
          __typename
        }
        target
        useRelativePath
        __typename
      }
      __typename
    }
    overlays {
      ...ProductCardOverLayFragment
      __typename
    }
    __typename
  }
  contents {
    ...ProductCardContentFragment
    __typename
  }
}
    ${LodgingCardProductSummarySectionFragmentFragmentDoc}
${LodgingCardHeadingSectionFragmentFragmentDoc}
${LodgingCardLinkActionFragmentFragmentDoc}
${ProductCardFooterLineItemFragmentFragmentDoc}
${LodgingCardMediaSectionFragmentFragmentDoc}
${LodgingCardDateSectionFragmentFragmentDoc}
${LodgingCardCompareSectionFragmentFragmentDoc}
${LodgingEGDSTextFragmentFragmentDoc}
${PriceSummaryFragmentFragmentDoc}
${LodgingEGDSStandardBadgeFragmentFragmentDoc}
${LodgingstandardBadgeFragmentDocFragmentDoc}
${AdaptexCampaignTrackingDetailFragmentFragmentDoc}
${ProductEventFragmentFragmentDoc}
${ProductCardOverLayFragmentFragmentDoc}
${ProductCardContentFragmentFragmentDoc}`;
export const ShoppingCarouselButtonFragmentFragmentDoc = gql`
    fragment ShoppingCarouselButtonFragment on ShoppingCarouselButton {
  analytics {
    linkName
    referrerId
  }
  accessibilityLabel
}
    `;
export const ShoppingCarouselFormatFragmentFragmentDoc = gql`
    fragment ShoppingCarouselFormatFragment on ShoppingCarouselFormat {
  nextButton {
    ...ShoppingCarouselButtonFragment
  }
  previousButton {
    ...ShoppingCarouselButtonFragment
  }
  itemsVisible
}
    ${ShoppingCarouselButtonFragmentFragmentDoc}`;
export const ShoppingListingContainerFragmentFragmentDoc = gql`
    fragment ShoppingListingContainerFragment on ShoppingListingContainer {
  __typename
  containerHeading: heading {
    ...LodgingEGDSHeadingFragment
  }
  items {
    ...LodgingCardFields
  }
  format {
    __typename
    ...ShoppingCarouselFormatFragment
  }
  impressionAnalytics {
    linkName
    referrerId
  }
}
    ${LodgingEGDSHeadingFragmentFragmentDoc}
${LodgingCardFieldsFragmentDoc}
${ShoppingCarouselFormatFragmentFragmentDoc}`;
export const LodgingListingDividerFieldsFragmentDoc = gql`
    fragment LodgingListingDividerFields on LodgingListingDivider {
  __typename
  title {
    titleText: text
    headingType
  }
  subtitle {
    subtitleText: text
  }
  graphic {
    ... on Icon {
      __typename
      description
      id
      iconSize: size
      theme
      title
      withBackground
    }
    ... on Illustration {
      __typename
      description
      url
      id
    }
    ... on Mark {
      __typename
      description
      markUrl: url {
        relativePath
        value
      }
      size
      id
    }
  }
  impressionAnalytics {
    event
    referrerId
  }
  backgroundTheme
}
    `;
export const PropertyListingStandardMessagingCardFragmentFragmentDoc = gql`
    fragment PropertyListingStandardMessagingCardFragment on EGDSStandardMessagingCard {
  __typename
  graphic {
    __typename
    ... on Illustration {
      description
      link: url
    }
    ... on Icon {
      description
      id
      iconSize: size
      theme
      title
      withBackground
      spotLight
    }
  }
  dismiss {
    accessibility
    analytics {
      ...ClientSideAnalyticsFragment
    }
    label
  }
  heading
  egdsElementId
  message
  links {
    action {
      accessibility
      analytics {
        linkName
        referrerId
      }
      resource {
        __typename
        ... on HttpURI {
          relativePath
        }
      }
      useRelativePath
    }
    text
  }
  impressionTracking {
    linkName
    referrerId
  }
}
    ${ClientSideAnalyticsFragmentFragmentDoc}`;
export const PropertyListingExpandoCardFragmentFragmentDoc = gql`
    fragment PropertyListingExpandoCardFragment on PropertyListingsIconTextExpando {
  __typename
  graphic {
    __typename
    ... on Illustration {
      link: url
      description
      id
    }
  }
  expandoCard {
    collapsedLabel
    expandedLabel
    expanded
    subtitle
    expandAnalytics {
      linkName
      referrerId
    }
    collapseAnalytics {
      linkName
      referrerId
    }
  }
  expandedContent {
    text
    graphic {
      __typename
      ... on Icon {
        id
        description
        token
        size
        theme
      }
    }
  }
}
    `;
export const LodgingMoreInfoTriggerFragmentFragmentDoc = gql`
    fragment LodgingMoreInfoTriggerFragment on EGDSStandardLink {
  __typename
  text
  icon {
    description
    id
    size
    title
    token
    withBackground
  }
  action {
    accessibility
    analytics {
      referrerId
      linkName
    }
    resource {
      __typename
      ... on HttpURI {
        relativePath
        value
      }
    }
    target
    useRelativePath
  }
  egdsElementId
  disabled
}
    `;
export const SponsoredContentPlacementFieldsFragmentDoc = gql`
    fragment SponsoredContentPlacementFields on SponsoredContentPlacement {
  __typename
  productType
  sponsoredContentContext {
    pageName
    variant
    sponsoredContentId
    targeting {
      adults
      kids
      origin
      destination
      locationResolver
      dateStart {
        day
        month
        year
      }
      dateEnd {
        day
        month
        year
      }
    }
  }
}
    `;
export const PropertySearchListingsSoldOutFieldsFragmentDoc = gql`
    fragment PropertySearchListingsSoldOutFields on PropertySearchListingsSoldOutCard {
  __typename
  cardContent: content {
    ... on EGDSStandardMessagingCard {
      __typename
      heading
      graphic {
        __typename
        ... on Icon {
          description
          id
          iconSize: size
          theme
          title
          withBackground
        }
      }
    }
  }
  actionButton {
    __typename
    ... on EGDSButton {
      primary
      analytics {
        __typename
        referrerId
        linkName
      }
    }
  }
  analytics {
    __typename
    event
    referrerId
    linkName
  }
}
    `;
export const PropertyListingFlexibleDateSearchButtonFragmentFragmentDoc = gql`
    fragment PropertyListingFlexibleDateSearchButtonFragment on FlexibleDateSearchButton {
  __typename
  button {
    __typename
    ... on UISecondaryButton {
      __typename
      primary
      analytics {
        __typename
        referrerId
        linkName
      }
    }
  }
  datePeriods {
    __typename
    ... on DatePeriod {
      __typename
      length
      unit
      bound
    }
  }
}
    `;
export const PropertyListingFlexibleDateSearchFieldsFragmentDoc = gql`
    fragment PropertyListingFlexibleDateSearchFields on FlexibleDateSearchCard {
  __typename
  cardContent: content {
    ... on EGDSStandardMessagingCard {
      __typename
      heading
      message
      graphic {
        __typename
        ... on Icon {
          __typename
          description
          id
          iconSize: size
          theme
          title
          withBackground
        }
      }
      impressionTracking {
        __typename
        referrerId
        linkName
      }
    }
  }
  changeDatesButton {
    __typename
    ... on UISecondaryButton {
      __typename
      primary
      analytics {
        __typename
        referrerId
        linkName
      }
    }
  }
  flexibleDateSearchButtons {
    __typename
    ...PropertyListingFlexibleDateSearchButtonFragment
  }
}
    ${PropertyListingFlexibleDateSearchButtonFragmentFragmentDoc}`;
export const LodgingEGDSRemovablePillFragmentFragmentDoc = gql`
    fragment LodgingEGDSRemovablePillFragment on EGDSBasicRemovablePill {
  __typename
  primary
  accessibility
  name
  value
  remove {
    __typename
    ... on Icon {
      id
      description
      size
    }
  }
  removeAnalytics {
    __typename
    referrerId
    linkName
  }
}
    `;
export const SearchFilterPillsFragmentFragmentDoc = gql`
    fragment SearchFilterPillsFragment on PropertySearchListingsOverfilteredCard {
  __typename
  filterPills {
    __typename
    ... on BasicShoppingAppliedFilter {
      filter {
        __typename
        ...LodgingEGDSRemovablePillFragment
      }
      linkUrl {
        __typename
        ... on UILinkAction {
          resource {
            __typename
            ... on HttpURI {
              value
              relativePath
            }
          }
          target
          useRelativePath
        }
      }
    }
  }
}
    ${LodgingEGDSRemovablePillFragmentFragmentDoc}`;
export const PropertyListingOverfilteredFragmentFragmentDoc = gql`
    fragment PropertyListingOverfilteredFragment on PropertySearchListingsOverfilteredCard {
  __typename
  cardContent: content {
    __typename
    ... on EGDSStandardMessagingCard {
      heading
      message
      graphic {
        __typename
        ... on Icon {
          description
          id
          iconSize: size
          withBackground
        }
      }
    }
  }
  ...SearchFilterPillsFragment
  action {
    button {
      __typename
      ... on UISecondaryButton {
        accessibility
        disabled
        primary
        analytics {
          __typename
          ... on ClientSideAnalytics {
            referrerId
            linkName
          }
        }
      }
    }
    action {
      __typename
      ... on UILinkAction {
        resource {
          __typename
          ... on HttpURI {
            value
            relativePath
          }
        }
        target
        useRelativePath
      }
    }
  }
  impressionAnalytics {
    __typename
    ... on ClientSideImpressionEventAnalytics {
      event
      referrerId
      linkName
    }
  }
}
    ${SearchFilterPillsFragmentFragmentDoc}`;
export const LoadingA11yLabelFragmentDoc = gql`
    fragment LoadingA11yLabel on OfferDetails {
  loading {
    accessibilityLabel
  }
}
    `;
export const SummaryHeaderFragmentDoc = gql`
    fragment SummaryHeader on PropertyInfo {
  summary {
    name
  }
}
    `;
export const ShoppingContextFragmentDoc = gql`
    fragment ShoppingContext on OfferDetails {
  shoppingContext {
    multiItem {
      id
    }
  }
}
    `;
export const AddPropertyToCartDocument = gql`
    mutation AddPropertyToCart($id: UUID!, $context: ContextInput!, $propertyOffer: PropertyOfferInput!, $cartPropertySearchContextInput: CartPropertySearchContextInput!) {
  cartItems(id: $id, context: $context) {
    addProperty(key: $propertyOffer, searchContext: $cartPropertySearchContextInput) {
      id
      itemCount
    }
  }
}
    `;
export const CreateMultiItemSessionDocument = gql`
    mutation CreateMultiItemSession($context: ContextInput!, $multiItemSearchContext: MultiItemSearchContextInput!) {
  createMultiItemSession(
    context: $context
    searchContext: $multiItemSearchContext
  ) {
    __typename
    ... on MultiItemSearchContextCreatedResponse {
      shoppingContext {
        multiItem {
          id
          packageType
        }
      }
    }
  }
}
    `;
export const CreateSessionCartDocument = gql`
    mutation CreateSessionCart($context: ContextInput!, $cartOptions: CartOptionsInput!) {
  createSessionCart(context: $context, cartOptions: $cartOptions) {
    id
  }
}
    `;
export const EmptyCartDocument = gql`
    mutation EmptyCart($context: ContextInput!, $id: UUID!) {
  cartItems(id: $id, context: $context) {
    emptyCart {
      id
      itemCount
    }
  }
}
    `;
export const FederatedCartDocument = gql`
    query FederatedCart($context: ContextInput!, $id: UUID) {
  cart(id: $id, context: $context) {
    itemCount
    items {
      id
      ... on PropertyCartItem {
        offers {
          offerIndex
          naturalKeys {
            id
            roomTypeId
            ratePlanId
            checkIn {
              isoFormat
            }
            checkOut {
              isoFormat
            }
            inventoryType
            rooms {
              numberOfAdults
              childAges
            }
          }
        }
      }
    }
  }
}
    `;
export const CartDocument = gql`
    query Cart($context: ContextInput!, $id: UUID) {
  cart(id: $id, context: $context) {
    itemCount
    items {
      id
      ... on PropertyCartItem {
        offers {
          offerIndex
          naturalKeys {
            id
            roomTypeId
            ratePlanId
            ratePlanType
            checkIn {
              isoFormat
            }
            checkOut {
              isoFormat
            }
            inventoryType
            rooms {
              numberOfAdults
              childAges
            }
          }
          offer {
            marketingChannelId
            units {
              name
              photos {
                description
                url
              }
              ratePlans {
                priceDetails {
                  availability {
                    available
                    minRoomsLeft
                  }
                  offerBookButton {
                    inputs {
                      ... on LodgingTextInput {
                        name
                        value
                      }
                    }
                  }
                  price {
                    total {
                      currency {
                        code
                        name
                        symbol
                      }
                      formatted
                      raw
                    }
                    lead {
                      currency {
                        code
                        name
                        symbol
                      }
                      formatted
                      raw
                    }
                  }
                  priceAfterLoyaltyPointsApplied {
                    total {
                      currency {
                        code
                        name
                        symbol
                      }
                      formatted
                      raw
                    }
                    lead {
                      currency {
                        code
                        name
                        symbol
                      }
                      formatted
                      raw
                    }
                  }
                  fees {
                    description
                  }
                }
              }
            }
          }
        }
        summary {
          name
          location {
            address {
              city
            }
          }
        }
        gallery {
          featured {
            url
          }
        }
      }
    }
  }
}
    `;
export const InitiateMultiItemSessionDocument = gql`
    mutation InitiateMultiItemSession($context: ContextInput!, $searchContext: MultiItemSearchContextInput!) {
  multiItemShopping(context: $context) {
    initiate(searchContext: $searchContext) {
      __typename
      ... on MultiItemSearchContextCreatedResponse {
        shoppingContext {
          multiItem {
            id
            packageType
          }
        }
        redirectUrl
      }
      ... on MultiItemSearchContextErrorResponse {
        message
      }
    }
  }
}
    `;
export const LodgingPwaPropertySearchDocument = gql`
    query LodgingPwaPropertySearch($context: ContextInput!, $destination: DestinationInput!, $rooms: [RoomInput!], $dateRange: PropertyDateRangeInput, $sort: PropertySort, $filters: PropertySearchFiltersInput, $marketing: PropertyMarketingInfoInput, $propertyShopOptions: PropertyShopOptionsInput, $searchPagination: PaginationInput, $searchIntent: SearchIntentInput, $shoppingContext: ShoppingContextInput, $criteria: PropertySearchCriteriaInput, $productShoppingCriteriaInput: ProductShoppingCriteriaInput, $returnPropertyType: Boolean = true, $includeDynamicMap: Boolean = false) {
  propertySearch(
    context: $context
    destination: $destination
    rooms: $rooms
    dateRange: $dateRange
    sort: $sort
    filters: $filters
    marketing: $marketing
    propertyShopOptions: $propertyShopOptions
    searchPagination: $searchPagination
    searchIntent: $searchIntent
    shoppingContext: $shoppingContext
    criteria: $criteria
    productShoppingCriteriaInput: $productShoppingCriteriaInput
    returnPropertyType: $returnPropertyType
  ) {
    dynamicMap @include(if: $includeDynamicMap) {
      mapToolbar {
        ...MapToolbarFragment
        __typename
      }
      autoSearchOnMapMove {
        ...LodgingEGDSCheckboxFragment
        __typename
      }
      action {
        ...LodgingEGDSFloatingButtonFragment
        __typename
      }
      adaptExSuccessEvents {
        ...LodgingAdaptExAnalyticsEventFragment
        __typename
      }
      filterPlacement
      map {
        ...DynamicMapFragment
        __typename
      }
      __typename
    }
    propertyListingAdaptexAnalyticsSuccessEvents {
      ...LodgingAdaptExAnalyticsEventFragment
    }
    pagination {
      paginationLabel
      trigger {
        __typename
        ... on LodgingPaginationNavigationButtons {
          previousButton {
            analytics {
              referrerId
              linkName
            }
            disabled
            primary
            accessibility
            icon {
              token
            }
          }
          nextButton {
            analytics {
              referrerId
              linkName
            }
            disabled
            primary
            accessibility
            icon {
              token
            }
          }
        }
        ... on UIPrimaryButton {
          analytics {
            referrerId
            linkName
          }
          accessibility
          disabled
          egdsElementId
          icon {
            description
            id
            title
          }
          primary
        }
        ... on LodgingScrollTrigger {
          triggerAfterPosition
          analytics {
            linkName
            referrerId
          }
        }
      }
      subSets {
        nextSubSet {
          size
          startingIndex
        }
        previousSubset {
          size
          startingIndex
        }
      }
    }
    criteria {
      primary {
        dateRange {
          checkInDate {
            ...CommonDateFields
          }
          checkOutDate {
            ...CommonDateFields
          }
        }
        destination {
          regionId
          regionName
        }
        rooms {
          adults
          children {
            age
          }
        }
        flexSearchCriteria {
          flexibility {
            bound
            unit
            length
          }
          searchRange {
            start {
              ...CommonDateFields
            }
            end {
              ...CommonDateFields
            }
          }
          flexibleSearchRequirement
        }
      }
      secondary {
        booleans {
          id
          value
        }
        counts {
          id
          value
        }
        dates {
          id
          value {
            ...CommonDateFields
          }
        }
        ranges {
          id
          max
          min
        }
        selections {
          id
          value
        }
      }
    }
    propertySearchListings {
      ... on RecentlyViewedPropertiesCarouselWrapper {
        __typename
        position
      }
      ... on LodgingCard {
        ...LodgingCardFields
      }
      ... on ShoppingListingContainer {
        ...ShoppingListingContainerFragment
      }
      ... on PropertySearchListingPlaceholder {
        __typename
        loadingComponent
      }
      ... on MessageResult {
        ...MessageFields
      }
      ... on LodgingHeading {
        __typename
        value
      }
      ... on StaticLodgingMultiItemCrossSell {
        __typename
        multiItemSearchContext {
          properties {
            primary {
              dateRange {
                checkInDate {
                  ...CommonDateFields
                }
                checkOutDate {
                  ...CommonDateFields
                }
              }
              destination {
                coordinates {
                  latitude
                  longitude
                }
                mapBounds {
                  latitude
                  longitude
                }
                pinnedPropertyId
                propertyIds
                regionId
                regionName
              }
              rooms {
                adults
                children {
                  age
                }
              }
            }
            secondary {
              booleans {
                id
                value
              }
              counts {
                id
                value
              }
              dates {
                id
                value {
                  ...CommonDateFields
                }
              }
              ranges {
                id
                max
                min
              }
              selections {
                id
                value
              }
            }
          }
        }
        crossSellProductType
        fallbackListing {
          __typename
          ... on MessageResult {
            ...MessageFields
          }
        }
      }
      ... on LodgingIntentCard {
        ...LodgingIntentCardFields
      }
      ... on LodgingListingDivider {
        ...LodgingListingDividerFields
      }
      ... on SponsoredContentPlacement {
        ...SponsoredContentPlacementFields
      }
      ... on PropertySearchListingsSoldOutCard {
        ...PropertySearchListingsSoldOutFields
      }
      ... on FlexibleDateSearchCard {
        ...PropertyListingFlexibleDateSearchFields
      }
      ... on PropertySearchListingsOverfilteredCard {
        ...PropertyListingOverfilteredFragment
      }
      ... on EGDSStandardMessagingCard {
        ...PropertyListingStandardMessagingCardFragment
      }
      ... on PropertyListingsIconTextExpando {
        ...PropertyListingExpandoCardFragment
      }
    }
    summary {
      resultMessages {
        __typename
        ... on EGDSPlainText {
          ...LodgingEGDSPlainTextFragment
        }
        ... on EGDSStandardLink {
          ...LodgingMoreInfoTriggerFragment
        }
      }
      messagingModule {
        header {
          ... on EGDSHeading {
            text
          }
        }
      }
      loyaltyInfo {
        pointsAppliedMessage
        saveWithPointsMessage
        saveWithPointsActionMessage
      }
      matchedPropertiesSize
      resultsHeading
    }
    shoppingContext {
      multiItem {
        id
        packageType
      }
    }
    multiItemSearchContext {
      ...MultiItemPropertySearchContextFields
      cars {
        primary {
          pickUpDateTime {
            ...CommonDateTimeFields
          }
          dropOffDateTime {
            ...CommonDateTimeFields
          }
          pickUpLocation {
            airportCode
          }
          dropOffLocation {
            airportCode
          }
        }
      }
      flights {
        primary {
          travelers {
            type
            age
          }
          tripType
          journeyCriterias {
            destination
            origin
            departureDate {
              day
              month
              year
            }
          }
          searchPreferences {
            airline
            advancedFilters
            cabinClass
          }
        }
      }
    }
    errorResponse {
      header
      body
      icon {
        description
        id
      }
      button {
        primary
        action {
          ... on UILinkAction {
            analytics {
              referrerId
              linkName
            }
            resource {
              ... on HttpURI {
                relativePath
                value
              }
            }
          }
        }
        disabled
      }
      errorRecoveryButtons {
        primary
        action {
          ... on UILinkAction {
            analytics {
              referrerId
              linkName
            }
            resource {
              ... on HttpURI {
                relativePath
                value
              }
            }
          }
        }
        disabled
      }
    }
    dialogErrorResponse {
      body
      button {
        primary
        action {
          ... on UILinkAction {
            analytics {
              referrerId
              linkName
            }
            resource {
              ... on HttpURI {
                relativePath
                value
              }
            }
          }
        }
        disabled
      }
    }
    mapTrigger {
      ...MapTriggerFragment
    }
  }
}
    ${MapToolbarFragmentFragmentDoc}
${LodgingEGDSCheckboxFragmentFragmentDoc}
${LodgingEGDSFloatingButtonFragmentFragmentDoc}
${LodgingAdaptExAnalyticsEventFragmentFragmentDoc}
${DynamicMapFragmentFragmentDoc}
${CommonDateFieldsFragmentDoc}
${LodgingCardFieldsFragmentDoc}
${ShoppingListingContainerFragmentFragmentDoc}
${MessageFieldsFragmentDoc}
${LodgingIntentCardFieldsFragmentDoc}
${LodgingListingDividerFieldsFragmentDoc}
${SponsoredContentPlacementFieldsFragmentDoc}
${PropertySearchListingsSoldOutFieldsFragmentDoc}
${PropertyListingFlexibleDateSearchFieldsFragmentDoc}
${PropertyListingOverfilteredFragmentFragmentDoc}
${PropertyListingStandardMessagingCardFragmentFragmentDoc}
${PropertyListingExpandoCardFragmentFragmentDoc}
${LodgingEGDSPlainTextFragmentFragmentDoc}
${LodgingMoreInfoTriggerFragmentFragmentDoc}
${MultiItemPropertySearchContextFieldsFragmentDoc}
${CommonDateTimeFieldsFragmentDoc}
${MapTriggerFragmentFragmentDoc}`;
export const PrepareCheckoutByCartIdDocument = gql`
    mutation PrepareCheckoutByCartId($context: ContextInput!, $id: UUID!, $totalPrice: MoneyInput!, $marketingChannelId: Int, $checkoutOptions: [CheckoutOptionInput!]) {
  prepareCheckoutByCartId(
    context: $context
    cartId: $id
    totalPrice: $totalPrice
    marketingChannelId: $marketingChannelId
    checkoutOptions: $checkoutOptions
  ) {
    tripId
    checkoutUrl
    failureReason {
      ... on MaxRoomsFailure {
        groupLinkMessage
        message
      }
    }
  }
}
    `;
export const PrepareCheckoutDocument = gql`
    mutation PrepareCheckout($context: ContextInput!, $properties: [PropertyNaturalKeyInput!], $cookies: String!) {
  prepareCheckout(context: $context, properties: $properties, cookies: $cookies) {
    tripId
    checkoutUrl
  }
}
    `;
export const PropertyInfoPageLayoutDocument = gql`
    query PropertyInfoPageLayout($context: ContextInput!, $propertyId: String!, $shoppingContext: ShoppingContextInput) {
  propertyInfo(
    context: $context
    propertyId: $propertyId
    shoppingContext: $shoppingContext
  ) {
    experimental {
      pageLayoutExperimentalFeature {
        templateName
      }
    }
  }
}
    `;
export const RemoveItemFromCartDocument = gql`
    mutation RemoveItemFromCart($cartId: UUID!, $context: ContextInput!, $itemId: UUID!) {
  cartItems(id: $cartId, context: $context) {
    remove(id: $itemId) {
      id
      itemCount
    }
  }
}
    `;
export const SearchResultsPageLayoutDocument = gql`
    query SearchResultsPageLayout($context: ContextInput!, $destination: DestinationInput!) {
  propertySearch(context: $context, destination: $destination) {
    experimental {
      pageLayoutFeatureExperiment {
        templateName
      }
    }
  }
}
    `;
export const SelectProductsDocument = gql`
    mutation SelectProducts($context: ContextInput!, $sessionId: String!, $priceToken: String, $properties: [PropertyNaturalKeyInput!], $flights: [FlightNaturalKeyInput!], $cars: [CarNaturalKeyInput!], $dealMarker: String) {
  multiItemShopping(context: $context) {
    selectProducts(
      sessionId: $sessionId
      priceToken: $priceToken
      properties: $properties
      flights: $flights
      cars: $cars
      dealMarker: $dealMarker
    ) {
      __typename
      ... on MultiItemSearchContextCreatedResponse {
        shoppingContext {
          multiItem {
            id
            packageType
          }
        }
        redirectUrl
      }
      ... on MultiItemSearchContextErrorResponse {
        message
      }
    }
  }
}
    `;
const defaultWrapper = (action, _operationName, _operationType) => action();
const AddPropertyToCartDocumentString = print(AddPropertyToCartDocument);
const CreateMultiItemSessionDocumentString = print(CreateMultiItemSessionDocument);
const CreateSessionCartDocumentString = print(CreateSessionCartDocument);
const EmptyCartDocumentString = print(EmptyCartDocument);
const FederatedCartDocumentString = print(FederatedCartDocument);
const CartDocumentString = print(CartDocument);
const InitiateMultiItemSessionDocumentString = print(InitiateMultiItemSessionDocument);
const LodgingPwaPropertySearchDocumentString = print(LodgingPwaPropertySearchDocument);
const PrepareCheckoutByCartIdDocumentString = print(PrepareCheckoutByCartIdDocument);
const PrepareCheckoutDocumentString = print(PrepareCheckoutDocument);
const PropertyInfoPageLayoutDocumentString = print(PropertyInfoPageLayoutDocument);
const RemoveItemFromCartDocumentString = print(RemoveItemFromCartDocument);
const SearchResultsPageLayoutDocumentString = print(SearchResultsPageLayoutDocument);
const SelectProductsDocumentString = print(SelectProductsDocument);
export function getSdk(client, withWrapper = defaultWrapper) {
  return {
    AddPropertyToCart(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(AddPropertyToCartDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'AddPropertyToCart', 'mutation');
    },
    CreateMultiItemSession(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(CreateMultiItemSessionDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateMultiItemSession', 'mutation');
    },
    CreateSessionCart(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(CreateSessionCartDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateSessionCart', 'mutation');
    },
    EmptyCart(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(EmptyCartDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'EmptyCart', 'mutation');
    },
    FederatedCart(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(FederatedCartDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'FederatedCart', 'query');
    },
    Cart(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(CartDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'Cart', 'query');
    },
    InitiateMultiItemSession(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(InitiateMultiItemSessionDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'InitiateMultiItemSession', 'mutation');
    },
    LodgingPwaPropertySearch(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(LodgingPwaPropertySearchDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'LodgingPwaPropertySearch', 'query');
    },
    PrepareCheckoutByCartId(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(PrepareCheckoutByCartIdDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'PrepareCheckoutByCartId', 'mutation');
    },
    PrepareCheckout(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(PrepareCheckoutDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'PrepareCheckout', 'mutation');
    },
    PropertyInfoPageLayout(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(PropertyInfoPageLayoutDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'PropertyInfoPageLayout', 'query');
    },
    RemoveItemFromCart(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(RemoveItemFromCartDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'RemoveItemFromCart', 'mutation');
    },
    SearchResultsPageLayout(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(SearchResultsPageLayoutDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SearchResultsPageLayout', 'query');
    },
    SelectProducts(variables, requestHeaders) {
      return withWrapper(wrappedRequestHeaders => client.rawRequest(SelectProductsDocumentString, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'SelectProducts', 'mutation');
    }
  };
}